/**
 * © 2025 Grupo Salamander SAPI de CV
 * Author: Pablo Adoue Peralta
 *
 * Spanish (Mexico) locale translations. Auto-generated by build-locale script
 *
 * */

const esmx = {
  "address/components/additional-info": "Información adicional",
  "address/components/admin-area-1": "Estado / provincia",
  "address/components/admin-area-1/department": "Departamento",
  "address/components/admin-area-1/parish": "Parroquia",
  "address/components/admin-area-1/province": "Provincia",
  "address/components/admin-area-1/region": "Región",
  "address/components/admin-area-1/state": "Estado",
  "address/components/admin-area-2": "Municipio / condado",
  "address/components/admin-area-2/municipality": "Municipio",
  "address/components/locality": "Ciudad",
  "address/components/postal-code": "Código postal",
  "address/components/street-name": "Calle",
  "address/components/street-number": "Número exterior",
  "address/components/sub-locality": "Barrio",
  "address/components/sub-locality/neighborhood-mx": "Colonia",
  "address/components/unit-number": "Número interior",
  "address/editor/country": "País",
  "address/editor/country-not-enabled":
    "Ese domicilio está en un país que no está disponible.",
  "address/editor/label": "Nombre (opcional)",
  "address/editor/locate": "Ubicar en el mapa",
  "address/editor/locate-none":
    "No se encontró una ubicación para este domicilio.",
  "address/editor/lookup-failed": "No se pudo consultar el código postal.",
  "address/editor/map": "Mapa del domicilio",
  "address/editor/map-placeholder": "El mapa no está disponible.",
  "address/editor/pick-settlement":
    "Elige la colonia de la lista de este código postal.",
  "address/editor/pin-confirm": "Confirmar ubicación",
  "address/editor/pin-confirmed": "Ubicación confirmada.",
  "address/editor/pin-drag-hint": "Arrastra el marcador a la ubicación exacta.",
  "address/editor/pin-remove": "Quitar ubicación",
  "address/editor/pin-suggested":
    "Ubicación sugerida. Confírmala o mueve el marcador.",
  "address/editor/place-failed": "No se pudo leer el domicilio seleccionado.",
  "address/editor/postal-example": "Ejemplo: {{example}}",
  "address/editor/postal-not-found":
    "Este código postal no está en el catálogo. Captura la colonia a mano.",
  "address/editor/primary": "Domicilio principal para este propósito",
  "address/editor/profiles-error":
    "No se pudo cargar la configuración de domicilios.",
  "address/editor/purpose": "Propósito",
  "address/editor/save-error": "No se pudo guardar el domicilio.",
  "address/editor/search": "Buscar domicilio",
  "address/editor/search-no-options": "Sin domicilios coincidentes",
  "address/editor/search-placeholder": "Empieza a escribir un domicilio",
  "address/panel/action-error": "No se pudo completar la acción.",
  "address/panel/add": "Agregar domicilio",
  "address/panel/delete": "Eliminar domicilio",
  "address/panel/delete-confirm": "Este domicilio se quitará del registro.",
  "address/panel/edit": "Editar domicilio",
  "address/panel/empty": "Aún no hay domicilios.",
  "address/panel/load-error": "No se pudieron cargar los domicilios.",
  "address/panel/primary": "Principal",
  "address/panel/set-primary": "Marcar como principal",
  "address/panel/title": "Domicilios",
  "address/purposes/billing": "Facturación",
  "address/purposes/correspondence": "Correspondencia",
  "address/purposes/fiscal": "Domicilio fiscal",
  "address/purposes/other": "Otro",
  "address/purposes/residence": "Residencia",
  "address/purposes/risk-location": "Ubicación del riesgo",
  "api/auth/login-revoked": "Acceso revocado",
  "api/auth/login-revoked-description":
    "Esta cuenta ya no tiene acceso a la plataforma.",
  "api/catalogue-reference-invalid": "Referencia de catálogo inválida",
  "api/catalogue-reference-invalid-description":
    "Selecciona una entrada habilitada del catálogo configurado para esta compañía.",
  "api/catalogue-update/already-running":
    "Ya hay una actualización del catálogo en curso",
  "api/catalogue-update/already-running-description":
    "Espera a que termine la actualización actual y solicita otra.",
  "api/configuration/ambiguous-inheritance":
    "Esta configuración hereda valores distintos de agencias padre igualmente cercanas.",
  "api/configuration/ambiguous-inheritance-description":
    "Define un valor explícito en esta agencia antes de guardar.",
  "api/configuration/cedent-availability-reserved":
    "Tu rol no puede cambiar esta disponibilidad de cedente.",
  "api/configuration/cedent-availability-reserved-description":
    "Solo los administradores del programa pueden activar o desactivar cedentes.",
  "api/configuration/cedent-line-removal-reserved":
    "Solo los administradores de todo el programa pueden quitar un ramo.",
  "api/configuration/cedent-line-removal-reserved-description":
    "Tu rol puede deshabilitar el ramo en lugar de quitarlo.",
  "api/configuration/cedent-outside-company":
    "La cedente no es una aseguradora de esta compañía.",
  "api/configuration/cedent-outside-company-description":
    "La disponibilidad solo puede definirse para una persona moral aseguradora registrada de la compañía del programa.",
  "api/configuration/commission-default-missing":
    "No hay una comisión predeterminada configurada para esta línea de negocio.",
  "api/configuration/commission-default-missing-description":
    "Pide a un administrador de la plataforma que configure las comisiones predeterminadas.",
  "api/configuration/currency-outside-boundary":
    "La moneda no está permitida para esta línea de negocio o programa.",
  "api/configuration/currency-outside-boundary-description":
    "Elige solo monedas habilitadas para la línea de negocio en este programa.",
  "api/configuration/currency-selection-reserved":
    "Solo los administradores de la plataforma pueden cambiar la selección de monedas.",
  "api/configuration/currency-selection-reserved-description":
    "Tu rol puede habilitar líneas de negocio pero no cambiar monedas.",
  "api/configuration/invalid-policy-types":
    "Los tipos de póliza permitidos no son válidos.",
  "api/configuration/invalid-policy-types-description":
    "Elige al menos un tipo de póliza del conjunto permitido.",
  "api/configuration/invalid-term-rule":
    "La regla de vigencia es inconsistente.",
  "api/configuration/invalid-term-rule-description":
    "Una vigencia fija requiere cantidad, unidad y vencimiento bloqueado; una vigencia acotada requiere un rango válido.",
  "api/configuration/lob-not-available-in-program":
    "Esta línea de negocio no está disponible en el programa.",
  "api/configuration/lob-not-available-in-program-description":
    "Habilítala primero para el programa.",
  "api/configuration/participation-outside-program":
    "La agencia no pertenece a este programa.",
  "api/configuration/participation-outside-program-description":
    "La configuración solo puede referirse a agencias del programa actual.",
  "api/configuration/program-mode-required":
    "Esta configuración solo está disponible para compañías organizadas por programas.",
  "api/configuration/program-mode-required-description":
    "La compañía no está configurada para aislamiento por programa.",
  "api/could-not-get-signed-link": "No se pudo obtener el enlace firmado",
  "api/could-not-get-signed-link-description":
    "No se pudo obtener el enlace firmado",
  "api/database/cross-instance-access":
    "Acceso a base de datos entre instancias",
  "api/database/cross-instance-access-detail":
    "No se puede acceder a {{requestedInstance}} mientras hay una operación de base de datos activa para {{activeInstance}}.",
  "api/documents/asset-in-use": "El recurso está en uso",
  "api/documents/asset-in-use-description":
    "Un documento o membrete publicado usa este archivo. Publica primero una versión sin él.",
  "api/documents/asset-type-refused": "Tipo de recurso rechazado",
  "api/documents/asset-type-refused-description":
    "El archivo no es una imagen o tipografía admitida, o su licencia prohíbe incrustarla.",
  "api/documents/asset-unavailable": "Recurso no disponible",
  "api/documents/asset-unavailable-description":
    "No se pudo cargar una imagen o tipografía que usa el documento. Inténtalo de nuevo o reemplaza el recurso.",
  "api/documents/binding-unknown": "Campo desconocido",
  "api/documents/binding-unknown-description":
    "El documento hace referencia a un campo que ninguno de sus proveedores de datos entrega.",
  "api/documents/block-id-duplicate": "Identificador de bloque duplicado",
  "api/documents/block-id-duplicate-description":
    "Dos bloques del documento comparten el mismo identificador.",
  "api/documents/body-too-complex":
    "El contenido del documento es demasiado grande o anidado",
  "api/documents/body-too-complex-description":
    "El documento tiene demasiados elementos, está demasiado anidado o trae demasiadas filas. Divídelo o quita contenido.",
  "api/documents/body-too-deep":
    "El documento tiene demasiados niveles anidados",
  "api/documents/body-too-deep-description":
    "Simplifica la estructura para que tenga máximo 32 niveles.",
  "api/documents/body-too-large": "El documento es demasiado grande",
  "api/documents/body-too-large-description":
    "El contenido del documento no puede superar 1 MiB.",
  "api/documents/body-too-many-nodes": "El documento tiene demasiados bloques",
  "api/documents/body-too-many-nodes-description":
    "Los bloques y las celdas de tabla no pueden sumar más de 5,000.",
  "api/documents/bundle-invalid": "Archivo de exportación no válido",
  "api/documents/bundle-invalid-description":
    "El archivo está dañado, fue editado o proviene de una versión incompatible.",
  "api/documents/caller-missing":
    "Servicio de documentos invocado sin solicitante",
  "api/documents/caller-missing-description":
    "El servicio de documentos se invocó sin la empresa o el usuario de la solicitud. Es un error interno; contacta a soporte.",
  "api/documents/condition-error": "Condición de documento no válida",
  "api/documents/condition-error-description":
    "No se pudo evaluar una condición de visibilidad del documento.",
  "api/documents/content-document-missing":
    "Al documento le falta su documento de contenido",
  "api/documents/content-document-missing-description":
    "El documento declara el proveedor de contenido pero su definición no indica un documento de contenido. Indica el documento de contenido en la definición e inténtalo de nuevo.",
  "api/documents/context-invalid": "Contexto de solicitud no válido",
  "api/documents/context-invalid-description":
    "No se pudo determinar la empresa o la instancia de la solicitud.",
  "api/documents/default-super-admin-only":
    "Solo un superadministrador puede cambiar los valores por defecto de la instancia",
  "api/documents/default-super-admin-only-description":
    "El membrete por defecto de la instancia solo lo puede modificar un superadministrador.",
  "api/documents/format-unavailable": "Formato no habilitado",
  "api/documents/format-unavailable-description":
    "Este documento no está disponible en el formato solicitado.",
  "api/documents/format-unsupported": "Formato de documento no compatible",
  "api/documents/format-unsupported-description":
    "El formato de documento solicitado no está disponible.",
  "api/documents/helper-unknown": "Función desconocida",
  "api/documents/helper-unknown-description":
    "Una plantilla llama a una función auxiliar que no existe.",
  "api/documents/letterhead-in-use": "El membrete está en uso",
  "api/documents/letterhead-in-use-description":
    "Un documento fija este membrete. Cambia primero ese documento.",
  "api/documents/letterhead-owner-taken":
    "Ya existe un membrete para este propietario",
  "api/documents/letterhead-owner-taken-description":
    "Edita el membrete existente en lugar de crear otro.",
  "api/documents/letterhead-unavailable": "Membrete no disponible",
  "api/documents/letterhead-unavailable-description":
    "El membrete que requiere este documento no existe, está deshabilitado o no está publicado.",
  "api/documents/no-draft": "No hay un borrador para publicar",
  "api/documents/no-draft-description": "Guarda un borrador antes de publicar.",
  "api/documents/no-published-version": "Sin versión publicada",
  "api/documents/no-published-version-description":
    "Publica una versión antes de exportar, o elige una versión.",
  "api/documents/not-applicable": "Documento no disponible aquí",
  "api/documents/not-applicable-description":
    "Este documento no se ofrece para este registro, etapa o usuario.",
  "api/documents/not-authorized": "Sin autorización",
  "api/documents/not-authorized-description":
    "Tu rol no puede realizar esta acción sobre documentos.",
  "api/documents/not-found": "Documento no encontrado",
  "api/documents/not-found-description": "El documento o la versión no existe.",
  "api/documents/precondition-unknown": "Requisito del documento no reconocido",
  "api/documents/precondition-unknown-description":
    "El documento tiene un requisito que este sistema no puede verificar, por lo que no se puede generar.",
  "api/documents/provider-deprecated": "Proveedor de datos obsoleto",
  "api/documents/provider-deprecated-description":
    "El proveedor de datos se conserva solo para documentos de sistema y no puede usarse en documentos propios.",
  "api/documents/provider-requires":
    "Falta una dependencia del proveedor de datos",
  "api/documents/provider-requires-description":
    "El proveedor de datos necesita otro proveedor que el documento no declara.",
  "api/documents/provider-subject-unsupported":
    "Proveedor de datos no compatible con este sujeto",
  "api/documents/provider-subject-unsupported-description":
    "El proveedor de datos no puede cargar datos para el tipo de registro de este documento.",
  "api/documents/render-busy": "El servicio de documentos está ocupado",
  "api/documents/render-busy-description":
    "Se están generando demasiados documentos en este momento. Inténtalo de nuevo en unos segundos.",
  "api/documents/render-failed": "No se pudo generar el documento",
  "api/documents/render-failed-description":
    "No se pudo generar el archivo del documento. Revisa las fuentes, imágenes y configuración de página del documento e inténtalo de nuevo.",
  "api/documents/render-required": "El documento debe generarse de nuevo",
  "api/documents/render-required-description":
    "El archivo guardado ya no está disponible. Intenta generar el documento de nuevo.",
  "api/documents/render-timeout": "El documento tardó demasiado en generarse",
  "api/documents/render-timeout-description":
    "No se pudo generar el documento a tiempo. Inténtalo de nuevo o simplifica el documento.",
  "api/documents/repeat-invalid": "Repetidor de documento no válido",
  "api/documents/repeat-invalid-description":
    "Un repetidor del documento apunta a algo que no es una lista o usa un alias no válido.",
  "api/documents/request-invalid": "Solicitud de documento no válida",
  "api/documents/request-invalid-description":
    "A la solicitud le falta un campo o uno de sus valores no es válido.",
  "api/documents/revision-conflict":
    "El documento fue modificado por alguien más",
  "api/documents/revision-conflict-description":
    "Recárgalo e inténtalo de nuevo.",
  "api/documents/schema-invalid": "Cuerpo de documento no válido",
  "api/documents/schema-invalid-description":
    "El cuerpo del documento o del membrete no coincide con su esquema.",
  "api/documents/slug-invalid": "La clave del documento no es válida",
  "api/documents/slug-invalid-description":
    "Usa letras minúsculas y dígitos separados por un solo guion, hasta 64 caracteres.",
  "api/documents/slug-taken": "El identificador del documento ya está en uso",
  "api/documents/slug-taken-description":
    "Otro documento de esta empresa ya usa ese identificador.",
  "api/documents/system-asset-super-admin-only":
    "Los recursos del sistema son de solo lectura",
  "api/documents/system-asset-super-admin-only-description":
    "Solo un superadministrador puede cambiar un recurso del sistema.",
  "api/documents/template-error": "Error en la plantilla del documento",
  "api/documents/template-error-description":
    "No se pudo generar la plantilla del documento. Corrige el bloque indicado e inténtalo de nuevo.",
  "api/documents/unauthenticated": "Se requiere iniciar sesión",
  "api/documents/unauthenticated-description":
    "Inicia sesión para usar documentos.",
  "api/documents/unknown-provider": "Proveedor de datos desconocido",
  "api/documents/unknown-provider-description":
    "El documento declara un proveedor de datos que no existe.",
  "api/documents/value-missing": "Valor no disponible",
  "api/documents/value-missing-description":
    "Un valor al que hace referencia el documento no está en sus datos; se deja en blanco.",
  "api/documents/version-not-published": "La versión no está publicada",
  "api/documents/version-not-published-description":
    "Solo una versión publicada puede quedar vigente.",
  "api/errors/company-access-denied": "Acceso a compañía denegado",
  "api/errors/company-access-denied-description":
    "No tienes acceso a esta compañía",
  "api/errors/company-header-missing": "Encabezado de compañía faltante",
  "api/errors/company-header-missing-description":
    "El encabezado X-Company-Id es requerido",
  "api/invalid-in-force-date": "Fecha de vigencia inválida",
  "api/laipo/token-principal-not-allowed":
    "Los tokens de API no pueden usar el asistente.",
  "api/marketing/activation-failed": "No se pudo activar Marketing",
  "api/marketing/activation-failed-description":
    "Revisa la configuración del proveedor, los límites y el remitente e inténtalo de nuevo.",
  "api/marketing/activation-forbidden": "No se permite la activación",
  "api/marketing/activation-forbidden-description":
    "Se requieren permisos de configuración de Marketing y de la empresa.",
  "api/marketing/artifact/checksum-mismatch":
    "El artefacto almacenado no superó la verificación",
  "api/marketing/artifact/checksum-mismatch-description":
    "El contenido almacenado no coincide con su checksum registrado.",
  "api/marketing/artifact/company-mismatch":
    "Este artefacto no pertenece a tu empresa",
  "api/marketing/artifact/company-mismatch-description":
    "La clave de almacenamiento solicitada no pertenece a la empresa esperada.",
  "api/marketing/artifact/storage-unavailable":
    "El almacenamiento de artefactos no está disponible",
  "api/marketing/artifact/storage-unavailable-description":
    "Inténtalo de nuevo más tarde, o contacta a soporte si continúa.",
  "api/marketing/asset-category/invalid-label":
    "Ingresa una etiqueta en ambos idiomas",
  "api/marketing/asset-category/invalid-label-description":
    "Una categoría de recursos necesita una etiqueta en inglés y en español.",
  "api/marketing/asset-category/invalid-slug":
    "Ingresa un identificador de categoría",
  "api/marketing/asset-category/invalid-slug-description":
    "El identificador de la categoría no puede estar vacío.",
  "api/marketing/asset-category/not-found": "Categoría no encontrada",
  "api/marketing/asset-category/not-found-description":
    "Esta categoría de recursos no existe para tu empresa.",
  "api/marketing/asset-version/immutable-field":
    "Este campo no se puede modificar",
  "api/marketing/asset-version/immutable-field-description":
    "Una versión de un recurso es inmutable una vez creada; sube una nueva versión en su lugar.",
  "api/marketing/asset-version/invalid-scan-state": "Elige limpio o bloqueado",
  "api/marketing/asset-version/invalid-scan-state-description":
    "Una atestación manual de escaneo debe registrar limpio o bloqueado.",
  "api/marketing/asset/asset-version-required": "Elige una versión de recurso",
  "api/marketing/asset/asset-version-required-description":
    "Se requiere una versión de recurso para continuar.",
  "api/marketing/asset/bootstrap-company-not-found": "Empresa no encontrada",
  "api/marketing/asset/bootstrap-company-not-found-description":
    "No se pudo encontrar esta empresa al registrar el logo.",
  "api/marketing/asset/bootstrap-fetch-failed":
    "No se pudo obtener el logo alojado",
  "api/marketing/asset/bootstrap-fetch-failed-description":
    "Confirma que la URL sea accesible públicamente e inténtalo de nuevo.",
  "api/marketing/asset/bootstrap-fields-required":
    "Ingresa un nombre, categoría y URL alojada",
  "api/marketing/asset/bootstrap-fields-required-description":
    "Los tres campos son obligatorios para registrar un logo existente.",
  "api/marketing/asset/derivative-too-large":
    "Esta imagen no pudo redimensionarse para correo",
  "api/marketing/asset/derivative-too-large-description":
    "Elige una imagen más pequeña o simple e inténtalo de nuevo.",
  "api/marketing/asset/document-not-publishable":
    "Los documentos no pueden publicarse como imágenes en línea",
  "api/marketing/asset/document-not-publishable-description":
    "Solo las imágenes pueden publicarse para usarse en el contenido de correos.",
  "api/marketing/asset/file-too-large": "Este archivo es demasiado grande",
  "api/marketing/asset/file-too-large-description":
    "Elige un archivo más pequeño e inténtalo de nuevo.",
  "api/marketing/asset/invalid-document":
    "Este archivo no es un documento válido",
  "api/marketing/asset/invalid-document-description":
    "Solo se admiten documentos PDF.",
  "api/marketing/asset/invalid-hosted-url": "Ingresa una URL HTTPS válida",
  "api/marketing/asset/invalid-hosted-url-description":
    "El logo alojado debe servirse por HTTPS desde una URL existente.",
  "api/marketing/asset/invalid-image": "Este archivo no es una imagen válida",
  "api/marketing/asset/invalid-image-description":
    "Solo se admiten imágenes PNG, JPEG y WebP.",
  "api/marketing/asset/invalid-kind": "Elige imagen o documento",
  "api/marketing/asset/invalid-kind-description":
    "El tipo de recurso debe ser imagen o documento.",
  "api/marketing/asset/invalid-publication-purpose":
    "Propósito de publicación inválido",
  "api/marketing/asset/invalid-publication-purpose-description":
    "Elige un propósito de publicación admitido.",
  "api/marketing/asset/kind-mismatch":
    "Este archivo no coincide con el tipo de recurso",
  "api/marketing/asset/kind-mismatch-description":
    "Una imagen no puede subirse como nueva versión de un documento, ni viceversa.",
  "api/marketing/asset/name-and-category-required":
    "Ingresa un nombre y elige una categoría",
  "api/marketing/asset/name-and-category-required-description":
    "Un nuevo recurso necesita un nombre y una categoría.",
  "api/marketing/asset/not-found": "Recurso no encontrado",
  "api/marketing/asset/not-found-description":
    "Este recurso no existe para tu empresa.",
  "api/marketing/asset/not-publish-ready":
    "Este recurso no está listo para publicarse",
  "api/marketing/asset/not-publish-ready-description":
    "Un recurso debe estar verificado y escaneado como limpio antes de poder publicarse.",
  "api/marketing/asset/publication-not-found": "Publicación no encontrada",
  "api/marketing/asset/publication-not-found-description":
    "Esta publicación no existe para tu empresa.",
  "api/marketing/asset/publication-required": "Elige una publicación",
  "api/marketing/asset/publication-required-description":
    "Se requiere una publicación para continuar.",
  "api/marketing/asset/upload-id-required": "No se pudo encontrar la carga",
  "api/marketing/asset/upload-id-required-description":
    "Inicia una nueva carga e inténtalo de nuevo.",
  "api/marketing/asset/upload-not-found":
    "No se pudo encontrar el archivo cargado",
  "api/marketing/asset/upload-not-found-description":
    "La carga pudo haber expirado. Inicia una nueva carga e inténtalo de nuevo.",
  "api/marketing/asset/version-not-found": "Versión de recurso no encontrada",
  "api/marketing/asset/version-not-found-description":
    "Esta versión de recurso no existe para tu empresa.",
  "api/marketing/audience/audience-not-ready":
    "Esta categoría aún no se puede enviar: su elegibilidad operativa no está disponible.",
  "api/marketing/audience/audience-not-ready-description":
    "Esta categoría aún no se puede enviar: su elegibilidad operativa no está disponible.",
  "api/marketing/audience/candidate-limit-exceeded":
    "La audiencia supera el límite permitido. Reduce su selección.",
  "api/marketing/audience/candidate-limit-exceeded-description":
    "La audiencia supera el límite permitido. Reduce su selección.",
  "api/marketing/audience/invalid-definition":
    "Revisa los campos, operadores y valores de la audiencia.",
  "api/marketing/audience/invalid-definition-description":
    "Revisa los campos, operadores y valores de la audiencia.",
  "api/marketing/audience/not-found":
    "No se encontró la audiencia en esta empresa.",
  "api/marketing/audience/not-found-description":
    "No se encontró la audiencia en esta empresa.",
  "api/marketing/audience/source-access-denied":
    "No tienes permiso para usar uno o más campos del origen de esta audiencia.",
  "api/marketing/audience/source-access-denied-description":
    "No tienes permiso para usar uno o más campos del origen de esta audiencia.",
  "api/marketing/audience/source-unavailable":
    "El origen de la audiencia no está disponible o cambió. Revisa su configuración.",
  "api/marketing/audience/source-unavailable-description":
    "El origen de la audiencia no está disponible o cambió. Revisa su configuración.",
  "api/marketing/audit-event-immutable":
    "Los eventos de auditoría no se pueden modificar",
  "api/marketing/audit-event-immutable-description":
    "El historial de auditoría es permanente.",
  "api/marketing/brand-profile/invalid-name":
    "Ingresa un nombre de perfil de marca",
  "api/marketing/brand-profile/invalid-name-description":
    "El nombre del perfil de marca no puede estar vacío.",
  "api/marketing/bulk-update-not-allowed": "No se permiten cambios masivos",
  "api/marketing/bulk-update-not-allowed-description":
    "Actualiza cada registro con su revisión actual.",
  "api/marketing/campaign-approval-immutable":
    "Una decisión de aprobación no se puede modificar",
  "api/marketing/campaign-approval-immutable-description":
    "Las decisiones de aprobación son registros permanentes.",
  "api/marketing/campaign-approval/invalid-decision":
    "La decisión de aprobación no es válida",
  "api/marketing/campaign-approval/invalid-decision-description":
    "La decisión debe ser aprobada o rechazada.",
  "api/marketing/campaign-approval/invalid-revision-hash":
    "El hash de la revisión aprobada no es válido",
  "api/marketing/campaign-approval/invalid-revision-hash-description":
    "El hash debe ser un resumen hexadecimal de 64 caracteres en minúsculas.",
  "api/marketing/campaign-revision-immutable":
    "Una revisión preparada no se puede modificar",
  "api/marketing/campaign-revision-immutable-description":
    "Prepara una nueva revisión en lugar de editar una anterior.",
  "api/marketing/campaign-revision/invalid-audience-selection":
    "La selección de audiencia no es válida",
  "api/marketing/campaign-revision/invalid-audience-selection-description":
    "La selección de audiencia debe ser un objeto con ids de listas, grupos y audiencias.",
  "api/marketing/campaign-revision/invalid-excluded-contacts":
    "Los contactos excluidos no son válidos",
  "api/marketing/campaign-revision/invalid-excluded-contacts-description":
    "Los contactos excluidos deben ser una lista de ids de contacto.",
  "api/marketing/campaign-revision/invalid-readiness-state":
    "El estado de preparación de la revisión no es válido",
  "api/marketing/campaign-revision/invalid-readiness-state-description":
    "Usa pendiente, lista o inválida.",
  "api/marketing/campaign-revision/invalid-revision-hash":
    "El hash de la revisión no es válido",
  "api/marketing/campaign-revision/invalid-revision-hash-description":
    "El hash debe ser un resumen hexadecimal de 64 caracteres en minúsculas.",
  "api/marketing/campaign-revision/invalid-revision-number":
    "El número de revisión no es válido",
  "api/marketing/campaign-revision/invalid-revision-number-description":
    "Los números de revisión empiezan en 1.",
  "api/marketing/campaign-write-forbidden":
    "Los registros de campaña solo cambian mediante comandos de campaña",
  "api/marketing/campaign-write-forbidden-description":
    "Usa las acciones de campaña en lugar de editar los registros directamente.",
  "api/marketing/campaign/campaign-locked":
    "Esta campaña ya no se puede editar",
  "api/marketing/campaign/campaign-locked-description":
    "Ya se programó un envío. Duplica la campaña para cambiar su contenido.",
  "api/marketing/campaign/conflict":
    "Otro cambio en esta campaña se guardó primero",
  "api/marketing/campaign/conflict-description":
    "Recarga la campaña e inténtalo de nuevo.",
  "api/marketing/campaign/decision-conflict":
    "Ya se registró una decisión distinta",
  "api/marketing/campaign/decision-conflict-description":
    "Prepara una nueva revisión para cambiar el resultado.",
  "api/marketing/campaign/invalid-input": "Revisa los datos de la campaña",
  "api/marketing/campaign/invalid-input-description":
    "Revisa los campos e inténtalo de nuevo.",
  "api/marketing/campaign/invalid-name": "La campaña necesita un nombre",
  "api/marketing/campaign/invalid-name-description":
    "Escribe un nombre para la campaña.",
  "api/marketing/campaign/invalid-state":
    "El estado de la campaña no es válido",
  "api/marketing/campaign/invalid-state-description":
    "Usa uno de los estados de campaña admitidos.",
  "api/marketing/campaign/not-found": "No se encontró la campaña",
  "api/marketing/campaign/not-found-description":
    "Es posible que se haya eliminado o que pertenezca a otra empresa.",
  "api/marketing/campaign/reference-denied":
    "No puedes usar un elemento seleccionado",
  "api/marketing/campaign/reference-denied-description":
    "Tu rol no permite leer uno de los elementos seleccionados.",
  "api/marketing/campaign/reference-not-found":
    "No se encontró un elemento seleccionado",
  "api/marketing/campaign/reference-not-found-description":
    "La versión de plantilla, categoría, remitente, lista, grupo, audiencia o contacto no existe en esta empresa.",
  "api/marketing/campaign/revision-not-current":
    "Esta no es la revisión vigente",
  "api/marketing/campaign/revision-not-current-description":
    "Solo la última revisión preparada se puede aprobar o rechazar.",
  "api/marketing/campaign/revision-not-found":
    "No se encontró la revisión de la campaña",
  "api/marketing/campaign/revision-not-found-description":
    "Es posible que pertenezca a otra campaña o empresa.",
  "api/marketing/campaign/revision-not-ready": "La revisión no está lista",
  "api/marketing/campaign/revision-not-ready-description":
    "Corrige los problemas pendientes y prepara una nueva revisión antes de aprobar.",
  "api/marketing/campaign/stale-revision":
    "La campaña cambió desde que la abriste",
  "api/marketing/campaign/stale-revision-description":
    "Recarga la campaña y vuelve a aplicar tus cambios.",
  "api/marketing/campaign/state-conflict":
    "La campaña no está en un estado que permita esta acción",
  "api/marketing/campaign/state-conflict-description":
    "Recarga la campaña para ver su estado actual.",
  "api/marketing/capability-denied":
    "No tienes permiso para realizar esta acción.",
  "api/marketing/capability-denied-description":
    "Marketing debe estar habilitado y tu rol actual debe permitir esta acción.",
  "api/marketing/category/invalid-description": "La descripción es inválida",
  "api/marketing/category/invalid-description-description":
    "Proporciona una descripción en inglés y español, o déjala vacía.",
  "api/marketing/category/invalid-label":
    "Se requiere una etiqueta en ambos idiomas",
  "api/marketing/category/invalid-label-description":
    "Ingresa etiquetas en inglés y español que no estén vacías.",
  "api/marketing/category/not-found": "Categoría no encontrada",
  "api/marketing/category/not-found-description":
    "La categoría solicitada no existe para esta empresa.",
  "api/marketing/company-id-immutable": "No se puede cambiar la empresa",
  "api/marketing/company-id-immutable-description":
    "Crea un registro separado para la otra empresa.",
  "api/marketing/contact/delete-not-allowed": "Los contactos deben archivarse",
  "api/marketing/contact/delete-not-allowed-description":
    "Archiva este contacto para conservar el historial de la dirección y sus preferencias.",
  "api/marketing/contact/invalid-email": "Dirección de correo no válida",
  "api/marketing/contact/invalid-email-description":
    "Ingresa una dirección de correo válida sin nombre para mostrar.",
  "api/marketing/contact/invalid-input":
    "Revisa el correo, el nombre y el idioma del contacto.",
  "api/marketing/contact/invalid-input-description":
    "Revisa el correo, el nombre y el idioma del contacto.",
  "api/marketing/contact/not-found": "Contacto no encontrado",
  "api/marketing/contact/not-found-description":
    "Este contacto no está disponible en la empresa seleccionada.",
  "api/marketing/contacts/candidate-limit-exceeded":
    "Se alcanzó el límite de consulta de contactos",
  "api/marketing/contacts/candidate-limit-exceeded-description":
    "Este directorio supera el límite de consulta permitido.",
  "api/marketing/contacts/display-name-entity-owned":
    "El nombre lo administra el registro vinculado",
  "api/marketing/contacts/display-name-entity-owned-description":
    "Este contacto está vinculado a un registro del directorio; su nombre no se puede editar aquí.",
  "api/marketing/contacts/forbidden": "Acceso al contacto denegado",
  "api/marketing/contacts/forbidden-description":
    "No tienes acceso a esta operación de contactos o a los campos necesarios.",
  "api/marketing/contacts/invalid-filter": "Filtro de contactos no válido",
  "api/marketing/contacts/invalid-filter-description":
    "Usa uno de: all, entity-linked, mailing-only, unsubscribed, suppressed.",
  "api/marketing/contacts/invalid-input": "Solicitud de contactos no válida",
  "api/marketing/contacts/invalid-input-description":
    "Usa un desplazamiento no negativo, un tamaño de página entre 1 y 100 y solo los parámetros de consulta permitidos.",
  "api/marketing/contacts/invalid-page": "Página no válida",
  "api/marketing/contacts/invalid-page-description":
    "Usa un desplazamiento no negativo y un tamaño de página entre 1 y 100.",
  "api/marketing/contacts/not-found": "Contacto no encontrado",
  "api/marketing/contacts/not-found-description":
    "El contacto solicitado no está disponible en esta empresa.",
  "api/marketing/context-invalid": "Contexto de Marketing inválido",
  "api/marketing/context-invalid-description":
    "Tu sesión debe pertenecer a la empresa seleccionada.",
  "api/marketing/cross-company-target": "La empresa no coincide",
  "api/marketing/cross-company-target-description":
    "Selecciona registros que pertenezcan a la misma empresa.",
  "api/marketing/delivery-attempt-invalid-transition":
    "El intento de entrega no puede pasar a ese estado",
  "api/marketing/delivery-attempt-invalid-transition-description":
    "Solo se permiten las transiciones de entrega documentadas.",
  "api/marketing/delivery-attempt/invalid-field":
    "Un valor del intento de entrega no es válido",
  "api/marketing/delivery-attempt/invalid-field-description":
    "Revisa los valores del intento de entrega e inténtalo de nuevo.",
  "api/marketing/derived-membership-service-only": "La membresía se sincroniza",
  "api/marketing/derived-membership-service-only-description":
    "Edita la relación de origen para cambiar la membresía derivada.",
  "api/marketing/dispatch-command/already-scheduled":
    "Esta campaña ya tiene un envío programado",
  "api/marketing/dispatch-command/already-scheduled-description":
    "Una campaña solo se puede enviar una vez.",
  "api/marketing/dispatch-command/ambiguous-local-time":
    "Esa hora local ocurre dos veces en la zona horaria elegida",
  "api/marketing/dispatch-command/ambiguous-local-time-description":
    "Envía el desfase UTC que corresponde.",
  "api/marketing/dispatch-command/dispatch-held": "El envío está retenido",
  "api/marketing/dispatch-command/dispatch-held-description":
    "Resuelve la retención antes de reanudar.",
  "api/marketing/dispatch-command/dispatch-not-found":
    "No se encontró el envío",
  "api/marketing/dispatch-command/dispatch-not-found-description":
    "Puede pertenecer a otra empresa o ya no existir.",
  "api/marketing/dispatch-command/dispatch-state-conflict":
    "El envío no está en un estado que permita esta acción",
  "api/marketing/dispatch-command/dispatch-state-conflict-description":
    "Recarga el envío para ver su estado actual.",
  "api/marketing/dispatch-command/idempotency-conflict":
    "Esa clave de idempotencia ya se usó en una solicitud distinta",
  "api/marketing/dispatch-command/idempotency-conflict-description":
    "Usa una clave nueva para una solicitud distinta.",
  "api/marketing/dispatch-command/idempotency-key-required":
    "El encabezado Idempotency-Key es obligatorio",
  "api/marketing/dispatch-command/idempotency-key-required-description":
    "Envía una clave única (letras, dígitos y . _ ~ : -) con esta solicitud.",
  "api/marketing/dispatch-command/invalid-dispatch-ids":
    "La lista de envíos no es válida",
  "api/marketing/dispatch-command/invalid-dispatch-ids-description":
    "Envía entre 1 y 100 identificadores de envío.",
  "api/marketing/dispatch-command/invalid-offset":
    "El desfase UTC no coincide con la hora elegida",
  "api/marketing/dispatch-command/invalid-offset-description":
    "Usa un desfase como -06:00 que aplique en esa hora.",
  "api/marketing/dispatch-command/invalid-scheduled-at":
    "La hora de envío no es válida",
  "api/marketing/dispatch-command/invalid-scheduled-at-description":
    "Usa una fecha y hora local como 2026-11-03T09:30.",
  "api/marketing/dispatch-command/invalid-time-zone":
    "La zona horaria no es válida",
  "api/marketing/dispatch-command/invalid-time-zone-description":
    "Usa una zona IANA como America/Mexico_City.",
  "api/marketing/dispatch-command/nonexistent-local-time":
    "Esa hora local no existe en la zona horaria elegida",
  "api/marketing/dispatch-command/nonexistent-local-time-description":
    "Los relojes se saltan esa hora. Elige otra hora.",
  "api/marketing/dispatch-command/not-ready":
    "Esta campaña aún no se puede enviar",
  "api/marketing/dispatch-command/not-ready-description":
    "Resuelve los problemas de preparación e inténtalo de nuevo.",
  "api/marketing/dispatch-command/schedule-in-past":
    "La hora de envío debe estar en el futuro",
  "api/marketing/dispatch-command/schedule-in-past-description":
    "Elige una hora posterior.",
  "api/marketing/dispatch-command/schedule-too-far":
    "La hora de envío está demasiado lejos",
  "api/marketing/dispatch-command/schedule-too-far-description":
    "Elige una hora dentro de los próximos 90 días.",
  "api/marketing/dispatch-command/still-draining":
    "El envío aún se está deteniendo",
  "api/marketing/dispatch-command/still-draining-description":
    "Espera a que esté en pausa y luego reanúdalo.",
  "api/marketing/dispatch-command/test-recipient-not-allowed":
    "Un destinatario de prueba no está en la lista permitida",
  "api/marketing/dispatch-command/test-recipient-not-allowed-description":
    "Agrega la dirección a los destinatarios de prueba en la política de marketing.",
  "api/marketing/dispatch-command/test-recipient-suppressed":
    "Un destinatario de prueba está suprimido",
  "api/marketing/dispatch-command/test-recipient-suppressed-description":
    "Elige otra dirección.",
  "api/marketing/dispatch-command/test-recipients-invalid":
    "Los destinatarios de prueba no son válidos",
  "api/marketing/dispatch-command/test-recipients-invalid-description":
    "Indica entre 1 y 5 correos electrónicos válidos.",
  "api/marketing/dispatch-command/version-conflict":
    "El envío cambió antes de aplicar esta acción",
  "api/marketing/dispatch-command/version-conflict-description":
    "Recarga el envío e inténtalo de nuevo.",
  "api/marketing/dispatch-field-immutable":
    "Este valor del envío no se puede modificar",
  "api/marketing/dispatch-field-immutable-description":
    "Programa un nuevo envío en lugar de editar un valor fijo.",
  "api/marketing/dispatch-run/invalid-field":
    "Un valor de la ejecución del envío no es válido",
  "api/marketing/dispatch-run/invalid-field-description":
    "Revisa los valores de la ejecución e inténtalo de nuevo.",
  "api/marketing/dispatch-state-write-forbidden":
    "El estado del envío no se puede escribir directamente",
  "api/marketing/dispatch-state-write-forbidden-description":
    "Usa un comando del envío para cambiar su estado.",
  "api/marketing/dispatch/illegal-transition":
    "El envío no puede pasar a ese estado",
  "api/marketing/dispatch/illegal-transition-description":
    "Recarga el envío y usa una acción disponible en su estado actual.",
  "api/marketing/dispatch/invalid-field": "Un valor del envío no es válido",
  "api/marketing/dispatch/invalid-field-description":
    "Revisa los valores del envío e inténtalo de nuevo.",
  "api/marketing/dispatch/invalid-input": "El cambio del envío no es válido",
  "api/marketing/dispatch/invalid-input-description":
    "Revisa los valores enviados e inténtalo de nuevo.",
  "api/marketing/dispatch/invalid-set":
    "Ese campo del envío no se puede modificar",
  "api/marketing/dispatch/invalid-set-description":
    "Solo se pueden actualizar los campos del flujo del envío.",
  "api/marketing/dispatch/run-dispatch-not-found": "No se encontró el envío",
  "api/marketing/dispatch/run-dispatch-not-found-description":
    "Verifica que el envío pertenezca a esta empresa.",
  "api/marketing/exclusion-actor-forbidden": "Actor de exclusión no válido",
  "api/marketing/exclusion-actor-forbidden-description":
    "La exclusión debe identificar al operador autenticado.",
  "api/marketing/exclusion-already-lifted":
    "Esta exclusión ya fue retirada. Actualiza la lista de miembros.",
  "api/marketing/exclusion-already-lifted-description":
    "Esta exclusión ya fue retirada. Actualiza la lista de miembros.",
  "api/marketing/exclusion-delete-not-allowed":
    "No se puede eliminar el historial de exclusiones",
  "api/marketing/exclusion-delete-not-allowed-description":
    "Retira la exclusión para permitir la membresía nuevamente y conservar su historial.",
  "api/marketing/exclusion-immutable":
    "No se puede cambiar la evidencia de exclusión",
  "api/marketing/exclusion-immutable-description":
    "Crea o retira una exclusión mediante las acciones autorizadas.",
  "api/marketing/exclusion-removal-forbidden":
    "No se puede retirar la exclusión",
  "api/marketing/exclusion-removal-forbidden-description":
    "Un operador autenticado debe retirar explícitamente una exclusión activa.",
  "api/marketing/group-not-found": "No se encontró el grupo en esta empresa.",
  "api/marketing/group-not-found-description":
    "No se encontró el grupo en esta empresa.",
  "api/marketing/import/cell-too-large":
    "Una celda del CSV supera el tamaño permitido.",
  "api/marketing/import/cell-too-large-description":
    "Una celda del CSV supera el tamaño permitido.",
  "api/marketing/import/commit-key-conflict":
    "Esta clave de importación ya está en uso. Abre la importación existente o inicia una nueva.",
  "api/marketing/import/commit-key-conflict-description":
    "Esta clave de importación ya está en uso. Abre la importación existente o inicia una nueva.",
  "api/marketing/import/company-scope":
    "La importación y sus filas deben pertenecer a la empresa seleccionada.",
  "api/marketing/import/company-scope-description":
    "La importación y sus filas deben pertenecer a la empresa seleccionada.",
  "api/marketing/import/file-too-large":
    "El CSV supera el tamaño de archivo permitido.",
  "api/marketing/import/file-too-large-description":
    "El CSV supera el tamaño de archivo permitido.",
  "api/marketing/import/forbidden":
    "No tienes permiso para importar contactos.",
  "api/marketing/import/forbidden-description":
    "No tienes permiso para importar contactos.",
  "api/marketing/import/import-in-progress":
    "Esta importación todavía se está procesando.",
  "api/marketing/import/import-in-progress-description":
    "Espera un momento e inténtalo de nuevo. La importación continúa donde se quedó.",
  "api/marketing/import/invalid-headers":
    "El CSV debe tener encabezados de columna válidos y únicos.",
  "api/marketing/import/invalid-headers-description":
    "El CSV debe tener encabezados de columna válidos y únicos.",
  "api/marketing/import/invalid-input":
    "Revisa los datos de la importación e inténtalo de nuevo.",
  "api/marketing/import/invalid-input-description":
    "Revisa los datos de la importación e inténtalo de nuevo.",
  "api/marketing/import/invalid-limits":
    "Los límites de importación deben estar dentro del rango permitido.",
  "api/marketing/import/invalid-limits-description":
    "Los límites de importación deben estar dentro del rango permitido.",
  "api/marketing/import/invalid-mapping":
    "Asigna una columna al correo y usa cada campo de destino una sola vez.",
  "api/marketing/import/invalid-mapping-description":
    "Asigna una columna al correo y usa cada campo de destino una sola vez.",
  "api/marketing/import/invalid-pagination":
    "La página de importación solicitada es inválida.",
  "api/marketing/import/invalid-pagination-description":
    "La página de importación solicitada es inválida.",
  "api/marketing/import/malformed-csv":
    "El CSV contiene comillas o separadores de fila inválidos.",
  "api/marketing/import/malformed-csv-description":
    "El CSV contiene comillas o separadores de fila inválidos.",
  "api/marketing/import/not-found":
    "No se encontró la importación en esta empresa.",
  "api/marketing/import/not-found-description":
    "No se encontró la importación en esta empresa.",
  "api/marketing/import/not-validated":
    "Corrige todos los errores de validación antes de confirmar la importación.",
  "api/marketing/import/not-validated-description":
    "Corrige todos los errores de validación antes de confirmar la importación.",
  "api/marketing/import/service-only":
    "Usa el flujo de importación para modificar este registro.",
  "api/marketing/import/service-only-description":
    "Usa el flujo de importación para modificar este registro.",
  "api/marketing/import/storage-unavailable":
    "El almacenamiento privado de importaciones no está disponible. Inténtalo más tarde o contacta a un administrador.",
  "api/marketing/import/storage-unavailable-description":
    "El almacenamiento privado de importaciones no está disponible. Inténtalo más tarde o contacta a un administrador.",
  "api/marketing/import/too-many-columns":
    "El CSV contiene más columnas de las permitidas.",
  "api/marketing/import/too-many-columns-description":
    "El CSV contiene más columnas de las permitidas.",
  "api/marketing/import/too-many-rows":
    "El CSV supera el número de filas permitido. Divídelo en importaciones más pequeñas.",
  "api/marketing/import/too-many-rows-description":
    "El CSV supera el número de filas permitido. Divídelo en importaciones más pequeñas.",
  "api/marketing/import/unsupported-encoding":
    "Guarda el CSV con codificación UTF-8 e inténtalo de nuevo.",
  "api/marketing/import/unsupported-encoding-description":
    "Guarda el CSV con codificación UTF-8 e inténtalo de nuevo.",
  "api/marketing/import/wrong-column-count":
    "Una fila del CSV tiene un número de columnas distinto al encabezado.",
  "api/marketing/import/wrong-column-count-description":
    "Una fila del CSV tiene un número de columnas distinto al encabezado.",
  "api/marketing/invalid-membership-selection":
    "Selecciona listas y grupos válidos de la empresa actual.",
  "api/marketing/invalid-membership-selection-description":
    "Selecciona listas y grupos válidos de la empresa actual.",
  "api/marketing/lists/candidate-limit-exceeded":
    "Se alcanzó el límite de consulta",
  "api/marketing/lists/candidate-limit-exceeded-description":
    "Este directorio supera el límite de consulta permitido.",
  "api/marketing/lists/consistent-snapshot-required":
    "Se requiere una lectura consistente",
  "api/marketing/lists/consistent-snapshot-required-description":
    "Reintenta esta operación con una nueva lectura consistente.",
  "api/marketing/lists/contact-not-found": "Contacto no encontrado",
  "api/marketing/lists/contact-not-found-description":
    "Un contacto seleccionado no está disponible en esta empresa.",
  "api/marketing/lists/forbidden": "Acceso a la lista denegado",
  "api/marketing/lists/forbidden-description":
    "No tienes acceso a esta operación de listas o a los campos necesarios.",
  "api/marketing/lists/invalid-input": "Datos de lista no válidos",
  "api/marketing/lists/invalid-input-description":
    "Proporciona un nombre de lista y una descripción de texto opcional sin campos adicionales.",
  "api/marketing/lists/invalid-members": "Miembros no válidos",
  "api/marketing/lists/invalid-members-description":
    "Selecciona entre 1 y 100 contactos.",
  "api/marketing/lists/invalid-page": "Página no válida",
  "api/marketing/lists/invalid-page-description":
    "Usa un desplazamiento no negativo y un tamaño de página entre 1 y 100.",
  "api/marketing/lists/invalid-search": "Se requiere un término de búsqueda",
  "api/marketing/lists/invalid-search-description":
    "Ingresa un nombre de contacto o correo electrónico para buscar.",
  "api/marketing/lists/not-found": "Lista no encontrada",
  "api/marketing/lists/not-found-description":
    "La lista solicitada no está disponible en esta empresa.",
  "api/marketing/lists/read-committed-required":
    "Transacción de escritura no disponible",
  "api/marketing/lists/read-committed-required-description":
    "Reintenta este cambio en una nueva transacción de lectura confirmada.",
  "api/marketing/membership-immutable":
    "No se puede cambiar la identidad de la membresía",
  "api/marketing/membership-immutable-description":
    "Retira la membresía y crea la que necesitas.",
  "api/marketing/membership-limit-exceeded":
    "La selección supera el límite de destinatarios. Reduce la selección.",
  "api/marketing/membership-limit-exceeded-description":
    "La selección supera el límite de destinatarios. Reduce la selección.",
  "api/marketing/module-disabled":
    "Este módulo no está habilitado para tu empresa.",
  "api/marketing/outbox-invalid-transition":
    "La entrada de la bandeja de salida no puede pasar a ese estado",
  "api/marketing/outbox-invalid-transition-description":
    "Solo se permiten las transiciones documentadas de la bandeja.",
  "api/marketing/outbox-not-found":
    "El envío no tiene entrada en la bandeja de salida",
  "api/marketing/outbox-not-found-description":
    "Programa el envío antes de reanudarlo.",
  "api/marketing/outbox/invalid-field":
    "Un valor de la bandeja de salida no es válido",
  "api/marketing/outbox/invalid-field-description":
    "Revisa los valores de la bandeja de salida e inténtalo de nuevo.",
  "api/marketing/policy/invalid-first-batch-size":
    "El tamaño del primer lote es inválido",
  "api/marketing/policy/invalid-first-batch-size-description":
    "Ingresa un número entero positivo dentro del límite de destinatarios de la campaña.",
  "api/marketing/policy/invalid-limit": "El límite configurado es inválido",
  "api/marketing/policy/invalid-limit-description":
    "Usa un número entero positivo dentro del límite admitido.",
  "api/marketing/policy/invalid-observation-hold":
    "La pausa de observación es inválida",
  "api/marketing/policy/invalid-observation-hold-description":
    "Ingresa cero o un número entero positivo de minutos.",
  "api/marketing/policy/invalid-test-recipients":
    "La lista de destinatarios de prueba es inválida",
  "api/marketing/policy/invalid-test-recipients-description":
    "Ingresa correos válidos de destinatarios de prueba aprobados.",
  "api/marketing/policy/test-recipient-limit-exceeded":
    "Demasiados destinatarios de prueba",
  "api/marketing/policy/test-recipient-limit-exceeded-description":
    "Reduce la lista al límite configurado de destinatarios de prueba.",
  "api/marketing/preference-token/category-not-optional":
    "No es posible cancelar la suscripción a esta categoría",
  "api/marketing/preference-token/category-not-optional-description":
    "Un token de un clic solo puede emitirse para una categoría que permita cancelar la suscripción.",
  "api/marketing/preference-token/immutable-field":
    "Este token no se puede modificar",
  "api/marketing/preference-token/immutable-field-description":
    "Revoca y reemite el token en lugar de modificar el registro existente.",
  "api/marketing/preference-token/missing-category":
    "Se requiere una categoría para este token",
  "api/marketing/preference-token/missing-category-description":
    "Un token de un clic debe estar limitado a una sola categoría.",
  "api/marketing/preference-token/missing-requested-changes":
    "No se proporcionaron cambios solicitados",
  "api/marketing/preference-token/missing-requested-changes-description":
    "Un token de confirmación de suscripción necesita al menos una categoría solicitada.",
  "api/marketing/preference-token/no-company-url":
    "Esta empresa no tiene un host de marca configurado",
  "api/marketing/preference-token/no-company-url-description":
    "Se requiere un registro de URL a nivel empresa antes de poder emitir un enlace de preferencias.",
  "api/marketing/preference-token/no-instance":
    "No se pudo determinar la instancia de este enlace",
  "api/marketing/preference-token/no-instance-description":
    "Emite el token dentro de un contexto ligado a una instancia.",
  "api/marketing/preferences/category-not-optional":
    "No se puede cambiar la preferencia de la categoría",
  "api/marketing/preferences/category-not-optional-description":
    "Selecciona una categoría opcional activa y envía cada categoría una sola vez.",
  "api/marketing/preferences/invalid-input":
    "Cambios de preferencias inválidos",
  "api/marketing/preferences/invalid-input-description":
    "Proporciona cambios de preferencias válidos y la revisión actual.",
  "api/marketing/preferences/invalid-token": "Este enlace ya no es válido",
  "api/marketing/preferences/invalid-token-description":
    "El enlace pudo haber caducado o ya haberse usado. Solicita uno nuevo desde un correo reciente.",
  "api/marketing/preferences/unavailable":
    "Las preferencias no están disponibles por el momento",
  "api/marketing/preferences/unavailable-description":
    "Inténtalo de nuevo más tarde.",
  "api/marketing/provider-binding/adapter-key-required":
    "Se requiere un adaptador de proveedor",
  "api/marketing/provider-binding/adapter-key-required-description":
    "Selecciona el adaptador de proveedor configurado.",
  "api/marketing/provider-binding/invalid-rate-ceiling":
    "El límite de envío del proveedor es inválido",
  "api/marketing/provider-binding/invalid-rate-ceiling-description":
    "Ingresa una tasa positiva o deja vacío el ajuste.",
  "api/marketing/readiness/audience-empty":
    "La campaña no tiene una audiencia seleccionada.",
  "api/marketing/readiness/authority-revoked":
    "La persona que programó este envío ya no tiene permiso para enviar campañas.",
  "api/marketing/readiness/binding-not-ready":
    "La conexión del remitente no está lista para enviar.",
  "api/marketing/readiness/category-disabled":
    "La categoría de la campaña está deshabilitada o ya no existe.",
  "api/marketing/readiness/dispatch-not-found":
    "El envío no se encontró en esta empresa.",
  "api/marketing/readiness/hold-active":
    "Una retención activa está bloqueando este envío.",
  "api/marketing/readiness/launch-readiness-failed":
    "Una verificación de preparación para envío está fallando. Revisa la configuración de entregabilidad.",
  "api/marketing/readiness/missed-window":
    "La hora programada pasó hace más de 30 minutos, por lo que el envío no se inició.",
  "api/marketing/readiness/module-disabled":
    "Marketing no está habilitado para esta empresa.",
  "api/marketing/readiness/operational-eligibility-missing":
    "Esta categoría operativa no tiene una fuente de elegibilidad configurada, por lo que no se puede enviar.",
  "api/marketing/readiness/prefetched-input-missing":
    "No se pudo completar una verificación de estado necesaria. Inténtalo de nuevo en unos momentos.",
  "api/marketing/readiness/provider-sending-paused":
    "La cuenta del proveedor de correo no puede enviar por el momento.",
  "api/marketing/readiness/revision-drifted":
    "Algo con lo que se aprobó esta revisión cambió (categoría, definición de audiencia, remitente, perfil de marca o plantilla). Prepara una nueva revisión y apruébala de nuevo.",
  "api/marketing/readiness/revision-not-approved":
    "La revisión de la campaña no está aprobada. Aprueba esta revisión exacta antes de enviar.",
  "api/marketing/readiness/revision-not-current":
    "Esta no es la revisión vigente de la campaña.",
  "api/marketing/readiness/revision-not-found":
    "La revisión de la campaña no se encontró en esta empresa.",
  "api/marketing/readiness/revision-not-ready":
    "La revisión de la campaña no está lista para enviarse. Corrige primero sus errores de validación.",
  "api/marketing/readiness/sender-not-ready":
    "El remitente o su conexión con el proveedor no está listo para enviar.",
  "api/marketing/readiness/subject-not-static":
    "El asunto no puede contener marcadores de personalización.",
  "api/marketing/readiness/template-version-missing":
    "La versión de plantilla de esta campaña ya no está disponible.",
  "api/marketing/recipient-invalid-transition":
    "El destinatario no puede pasar a ese estado",
  "api/marketing/recipient-invalid-transition-description":
    "Solo se permiten las transiciones de entrega documentadas.",
  "api/marketing/recipient/invalid-field":
    "Un valor del destinatario no es válido",
  "api/marketing/recipient/invalid-field-description":
    "Revisa los valores del destinatario e inténtalo de nuevo.",
  "api/marketing/resources/bootstrap-version-not-downloadable":
    "Este recurso no se puede descargar ni volver a publicar",
  "api/marketing/resources/bootstrap-version-not-downloadable-description":
    "Esta versión hace referencia a una imagen ya publicada y no tiene un original privado para descargar o volver a publicar.",
  "api/marketing/resources/bootstrap-version-not-publishable":
    "Este recurso no se puede volver a publicar",
  "api/marketing/resources/bootstrap-version-not-publishable-description":
    "Esta versión hace referencia a una imagen ya publicada y no tiene un original privado para publicar. Ya cuenta con su propia publicación desde el paso de registro inicial.",
  "api/marketing/revision-conflict": "Este registro ha cambiado",
  "api/marketing/revision-conflict-description":
    "Recarga la versión más reciente antes de guardar tus cambios.",
  "api/marketing/sender/binding-required":
    "Selecciona una vinculación de proveedor",
  "api/marketing/sender/binding-required-description":
    "Un remitente institucional debe estar vinculado a una vinculación de proveedor.",
  "api/marketing/sender/invalid-display-name": "Ingresa un nombre visible",
  "api/marketing/sender/invalid-display-name-description":
    "El nombre institucional mostrado a los destinatarios no puede estar vacío.",
  "api/marketing/sender/invalid-from-email":
    "Ingresa una dirección de remitente válida",
  "api/marketing/sender/invalid-from-email-description":
    "La dirección de remitente debe ser un correo institucional válido.",
  "api/marketing/sender/invalid-reply-to":
    "Ingresa una dirección de respuesta válida",
  "api/marketing/sender/invalid-reply-to-description":
    "La dirección de respuesta debe ser un correo institucional válido.",
  "api/marketing/sender/invalid-verification-state":
    "Resultado de verificación inválido",
  "api/marketing/sender/invalid-verification-state-description":
    "El resultado de verificación debe ser un estado de disposición reconocido.",
  "api/marketing/sender/not-send-ready":
    "Este remitente no está listo para enviar",
  "api/marketing/sender/not-send-ready-description":
    "Solo un remitente verificado y habilitado puede convertirse en el predeterminado de la empresa.",
  "api/marketing/service-write-required": "Usa la acción disponible",
  "api/marketing/service-write-required-description":
    "Este registro solo se puede cambiar mediante su acción específica.",
  "api/marketing/source-binding/invalid-allowed-fields":
    "La configuración de campos del origen es inválida.",
  "api/marketing/source-binding/invalid-allowed-fields-description":
    "La configuración de campos del origen es inválida.",
  "api/marketing/template-version-immutable":
    "Una versión guardada no se puede modificar",
  "api/marketing/template-version-immutable-description":
    "Guarda una nueva versión en lugar de editar una anterior.",
  "api/marketing/template/category-missing":
    "Esta plantilla no tiene una categoría de comunicación",
  "api/marketing/template/category-missing-description":
    "Asigna una categoría de comunicación antes de previsualizar o enviar esta plantilla.",
  "api/marketing/template/fallback-references-variable":
    "Un valor de respaldo no puede hacer referencia a otra variable",
  "api/marketing/template/fallback-references-variable-description":
    "Usa un valor de respaldo simple en lugar de un token de personalización.",
  "api/marketing/template/header-injection":
    "El asunto y el preencabezado no pueden contener saltos de línea",
  "api/marketing/template/header-injection-description":
    "Elimina los saltos de línea del asunto o el preencabezado.",
  "api/marketing/template/invalid-category":
    "Categoría de comunicación inválida",
  "api/marketing/template/invalid-category-description":
    "Elige una categoría de comunicación que pertenezca a tu empresa.",
  "api/marketing/template/invalid-current-version": "Versión actual inválida",
  "api/marketing/template/invalid-current-version-description":
    "La versión seleccionada debe pertenecer a esta misma plantilla.",
  "api/marketing/template/invalid-input":
    "Algunos campos faltan o son inválidos",
  "api/marketing/template/invalid-input-description":
    "Revisa el asunto, el código HTML y las variables de personalización.",
  "api/marketing/template/invalid-name":
    "Se requiere un nombre para la plantilla",
  "api/marketing/template/invalid-name-description":
    "Escribe un nombre para identificar esta plantilla.",
  "api/marketing/template/invalid-subject": "Se requiere una línea de asunto",
  "api/marketing/template/invalid-subject-description":
    "Escribe el asunto que verán los destinatarios.",
  "api/marketing/template/invalid-version-number": "Número de versión inválido",
  "api/marketing/template/invalid-version-number-description":
    "Los números de versión se asignan automáticamente; no los establezcas manualmente.",
  "api/marketing/template/missing-contact":
    "Se requiere un destinatario para una representación de producción",
  "api/marketing/template/missing-contact-description":
    "Los modos de vista previa o envío de prueba no requieren un destinatario real.",
  "api/marketing/template/not-found": "Plantilla no encontrada",
  "api/marketing/template/not-found-description":
    "Esta plantilla no existe o no tienes acceso a ella.",
  "api/marketing/template/oversized-source":
    "Este contenido es demasiado grande o está anidado en exceso",
  "api/marketing/template/oversized-source-description":
    "Reduce el tamaño del HTML o simplifica su anidación antes de guardar esta versión.",
  "api/marketing/template/placeholder-not-allowed-here":
    "Esta variable no se puede usar aquí",
  "api/marketing/template/placeholder-not-allowed-here-description":
    "Las variables solo se permiten dentro de texto simple o como el valor completo de un atributo de enlace (href).",
  "api/marketing/template/preference-token-pending-integration":
    "El envío aún no está disponible",
  "api/marketing/template/preference-token-pending-integration-description":
    "La emisión de tokens de preferencias aún no está disponible en este entorno.",
  "api/marketing/template/reserved-variable-name":
    "Este nombre de variable está reservado",
  "api/marketing/template/reserved-variable-name-description":
    'Los nombres que comienzan con "system." están reservados para el pie de página y el bloque de identidad de la plataforma.',
  "api/marketing/template/version-not-found":
    "Versión de plantilla no encontrada",
  "api/marketing/template/version-not-found-description":
    "Esta versión no existe o no tienes acceso a ella.",
  "api/marketing/unauthenticated": "Inicio de sesión requerido",
  "api/marketing/unauthenticated-description":
    "Marketing no está disponible para solicitudes sin autenticar.",
  "api/models/Address/company-not-found": "Compañía no encontrada",
  "api/models/Address/company-not-found-description": "Compañía no encontrada",
  "api/models/Address/coordinates-invalid": "Coordenadas inválidas",
  "api/models/Address/coordinates-invalid-description":
    "La latitud y la longitud no son válidas.",
  "api/models/Address/country-not-enabled": "País no habilitado",
  "api/models/Address/country-not-enabled-description":
    "Las direcciones no están habilitadas para el país {{country}}.",
  "api/models/Address/country-profile-missing": "Perfil de país faltante",
  "api/models/Address/country-profile-missing-description":
    "No existe un perfil de dirección para el país {{country}}.",
  "api/models/Address/country-required": "País requerido",
  "api/models/Address/country-required-description":
    "La dirección necesita un país.",
  "api/models/Address/entity-id-is-required":
    "Es necesario el Id de la entidad",
  "api/models/Address/entity-id-is-required-description":
    "Es necesario el Id de la entidad",
  "api/models/Address/entity-not-found": "Entidad no encontrada",
  "api/models/Address/entity-not-found-description": "Entidad no encontrada",
  "api/models/Address/geo-attempt-server-only":
    "El calendario de geocodificación lo administra el servidor",
  "api/models/Address/geo-attempt-server-only-description":
    "La fecha del intento de geocodificación no puede establecerse desde una solicitud.",
  "api/models/Address/geo-entry-not-found": "Lugar no encontrado",
  "api/models/Address/geo-entry-not-found-description":
    "El lugar seleccionado no está en el catálogo geográfico.",
  "api/models/Address/geo-source-invalid": "Fuente geográfica inválida",
  "api/models/Address/geo-source-invalid-description":
    "La fuente geográfica {{source}} no es válida.",
  "api/models/Address/geo-source-server-only":
    "Fuente geográfica administrada por el servidor",
  "api/models/Address/geo-source-server-only-description":
    "Solo el servicio de geocodificación puede marcar una dirección como geocodificada.",
  "api/models/Address/geocode-query-invalid": "Texto de búsqueda inválido",
  "api/models/Address/geocode-query-invalid-description":
    "Escribe entre 1 y 200 caracteres para buscar una dirección.",
  "api/models/Address/geocode-unavailable":
    "Búsqueda de direcciones no disponible",
  "api/models/Address/geocode-unavailable-description":
    "No se pudo completar la búsqueda de direcciones. Inténtalo más tarde.",
  "api/models/Address/geocoding-disabled":
    "Búsqueda de direcciones no disponible",
  "api/models/Address/geocoding-disabled-description":
    "La búsqueda de direcciones no está habilitada en esta plataforma.",
  "api/models/Address/not-configured": "Direcciones no configuradas",
  "api/models/Address/not-configured-description":
    "La configuración de direcciones no se ha definido para esta compañía.",
  "api/models/Address/owner-company-unresolved": "Compañía no determinada",
  "api/models/Address/owner-company-unresolved-description":
    "No se pudo determinar la compañía del registro propietario.",
  "api/models/Address/owner-id-required": "Propietario requerido",
  "api/models/Address/owner-id-required-description":
    "Una dirección debe pertenecer a un registro.",
  "api/models/Address/owner-immutable": "El propietario no puede cambiar",
  "api/models/Address/owner-immutable-description":
    "El propietario de una dirección no puede cambiarse.",
  "api/models/Address/owner-model-not-allowed": "Propietario no permitido",
  "api/models/Address/owner-model-not-allowed-description":
    "Este tipo de registro no puede tener direcciones.",
  "api/models/Address/owner-not-found": "Propietario no encontrado",
  "api/models/Address/owner-not-found-description":
    "No se encontró el registro propietario de esta dirección.",
  "api/models/Address/postal-code-invalid": "Código postal inválido",
  "api/models/Address/postal-code-invalid-description":
    "El valor de {{component}} no es un código postal válido.",
  "api/models/Address/purpose-unknown": "Propósito desconocido",
  "api/models/Address/purpose-unknown-description":
    "No se reconoce el propósito de dirección {{purpose}}.",
  "api/models/Address/required-missing": "Dirección incompleta",
  "api/models/Address/required-missing-description":
    "Faltan campos obligatorios de la dirección: {{components}}.",
  "api/models/Address/settings-invalid":
    "Configuración de direcciones inválida",
  "api/models/Address/settings-invalid-description":
    "La configuración de direcciones tiene un formato inválido.",
  "api/models/Address/value-too-long": "Valor demasiado largo",
  "api/models/Address/value-too-long-description":
    "El valor de {{component}} es demasiado largo.",
  "api/models/AddressCountryProfile/invalid-shape": "Perfil de país inválido",
  "api/models/AddressCountryProfile/invalid-shape-description":
    "El campo {{field}} del perfil de dirección del país es inválido: {{problem}}.",
  "api/models/AddressCountryProfile/write-forbidden":
    "Los perfiles de dirección por país solo cambian mediante migración",
  "api/models/AddressCountryProfile/write-forbidden-description":
    "Estos registros no se pueden crear, editar ni eliminar mediante la API.",
  "api/models/AgentKey/assignments-outside-validity":
    "La clave tiene asignaciones fuera de la nueva vigencia",
  "api/models/AgentKey/assignments-outside-validity-description":
    "Cierra o acorta las {{count}} asignaciones de esta clave antes de reducir su vigencia",
  "api/models/AgentKey/code-already-exists": "La clave ya existe",
  "api/models/AgentKey/code-already-exists-description":
    "La aseguradora ya tiene la clave {{code}}",
  "api/models/AgentKey/code-is-required": "La clave de agente es obligatoria",
  "api/models/AgentKey/code-is-required-description":
    "Captura la clave tal como la emitió la aseguradora",
  "api/models/AgentKey/company-is-required": "La compañía es obligatoria",
  "api/models/AgentKey/company-is-required-description":
    "Una clave de agente necesita la compañía a la que pertenece",
  "api/models/AgentKey/company-mismatch": "Compañía no permitida",
  "api/models/AgentKey/company-mismatch-description":
    "Una clave de agente pertenece a la compañía en la que estás trabajando",
  "api/models/AgentKey/delete-not-allowed":
    "Las claves de agente no se eliminan",
  "api/models/AgentKey/delete-not-allowed-description":
    "Da de baja la clave: se conserva en el historial",
  "api/models/AgentKey/holder-not-canonical-agency":
    "Titular de la clave no válido",
  "api/models/AgentKey/holder-not-canonical-agency-description":
    "El titular debe ser la entidad legal de la agencia en esta compañía, no una de sus posiciones",
  "api/models/AgentKey/immutable-field": "El campo no se puede cambiar",
  "api/models/AgentKey/immutable-field-description":
    "La aseguradora y el titular de una clave no cambian; da de baja la clave y registra una nueva",
  "api/models/AgentKey/insurer-not-appointed":
    "La aseguradora no está designada",
  "api/models/AgentKey/insurer-not-appointed-description":
    "Solo se pueden registrar claves de agente de aseguradoras designadas",
  "api/models/AgentKey/key-has-assignments": "La clave tiene asignaciones",
  "api/models/AgentKey/key-has-assignments-description":
    "Da de baja la clave en lugar de eliminarla, para conservar su historial",
  "api/models/AgentKey/mutation-not-allowed": "Operación no permitida",
  "api/models/AgentKey/mutation-not-allowed-description":
    "Las claves de agente se modifican una a la vez",
  "api/models/AgentKey/retire-forbidden": "No puedes dar de baja esta clave",
  "api/models/AgentKey/retire-forbidden-description":
    "Solo un administrador de la compañía puede dar de baja una clave de agente",
  "api/models/AgentKey/validity-invalid": "Vigencia no válida",
  "api/models/AgentKey/validity-invalid-description":
    "La fecha de inicio es obligatoria y la fecha de fin no puede ser anterior",
  "api/models/AgentKeyAssignment/conflict":
    "La posición ya tiene una clave vigente",
  "api/models/AgentKeyAssignment/conflict-description":
    "{{node}} ya usa la clave {{code}} con esta aseguradora en ese periodo",
  "api/models/AgentKeyAssignment/immutable-field":
    "El campo no se puede cambiar",
  "api/models/AgentKeyAssignment/immutable-field-description":
    "Solo la vigencia de una asignación puede cambiar",
  "api/models/AgentKeyAssignment/key-not-found":
    "Clave de agente no encontrada",
  "api/models/AgentKeyAssignment/key-not-found-description":
    "La clave no existe en esta compañía",
  "api/models/AgentKeyAssignment/mutation-not-allowed":
    "Operación no permitida",
  "api/models/AgentKeyAssignment/mutation-not-allowed-description":
    "Las asignaciones se modifican una a la vez",
  "api/models/AgentKeyAssignment/node-not-holder-position":
    "Posición no válida",
  "api/models/AgentKeyAssignment/node-not-holder-position-description":
    "Una clave solo se asigna a su titular o a una de sus posiciones",
  "api/models/AgentKeyAssignment/outside-key-validity":
    "Fuera de la vigencia de la clave",
  "api/models/AgentKeyAssignment/outside-key-validity-description":
    "Una asignación debe estar dentro de la vigencia de su clave",
  "api/models/AgentKeyAssignment/validity-invalid": "Vigencia no válida",
  "api/models/AgentKeyAssignment/validity-invalid-description":
    "La fecha de inicio es obligatoria y la fecha de fin no puede ser anterior",
  "api/models/ApiToken/entity-not-found": "Entidad No Encontrada",
  "api/models/ApiToken/entity-not-found-description":
    "La entidad especificada no existe.",
  "api/models/ApiToken/entity-required": "Entidad Requerida",
  "api/models/ApiToken/entity-required-description":
    "Un token de API debe estar asociado con una entidad.",
  "api/models/ApiToken/token-fields-restricted":
    "Los campos del token solo cambian mediante las acciones del token.",
  "api/models/ApiToken/token-fields-restricted-description":
    "TokenVersion y EntityId solo pueden cambiar mediante generate-token o regenerate-token.",
  "api/models/ApiToken/token-secret-not-configured":
    "Error de Configuración de Token",
  "api/models/ApiToken/token-secret-not-configured-description":
    "El secreto de firma del token JWT no está configurado. Contacte a su administrador.",
  "api/models/ApiTokenRole/account-not-found": "Cuenta No Encontrada",
  "api/models/ApiTokenRole/account-not-found-description":
    "La cuenta especificada no existe.",
  "api/models/ApiTokenRole/agency-not-found": "Agencia No Encontrada",
  "api/models/ApiTokenRole/agency-not-found-description":
    "La agencia especificada no existe.",
  "api/models/ApiTokenRole/already-assigned": "Rol Ya Asignado",
  "api/models/ApiTokenRole/already-assigned-description":
    "Este rol ya está asignado al token de API.",
  "api/models/ApiTokenRole/company-not-found": "Compañía No Encontrada",
  "api/models/ApiTokenRole/company-not-found-description":
    "La compañía especificada no existe.",
  "api/models/ApiTokenRole/exceeds-parent-permissions":
    "Excede los Permisos del Padre",
  "api/models/ApiTokenRole/exceeds-parent-permissions-description":
    "El rol del token excede los permisos de la entidad padre. Un token no puede tener acceso mayor que su propietario.",
  "api/models/ApiTokenRole/multiple-scope-fks": "Alcance Inválido",
  "api/models/ApiTokenRole/multiple-scope-fks-description":
    "Solo se puede especificar uno de CompanyId, AccountId o AgencyId.",
  "api/models/ApiTokenRole/not-an-agency": "No es una Agencia",
  "api/models/ApiTokenRole/not-an-agency-description":
    "La entidad especificada no es una agencia.",
  "api/models/ApiTokenRole/role-not-active": "Rol No Activo",
  "api/models/ApiTokenRole/role-not-active-description":
    "El rol especificado no está activo.",
  "api/models/ApiTokenRole/role-not-found": "Rol No Encontrado",
  "api/models/ApiTokenRole/role-not-found-description":
    "El rol especificado no existe.",
  "api/models/ApiTokenRole/scope-mismatch": "Desajuste de Alcance",
  "api/models/ApiTokenRole/scope-mismatch-description":
    "La clave foránea de alcance no coincide con el tipo de alcance del rol.",
  "api/models/ApiTokenRole/token-not-found": "Token de API No Encontrado",
  "api/models/ApiTokenRole/token-not-found-description":
    "El token de API especificado no existe.",
  "api/models/AuditEvent/append-only":
    "Los eventos de auditoría no se pueden modificar",
  "api/models/AuditEvent/append-only-description":
    "Los registros de auditoría solo admiten altas.",
  "api/models/AuditEvent/trail-forbidden":
    "Sin permiso para leer este historial",
  "api/models/AuditEvent/trail-forbidden-description":
    "Solo un administrador de la compañía que pueda leer el registro puede leer su historial.",
  "api/models/AuditEvent/trail-invalid": "Solicitud de bitácora no válida",
  "api/models/AuditEvent/trail-invalid-description":
    "Indica el modelo y el id del registro cuyo historial quieres leer.",
  "api/models/AuditEvent/trail-target-not-allowed":
    "Historial no disponible para este modelo",
  "api/models/AuditEvent/trail-target-not-allowed-description":
    "El historial de este tipo de registro no se puede consultar.",
  "api/models/AuditEvent/trail-target-not-found": "Registro no encontrado",
  "api/models/AuditEvent/trail-target-not-found-description":
    "El registro no existe en la compañía.",
  "api/models/CatalogueDefinition/invalid-management":
    "Declaración de gestión inválida",
  "api/models/CatalogueDefinition/invalid-management-description":
    'Management debe ser nulo o { owner: "ingest", availability: boolean }.',
  "api/models/CatalogueDefinition/managed-structure-forbidden":
    "Cambio de catálogo gestionado prohibido",
  "api/models/CatalogueDefinition/managed-structure-forbidden-description":
    "Un catálogo gestionado y sus atributos se mantienen con la actualización automática y no se pueden cambiar ni eliminar aquí.",
  "api/models/CatalogueDefinition/management-forbidden":
    "Cambio de gestión prohibido",
  "api/models/CatalogueDefinition/management-forbidden-description":
    "Solo un superadministrador puede cambiar la declaración de gestión de un catálogo.",
  "api/models/CatalogueEntry/attribute-not-writable": "Atributo no editable",
  "api/models/CatalogueEntry/attribute-not-writable-description":
    "Tu rol no puede modificar este atributo",
  "api/models/CatalogueEntry/availability-not-managed":
    "Este catálogo no tiene control de disponibilidad",
  "api/models/CatalogueEntry/availability-not-managed-description":
    "Solo las versiones de un catálogo que declara disponibilidad se pueden habilitar o deshabilitar.",
  "api/models/CatalogueEntry/constraint-violation":
    "Violación de restricción de entrada de catálogo",
  "api/models/CatalogueEntry/constraint-violation-description":
    "Esta entrada no cumple una condición requerida de su catálogo.",
  "api/models/CatalogueEntry/definition-not-found": "Catálogo no encontrado",
  "api/models/CatalogueEntry/definition-not-found-description":
    "El catálogo no existe en la compañía.",
  "api/models/CatalogueEntry/definition-not-program-manageable":
    "Los administradores de programa no pueden administrar este catálogo",
  "api/models/CatalogueEntry/definition-not-program-manageable-description":
    "Solo los administradores de la plataforma pueden crear, editar o eliminar entradas de este catálogo.",
  "api/models/CatalogueEntry/entry-not-found":
    "Entrada del catálogo no encontrada",
  "api/models/CatalogueEntry/entry-not-found-description":
    "Esta entrada ya no existe en la compañía.",
  "api/models/CatalogueEntry/invalid-constraint-descriptor":
    "Descriptor de restricción de catálogo inválido",
  "api/models/CatalogueEntry/invalid-constraint-descriptor-description":
    "Una restricción declarada en este catálogo no tiene un tipo definido.",
  "api/models/CatalogueEntry/managed-write-forbidden":
    "Las entradas de un catálogo administrado solo las cambia el motor de ingesta",
  "api/models/CatalogueEntry/managed-write-forbidden-description":
    "Las entradas de un catálogo que se actualiza desde una fuente externa no se pueden crear, cambiar, habilitar, deshabilitar ni eliminar mediante la API de datos genérica.",
  "api/models/CatalogueEntry/not-owned":
    "Esta entrada del catálogo no puede modificarse desde este programa",
  "api/models/CatalogueEntry/not-owned-description":
    "La entrada pertenece a toda la compañía o a otro programa. Pide a un administrador de la plataforma que la modifique.",
  "api/models/CatalogueEntry/options-invalid": "Consulta de catálogo no válida",
  "api/models/CatalogueEntry/options-invalid-description":
    "Revisa el catálogo, los filtros y la página de la solicitud.",
  "api/models/CatalogueEntry/resolve-references-invalid-model":
    "Modelo no soportado para la resolución de referencias de catálogo",
  "api/models/CatalogueEntry/resolve-references-invalid-model-description":
    "Las referencias de catálogo solo pueden resolverse para una Policy o un SubjectMatterInstance.",
  "api/models/CatalogueEntry/resolve-references-not-found":
    "Registro no encontrado",
  "api/models/CatalogueEntry/resolve-references-not-found-description":
    "El registro no existe o no es visible para ti.",
  "api/models/CatalogueEntry/set-availability-forbidden":
    "Sin permiso para cambiar la disponibilidad",
  "api/models/CatalogueEntry/set-availability-forbidden-description":
    "Solo un administrador de la compañía puede habilitar o deshabilitar una versión de su catálogo.",
  "api/models/CatalogueEntry/set-availability-invalid":
    "Cambio de disponibilidad no válido",
  "api/models/CatalogueEntry/set-availability-invalid-description":
    "Indica solo si la versión está habilitada, como verdadero o falso.",
  "api/models/CatalogueEntry/unknown-constraint-type":
    "Tipo de restricción de catálogo desconocido",
  "api/models/CatalogueEntry/unknown-constraint-type-description":
    "Una restricción declarada en este catálogo tiene un tipo no reconocido.",
  "api/models/CatalogueEntryExternalRef/catalogue-entry-id-is-required":
    "La entrada de catálogo es requerida",
  "api/models/CatalogueEntryExternalRef/catalogue-entry-id-is-required-description":
    "Una referencia externa debe apuntar a una entrada de catálogo",
  "api/models/CatalogueEntryExternalRef/catalogue-entry-not-found":
    "Entrada de catálogo no encontrada",
  "api/models/CatalogueEntryExternalRef/catalogue-entry-not-found-description":
    "La entrada de catálogo referenciada no existe",
  "api/models/CatalogueEntryExternalRef/duplicate-identity":
    "Identidad de origen duplicada",
  "api/models/CatalogueEntryExternalRef/duplicate-identity-description":
    "Ya existe una referencia vigente para ese sistema, código y calificador",
  "api/models/CatalogueEntryExternalRef/duplicate-system-key":
    "Referencia externa duplicada",
  "api/models/CatalogueEntryExternalRef/duplicate-system-key-description":
    "Esta entrada de catálogo ya tiene una referencia para ese sistema",
  "api/models/CatalogueEntryExternalRef/external-id-is-required":
    "El identificador externo es requerido",
  "api/models/CatalogueEntryExternalRef/external-id-is-required-description":
    "Una referencia externa debe incluir el identificador del sistema externo",
  "api/models/CatalogueEntryExternalRef/managed-write-forbidden":
    "Las referencias de origen del catálogo solo las cambia el motor de ingesta",
  "api/models/CatalogueEntryExternalRef/managed-write-forbidden-description":
    "Estos registros no se pueden crear, editar ni eliminar mediante la API de datos genérica.",
  "api/models/CatalogueEntryExternalRef/system-key-is-required":
    "La clave del sistema es requerida",
  "api/models/CatalogueEntryExternalRef/system-key-is-required-description":
    "Una referencia externa debe declarar la clave de su sistema origen",
  "api/models/CatalogueIngestMapping/managed-write-forbidden":
    "El diccionario de nombres del catálogo solo lo cambia el motor de ingesta",
  "api/models/CatalogueIngestMapping/managed-write-forbidden-description":
    "Estos registros no se pueden crear, editar ni eliminar mediante la API de datos genérica.",
  "api/models/CatalogueIngestMapping/normalize-forbidden":
    "Sin permiso para cambiar el diccionario",
  "api/models/CatalogueIngestMapping/normalize-forbidden-description":
    "Solo un administrador de la compañía puede definir los nombres de marca y modelo del diccionario de su catálogo.",
  "api/models/CatalogueIngestMapping/normalize-invalid":
    "Entrada de diccionario no válida",
  "api/models/CatalogueIngestMapping/normalize-invalid-description":
    "La marca y el modelo necesitan un nombre de 1 a 120 caracteres, y la solicitud debe indicar si se incluye el nombre del modelo y la revisión que se editó.",
  "api/models/CatalogueIngestMapping/revision-conflict":
    "La entrada del diccionario cambió",
  "api/models/CatalogueIngestMapping/revision-conflict-description":
    "Otra persona cambió esta entrada del diccionario. Vuelve a cargarla y aplica tu cambio de nuevo.",
  "api/models/CatalogueIngestRecord/managed-write-forbidden":
    "Los registros de origen del catálogo solo los cambia el motor de ingesta",
  "api/models/CatalogueIngestRecord/managed-write-forbidden-description":
    "Estos registros no se pueden crear, editar ni eliminar mediante la API de datos genérica.",
  "api/models/CatalogueUpdateRun/admin-forbidden":
    "Sin permiso para actualizar el catálogo",
  "api/models/CatalogueUpdateRun/admin-forbidden-description":
    "Solo un administrador de la compañía puede iniciar o previsualizar una actualización del catálogo.",
  "api/models/CatalogueUpdateRun/company-required": "Se requiere una compañía",
  "api/models/CatalogueUpdateRun/company-required-description":
    "Elige la compañía cuyo catálogo se actualiza.",
  "api/models/CatalogueUpdateRun/invalid-field":
    "Campo de ejecución de actualización inválido",
  "api/models/CatalogueUpdateRun/invalid-field-description":
    "Un campo tiene un valor ausente o mal formado (Counts y Errors tienen una forma fija).",
  "api/models/CatalogueUpdateRun/not-configured":
    "La actualización del catálogo no está configurada",
  "api/models/CatalogueUpdateRun/not-configured-description":
    "Esta compañía no tiene una configuración válida de fuentes del catálogo.",
  "api/models/CatalogueUpdateRun/run-closed":
    "La ejecución de actualización está cerrada",
  "api/models/CatalogueUpdateRun/run-closed-description":
    "Status, Counts y Errors ya no cambian una vez que terminó.",
  "api/models/CatalogueUpdateRun/super-admin-forbidden":
    "Sin permiso para cargar los datos de referencia",
  "api/models/CatalogueUpdateRun/super-admin-forbidden-description":
    "Solo un superadministrador puede iniciar la carga de los datos de referencia compartidos de esta instancia.",
  "api/models/CatalogueUpdateRun/write-forbidden":
    "Las ejecuciones de actualización del catálogo solo las cambia el motor de ingesta",
  "api/models/CatalogueUpdateRun/write-forbidden-description":
    "Estos registros no se pueden crear, editar ni eliminar mediante la API de datos genérica.",
  "api/models/CatalogueUpdateRun/year-range-invalid": "Rango de años inválido",
  "api/models/CatalogueUpdateRun/year-range-invalid-description":
    "Indica ambos años como números enteros, el primero no posterior al segundo, desde el primer año que pueden surtir las fuentes hasta el año siguiente.",
  "api/models/CatalogueUpdateRunPortion/invalid-field":
    "Campo de porción de ejecución inválido",
  "api/models/CatalogueUpdateRunPortion/invalid-field-description":
    "Un campo tiene un valor ausente o mal formado (Counts y Errors tienen una forma fija).",
  "api/models/CatalogueUpdateRunPortion/portion-closed":
    "La porción de ejecución está cerrada",
  "api/models/CatalogueUpdateRunPortion/portion-closed-description":
    "Status, Counts y Errors ya no cambian una vez que terminó.",
  "api/models/CatalogueUpdateRunPortion/write-forbidden":
    "Las porciones de ejecución de actualización del catálogo solo las cambia el motor de ingesta",
  "api/models/CatalogueUpdateRunPortion/write-forbidden-description":
    "Estos registros no se pueden crear, editar ni eliminar mediante la API de datos genérica.",
  "api/models/ComissionTable/entity-id-is-required":
    "Es necesario el Id de la entidad",
  "api/models/ComissionTable/entity-not-found": "Entidad no encontrada",
  "api/models/ComissionTable/invalid-component":
    "El componente de la tabla de comisiones no es válido.",
  "api/models/ComissionTable/invalid-component-description":
    "Las tablas de agencia requieren una agencia; las de cedente requieren programa, cedente y tasa.",
  "api/models/CommunicationContact/entity-owned-field-read-only":
    "Este campo proviene del directorio de entidades",
  "api/models/CommunicationContact/entity-owned-field-read-only-description":
    "Edita la entidad de origen para cambiar su nombre o dirección.",
  "api/models/Company/country-is-required": "El país es requerido",
  "api/models/Company/country-is-required-description":
    "Una compañía debe tener un país",
  "api/models/Company/country-not-found": "País no encontrado",
  "api/models/Company/country-not-found-description":
    "El país especificado no existe",
  "api/models/Company/id-already-exists": "El Id ya existe",
  "api/models/Company/id-already-exists-description":
    "Ya existe una compañía registrada con el Id proporcionado.",
  "api/models/Company/id-required": "Es necesario el Id",
  "api/models/Company/id-required-description":
    "Es necesario proporcionar un Id al crear una nueva Compañía",
  "api/models/Company/id-update-not-allowed": "No se permite actualizar el Id",
  "api/models/Company/id-update-not-allowed-description":
    "Una vez que se definió el Id de una compañía, no es posible modificarlo.",
  "api/models/Company/maximum-parent-companies-reached":
    "No se pueden agregar más subsidiarias",
  "api/models/Company/maximum-parent-companies-reached-description":
    "No es posible agregar esta empresa como subsidiaria ya que se ha alcanzado el límite máximo de empresas viculadas que puede haber.",
  "api/models/Company/parent-company-not-found":
    "No se encontró la empresa matriz",
  "api/models/Company/parent-company-not-found-description":
    "No se encontró ninguna empresa matríz con el Id proporcionado",
  "api/models/Company/parents-cant-be-directly-modyfied":
    "No se puede modificar directamente",
  "api/models/Company/parents-cant-be-directly-modyfied-description":
    "Los campos de empresa matriz no pueden ser modificados directamente. Solo se puede modificar el campo ParentId y los demás campos se actualizarán automáticamente.",
  "api/models/Company/tax-id-already-exists": "El RFC ya está registrado",
  "api/models/Company/tax-id-already-exists-description":
    "Ya existe una compañía registrada con el RFC proporcionado. En caso de que la información sea correcta, puedes utilizar el cliente existente, de lo contrario verifica la información e intenta nuevamente.",
  "api/models/CoverageDefinition/definition-id-is-required":
    "Se requiere la definición de objeto asegurado",
  "api/models/CoverageDefinition/definition-id-is-required-description":
    "Proporciona el SubjectMatterDefinitionId al que pertenece esta cobertura.",
  "api/models/CoverageDefinition/definition-not-found":
    "Definición de objeto asegurado no encontrada",
  "api/models/CoverageDefinition/definition-not-found-description":
    "La definición de objeto asegurado referenciada no existe.",
  "api/models/CoverageDefinition/duplicate-slug": "Slug de cobertura duplicado",
  "api/models/CoverageDefinition/duplicate-slug-description":
    "Ya existe una cobertura con este slug para esta definición de objeto asegurado y línea de negocio.",
  "api/models/CoverageDefinition/line-of-business-below-proposal-start":
    "La línea de negocio está por debajo de una línea de negocio donde inician propuestas",
  "api/models/CoverageDefinition/line-of-business-below-proposal-start-description":
    "Esta cobertura está declarada en una línea de negocio estrictamente por debajo de una que ya ancla un QuoteBridge activo. Decláela en esa línea de negocio o en una superior.",
  "api/models/CoverageDefinition/line-of-business-id-is-required":
    "Se requiere la línea de negocio",
  "api/models/CoverageDefinition/line-of-business-id-is-required-description":
    "Proporciona el LineOfBusinessId en el que se declara esta cobertura.",
  "api/models/CoverageDefinition/line-of-business-not-found":
    "Línea de negocio no encontrada",
  "api/models/CoverageDefinition/line-of-business-not-found-description":
    "La línea de negocio referenciada no existe.",
  "api/models/CoverageDefinition/resolve-inheritance-invalid-body":
    "Se requiere la definición de objeto asegurado",
  "api/models/CoverageDefinition/resolve-inheritance-invalid-body-description":
    "Proporciona el SubjectMatterDefinitionId para resolver sus coberturas.",
  "api/models/CoverageDefinition/resolve-inheritance-not-found":
    "Definición de objeto asegurado no encontrada",
  "api/models/CoverageDefinition/resolve-inheritance-not-found-description":
    "No existe un SubjectMatterDefinition con este id.",
  "api/models/Currency/id-is-required": "Es necesario el Id",
  "api/models/Currency/id-is-required-description": "Es necesario el Id",
  "api/models/DocumentAsset/asset-immutable":
    "El archivo de un recurso no se puede cambiar",
  "api/models/DocumentAsset/asset-immutable-description":
    "Solo el nombre puede cambiar; sube un nuevo recurso.",
  "api/models/DocumentAsset/bulk-write-refused":
    "No se permiten cambios masivos",
  "api/models/DocumentAsset/bulk-write-refused-description":
    "Modifica los recursos de documento uno por uno.",
  "api/models/DocumentAsset/invalid-content-type":
    "Este tipo de archivo no está permitido para el tipo de recurso",
  "api/models/DocumentAsset/invalid-content-type-description":
    "Las imágenes aceptan PNG, JPEG, GIF o WebP; los fondos PNG, JPEG o WebP; las fuentes TTF u OTF.",
  "api/models/DocumentAsset/invalid-key":
    "El archivo del recurso no pertenece a esta empresa",
  "api/models/DocumentAsset/invalid-key-description":
    "La clave de almacenamiento no está bajo el prefijo de la empresa.",
  "api/models/DocumentAsset/invalid-kind": "Tipo de recurso inválido",
  "api/models/DocumentAsset/invalid-kind-description":
    "Elige imagen, fondo o fuente.",
  "api/models/DocumentAsset/invalid-size":
    "El tamaño del archivo no está permitido",
  "api/models/DocumentAsset/invalid-size-description":
    "Imágenes y fondos hasta 10 MiB, fuentes hasta 5 MiB.",
  "api/models/DocumentAsset/key-required": "El archivo subido es obligatorio",
  "api/models/DocumentAsset/key-required-description":
    "Sube el archivo antes de registrar el recurso.",
  "api/models/DocumentAsset/system-super-admin-only":
    "Solo un superadministrador puede cambiar un recurso del sistema",
  "api/models/DocumentAsset/system-super-admin-only-description":
    "Los recursos del sistema son compartidos por todas las compañías.",
  "api/models/DocumentAvailability/invalid-audience": "Audiencia inválida",
  "api/models/DocumentAvailability/invalid-audience-description":
    "La audiencia debe ser una lista de roles de visualización conocidos.",
  "api/models/DocumentAvailability/invalid-definition":
    "Definición de documento inválida",
  "api/models/DocumentAvailability/invalid-definition-description":
    "La disponibilidad debe pertenecer a una definición de documento existente.",
  "api/models/DocumentAvailability/invalid-line-of-business": "Ramo inválido",
  "api/models/DocumentAvailability/invalid-line-of-business-description":
    "El ramo debe pertenecer a la misma compañía que la definición.",
  "api/models/DocumentAvailability/invalid-precondition":
    "Condición previa inválida",
  "api/models/DocumentAvailability/invalid-precondition-description":
    "Cada condición previa debe ser un objeto con un tipo conocido.",
  "api/models/DocumentAvailability/too-many-rows":
    "Demasiadas filas de disponibilidad",
  "api/models/DocumentAvailability/too-many-rows-description":
    "Un documento puede tener como máximo 200 filas de disponibilidad.",
  "api/models/DocumentDefinition/bulk-write-refused":
    "No se permiten cambios masivos",
  "api/models/DocumentDefinition/bulk-write-refused-description":
    "Modifica los definiciones de documento uno por uno.",
  "api/models/DocumentDefinition/company-id-immutable":
    "Una definición de documento no puede cambiar de compañía",
  "api/models/DocumentDefinition/company-id-immutable-description":
    "La compañía de una definición se fija al crearla.",
  "api/models/DocumentDefinition/invalid-current-version":
    "Versión vigente inválida",
  "api/models/DocumentDefinition/invalid-current-version-description":
    "La versión vigente debe ser una versión publicada de esta definición.",
  "api/models/DocumentDefinition/invalid-letterhead": "Membrete fijo inválido",
  "api/models/DocumentDefinition/invalid-letterhead-description":
    "Un membrete fijo debe ser el predeterminado de la instancia o pertenecer a la misma compañía.",
  "api/models/DocumentDefinition/invalid-slug":
    "La definición del documento necesita un identificador",
  "api/models/DocumentDefinition/invalid-slug-description":
    "Indica un identificador que no esté vacío.",
  "api/models/DocumentDefinition/revision-conflict":
    "La definición del documento fue modificada por alguien más",
  "api/models/DocumentDefinition/revision-conflict-description":
    "Recarga la definición e inténtalo de nuevo.",
  "api/models/DocumentDefinitionVersion/invalid-definition":
    "La definición de documento no existe",
  "api/models/DocumentDefinitionVersion/invalid-definition-description":
    "La versión debe pertenecer a una definición existente.",
  "api/models/DocumentDefinitionVersion/version-immutable":
    "Una versión publicada no se puede modificar",
  "api/models/DocumentDefinitionVersion/version-immutable-description":
    "Guarda un nuevo borrador en lugar de editar una versión publicada o retirada.",
  "api/models/DocumentEngine/write-forbidden":
    "Los registros del motor de documentos solo los cambia el motor",
  "api/models/DocumentEngine/write-forbidden-description":
    "Estos registros no se pueden crear, editar ni eliminar mediante la API de datos genérica.",
  "api/models/DocumentTemplate/scope-change-not-allowed":
    "Este registro no se puede mover a otra compañía.",
  "api/models/ERAircraft/age-rate-not-found": "Tarifa de edad no encontrada",
  "api/models/ERAircraft/age-rate-not-found-description":
    "Tarifa de edad no encontrada",
  "api/models/ERAircraft/base-rate-not-found": "Tarifa base no encontrada",
  "api/models/ERAircraft/base-rate-not-found-description":
    "Tarifa base no encontrada",
  "api/models/ERAircraft/could-not-get-year": "No se pudo obtener el año",
  "api/models/ERAircraft/could-not-get-year-description":
    "No se pudo obtener el año",
  "api/models/ERAircraft/create-response-invalid":
    "La creación de la aeronave falló",
  "api/models/ERAircraft/create-response-invalid-description":
    "El servidor devolvió una respuesta incompleta — intente de nuevo",
  "api/models/ERAircraft/endorsement-fetch-failed":
    "No se pudo cargar el endoso de la aeronave",
  "api/models/ERAircraft/endorsement-fetch-failed-description":
    "No se pudo obtener el registro de endoso de la aeronave — intente de nuevo",
  "api/models/ERAircraft/entity-id-is-required":
    "Es necesario el Id de la entidad",
  "api/models/ERAircraft/entity-id-is-required-description":
    "Es necesario el Id de la entidad",
  "api/models/ERAircraft/entity-not-found": "Entidad no encontrada",
  "api/models/ERAircraft/entity-not-found-description": "Entidad no encontrada",
  "api/models/ERAircraft/no-agency-hierarchy":
    "No se puede crear aeronave sin información de agencia",
  "api/models/ERAircraft/no-agency-hierarchy-description":
    "Ni la póliza ni la entidad tiene datos de jerarquía de agencia — contacte a soporte",
  "api/models/ERAircraft/policy-not-found": "Póliza no encontrada",
  "api/models/ERAircraft/policy-not-found-description": "Póliza no encontrada",
  "api/models/ERAircraft/usage-not-found": "Uso no encontrado",
  "api/models/ERAircraft/usage-not-found-description": "Uso no encontrado",
  "api/models/ERAircraft/voluntary-settlements-rate-not-found":
    "Tarifa de arreglos voluntarios no encontrada",
  "api/models/ERAircraft/voluntary-settlements-rate-not-found-description":
    "Tarifa de arreglos voluntarios no encontrada",
  "api/models/ERAircraftProposal/age-rate-not-found":
    "Tarifa de edad no encontrada",
  "api/models/ERAircraftProposal/age-rate-not-found-description":
    "Ninguna tarifa de edad coincide con la edad de la aeronave y las fechas de la póliza",
  "api/models/ERAircraftProposal/aircraft-id-missing":
    "Se requiere una aeronave para crear una propuesta",
  "api/models/ERAircraftProposal/aircraft-id-missing-description":
    "La aeronave debe crearse antes de la propuesta — regrese e intente de nuevo",
  "api/models/ERAircraftProposal/aircraft-not-found": "Aeronave no encontrada",
  "api/models/ERAircraftProposal/aircraft-not-found-description":
    "No se encontró la aeronave referida por la propuesta",
  "api/models/ERAircraftProposal/base-rate-not-found":
    "Tarifa base no encontrada",
  "api/models/ERAircraftProposal/base-rate-not-found-description":
    "Ninguna tarifa base coincide con el valor de casco y las fechas de la póliza",
  "api/models/ERAircraftProposal/cargo-rate-not-found":
    "Tarifa de responsabilidad de carga no encontrada",
  "api/models/ERAircraftProposal/cargo-rate-not-found-description":
    "Ninguna tarifa de responsabilidad de carga coincide con el límite seleccionado",
  "api/models/ERAircraftProposal/cmp-rate-not-found":
    "Tarifa de gastos médicos a tripulación no encontrada",
  "api/models/ERAircraftProposal/cmp-rate-not-found-description":
    "Ninguna tarifa de gastos médicos a tripulación coincide con el límite seleccionado",
  "api/models/ERAircraftProposal/create-response-invalid":
    "La creación de la propuesta de aeronave falló",
  "api/models/ERAircraftProposal/create-response-invalid-description":
    "El servidor devolvió una respuesta incompleta — intente de nuevo",
  "api/models/ERAircraftProposal/cvs-rate-not-found":
    "Tarifa de arreglos voluntarios a tripulación no encontrada",
  "api/models/ERAircraftProposal/cvs-rate-not-found-description":
    "Ninguna tarifa de arreglos voluntarios a tripulación coincide con el límite seleccionado",
  "api/models/ERAircraftProposal/geographic-limit-not-defined":
    "Límite geográfico no definido",
  "api/models/ERAircraftProposal/geographic-limit-not-defined-description":
    "Se requiere un límite geográfico para cotizar la cobertura de casco",
  "api/models/ERAircraftProposal/hangar-rate-not-found":
    "Tarifa de responsabilidad de hangar no encontrada",
  "api/models/ERAircraftProposal/hangar-rate-not-found-description":
    "Ninguna tarifa de responsabilidad de hangar coincide con el límite seleccionado",
  "api/models/ERAircraftProposal/invalid-in-force-date":
    "Fecha de vigencia inválida",
  "api/models/ERAircraftProposal/invalid-in-force-date-description":
    "La fecha de vigencia de la póliza falta o es inválida",
  "api/models/ERAircraftProposal/liability-rate-not-found":
    "Tarifa de responsabilidad civil no encontrada",
  "api/models/ERAircraftProposal/liability-rate-not-found-description":
    "Ninguna tarifa de responsabilidad civil coincide con el límite seleccionado y las fechas de la póliza",
  "api/models/ERAircraftProposal/limit-rate-not-found":
    "Tarifa de límite geográfico no encontrada",
  "api/models/ERAircraftProposal/limit-rate-not-found-description":
    "Ninguna tarifa coincide con el límite geográfico seleccionado",
  "api/models/ERAircraftProposal/luggage-rate-not-found":
    "Tarifa de responsabilidad de equipaje no encontrada",
  "api/models/ERAircraftProposal/luggage-rate-not-found-description":
    "Ninguna tarifa de responsabilidad de equipaje coincide con el límite seleccionado",
  "api/models/ERAircraftProposal/missing-scope":
    "Error de alcance de propuesta",
  "api/models/ERAircraftProposal/missing-scope-description":
    "La póliza no tiene información de compañía — contacte a soporte",
  "api/models/ERAircraftProposal/pmp-rate-not-found":
    "Tarifa de gastos médicos a pasajeros no encontrada",
  "api/models/ERAircraftProposal/pmp-rate-not-found-description":
    "Ninguna tarifa de gastos médicos a pasajeros coincide con el límite seleccionado",
  "api/models/ERAircraftProposal/policy-not-found": "Póliza no encontrada",
  "api/models/ERAircraftProposal/policy-not-found-description":
    "No se encontró la póliza referida por la propuesta",
  "api/models/ERAircraftProposal/pvs-rate-not-found":
    "Tarifa de arreglos voluntarios a pasajeros no encontrada",
  "api/models/ERAircraftProposal/pvs-rate-not-found-description":
    "Ninguna tarifa de arreglos voluntarios a pasajeros coincide con el límite seleccionado",
  "api/models/ERAircraftProposal/spare-parts-limit-exceeded":
    "Límite de repuestos excedido",
  "api/models/ERAircraftProposal/spare-parts-limit-exceeded-description":
    "El límite de repuestos excede el máximo permitido",
  "api/models/ERAircraftProposal/spare-parts-ratio-exceeded":
    "Ratio de repuestos excedido",
  "api/models/ERAircraftProposal/spare-parts-ratio-exceeded-description":
    "El ratio de límite de repuestos sobre valor de casco excede el máximo permitido",
  "api/models/ERAircraftProposal/usage-rates-not-found":
    "Tarifas de uso no encontradas",
  "api/models/ERAircraftProposal/usage-rates-not-found-description":
    "Ninguna tarifa de uso coincide con los usos seleccionados y las fechas de la póliza",
  "api/models/ERAircraftProposal/war-risk-rate-not-found":
    "Tarifa de riesgo de guerra no encontrada",
  "api/models/ERAircraftProposal/war-risk-rate-not-found-description":
    "Ninguna tarifa de riesgo de guerra coincide con el valor de casco y las fechas de la póliza",
  "api/models/Entity/access-flags-restricted":
    "Solo los administradores de plataforma pueden cambiar los indicadores de acceso de la cuenta.",
  "api/models/Entity/access-flags-restricted-description":
    "Cambiar los indicadores de inicio de sesión, cuenta de prueba o revocación requiere un administrador de la compañía de esta cuenta, o un administrador de plataforma.",
  "api/models/Entity/account-admin-read-only":
    "El campo Administrador de Cuenta es de solo lectura",
  "api/models/Entity/account-admin-read-only-description":
    "El campo Administrador de Cuenta es calculado y no puede ser actualizado directamente",
  "api/models/Entity/account-employee-read-only":
    "El campo Empleado de Cuenta es de solo lectura",
  "api/models/Entity/account-employee-read-only-description":
    "El campo Empleado de Cuenta es calculado y no puede ser actualizado directamente",
  "api/models/Entity/account-manager-read-only":
    "El campo Gerente de Cuenta es de solo lectura",
  "api/models/Entity/account-manager-read-only-description":
    "El campo Gerente de Cuenta es calculado y no puede ser actualizado directamente",
  "api/models/Entity/account-user-read-only":
    "El campo Usuario de Cuenta es de solo lectura",
  "api/models/Entity/account-user-read-only-description":
    "El campo Usuario de Cuenta es calculado y no puede ser actualizado directamente",
  "api/models/Entity/agency-admin-read-only":
    "El campo Administrador de Agencia es de solo lectura",
  "api/models/Entity/agency-admin-read-only-description":
    "El campo Administrador de Agencia es calculado y no puede ser actualizado directamente",
  "api/models/Entity/agency-employee-read-only":
    "El campo Empleado de Agencia es de solo lectura",
  "api/models/Entity/agency-employee-read-only-description":
    "El campo Empleado de Agencia es calculado y no puede ser actualizado directamente",
  "api/models/Entity/agency-has-hierarchy-children":
    "Esta agencia tiene agencias que dependen de ella",
  "api/models/Entity/agency-has-hierarchy-children-description":
    "Mueve las agencias que dependen de esta agencia a otra agencia superior antes de eliminarla.",
  "api/models/Entity/agency-manager-read-only":
    "El campo Gerente de Agencia es de solo lectura",
  "api/models/Entity/agency-manager-read-only-description":
    "El campo Gerente de Agencia es calculado y no puede ser actualizado directamente",
  "api/models/Entity/agency-user-read-only":
    "El campo Usuario de Agencia es de solo lectura",
  "api/models/Entity/agency-user-read-only-description":
    "El campo Usuario de Agencia es calculado y no puede ser actualizado directamente",
  "api/models/Entity/anagram-read-only": "El anagrama es de solo lectura",
  "api/models/Entity/anagram-read-only-description":
    "El campo Anagrama es calculado y no puede ser actualizado directamente",
  "api/models/Entity/appearance-invalid": "Elige Claro, Oscuro o Automático.",
  "api/models/Entity/appearance-invalid-description":
    "La preferencia de apariencia debe ser claro, oscuro, automático o vacía.",
  "api/models/Entity/appearance-self-only":
    "Solo puedes cambiar tu propia preferencia de apariencia.",
  "api/models/Entity/appearance-self-only-description":
    "Esta acción establece la preferencia de Claro/Oscuro/Automático del usuario que la solicita y no puede aplicarse a otra cuenta.",
  "api/models/Entity/appearance-write-restricted":
    "La preferencia de apariencia solo puede cambiarla su propio usuario.",
  "api/models/Entity/appearance-write-restricted-description":
    "La apariencia es una preferencia personal de Claro/Oscuro/Automático y solo puede cambiarse mediante la acción de autoservicio dedicada, nunca con una actualización genérica de la entidad.",
  "api/models/Entity/cedent-admin-read-only":
    "El campo Administrador de Cedente es de solo lectura",
  "api/models/Entity/cedent-admin-read-only-description":
    "El campo Administrador de Cedente es calculado y no puede ser actualizado directamente",
  "api/models/Entity/cedent-employee-read-only":
    "El campo Empleado de Cedente es de solo lectura",
  "api/models/Entity/cedent-employee-read-only-description":
    "El campo Empleado de Cedente es calculado y no puede ser actualizado directamente",
  "api/models/Entity/cedent-in-use":
    "Este cedente está en uso y no se puede eliminar",
  "api/models/Entity/cedent-in-use-description":
    "Este cedente tiene pólizas, negocio, roles o membresías y no se puede eliminar.",
  "api/models/Entity/cedent-manager-read-only":
    "El campo Gerente de Cedente es de solo lectura",
  "api/models/Entity/cedent-manager-read-only-description":
    "El campo Gerente de Cedente es calculado y no puede ser actualizado directamente",
  "api/models/Entity/cedent-user-read-only":
    "El campo Usuario de Cedente es de solo lectura",
  "api/models/Entity/cedent-user-read-only-description":
    "El campo Usuario de Cedente es calculado y no puede ser actualizado directamente",
  "api/models/Entity/child-entity-readonly":
    "La entidad hija es de solo lectura",
  "api/models/Entity/child-entity-readonly-description":
    "Los atributos de la agencia hija se heredan del padre. Solo el Alias puede modificarse directamente.",
  "api/models/Entity/child-hierarchy-invalid": "Nivel de jerarquía inválido",
  "api/models/Entity/child-hierarchy-invalid-description":
    "La agencia hija debe estar en un nivel de jerarquía inferior a su agencia padre.",
  "api/models/Entity/cognito-config-not-available":
    "El cambio de correo de inicio de sesión requiere configuración de Cognito.",
  "api/models/Entity/company-admin-read-only":
    "El campo Administrador de Compañía es de solo lectura",
  "api/models/Entity/company-admin-read-only-description":
    "El campo Administrador de Compañía es calculado y no puede ser actualizado directamente",
  "api/models/Entity/company-employee-read-only":
    "El campo Empleado de Compañía es de solo lectura",
  "api/models/Entity/company-employee-read-only-description":
    "El campo Empleado de Compañía es calculado y no puede ser actualizado directamente",
  "api/models/Entity/company-id-is-required":
    "Es necesario el Id de la compañía",
  "api/models/Entity/company-id-is-required-description":
    "Es necesario proporcionar el  Id de la compañía al crear una nueva Entidad.",
  "api/models/Entity/company-manager-read-only":
    "El campo Gerente de Compañía es de solo lectura",
  "api/models/Entity/company-manager-read-only-description":
    "El campo Gerente de Compañía es calculado y no puede ser actualizado directamente",
  "api/models/Entity/company-not-found": "Compañía no encontrada",
  "api/models/Entity/company-not-found-description":
    "No se encontró la compañía proporcionada al intentar crear una nueva Entidad.",
  "api/models/Entity/company-user-read-only":
    "El campo Usuario de Compañía es de solo lectura",
  "api/models/Entity/company-user-read-only-description":
    "El campo Usuario de Compañía es calculado y no puede ser actualizado directamente",
  "api/models/Entity/country-is-required": "El país es requerido",
  "api/models/Entity/country-is-required-description":
    "Las entidades naturales y legales deben tener un país",
  "api/models/Entity/country-not-found": "País no encontrado",
  "api/models/Entity/country-not-found-description":
    "El país especificado no existe",
  "api/models/Entity/duplicate-entity": "Entidad duplicada",
  "api/models/Entity/duplicate-entity-description":
    "Ya existe una entidad con la misma información",
  "api/models/Entity/email-already-exists":
    "El correo electrónico ya está registrado",
  "api/models/Entity/email-already-exists-description":
    "Ya existe otra persona o empresa registrada con este correo electrónico.",
  "api/models/Entity/email-is-not-valid": "Correo electrónico inválido",
  "api/models/Entity/email-is-not-valid-description":
    "Correo electrónico inválido",
  "api/models/Entity/external-id-already-exists":
    "Otra aseguradora ya tiene este ID externo.",
  "api/models/Entity/external-id-already-exists-description":
    "El ID externo debe ser único entre aseguradoras. Revisa el valor o usa el registro existente.",
  "api/models/Entity/external-id-is-required": "El ID externo es obligatorio.",
  "api/models/Entity/external-id-is-required-description":
    "Captura el ID externo de esta aseguradora para continuar.",
  "api/models/Entity/external-id-not-allowed":
    "El ID externo no se puede asignar ni cambiar.",
  "api/models/Entity/external-id-not-allowed-description":
    "Solo un administrador de la compañía de esta cuenta, o un administrador de plataforma, puede asignar o cambiar el ID externo.",
  "api/models/Entity/hidden-read-only": "El campo Oculto es de solo lectura",
  "api/models/Entity/hidden-read-only-description":
    "El campo Oculto es calculado y no puede ser actualizado directamente",
  "api/models/Entity/hierarchy-parent-invalid": "Agencia superior inválida",
  "api/models/Entity/hierarchy-parent-invalid-description":
    "La agencia superior debe ser una agencia de la misma compañía, con un nivel de jerarquía superior a esta, y no puede ser esta agencia ni una de las agencias que dependen de ella.",
  "api/models/Entity/id-can-not-be-modified": "No se puede modificar el Id",
  "api/models/Entity/id-can-not-be-modified-description":
    "No se puede modificar el Id",
  "api/models/Entity/identity-parent-invalid": "Entidad legal inválida",
  "api/models/Entity/identity-parent-invalid-description":
    "Un alias debe pertenecer a la entidad legal principal de una agencia de la misma compañía, no a otro alias.",
  "api/models/Entity/immutable-field": "El campo no se puede cambiar",
  "api/models/Entity/login-email-change-disabled-in-environment":
    "El cambio de correo de inicio de sesión no está disponible en este entorno.",
  "api/models/Entity/login-email-change-disabled-in-environment-description":
    "Los grupos de usuarios de Cognito se comparten entre entornos; esta acción solo los modifica en producción.",
  "api/models/Entity/login-email-change-forbidden":
    "No puedes cambiar el correo de inicio de sesión de este usuario.",
  "api/models/Entity/login-email-change-forbidden-description":
    "Cambiar el correo de inicio de sesión de otro usuario requiere tener acceso a todas sus compañías, y un objetivo administrador requiere superAdmin.",
  "api/models/Entity/login-email-change-restricted":
    "El correo de inicio de sesión solo se puede cambiar con la acción dedicada.",
  "api/models/Entity/login-email-change-restricted-description":
    "Una actualización genérica no puede cambiar el correo de inicio de sesión de un usuario con una identidad de acceso existente.",
  "api/models/Entity/login-email-in-use":
    "Ese correo ya lo usa otro inicio de sesión.",
  "api/models/Entity/login-email-in-use-description":
    "Elige una dirección de correo diferente.",
  "api/models/Entity/login-email-invalid":
    "Ingresa un correo válido y distinto.",
  "api/models/Entity/login-email-invalid-description":
    "El nuevo correo de inicio de sesión debe ser una dirección válida y distinta de la actual.",
  "api/models/Entity/national-id-already-exists": "El CURP ya está registrado",
  "api/models/Entity/national-id-already-exists-description":
    "Ya existe una entidad registrada con el CURP proporcionado.",
  "api/models/Entity/not-a-token-entity": "Tipo de Entidad Inválido",
  "api/models/Entity/not-a-token-entity-description":
    "La regeneración de token solo está disponible para entidades de tipo token.",
  "api/models/Entity/out-of-scope":
    "Este registro está fuera de tu alcance de acceso.",
  "api/models/Entity/out-of-scope-description":
    "Esta cuenta o asignación de rol está fuera de las compañías, agencias o cedentes a los que tienes acceso.",
  "api/models/Entity/participation-canonical-not-eligible":
    "La organización seleccionada no está disponible para esta participación",
  "api/models/Entity/participation-canonical-not-eligible-description":
    "La organización seleccionada no es una de las agencias canónicas disponibles para usted en esta alta.",
  "api/models/Entity/participation-columns-read-only":
    "La plataforma administra el nivel, el programa y la raíz de programa",
  "api/models/Entity/participation-columns-read-only-description":
    "El nivel de participación, el programa y la raíz de programa son establecidos por la plataforma y no se pueden escribir directamente.",
  "api/models/Entity/participation-defaults-missing":
    "La configuración del programa necesaria para crear esta agencia está incompleta",
  "api/models/Entity/participation-defaults-missing-description":
    "Al programa le falta la configuración que esta nueva participación necesita (líneas de negocio, monedas o términos de comisión).",
  "api/models/Entity/participation-identity-required":
    "Busque el identificador, seleccione una organización existente o cree una nueva",
  "api/models/Entity/participation-identity-required-description":
    "Resuelva la identidad legal de una nueva participación mediante la búsqueda del identificador, una organización existente o un nuevo registro.",
  "api/models/Entity/participation-in-use":
    "Esta participación está en uso y no se puede eliminar",
  "api/models/Entity/participation-in-use-description":
    "Esta participación tiene vínculos jerárquicos, negocio, roles o membresías y no se puede eliminar.",
  "api/models/Entity/participation-level-immutable":
    "El nivel jerárquico de una participación no se puede cambiar",
  "api/models/Entity/participation-level-immutable-description":
    "El nivel jerárquico de una participación no se puede cambiar una vez establecido.",
  "api/models/Entity/participation-level-not-creatable":
    "Solo se pueden crear participaciones en los niveles de agencia 3, 2 y 1",
  "api/models/Entity/participation-level-not-creatable-description":
    "Las raíces de programa y los contenedores regionales solo se crean mediante migraciones de la plataforma.",
  "api/models/Entity/participation-not-found":
    "No se encontró la participación en este programa",
  "api/models/Entity/participation-not-found-description":
    "No existe una participación activa con este id en el programa actual.",
  "api/models/Entity/participation-parent-not-eligible":
    "El padre seleccionado no es elegible en este programa",
  "api/models/Entity/participation-parent-not-eligible-description":
    "El padre seleccionado no es una participación activa un nivel arriba, en este programa.",
  "api/models/Entity/participation-parents-required":
    "Seleccione al menos un padre",
  "api/models/Entity/participation-parents-required-description":
    "Una participación debe tener al menos un padre activo.",
  "api/models/Entity/participation-program-immutable":
    "Una participación no puede moverse a otro programa",
  "api/models/Entity/participation-program-immutable-description":
    "El programa de una participación no se puede cambiar una vez establecido.",
  "api/models/Entity/participation-requires-agency":
    "Un nivel de participación requiere una agencia",
  "api/models/Entity/participation-requires-agency-description":
    "Solo las entidades de tipo agencia pueden tener un nivel de participación.",
  "api/models/Entity/participation-requires-alias":
    "Las participaciones operativas deben referir a su entidad legal",
  "api/models/Entity/participation-requires-alias-description":
    "Una participación operativa (agencia 3, 2 o 1) debe ser un alias de una entidad legal canónica.",
  "api/models/Entity/participation-requires-method":
    "Las agencias de un programa se crean mediante el alta de participación",
  "api/models/Entity/participation-requires-method-description":
    "En modo de programa, las entidades de agencia y alias deben crearse mediante el método de alta de participación.",
  "api/models/Entity/program-mode-required":
    "Esta operación solo está disponible dentro de un programa",
  "api/models/Entity/program-mode-required-description":
    "Los vínculos jerárquicos solo se pueden administrar en una compañía que opera por programas.",
  "api/models/Entity/program-root-immutable":
    "El indicador de raíz de programa no se puede cambiar",
  "api/models/Entity/program-root-immutable-description":
    "Si una participación es raíz de programa no se puede cambiar después de creada.",
  "api/models/Entity/program-root-invalid":
    "La referencia al programa no es válida",
  "api/models/Entity/program-root-invalid-description":
    "El programa, el nivel y el indicador de raíz de programa de la participación deben ser consistentes entre sí.",
  "api/models/Entity/registration/access-denied": "Sin autorización",
  "api/models/Entity/registration/access-denied-description":
    "No tienes autorización para registrar entidades en este contexto.",
  "api/models/Entity/registration/already-associated-with-agency":
    "Ya registrada en esta agencia",
  "api/models/Entity/registration/already-associated-with-agency-description":
    "Esta cedente ya está registrada en esta agencia.",
  "api/models/Entity/registration/appointed-carrier-not-registrable":
    "No se puede establecer aseguradora asignada aquí",
  "api/models/Entity/registration/appointed-carrier-not-registrable-description":
    "AppointedCarrier no puede cambiarse mediante el registro.",
  "api/models/Entity/registration/auth-required": "Autenticación requerida",
  "api/models/Entity/registration/auth-required-description":
    "Inicia sesión para usar el registro.",
  "api/models/Entity/registration/country-not-enabled": "País no disponible",
  "api/models/Entity/registration/country-not-enabled-description":
    "El registro aún no está disponible para este país.",
  "api/models/Entity/registration/duplicate": "Ya registrada",
  "api/models/Entity/registration/duplicate-description":
    "Ya existe una aseguradora con este identificador.",
  "api/models/Entity/registration/identifier-required":
    "Identificador oficial requerido",
  "api/models/Entity/registration/identifier-required-description":
    "Las cedentes y aseguradoras requieren su identificador oficial.",
  "api/models/Entity/registration/identity-fields-server-derived":
    "Los campos de identidad los calcula la plataforma",
  "api/models/Entity/registration/identity-fields-server-derived-description":
    "Elimina de la solicitud los campos de identidad normalizados.",
  "api/models/Entity/registration/identity-lookup-token-invalid":
    "La consulta expiró",
  "api/models/Entity/registration/identity-lookup-token-invalid-description":
    "Vuelve a consultar el identificador antes de continuar.",
  "api/models/Entity/registration/identity-target-invalid":
    "Destino de identidad inválido",
  "api/models/Entity/registration/identity-target-invalid-description":
    "Solo se puede aplicar una identidad verificada a una persona moral canónica activa.",
  "api/models/Entity/registration/insurer-facet-requires-registration":
    "Usa el flujo de registro",
  "api/models/Entity/registration/insurer-facet-requires-registration-description":
    "Las cedentes y aseguradoras solo se activan mediante el registro por país.",
  "api/models/Entity/registration/invalid-context":
    "Contexto de registro requerido",
  "api/models/Entity/registration/invalid-context-ambiguous-agency":
    "Contacta a tu administrador",
  "api/models/Entity/registration/invalid-context-ambiguous-agency-description":
    "Perteneces a más de una agencia; pide a tu administrador que registre esta cedente en la agencia correcta.",
  "api/models/Entity/registration/invalid-context-description":
    "No pudimos determinar dónde registrar esta entidad.",
  "api/models/Entity/registration/invalid-format": "Identificador inválido",
  "api/models/Entity/registration/invalid-format-description":
    "El identificador no cumple el formato o dígito verificador oficial de este país.",
  "api/models/Entity/registration/legal-name-required":
    "Razón social requerida",
  "api/models/Entity/registration/legal-name-required-description":
    "Captura la razón social para continuar.",
  "api/models/Entity/registration/lookup-failed": "La consulta falló",
  "api/models/Entity/registration/lookup-failed-description":
    "No pudimos verificar el identificador. Inténtalo de nuevo.",
  "api/models/Entity/registration/member-flow-required": "Miembro del programa",
  "api/models/Entity/registration/member-flow-required-description":
    "Esta aseguradora es miembro original del programa y opera mediante el flujo de miembros.",
  "api/models/Entity/registration/namespace-conflict":
    "Identificador ya registrado en otra jurisdicción",
  "api/models/Entity/registration/namespace-conflict-description":
    "El mismo identificador oficial existe con otro país. Se requiere una corrección autorizada.",
  "api/models/Entity/registration/prohibited-identifier":
    "Identificador genérico no permitido",
  "api/models/Entity/registration/prohibited-identifier-description":
    "No se pueden registrar identificadores genéricos o compartidos; usa el identificador propio de la entidad.",
  "api/models/Entity/registration/soft-deleted": "Se requiere restauración",
  "api/models/Entity/registration/soft-deleted-description":
    "Esta entidad fue eliminada; un usuario con permiso debe restaurarla.",
  "api/models/Entity/registration/stale-save":
    "Este identificador acaba de ser registrado por alguien más",
  "api/models/Entity/registration/stale-save-description":
    "Un registro concurrente reclamó primero este identificador. Recarga e inténtalo de nuevo.",
  "api/models/Entity/registration/unavailable": "Registro no disponible",
  "api/models/Entity/registration/unavailable-description":
    "El registro está deshabilitado en este momento.",
  "api/models/Entity/registration/unexpected-attributes": "Solicitud inválida",
  "api/models/Entity/registration/unexpected-attributes-description":
    "Solo se pueden enviar razón social, nombre comercial y fecha de constitución.",
  "api/models/Entity/reparent-reserved":
    "Solo la administración de la plataforma puede cambiar los padres",
  "api/models/Entity/reparent-reserved-description":
    "Cambiar los padres de una participación está reservado a la administración de la plataforma a nivel compañía.",
  "api/models/Entity/save-policy-party/auth-required":
    "Autenticación requerida",
  "api/models/Entity/save-policy-party/auth-required-description":
    "Inicia sesión para guardar una parte de una póliza.",
  "api/models/Entity/save-policy-party/existing-party-out-of-reach":
    "Esta persona o empresa ya existe",
  "api/models/Entity/save-policy-party/existing-party-out-of-reach-description":
    "Ya existe una persona o empresa con estos datos y está fuera de tu acceso, por lo que no se puede vincular desde aquí. Un administrador puede vincularla a la póliza.",
  "api/models/Entity/save-policy-party/forbidden":
    "No se puede guardar la parte",
  "api/models/Entity/save-policy-party/forbidden-description":
    "No tienes permiso para cambiar las partes de esta póliza.",
  "api/models/Entity/save-policy-party/identity-fields-admin-only":
    "Solo un administrador puede cambiar esto",
  "api/models/Entity/save-policy-party/identity-fields-admin-only-description":
    "La razón social y la fecha de constitución de una empresa que ya existe solo las puede cambiar un administrador. El resto de los datos sí se puede guardar.",
  "api/models/Entity/save-policy-party/invalid-request":
    "Solicitud de parte inválida",
  "api/models/Entity/save-policy-party/invalid-request-description":
    "La solicitud incluye un campo que esta acción no acepta.",
  "api/models/Entity/save-policy-party/protected-entity":
    "Este registro no se puede editar aquí",
  "api/models/Entity/save-policy-party/protected-entity-description":
    "Esta persona o empresa también es un usuario, una agencia, una cedente u otro tipo de registro, por lo que sus datos no se pueden cambiar desde una póliza.",
  "api/models/Entity/save-policy-party/stale": "La póliza cambió",
  "api/models/Entity/save-policy-party/stale-description":
    "Alguien más modificó la póliza mientras guardabas. Vuelve a cargarla e inténtalo de nuevo.",
  "api/models/Entity/shared-identity-read-only":
    "Los datos de identidad legal compartidos no se pueden editar.",
  "api/models/Entity/shared-identity-read-only-description":
    "Solo un administrador de la compañía de esta cuenta, o un administrador de plataforma, puede cambiar estos datos.",
  "api/models/Entity/tax-id-already-exists": "El RFC ya está registrado",
  "api/models/Entity/tax-id-already-exists-description":
    "Ya existe una compañía registrada con el RFC proporcionado. En caso de que la información sea correcta, puedes utilizar el cliente existente, de lo contrario verifica la información e intenta nuevamente.",
  "api/models/Entity/token-secret-not-configured":
    "Error de Configuración de Token",
  "api/models/Entity/token-secret-not-configured-description":
    "El secreto de firma del token JWT no está configurado. Contacte a su administrador.",
  "api/models/Entity/type-can-not-be-modified": "No se puede modificar el tipo",
  "api/models/Entity/type-can-not-be-modified-description":
    "No se puede modificar el tipo de entidad una vez que ha sido creado.",
  "api/models/Entity/type-is-not-valid": "Tipo inválido",
  "api/models/Entity/type-is-not-valid-description":
    'El tipo de entidad debe ser "natural" o "legal". El valor proporcionado no es válido.',
  "api/models/EntityAgencyRegistration/immutable":
    "El registro no se puede modificar",
  "api/models/EntityAgencyRegistration/immutable-description":
    "Un registro de cedente no se puede modificar una vez creado.",
  "api/models/EntityAgencyRegistration/not-deletable":
    "El registro no se puede eliminar",
  "api/models/EntityAgencyRegistration/not-deletable-description":
    "Los registros de cedentes no se pueden eliminar.",
  "api/models/EntityAgencyRegistration/registration-service-only":
    "El registro no se puede crear aquí",
  "api/models/EntityAgencyRegistration/registration-service-only-description":
    "Los registros de cedentes solo se crean mediante el flujo de registro.",
  "api/models/EntityContact/contact-already-linked": "Contacto Ya Vinculado",
  "api/models/EntityContact/contact-already-linked-description":
    "Este contacto ya está vinculado a la entidad.",
  "api/models/EntityContact/contact-entity-not-found": "Contacto No Encontrado",
  "api/models/EntityContact/contact-entity-not-found-description":
    "La entidad de contacto especificada no existe.",
  "api/models/EntityContact/contact-must-be-natural":
    "El Contacto Debe Ser Persona Física",
  "api/models/EntityContact/contact-must-be-natural-description":
    "Solo las entidades de tipo natural pueden ser agregadas como contactos.",
  "api/models/EntityContact/entity-id-required": "ID de Entidad Requerido",
  "api/models/EntityContact/entity-id-required-description":
    "EntityId es requerido para crear una relación de contacto.",
  "api/models/EntityContact/missing-required-fields":
    "Campos Requeridos Faltantes",
  "api/models/EntityContact/missing-required-fields-description":
    "EntityId y ContactId son requeridos para crear una relación de contacto.",
  "api/models/EntityContact/reports-to-different-entity":
    "El Gerente Pertenece a una Entidad Diferente",
  "api/models/EntityContact/reports-to-different-entity-description":
    "El contacto ReportsTo debe pertenecer a la misma entidad.",
  "api/models/EntityContact/reports-to-not-found": "Gerente No Encontrado",
  "api/models/EntityContact/reports-to-not-found-description":
    "El registro de contacto ReportsTo especificado no existe o ha sido eliminado.",
  "api/models/EntityContact/self-contact-not-allowed":
    "Auto-Contacto No Permitido",
  "api/models/EntityContact/self-contact-not-allowed-description":
    "Una entidad no puede ser vinculada a sí misma como contacto.",
  "api/models/EntityEmail/email-already-exists":
    "El correo electrónico ya está registrado",
  "api/models/EntityEmail/email-already-exists-description":
    "El correo electrónico ya está registrado",
  "api/models/EntityEmail/entity-email-is-invalid":
    "Correo electrónico inválido",
  "api/models/EntityEmail/entity-email-is-invalid-description":
    "El correo electrónico proporcionado no es válido.",
  "api/models/EntityEmail/entity-email-is-required":
    "El correo electrónico es necesario",
  "api/models/EntityEmail/entity-email-is-required-description":
    "El correo electrónico es necesario al crear un nuevo correo electrónico de entidad",
  "api/models/EntityEmail/entity-id-is-required":
    "Es necesario el Id de la entidad",
  "api/models/EntityEmail/entity-id-is-required-description":
    "Es necesario el Id de la entidad al crear un nuevo correo electrónico de entidad",
  "api/models/EntityEmail/entity-not-found": "Entidad no encontrada",
  "api/models/EntityEmail/entity-not-found-description":
    "No se encontró la entidad proporcionada",
  "api/models/EntityFile/entity-id-is-required":
    "Es necesario el Id de la entidad",
  "api/models/EntityFile/entity-id-is-required-description":
    "Es necesario el Id de la entidad",
  "api/models/EntityFile/entity-not-found": "Entidad no encontrada",
  "api/models/EntityFile/entity-not-found-description": "Entidad no encontrada",
  "api/models/EntityIdentifierAlias/identity-service-only":
    "El alias de identificador no se puede crear aquí",
  "api/models/EntityIdentifierAlias/identity-service-only-description":
    "Los alias de identificador solo los crea el servicio de identidad de la plataforma.",
  "api/models/EntityIdentifierAlias/immutable":
    "El alias de identificador no se puede modificar",
  "api/models/EntityIdentifierAlias/immutable-description":
    "Un alias de identificador no se puede modificar una vez creado.",
  "api/models/EntityIdentifierAlias/not-deletable":
    "El alias de identificador no se puede eliminar",
  "api/models/EntityIdentifierAlias/not-deletable-description":
    "Los alias de identificador no se pueden eliminar.",
  "api/models/EntityIdentifierDefinition/incomplete-definition":
    "La definición del identificador está incompleta",
  "api/models/EntityIdentifierDefinition/incomplete-definition-description":
    "Solo se puede habilitar una definición con formato, política de dígito verificador, casos de prueba y evidencia verificados.",
  "api/models/EntityIdentifierDefinition/migration-only":
    "Las definiciones de identificador son de solo lectura",
  "api/models/EntityIdentifierDefinition/migration-only-description":
    "Las definiciones de identificador solo se crean y modifican mediante migraciones de base de datos.",
  "api/models/EntityIdentifierDefinition/unknown-checksum-algorithm":
    "Algoritmo de dígito verificador desconocido",
  "api/models/EntityIdentifierDefinition/unknown-checksum-algorithm-description":
    "La definición hace referencia a un algoritmo no registrado.",
  "api/models/EntityPhone/Phone-already-exists":
    "El teléfono ya está registrado",
  "api/models/EntityPhone/Phone-already-exists-description":
    "El número de teléfono ya está registrado. Por favor, utiliza uno diferente.",
  "api/models/EntityPhone/entity-Phone-is-invalid": "Teléfono no válido",
  "api/models/EntityPhone/entity-Phone-is-invalid-description":
    "El número de teléfono proporcionado no es válido",
  "api/models/EntityPhone/entity-Phone-is-required": "Es necesario el teléfono",
  "api/models/EntityPhone/entity-Phone-is-required-description":
    "Es necesario el teléfono",
  "api/models/EntityPhone/entity-id-is-required":
    "Es necesario el Id de la entidad",
  "api/models/EntityPhone/entity-id-is-required-description":
    "Es necesario el Id de la entidad",
  "api/models/EntityPhone/entity-not-found": "Entidad no encontrada",
  "api/models/EntityPhone/entity-not-found-description":
    "No se encontró la entidad con el Id proporcionado",
  "api/models/EntityRegistrationLookup/registration-service-only":
    "La consulta no se puede escribir aquí",
  "api/models/EntityRegistrationLookup/registration-service-only-description":
    "Las consultas de registro solo las escribe el servicio de registro.",
  "api/models/EntityRegulatoryException/company-id-is-required":
    "Se requiere una compañía",
  "api/models/EntityRegulatoryException/company-id-is-required-description":
    "La excepción debe pertenecer a una compañía.",
  "api/models/EntityRegulatoryException/company-mismatch":
    "La compañía no coincide con la solicitud",
  "api/models/EntityRegulatoryException/company-mismatch-description":
    "Solo se puede crear una excepción para la compañía de la sesión.",
  "api/models/EntityRegulatoryException/created-by-is-server-derived":
    "No se puede indicar el autor de una excepción",
  "api/models/EntityRegulatoryException/created-by-is-server-derived-description":
    "El autor siempre es el usuario que crea la excepción.",
  "api/models/EntityRegulatoryException/entity-id-is-required":
    "Se requiere una aseguradora",
  "api/models/EntityRegulatoryException/entity-id-is-required-description":
    "Elija la aseguradora a la que aplica la excepción.",
  "api/models/EntityRegulatoryException/entity-not-found":
    "No se encontró la aseguradora",
  "api/models/EntityRegulatoryException/entity-not-found-description":
    "La aseguradora no existe o no es aseguradora de esta compañía.",
  "api/models/EntityRegulatoryException/ids-are-immutable":
    "No se puede cambiar la aseguradora ni la compañía",
  "api/models/EntityRegulatoryException/ids-are-immutable-description":
    "Elimine la excepción y cree una nueva.",
  "api/models/EntityRegulatoryException/note-is-required":
    "Se requiere una nota",
  "api/models/EntityRegulatoryException/note-is-required-description":
    "Explique por qué esta aseguradora está activa aunque el regulador no la liste.",
  "api/models/EntityRegulatoryException/update-not-allowed":
    "No se puede editar una excepción",
  "api/models/EntityRegulatoryException/update-not-allowed-description":
    "Elimine la excepción y cree una nueva.",
  "api/models/EntityRole/account-not-found": "Cuenta no encontrada",
  "api/models/EntityRole/account-not-found-description":
    "No se encontró la entidad de cuenta especificada",
  "api/models/EntityRole/agency-assignment-requires-participation":
    "Esta agencia todavía no pertenece a un programa.",
  "api/models/EntityRole/agency-assignment-requires-participation-description":
    "Las asignaciones de rol con alcance de agencia requieren que la agencia forme parte de un programa de participación.",
  "api/models/EntityRole/agency-not-found": "Agencia no encontrada",
  "api/models/EntityRole/agency-not-found-description":
    "No se encontró la entidad de agencia especificada",
  "api/models/EntityRole/agency-not-in-company":
    "La agencia no pertenece a esta compañía",
  "api/models/EntityRole/agency-not-in-company-description":
    "La agencia especificada no está vinculada a la compañía actual. Solo se pueden asignar roles a agencias dentro de su compañía.",
  "api/models/EntityRole/assignment-limit-reached":
    "Esta persona ya tiene el máximo de roles permitido",
  "api/models/EntityRole/assignment-limit-reached-description":
    "Esta persona ya tiene tantas asignaciones de rol como permite esta compañía. Para cambiar su rol, elimina la asignación actual y después agrega la nueva.",
  "api/models/EntityRole/assignment-mixed-scope-types":
    "No se pueden combinar roles de agencia y de cedente",
  "api/models/EntityRole/assignment-mixed-scope-types-description":
    "Esta persona tiene un rol del otro tipo (agencia o cedente), y esta compañía no permite ambos en la misma persona. Elimina primero el rol actual.",
  "api/models/EntityRole/assignment-options-invalid-body":
    "La persona a la que se asignaría el rol no es válida",
  "api/models/EntityRole/assignment-options-invalid-body-description":
    "Envía el cuerpo vacío, o un objeto cuyo EntityId sea el id de la persona (texto).",
  "api/models/EntityRole/assignment-out-of-scope":
    "Esta asignación está fuera de tu autoridad de programa.",
  "api/models/EntityRole/assignment-out-of-scope-description":
    "Un administrador de programa solo puede asignar o quitar roles de agencia y cedente (por debajo de admin) dentro de su propio programa.",
  "api/models/EntityRole/cedent-not-found": "Cedente no encontrado",
  "api/models/EntityRole/cedent-not-found-description":
    "No se encontró la entidad de cedente especificada",
  "api/models/EntityRole/cedent-not-in-program":
    "Este cedente no pertenece a ese programa.",
  "api/models/EntityRole/cedent-not-in-program-description":
    "El cedente debe ser miembro activo del programa, o estar registrado como agencia en él.",
  "api/models/EntityRole/cedent-not-insurer":
    "La entidad no es una aseguradora",
  "api/models/EntityRole/cedent-not-insurer-description":
    "La entidad especificada no tiene IsInsurer establecido como verdadero",
  "api/models/EntityRole/company-account-agency-exclusive":
    "Compañía, Cuenta y Agencia son mutuamente excluyentes",
  "api/models/EntityRole/company-account-agency-exclusive-description":
    "Solo se puede proporcionar uno de CompanyId, AccountId o AgencyId",
  "api/models/EntityRole/company-account-or-agency-required":
    "Compañía, Cuenta o Agencia requerida",
  "api/models/EntityRole/company-account-or-agency-required-description":
    "Se debe proporcionar exactamente uno de CompanyId, AccountId o AgencyId",
  "api/models/EntityRole/company-not-found": "Compañía no encontrada",
  "api/models/EntityRole/company-not-found-description":
    "Compañía no encontrada",
  "api/models/EntityRole/company-role-requires-no-program":
    "Una asignación con alcance de compañía no puede indicar un programa.",
  "api/models/EntityRole/entity-not-agency": "La entidad no es una agencia",
  "api/models/EntityRole/entity-not-agency-description":
    "La entidad especificada no tiene IsAgency establecido como verdadero",
  "api/models/EntityRole/entity-not-found": "Entidad no encontrada",
  "api/models/EntityRole/entity-not-found-description":
    "No se encontró la entidad especificada",
  "api/models/EntityRole/global-role-super-admin-only":
    "Solo un superadministrador puede administrar roles globales.",
  "api/models/EntityRole/global-role-super-admin-only-description":
    "Un rol sin alcance de compañía, cuenta, agencia o cedente solo puede ser asignado o quitado por un superadministrador.",
  "api/models/EntityRole/program-context-mismatch":
    "El programa proporcionado no coincide con el contexto de la solicitud.",
  "api/models/EntityRole/program-context-mismatch-description":
    "Una asignación con alcance de cedente dentro de una solicitud de programa debe indicar ese mismo programa.",
  "api/models/EntityRole/program-required":
    "Se requiere un programa para esta asignación.",
  "api/models/EntityRole/program-required-description":
    "Las asignaciones con alcance de cedente hechas fuera de un contexto de solicitud deben indicar un programa explícitamente.",
  "api/models/EntityRole/replace-assignment-invalid-body":
    "Se requieren un id de eliminación y una asignación de reemplazo completa.",
  "api/models/EntityRole/replace-assignment-invalid-body-description":
    "El cuerpo debe incluir removeAssignmentId además de create.EntityId y create.RoleId.",
  "api/models/EntityRole/replace-assignment-reserved":
    "Esta asignación requiere autoridad de administrador de compañía.",
  "api/models/EntityRole/replace-assignment-reserved-description":
    "Reemplazar una asignación requiere un grupo companyAdmin con alcance de compañía para la compañía dueña tanto de la asignación eliminada como de la creada (o superAdmin).",
  "api/models/EntityRole/reserved-assignment":
    "Esta asignación requiere autoridad de administrador de compañía.",
  "api/models/EntityRole/reserved-assignment-description":
    "Crear o quitar un companyAdmin, o un agencyAdmin en la raíz de un programa, requiere un grupo companyAdmin con alcance de compañía para la compañía objetivo.",
  "api/models/EntityRole/role-already-assigned": "Rol ya asignado",
  "api/models/EntityRole/role-already-assigned-description":
    "Este usuario ya tiene este rol asignado",
  "api/models/EntityRole/role-cant-be-updated": "No se puede actualizar el rol",
  "api/models/EntityRole/role-cant-be-updated-description":
    "Los roles no pueden ser modificados, solo agregados o eliminados",
  "api/models/EntityRole/role-not-found":
    "No se encontró la asignación a reemplazar.",
  "api/models/EntityRole/role-not-found-description":
    "La asignación indicada por removeAssignmentId no existe o ya fue eliminada.",
  "api/models/EntityRole/target-entity-not-found":
    "Entidad objetivo no encontrada",
  "api/models/EntityRole/target-entity-not-found-description":
    "Entidad objetivo no encontrada",
  "api/models/ExternalCatalogue/company-id-is-required":
    "El catálogo necesita una compañía",
  "api/models/ExternalCatalogue/company-id-is-required-description":
    "Elige la compañía a la que pertenece el catálogo",
  "api/models/ExternalCatalogue/company-not-allowed": "Compañía no permitida",
  "api/models/ExternalCatalogue/company-not-allowed-description":
    "No puedes administrar catálogos de esa compañía",
  "api/models/ExternalCatalogue/company-not-found": "Compañía no encontrada",
  "api/models/ExternalCatalogue/company-not-found-description":
    "La compañía del catálogo no existe",
  "api/models/ExternalCatalogue/has-enabled-codes":
    "El catálogo aún tiene códigos activos",
  "api/models/ExternalCatalogue/has-enabled-codes-description":
    "Desactiva todos los códigos antes de eliminar el catálogo",
  "api/models/ExternalCatalogue/immutable-field":
    "El campo no se puede cambiar",
  "api/models/ExternalCatalogue/immutable-field-description":
    "La clave y la compañía de un catálogo no se pueden cambiar después de crearlo",
  "api/models/ExternalCatalogue/key-already-exists":
    "La clave del catálogo ya existe",
  "api/models/ExternalCatalogue/key-already-exists-description":
    "Esta compañía ya tiene un catálogo activo con esa clave",
  "api/models/ExternalCatalogue/key-invalid": "Clave de catálogo no válida",
  "api/models/ExternalCatalogue/key-invalid-description":
    "La clave solo puede contener letras minúsculas, números y guiones",
  "api/models/ExternalCatalogue/key-is-required":
    "El catálogo necesita una clave",
  "api/models/ExternalCatalogue/key-is-required-description":
    "Escribe una clave para el catálogo externo",
  "api/models/ExternalCatalogue/name-is-required":
    "El catálogo necesita un nombre",
  "api/models/ExternalCatalogue/name-is-required-description":
    "Escribe un nombre para el catálogo externo",
  "api/models/ExternalCatalogueCode/catalogue-disabled":
    "El catálogo está desactivado",
  "api/models/ExternalCatalogueCode/catalogue-disabled-description":
    "Activa el catálogo antes de agregarle códigos",
  "api/models/ExternalCatalogueCode/catalogue-not-found":
    "Catálogo no encontrado",
  "api/models/ExternalCatalogueCode/catalogue-not-found-description":
    "El catálogo externo no existe o no está disponible para ti",
  "api/models/ExternalCatalogueCode/code-already-assigned":
    "El código ya está asignado",
  "api/models/ExternalCatalogueCode/code-already-assigned-description":
    "Otra cedente tiene ese código en este catálogo",
  "api/models/ExternalCatalogueCode/code-is-required":
    "El código es obligatorio",
  "api/models/ExternalCatalogueCode/code-is-required-description":
    "Escribe el código asignado a la cedente",
  "api/models/ExternalCatalogueCode/entity-already-has-code":
    "La cedente ya tiene un código",
  "api/models/ExternalCatalogueCode/entity-already-has-code-description":
    "Desactiva su código actual en este catálogo antes de asignar otro",
  "api/models/ExternalCatalogueCode/entity-not-insurer":
    "La cedente no es válida para este catálogo",
  "api/models/ExternalCatalogueCode/entity-not-insurer-description":
    "Elige una cedente activa de la misma compañía",
  "api/models/ExternalCatalogueCode/immutable-field":
    "El campo no se puede cambiar",
  "api/models/ExternalCatalogueCode/immutable-field-description":
    "Para corregir un código, desactívalo y asigna uno nuevo",
  "api/models/ExternalCatalogueCode/mutation-not-allowed":
    "Operación no permitida",
  "api/models/ExternalCatalogueCode/mutation-not-allowed-description":
    "Los códigos se desactivan; nunca se eliminan ni se modifican en lote",
  "api/models/FileUploadTicket/content-type-not-allowed":
    "Este tipo de archivo no está permitido.",
  "api/models/FileUploadTicket/file-too-large":
    "El archivo excede el tamaño máximo.",
  "api/models/FileUploadTicket/key-not-issued":
    "No se pudo verificar el archivo subido. Súbelo de nuevo.",
  "api/models/FileUploadTicket/service-only":
    "Los tickets de carga no se pueden modificar",
  "api/models/FileUploadTicket/service-only-description":
    "Los tickets de carga solo los emite y consume el servicio de archivos.",
  "api/models/FileUploadTicket/upload-not-authorized":
    "No tienes permiso para subir archivos a este registro.",
  "api/models/FormDefinition/invalid-collection-config":
    "Configuración de colección inválida",
  "api/models/FormDefinition/invalid-config":
    "Configuración de formulario inválida",
  "api/models/FormDefinition/reserved-submit-platform-managed":
    "Esta acción del formulario no se puede definir",
  "api/models/FormDefinition/reserved-submit-platform-managed-description":
    "Los formularios que envían una acción de autoridad reservada los define la plataforma, no la API",
  "api/models/FormField/invalid-config":
    "Configuración de campo de formulario inválida",
  "api/models/FormRule/invalid-rule": "Regla de formulario inválida",
  "api/models/GeneratedDocument/invalid-definition-version":
    "Versión de definición inválida",
  "api/models/GeneratedDocument/invalid-definition-version-description":
    "La versión debe pertenecer a una definición de documento de la compañía de la póliza.",
  "api/models/GeneratedDocument/invalid-format":
    "Formato de documento inválido",
  "api/models/GeneratedDocument/invalid-format-description":
    "Elige PDF o Word.",
  "api/models/GeneratedDocument/invalid-letterhead-version":
    "Versión de membrete inválida",
  "api/models/GeneratedDocument/invalid-letterhead-version-description":
    "El membrete debe pertenecer a la compañía de la póliza o ser el predeterminado de la instancia.",
  "api/models/GeneratedDocument/invalid-storage-key":
    "El archivo generado no pertenece a esta empresa",
  "api/models/GeneratedDocument/invalid-storage-key-description":
    "La clave de almacenamiento no fue emitida para esta empresa y sujeto.",
  "api/models/GeneratedDocument/invalid-subject":
    "Sujeto de documento inválido",
  "api/models/GeneratedDocument/invalid-subject-description":
    "Un documento de póliza debe referirse a su propia póliza.",
  "api/models/GeneratedDocument/policy-id-required": "Se requiere una póliza",
  "api/models/GeneratedDocument/policy-id-required-description":
    "Un documento generado pertenece a una póliza.",
  "api/models/GeneratedDocument/policy-not-found": "Póliza no encontrada",
  "api/models/GeneratedDocument/policy-not-found-description":
    "El documento generado debe pertenecer a una póliza existente.",
  "api/models/GeneratedDocument/record-immutable":
    "Un documento generado no se puede modificar",
  "api/models/GeneratedDocument/record-immutable-description":
    "Los documentos generados solo se agregan; solo la expiración borra el archivo guardado.",
  "api/models/GeneratedDocument/scope-field-immutable":
    "Un campo de alcance no se puede cambiar",
  "api/models/GeneratedDocument/storage-key-required":
    "El archivo generado es obligatorio",
  "api/models/GeneratedDocument/storage-key-required-description":
    "Guarda el archivo antes de registrar el documento.",
  "api/models/IndividualVehicleCommissionTable/entity-id-is-required":
    "Es necesario el Id de la entidad",
  "api/models/IndividualVehicleCommissionTable/entity-id-is-required-description":
    "Es necesario el Id de la entidad",
  "api/models/IndividualVehicleCommissionTable/entity-not-found":
    "Entidad no encontrada",
  "api/models/IndividualVehicleCommissionTable/entity-not-found-description":
    "Entidad no encontrada",
  "api/models/InstanceSetting/bulk-write-forbidden":
    "Escritura masiva prohibida",
  "api/models/InstanceSetting/bulk-write-forbidden-description":
    "La configuración de instancia solo se escribe fila por fila, para validar cada valor.",
  "api/models/InstanceSetting/company-and-key-required":
    "Compañía y clave requeridas",
  "api/models/InstanceSetting/company-and-key-required-description":
    "La configuración de instancia requiere una compañía y una clave.",
  "api/models/InstanceSetting/protected-key-forbidden":
    "Configuración protegida",
  "api/models/InstanceSetting/protected-key-forbidden-description":
    "Solo un superadministrador puede cambiar esta configuración.",
  "api/models/InstanceSetting/sender-forbidden":
    "Cambio de remitente prohibido",
  "api/models/InstanceSetting/sender-forbidden-description":
    "Solo un superadministrador puede definir, cambiar o quitar el remitente de notificaciones de una compañía.",
  "api/models/InstanceSetting/value-invalid": "Valor de configuración inválido",
  "api/models/InstanceSetting/value-invalid-description":
    "El valor no coincide con la forma que requiere esta clave.",
  "api/models/Letterhead/bulk-write-refused": "No se permiten cambios masivos",
  "api/models/Letterhead/bulk-write-refused-description":
    "Modifica los membretes uno por uno.",
  "api/models/Letterhead/company-required": "Se requiere una compañía",
  "api/models/Letterhead/company-required-description":
    "Solo el membrete predeterminado no tiene compañía.",
  "api/models/Letterhead/default-super-admin-only":
    "Solo un superadministrador puede cambiar el membrete predeterminado",
  "api/models/Letterhead/default-super-admin-only-description":
    "El membrete predeterminado de la instancia es compartido por todas las compañías.",
  "api/models/Letterhead/invalid-current-version": "Versión vigente inválida",
  "api/models/Letterhead/invalid-current-version-description":
    "La versión vigente debe ser una versión publicada de este membrete.",
  "api/models/Letterhead/invalid-owner": "Propietario de membrete inválido",
  "api/models/Letterhead/invalid-owner-description":
    "Un membrete de agencia o cedente requiere una entidad agencia o aseguradora de la compañía; los demás membretes no llevan propietario.",
  "api/models/Letterhead/invalid-owner-type":
    "Tipo de propietario de membrete inválido",
  "api/models/Letterhead/invalid-owner-type-description":
    "Elige predeterminado, compañía, agencia o cedente.",
  "api/models/Letterhead/owner-immutable":
    "Un membrete no puede cambiar de propietario",
  "api/models/Letterhead/owner-immutable-description":
    "La compañía, el tipo de propietario y el propietario se fijan al crear el membrete.",
  "api/models/Letterhead/revision-conflict":
    "El membrete fue modificado por alguien más",
  "api/models/Letterhead/revision-conflict-description":
    "Recarga el membrete e inténtalo de nuevo.",
  "api/models/LetterheadVersion/invalid-letterhead": "El membrete no existe",
  "api/models/LetterheadVersion/invalid-letterhead-description":
    "La versión debe pertenecer a un membrete existente.",
  "api/models/LetterheadVersion/version-immutable":
    "Una versión publicada del membrete no se puede modificar",
  "api/models/LetterheadVersion/version-immutable-description":
    "Guarda un nuevo borrador.",
  "api/models/LineOfBusinessCommissionDefault/invalid-component-rates":
    "Las tasas de comisión predeterminadas no corresponden al componente.",
  "api/models/LineOfBusinessCommissionDefault/invalid-component-rates-description":
    "Los valores de agencia usan tasas por nivel; los de cedente usan una sola tasa.",
  "api/models/LineOfBusinessContentDefinition/identity-fields-are-required":
    "El documento, el espacio de nombres y la clave son obligatorios",
  "api/models/LineOfBusinessContentDefinition/identity-fields-are-required-description":
    "Una definición de contenido se identifica por su documento, espacio de nombres y clave",
  "api/models/LineOfBusinessContentDefinition/invalid-definition":
    "Definición de contenido inválida",
  "api/models/LineOfBusinessContentDefinition/invalid-definition-description":
    "La definición de contenido no es válida para su documento",
  "api/models/LineOfBusinessContentDefinition/line-of-business-id-is-required":
    "La línea de negocio es obligatoria",
  "api/models/LineOfBusinessContentDefinition/line-of-business-id-is-required-description":
    "Una definición de contenido debe pertenecer a una línea de negocio",
  "api/models/LineOfBusinessContentDefinition/line-of-business-not-found":
    "Línea de negocio no encontrada",
  "api/models/LineOfBusinessContentDefinition/line-of-business-not-found-description":
    "La línea de negocio de la definición de contenido no existe",
  "api/models/LineOfBusinessContentDefinition/unresolvable-definition":
    "La definición de contenido no se puede resolver",
  "api/models/LineOfBusinessContentDefinition/unresolvable-definition-description":
    "Una fila de contenido guardada de este documento está mal configurada, por lo que el documento no se puede generar. Los datos del error indican la fila.",
  "api/models/LineOfBusinessContentDefinition/write-forbidden":
    "Las definiciones de contenido solo cambian mediante migración",
  "api/models/LineOfBusinessContentDefinition/write-forbidden-description":
    "Estos registros no se pueden crear, editar ni eliminar mediante la API.",
  "api/models/LineOfBusinessReport/scope-change-not-allowed":
    "Este registro no se puede mover a otra compañía.",
  "api/models/MotorQuote/missing-scope": "Alcance de la cotización faltante",
  "api/models/MotorQuote/missing-scope-description":
    "La propuesta padre no tiene alcance de compañía.",
  "api/models/MotorQuote/policy-id-is-required": "Póliza requerida",
  "api/models/MotorQuote/policy-id-is-required-description":
    "Una cotización Motor debe pertenecer a una propuesta.",
  "api/models/MotorQuote/policy-not-found": "Propuesta no encontrada",
  "api/models/MotorQuote/policy-not-found-description":
    "La propuesta a la que pertenece esta cotización no existe.",
  "api/models/MotorQuoteCoverage/coverage-definition-mismatch":
    "La definición de cobertura no coincide",
  "api/models/MotorQuoteCoverage/coverage-definition-mismatch-description":
    "El CoverageDefinitionId proporcionado debe coincidir con el CoverageDefinitionId de la cobertura del objeto asegurado resuelta.",
  "api/models/MotorQuoteCoverage/coverage-definition-not-found":
    "Definición de cobertura no encontrada",
  "api/models/MotorQuoteCoverage/coverage-definition-not-found-description":
    "La definición de cobertura referenciada no existe.",
  "api/models/MotorQuoteCoverage/duplicate-coverage":
    "Resultado de tarificación de cobertura duplicado",
  "api/models/MotorQuoteCoverage/duplicate-coverage-description":
    "Ya existe un resultado de tarificación para esta cotización de motor y cobertura del objeto asegurado.",
  "api/models/MotorQuoteCoverage/motor-quote-id-is-required":
    "Se requiere la cotización de motor",
  "api/models/MotorQuoteCoverage/motor-quote-id-is-required-description":
    "Proporciona el MotorQuoteId al que pertenece este resultado de tarificación.",
  "api/models/MotorQuoteCoverage/motor-quote-not-found":
    "Cotización de motor no encontrada",
  "api/models/MotorQuoteCoverage/motor-quote-not-found-description":
    "La cotización de motor referenciada no existe.",
  "api/models/MotorQuoteCoverage/subject-matter-coverage-id-is-required":
    "Se requiere la cobertura del objeto asegurado",
  "api/models/MotorQuoteCoverage/subject-matter-coverage-id-is-required-description":
    "Proporciona el SubjectMatterCoverageId para el que se calculó este resultado de tarificación.",
  "api/models/MotorQuoteCoverage/subject-matter-coverage-not-found":
    "Cobertura del objeto asegurado no encontrada",
  "api/models/MotorQuoteCoverage/subject-matter-coverage-not-found-description":
    "La cobertura del objeto asegurado referenciada no existe.",
  "api/models/NavigationShortcut/invalid": "Acceso directo inválido",
  "api/models/NavigationShortcut/invalid-access-role-ids":
    "Los roles deben ser una lista no vacía de identificadores de rol, o ninguno.",
  "api/models/NavigationShortcut/invalid-target":
    "El destino debe ser un catálogo o una definición de objeto asegurado activo, o la configuración de fuentes del catálogo, de esta compañía.",
  "api/models/NavigationShortcut/label-required":
    "Proporciona una etiqueta o una clave de traducción, no ambas.",
  "api/models/NavigationShortcut/parent-company-mismatch":
    "El acceso directo padre pertenece a otra compañía.",
  "api/models/NavigationShortcut/parent-cycle":
    "Un acceso directo no puede estar dentro de sí mismo.",
  "api/models/NavigationShortcut/parent-not-found":
    "El acceso directo padre no existe.",
  "api/models/NavigationShortcut/target-required":
    "Este tipo de acceso directo necesita un destino. Solo un grupo no lo tiene.",
  "api/models/Notification/not-recipient":
    "Esta notificación pertenece a otro usuario",
  "api/models/Notification/not-recipient-description":
    "Solo puedes leer y marcar tus propias notificaciones.",
  "api/models/Notification/write-forbidden":
    "Las notificaciones solo las escribe el centro de notificaciones",
  "api/models/Notification/write-forbidden-description":
    "Las notificaciones no se pueden crear, editar ni eliminar mediante la API de datos genérica.",
  "api/models/ParticipationCedent/engine-managed":
    "Las filas de disponibilidad las administra el sistema",
  "api/models/ParticipationCedent/engine-managed-description":
    "Activa o desactiva la cedente; las filas no se pueden crear ni eliminar a mano.",
  "api/models/ParticipationCedent/immutable-field":
    "El campo no se puede cambiar",
  "api/models/ParticipationCedent/immutable-field-description":
    "Solo se pueden cambiar los interruptores de disponibilidad.",
  "api/models/ParticipationCedent/invalid-arguments":
    "La solicitud de la lista no es válida",
  "api/models/ParticipationCedent/invalid-arguments-description":
    "Revisa el identificador, el texto de búsqueda, el filtro, la página y el tamaño de página enviados.",
  "api/models/ParticipationCedent/not-accessible":
    "No puedes ver estas cedentes",
  "api/models/ParticipationCedent/not-accessible-description":
    "El programa o la agencia está fuera de tu acceso.",
  "api/models/ParticipationCedent/program-disabled":
    "La cedente está desactivada en el programa",
  "api/models/ParticipationCedent/program-disabled-description":
    "Activa la cedente en el programa antes de activarla para una agencia.",
  "api/models/ParticipationClosure/engine-managed":
    "La clausura jerárquica es administrada por la plataforma",
  "api/models/ParticipationClosure/engine-managed-description":
    "Las filas de la clausura jerárquica se recalculan automáticamente al cambiar los vínculos jerárquicos y no se pueden editar directamente.",
  "api/models/ParticipationEdge/company-mismatch":
    "Ambas participaciones deben pertenecer a la misma compañía",
  "api/models/ParticipationEdge/company-mismatch-description":
    "Un vínculo jerárquico no puede conectar participaciones de compañías distintas.",
  "api/models/ParticipationEdge/cross-program-edge":
    "Los vínculos jerárquicos no pueden cruzar programas",
  "api/models/ParticipationEdge/cross-program-edge-description":
    "Ambos extremos de un vínculo jerárquico operativo deben pertenecer al mismo programa.",
  "api/models/ParticipationEdge/cycle-detected":
    "Este vínculo crearía un ciclo en la jerarquía",
  "api/models/ParticipationEdge/cycle-detected-description":
    "Este vínculo jerárquico haría que una participación fuera su propio ancestro.",
  "api/models/ParticipationEdge/duplicate-edge":
    "Este vínculo jerárquico ya existe",
  "api/models/ParticipationEdge/duplicate-edge-description":
    "Ya existe un vínculo jerárquico activo entre estas participaciones.",
  "api/models/ParticipationEdge/engine-managed":
    "Los vínculos jerárquicos son administrados por la plataforma",
  "api/models/ParticipationEdge/engine-managed-description":
    "Los vínculos jerárquicos se crean y eliminan mediante los métodos de participación; no se permiten cambios masivos ni restauraciones de vínculos.",
  "api/models/ParticipationEdge/immutable":
    "Los vínculos jerárquicos no se pueden modificar; elimínelos y créelos de nuevo",
  "api/models/ParticipationEdge/immutable-description":
    "Un vínculo jerárquico no se puede cambiar una vez creado; elimínelo y cree uno nuevo.",
  "api/models/ParticipationEdge/level-not-adjacent":
    "El padre debe estar exactamente un nivel jerárquico arriba del hijo",
  "api/models/ParticipationEdge/level-not-adjacent-description":
    "Los vínculos jerárquicos solo pueden conectar una participación con el nivel directamente superior.",
  "api/models/ParticipationEdge/not-a-participation":
    "Ambos extremos de un vínculo jerárquico deben ser participaciones de agencia",
  "api/models/ParticipationEdge/not-a-participation-description":
    "Un vínculo jerárquico solo puede conectar dos participaciones de agencia activas.",
  "api/models/ParticipationEdge/self-link":
    "Una participación no puede ser su propio padre",
  "api/models/ParticipationEdge/self-link-description":
    "Un vínculo jerárquico no puede conectar una participación consigo misma.",
  "api/models/Pipeline/invalid-validity-config":
    "La configuración de vigencia del flujo es inválida",
  "api/models/Pipeline/invalid-validity-config-description":
    "La configuración de vigencia del flujo es inválida: {{problem}}.",
  "api/models/PipelineAction/invalid-prominence":
    "La prominencia de la acción es inválida",
  "api/models/PipelineAction/invalid-prominence-description":
    "La prominencia de una acción solo puede ser primary o quedar vacía.",
  "api/models/PipelineAction/invalid-transition":
    "La transición de la acción es inválida",
  "api/models/PipelineAction/invalid-transition-description":
    "La transición de la acción es inválida: {{problem}}.",
  "api/models/PipelineStage/all-steps-hidden":
    "Un FormLayout requiere al menos un paso no oculto",
  "api/models/PipelineStage/box-invalid-config":
    "field.config de un box del DetailLayout debe ser un objeto",
  "api/models/PipelineStage/box-invalid-span":
    "config.span de box debe ser 'half' o 'full'",
  "api/models/PipelineStage/box-invalid-title-key":
    "field.config.titleKey de un box del DetailLayout debe ser un string no vacío",
  "api/models/PipelineStage/entity-row-invalid-config":
    "La config de una fila de entidad (policy-holder, primary-insured, agency, cedent, requester) debe ser un objeto con hideWhenEmpty booleano opcional",
  "api/models/PipelineStage/eyebrow-key-must-be-string":
    "El eyebrowKey de un diseño de formulario debe ser un texto no vacío",
  "api/models/PipelineStage/field-grid-invalid-label":
    "Un campo field-grid del DetailLayout requiere un config.label no vacío",
  "api/models/PipelineStage/field-grid-invalid-source":
    "Un campo field-grid del DetailLayout requiere un config.source válido",
  "api/models/PipelineStage/field-grid-missing-config":
    "Un campo field-grid del DetailLayout requiere un objeto config",
  "api/models/PipelineStage/field-grid-missing-definition-id":
    "Un campo field-grid de subject-matter requiere config.definitionId",
  "api/models/PipelineStage/field-grid-missing-rows":
    "Un campo field-grid del DetailLayout requiere un config.rows no vacío",
  "api/models/PipelineStage/field-grid-row-invalid-emphasis":
    "emphasis de una fila de field-grid debe ser un booleano",
  "api/models/PipelineStage/field-grid-row-invalid-format":
    "Una fila de field-grid nombra un format desconocido",
  "api/models/PipelineStage/field-grid-row-invalid-hide-when-empty":
    "row.hideWhenEmpty de field-grid debe ser un booleano",
  "api/models/PipelineStage/field-grid-row-invalid-value-template":
    "valueTemplate de la fila de field-grid debe ser un texto no vacío",
  "api/models/PipelineStage/field-grid-row-missing-label":
    "Cada fila de field-grid requiere un label",
  "api/models/PipelineStage/field-grid-row-missing-path":
    "Cada fila de field-grid requiere un path",
  "api/models/PipelineStage/field-grid-row-missing-path-end":
    "Una fila date-range de field-grid requiere pathEnd",
  "api/models/PipelineStage/field-grid-row-must-be-object":
    "Cada fila de field-grid debe ser un objeto",
  "api/models/PipelineStage/field-invalid-avatar-path":
    "field.avatarPath de un campo del DetailLayout debe ser un string no vacío",
  "api/models/PipelineStage/field-invalid-display":
    "field.config.display de un campo del DetailLayout debe ser 'labelled'",
  "api/models/PipelineStage/field-invalid-emphasis":
    "field.config.emphasis de un campo del DetailLayout debe ser un booleano",
  "api/models/PipelineStage/field-invalid-hide-label":
    "field.config.hideLabel de un campo del DetailLayout debe ser un booleano",
  "api/models/PipelineStage/field-invalid-path-end":
    "field.config.pathEnd de un campo del DetailLayout debe ser un texto no vacío",
  "api/models/PipelineStage/field-invalid-subtitle-format":
    "subtitleFormat debe ser un formato de campo válido",
  "api/models/PipelineStage/field-invalid-subtitle-path":
    "field.subtitlePath de un campo del DetailLayout debe ser un string no vacío",
  "api/models/PipelineStage/field-invalid-subtitle-template":
    "field.config.subtitleTemplate de un campo del DetailLayout debe ser un texto no vacío",
  "api/models/PipelineStage/field-invalid-suffix":
    "field.suffix de un campo del DetailLayout debe ser un string no vacío",
  "api/models/PipelineStage/field-invalid-term-time":
    "La hora del periodo debe ser un texto HH:mm de 24 horas",
  "api/models/PipelineStage/field-invalid-use-policy-icon":
    "field.usePolicyIcon de un campo del DetailLayout debe ser un booleano",
  "api/models/PipelineStage/field-invalid-value-template":
    "field.config.valueTemplate de un campo del DetailLayout debe ser un texto no vacío",
  "api/models/PipelineStage/field-list-invalid-avatar-from":
    "config.avatarFrom de field-list debe ser un texto no vacío",
  "api/models/PipelineStage/field-list-invalid-avatar-path":
    "config.avatarPath de field-list debe ser un texto no vacío",
  "api/models/PipelineStage/field-list-invalid-format":
    "Un campo field-list del DetailLayout nombra un format desconocido",
  "api/models/PipelineStage/field-list-invalid-hide-when-empty":
    "field.hideWhenEmpty de field-list debe ser un booleano",
  "api/models/PipelineStage/field-list-invalid-label-key":
    "config.labelKey de field-list debe ser un texto no vacío",
  "api/models/PipelineStage/field-list-invalid-source":
    "Un campo field-list del DetailLayout requiere un config.source válido",
  "api/models/PipelineStage/field-list-invalid-subtitle-template":
    "config.subtitleTemplate de field-list debe ser un texto no vacío",
  "api/models/PipelineStage/field-list-invalid-warning-path":
    "Un field-list requiere warningWhenPath y warningTextPath juntos, cada uno un texto no vacío",
  "api/models/PipelineStage/field-list-missing-config":
    "Un campo field-list del DetailLayout requiere un objeto config",
  "api/models/PipelineStage/field-list-missing-definition-id":
    "Un campo field-list de subject-matter requiere config.definitionId",
  "api/models/PipelineStage/field-list-missing-label-path":
    "Un campo field-list del DetailLayout requiere config.labelPath",
  "api/models/PipelineStage/field-list-missing-rows-path":
    "Un campo field-list del DetailLayout requiere config.rowsPath",
  "api/models/PipelineStage/field-list-missing-title-path":
    "Un campo field-list del DetailLayout requiere config.titlePath",
  "api/models/PipelineStage/field-missing-coverage-slug":
    "Un campo subject-matter-coverage requiere config.coverageSlug",
  "api/models/PipelineStage/field-missing-path-end":
    "Un campo date-range del DetailLayout requiere config.pathEnd",
  "api/models/PipelineStage/field-table-column-invalid-cell":
    "El cell de una columna de field-table debe ser 'tag'",
  "api/models/PipelineStage/field-table-column-invalid-format":
    "Una columna de field-table nombra un format desconocido",
  "api/models/PipelineStage/field-table-column-invalid-label-path":
    "El labelPath de una columna de field-table debe ser un texto no vacío",
  "api/models/PipelineStage/field-table-column-missing-label":
    "Cada columna de field-table requiere un label",
  "api/models/PipelineStage/field-table-column-missing-path":
    "Cada columna de field-table requiere un path",
  "api/models/PipelineStage/field-table-column-must-be-object":
    "Cada columna de field-table debe ser un objeto",
  "api/models/PipelineStage/field-table-invalid-caption-path":
    "El captionPath de un field-table debe ser un texto no vacío",
  "api/models/PipelineStage/field-table-invalid-display":
    "field.config.display de field-table debe ser 'table', 'compact' o 'list'",
  "api/models/PipelineStage/field-table-invalid-source":
    "Un campo field-table del DetailLayout requiere un config.source válido",
  "api/models/PipelineStage/field-table-invalid-tag-key":
    "field.config.tagKey de field-table debe ser un texto no vacío",
  "api/models/PipelineStage/field-table-missing-columns":
    "Un campo field-table del DetailLayout requiere un config.columns no vacío",
  "api/models/PipelineStage/field-table-missing-config":
    "Un campo field-table del DetailLayout requiere un objeto config",
  "api/models/PipelineStage/field-table-missing-definition-id":
    "Un campo field-table de subject-matter requiere config.definitionId",
  "api/models/PipelineStage/field-table-missing-label":
    "Un campo field-table del DetailLayout requiere config.label",
  "api/models/PipelineStage/field-table-missing-rows-path":
    "Un campo field-table del DetailLayout requiere config.rowsPath",
  "api/models/PipelineStage/field-unknown-component":
    "Un campo del DetailLayout nombra un componente sin renderizador en el slip",
  "api/models/PipelineStage/figure-invalid-background":
    "config.background de figure debe ser un color #rrggbb",
  "api/models/PipelineStage/figure-invalid-caption":
    "config.caption de figure debe ser una cadena no vacía",
  "api/models/PipelineStage/figure-invalid-caption-format":
    "config.captionFormat de figure nombra un format desconocido",
  "api/models/PipelineStage/figure-invalid-caption-path":
    "config.captionPath de figure debe ser una cadena no vacía",
  "api/models/PipelineStage/figure-invalid-foreground":
    "config.foreground de figure debe ser un color #rrggbb",
  "api/models/PipelineStage/figure-invalid-format":
    "Un campo figure del DetailLayout nombra un format desconocido",
  "api/models/PipelineStage/figure-invalid-hide-when-empty":
    "config.hideWhenEmpty de figure debe ser un booleano",
  "api/models/PipelineStage/figure-invalid-source":
    "Un campo figure del DetailLayout requiere un config.source válido",
  "api/models/PipelineStage/figure-invalid-tone":
    "config.tone de figure debe ser black, grey, accent o white",
  "api/models/PipelineStage/figure-missing-config":
    "Un campo figure del DetailLayout requiere un objeto config",
  "api/models/PipelineStage/figure-missing-coverage-slug":
    "Un campo figure de subject-matter-coverage requiere config.coverageSlug",
  "api/models/PipelineStage/figure-missing-definition-id":
    "Un campo figure de subject-matter requiere config.definitionId",
  "api/models/PipelineStage/figure-missing-label":
    "Un campo figure del DetailLayout requiere un config.label no vacío",
  "api/models/PipelineStage/figure-missing-path":
    "Un campo figure del DetailLayout requiere un config.path no vacío",
  "api/models/PipelineStage/invalid-attribute-requirements":
    "La configuración de campos de la etapa es inválida",
  "api/models/PipelineStage/invalid-attribute-requirements-description":
    "La configuración de campos de la etapa es inválida: {{problem}}.",
  "api/models/PipelineStage/invalid-court":
    "La responsabilidad de la etapa es inválida",
  "api/models/PipelineStage/invalid-court-description":
    "La responsabilidad de la etapa es inválida: {{problem}}.",
  "api/models/PipelineStage/invalid-drop-empty-template-segments":
    "dropEmptyTemplateSegments debe ser un booleano",
  "api/models/PipelineStage/invalid-form-layout":
    "El diseño del formulario de la etapa es inválido",
  "api/models/PipelineStage/invalid-layout":
    "El diseño de la etapa es inválido",
  "api/models/PipelineStage/invalid-list-config":
    "La configuración de lista de la etapa es inválida",
  "api/models/PipelineStage/invalid-list-config-description":
    "La configuración de lista de la etapa es inválida: {{problem}}.",
  "api/models/PipelineStage/invalid-validity-clock":
    "El reloj de vigencia de la etapa es inválido",
  "api/models/PipelineStage/invalid-validity-clock-description":
    "El reloj de vigencia de la etapa es inválido: {{problem}}.",
  "api/models/PipelineStage/policy-information-invalid-config":
    "La config de un campo policy-information debe ser un objeto con placeholderWhenEmpty booleano opcional",
  "api/models/PipelineStage/policy-term-config-must-be-object":
    "El config de un nodo policy-term debe ser un objeto",
  "api/models/PipelineStage/quote-view-missing-config":
    "Un campo quote del DetailLayout requiere un objeto config",
  "api/models/PipelineStage/quote-view-missing-record-model":
    "Un campo quote del DetailLayout requiere config.recordModel",
  "api/models/PipelineStage/quote-view-missing-sections":
    "Un campo quote del DetailLayout requiere config.layout.sections",
  "api/models/PipelineStage/rate-table-invalid-label":
    "config.label de rate-table debe ser un texto no vacío",
  "api/models/PipelineStage/rate-table-invalid-source":
    "field.config.source de rate-table no es una fuente válida",
  "api/models/PipelineStage/rate-table-missing-config":
    "Un campo rate-table del DetailLayout requiere un objeto config",
  "api/models/PipelineStage/rate-table-missing-definition-id":
    "Un rate-table de materia asegurada del DetailLayout requiere config.definitionId",
  "api/models/PipelineStage/rate-table-missing-rows":
    "Un campo rate-table del DetailLayout requiere un config.rows no vacío",
  "api/models/PipelineStage/rate-table-row-invalid-flag":
    "emphasis, total, hideWhenEmpty y hideWhenZero de una fila de rate-table deben ser booleanos",
  "api/models/PipelineStage/rate-table-row-invalid-string":
    "basePath, ratePath, note y notePath de una fila de rate-table deben ser textos no vacíos",
  "api/models/PipelineStage/rate-table-row-missing-amount-path":
    "Cada fila de rate-table del DetailLayout requiere amountPath",
  "api/models/PipelineStage/rate-table-row-missing-label":
    "Cada fila de rate-table del DetailLayout requiere label",
  "api/models/PipelineStage/rate-table-row-must-be-object":
    "Cada fila de rate-table del DetailLayout debe ser un objeto",
  "api/models/PipelineStage/step-duplicate-slug":
    "Dos pasos de este FormLayout comparten el mismo slug",
  "api/models/PipelineStage/step-invalid-collection-config":
    "La configuración de un paso subject-matter-collection requiere un writeback con atributo y bandera empty o nonEmpty",
  "api/models/PipelineStage/step-invalid-coverage-of":
    "El coverageOf de un paso requiere hostDefinitionSlug y coverageSlug como cadenas no vacías, y stateField (si está presente) como cadena no vacía",
  "api/models/PipelineStage/step-invalid-hidden":
    'La bandera "hidden" de un paso debe ser booleana',
  "api/models/PipelineStage/step-invalid-onsubmit":
    "El config.onSubmit de un paso debe ser un objeto",
  "api/models/PipelineStage/step-invalid-party-sections":
    "Un paso de secciones de partes requiere una lista de secciones con claves únicas, una clave de título, un tipo válido y su alcance o definición de parte correspondiente",
  "api/models/PipelineStage/step-invalid-party-sections-description":
    "Un paso de secciones de partes requiere una lista de secciones con claves únicas, una clave de título, un tipo válido y su alcance o definición de parte correspondiente",
  "api/models/PipelineStage/step-invalid-redirect-tab":
    "El config.redirectTab de un paso debe ser una cadena no vacía",
  "api/models/PipelineStage/step-invalid-related-party-of":
    "El relatedPartyOf de un paso requiere hostDefinitionSlug y relatedPartySlug como cadenas no vacías",
  "api/models/PipelineStage/step-onsubmit-missing-failure-step":
    "config.onSubmit.onFailureStep debe ser un slug de paso no vacío",
  "api/models/PipelineStage/step-onsubmit-unknown-calculation":
    "config.onSubmit.calculate debe nombrar una acción de cálculo conocida",
  "api/models/PipelineStage/step-onsubmit-unknown-failure-step":
    "config.onSubmit.onFailureStep debe nombrar otro paso del mismo FormLayout",
  "api/models/PipelineStage/tab-activity-config-must-be-object":
    "El config de una pestaña de actividad debe ser un objeto",
  "api/models/PipelineStage/tab-activity-invalid-sources":
    "Las fuentes de una pestaña de actividad deben ser una lista no vacía de fuentes conocidas sin repetir",
  "api/models/PipelineStage/tab-activity-unknown-key":
    "Una pestaña de actividad solo acepta slug, label, type y config (sin fields ni badge)",
  "api/models/PipelineStage/tab-activity-unknown-param":
    "El config de una pestaña de actividad solo acepta sources",
  "api/models/PipelineStage/tab-badge-invalid-count-of":
    "countOf del badge de una pestaña del DetailLayout nombra un modelo no permitido",
  "api/models/PipelineStage/tab-badge-must-be-object":
    "El badge de una pestaña del DetailLayout debe ser un objeto",
  "api/models/PipelineStage/tab-invalid-type":
    "El tipo de una pestaña del DetailLayout debe ser fields o activity",
  "api/models/PipelineStage/term-time-not-allowed":
    "termStartTime y termEndTime solo se permiten en un campo date-range o en el nodo policy-term",
  "api/models/PipelineStage/validity-config-must-be-object":
    "La configuración de un nodo validity debe ser un objeto con expiredKey (y opcionalmente runningKey)",
  "api/models/PipelineStage/validity-dates-config-must-be-object":
    "La configuración de un nodo validity-dates debe ser un objeto con titleKey, issuedLabelKey, validUntilLabelKey, remainingKey y expiredKey",
  "api/models/PipelineStage/validity-dates-invalid-key":
    "titleKey, issuedLabelKey, validUntilLabelKey, remainingKey y expiredKey de un nodo validity-dates deben ser textos no vacíos",
  "api/models/PipelineStage/validity-dates-unknown-config-key":
    "La configuración de un nodo validity-dates solo acepta titleKey, issuedLabelKey, validUntilLabelKey, remainingKey y expiredKey",
  "api/models/PipelineStage/validity-invalid-key":
    "expiredKey de un nodo validity (y runningKey, si se indica) deben ser textos no vacíos",
  "api/models/PipelineStage/validity-unknown-config-key":
    "La configuración de un nodo validity solo acepta runningKey y expiredKey",
  "api/models/PipelineTransition/duplicate-reactivate":
    "La etapa ya tiene una transición de reactivación",
  "api/models/PipelineTransition/duplicate-reactivate-description":
    "Una etapa solo puede declarar una transición de acción de reactivación habilitada; la etapa {{sourceStageId}} ya tiene una.",
  "api/models/PipelineTransition/invalid-config":
    "La configuración de la transición es inválida",
  "api/models/PipelineTransition/invalid-config-description":
    "La configuración de la transición {{type}} es inválida: {{problem}}.",
  "api/models/Policy/agency-id-is-required": "Es necesario el Id de la agencia",
  "api/models/Policy/agency-not-eligible": "Agencia no disponible",
  "api/models/Policy/agency-not-eligible-description":
    "No puedes crear negocios para la agencia seleccionada en este programa.",
  "api/models/Policy/agency-not-found": "Agencia no encontrada",
  "api/models/Policy/agent-key-required":
    "Se requiere una clave de agente vigente",
  "api/models/Policy/agent-key-required-description":
    "No hay una clave de agente vigente con {{insurer}} para esta agencia ni para la casa. Captura una clave vigente antes de emitir.",
  "api/models/Policy/already-cancelled": "La póliza ya está cancelada",
  "api/models/Policy/already-issued": "La póliza ya fue emitida",
  "api/models/Policy/already-moved": "Este caso ya fue movido",
  "api/models/Policy/already-moved-automatic-description":
    "Este caso se movió a otra etapa de forma automática. Recárgalo para ver en qué etapa está ahora.",
  "api/models/Policy/already-moved-description":
    "{{actor}} ya movió este caso a otra etapa. Recárgalo para ver en qué etapa está ahora.",
  "api/models/Policy/already-moved-unknown-description":
    "Alguien ya movió este caso a otra etapa. Recárgalo para ver en qué etapa está ahora.",
  "api/models/Policy/assignee-write-forbidden":
    "El responsable no se puede escribir directamente",
  "api/models/Policy/assignee-write-forbidden-description":
    "Usa tomar o reasignar en la tarea para cambiar el responsable.",
  "api/models/Policy/authority-correct-field-not-allowed":
    "Este campo no se puede corregir",
  "api/models/Policy/authority-correct-field-not-allowed-description":
    "El campo {{field}} no se puede modificar con una corrección.",
  "api/models/Policy/authority-correct-not-allowed":
    "La corrección no se puede hacer",
  "api/models/Policy/authority-correct-not-allowed-description":
    "Solo un usuario con sesión iniciada y autoridad de corrección puede corregir un caso.",
  "api/models/Policy/authority-correct-not-configured":
    "Las correcciones de autoridad no están configuradas",
  "api/models/Policy/authority-correct-not-configured-description":
    "Esta compañía no ha configurado los motivos para corregir un caso.",
  "api/models/Policy/authority-correct-nothing-to-change":
    "La corrección no cambia nada",
  "api/models/Policy/authority-correct-nothing-to-change-description":
    "Indica al menos un campo con un valor nuevo.",
  "api/models/Policy/authority-correct-reason-invalid":
    "El motivo de la corrección no es válido",
  "api/models/Policy/authority-correct-reason-invalid-description":
    "Elige un motivo de la lista de motivos de corrección. La explicación admite hasta 2000 caracteres.",
  "api/models/Policy/authority-correct-reason-required":
    "Se requiere un motivo para la corrección",
  "api/models/Policy/authority-correct-reason-required-description":
    "Explica por qué se corrige el caso.",
  "api/models/Policy/av-crop-duster-hull-deductible-not-found":
    "No se encontró el deducible de casco para fumigación",
  "api/models/Policy/av-crop-duster-hull-deductible-not-found-description":
    "No hay un deducible de casco para fumigación configurado para el valor de casco asegurado. Contacte a soporte.",
  "api/models/Policy/av-fumigation-liability-cap-exceeded":
    "Límite de responsabilidad superior al máximo de la tarifa de fumigación",
  "api/models/Policy/av-fumigation-liability-cap-exceeded-description":
    "El límite de responsabilidad {{limit}} excede el máximo de la tarifa de fumigación: {{maxLimit}}.",
  "api/models/Policy/av-fumigation-occupant-limit-exceeded":
    "Límite por ocupante superior al máximo de la tarifa de fumigación",
  "api/models/Policy/av-fumigation-occupant-limit-exceeded-description":
    "El límite por ocupante no puede superar USD {{maxLimit}} en la tarifa de fumigación. Límites declarados: pagos voluntarios de pasajeros {{pvs}}, pagos voluntarios de tripulación {{cvs}}, gastos médicos de pasajeros {{pmp}}, gastos médicos de tripulación {{cmp}}.",
  "api/models/Policy/av-hangar-liability-deductible-not-found":
    "No se encontró el deducible de responsabilidad de hangar",
  "api/models/Policy/av-hangar-liability-deductible-not-found-description":
    "No hay un deducible de responsabilidad de hangar configurado para la cobertura habilitada y el límite de responsabilidad. Contacte a soporte.",
  "api/models/Policy/av-hull-deductible-not-found":
    "No se encontró el deducible del casco",
  "api/models/Policy/av-hull-deductible-not-found-description":
    "No hay un deducible de casco configurado para el(los) uso(s) seleccionado(s) y el valor de casco asegurado. Contacte a soporte.",
  "api/models/Policy/av-hull-type-cap-exceeded":
    "Valor del casco superior al máximo por tipo de aeronave",
  "api/models/Policy/av-hull-type-cap-exceeded-description":
    "El valor del casco excede el máximo permitido para el tipo de aeronave: 5,000,000 para aviones y 2,500,000 para helicópteros.",
  "api/models/Policy/av-liability-type-cap-exceeded":
    "Límite de responsabilidad superior al máximo por tipo de aeronave",
  "api/models/Policy/av-liability-type-cap-exceeded-description":
    "El límite de responsabilidad (LUC) excede el máximo permitido para el tipo de aeronave: 5,000,000 para aviones y helicópteros.",
  "api/models/Policy/av-parts-spares-deductible-not-found":
    "No se encontró el deducible de partes y repuestos",
  "api/models/Policy/av-parts-spares-deductible-not-found-description":
    "No hay un deducible de partes y repuestos configurado para la cobertura habilitada y la suma asegurada. Contacte a soporte.",
  "api/models/Policy/av-quote-aircraft-incomplete":
    "Información de la aeronave incompleta",
  "api/models/Policy/av-quote-aircraft-incomplete-description":
    "Se requieren el tipo y la clase de aeronave para cotizar esta propuesta.",
  "api/models/Policy/av-quote-geographic-limit-unavailable":
    "Límite geográfico no disponible",
  "api/models/Policy/av-quote-geographic-limit-unavailable-description":
    "El límite geográfico seleccionado no está disponible para esta categoría de aeronave.",
  "api/models/Policy/av-quote-lob-not-found": "Línea de negocio no encontrada",
  "api/models/Policy/av-quote-lob-not-found-description":
    "No se encontró una línea de negocio para esta categoría de aeronave.",
  "api/models/Policy/av-quote-missing-subject-matter":
    "Cotización no disponible",
  "api/models/Policy/av-quote-missing-subject-matter-description":
    "La propuesta no tiene la información de aeronave o coberturas.",
  "api/models/Policy/av-quote-no-duster-jet":
    "Los jets no pueden cotizarse para fumigación",
  "api/models/Policy/av-quote-no-duster-jet-description":
    "Las aeronaves jet no pueden cotizarse como aeronaves de fumigación.",
  "api/models/Policy/av-quote-usage-unavailable": "Uso no disponible",
  "api/models/Policy/av-quote-usage-unavailable-description":
    "Un uso seleccionado no tiene tarifa disponible para esta categoría de aeronave.",
  "api/models/Policy/av-usage-age-cap-exceeded":
    "Antigüedad de la aeronave superior al máximo para el uso seleccionado",
  "api/models/Policy/av-usage-age-cap-exceeded-description":
    "La antigüedad de la aeronave ({{age}} años) excede el máximo de {{maxAge}} años para el uso «{{restrictingUse}}».",
  "api/models/Policy/av-usage-age-cap-not-found":
    "No se encontró el límite de antigüedad por uso",
  "api/models/Policy/av-usage-age-cap-not-found-description":
    "No hay un límite de antigüedad de la aeronave configurado para el(los) uso(s) seleccionado(s). Contacte a soporte.",
  "api/models/Policy/av-usage-hull-value-cap-exceeded":
    "Valor del casco superior al máximo para el uso seleccionado",
  "api/models/Policy/av-usage-hull-value-cap-exceeded-description":
    "El valor del casco para el uso «{{restrictingUse}}» no puede superar USD {{maxHullValue}}.",
  "api/models/Policy/av-usage-hull-value-cap-not-found":
    "No se encontró el máximo de valor de casco por uso",
  "api/models/Policy/av-usage-hull-value-cap-not-found-description":
    "No hay un máximo de valor de casco configurado para el(los) uso(s) seleccionado(s). Contacte a soporte.",
  "api/models/Policy/av-usage-not-yet-quotable": "Uso aún no cotizable",
  "api/models/Policy/av-usage-not-yet-quotable-description":
    "El uso «{{use}}» todavía no se puede cotizar en el sistema. Contacta a suscripción.",
  "api/models/Policy/back-transition-blocked":
    "Recotiza para guardar los cambios",
  "api/models/Policy/back-transition-blocked-description":
    "La propuesta cambió desde la última cotización, por lo que no puede regresar. Recotiza para guardar los cambios.",
  "api/models/Policy/cannot-duplicate-parent": "No se puede duplicar",
  "api/models/Policy/cannot-duplicate-policy": "No se puede duplicar",
  "api/models/Policy/cannot-endorse-parent":
    "No se puede endosar una póliza padre directamente",
  "api/models/Policy/cannot-endorse-proposal":
    "No se puede endosar una propuesta",
  "api/models/Policy/cedent-not-available": "Cedente no disponible",
  "api/models/Policy/cedent-not-available-description":
    "El cedente seleccionado no está habilitado para este programa y agencia (o para negocios sin agencia).",
  "api/models/Policy/cedent-not-eligible": "Cedente no disponible",
  "api/models/Policy/cedent-not-eligible-description":
    "El cedente seleccionado no está disponible para este contexto.",
  "api/models/Policy/cedent-scope-violation": "Cedente fuera de tu alcance",
  "api/models/Policy/cedent-scope-violation-description":
    "Solo puedes crear pólizas para los cedentes a los que perteneces. Por favor selecciona uno de tus cedentes e inténtalo de nuevo.",
  "api/models/Policy/close-ambiguous":
    "Este caso tiene más de una forma de cerrarse",
  "api/models/Policy/close-ambiguous-description":
    "El flujo de este caso declara más de una transición de cierre desde su etapa actual. Pide a un administrador que deje solo una.",
  "api/models/Policy/close-not-available":
    "Este caso no se puede cerrar como perdido",
  "api/models/Policy/close-not-available-description":
    "El flujo de este caso no permite cerrarlo como perdido desde su etapa actual.",
  "api/models/Policy/close-not-configured":
    "Los motivos de cierre no están configurados",
  "api/models/Policy/close-not-configured-description":
    "Tu empresa no tiene un catálogo de motivos de cierre. Pide a un administrador que lo configure.",
  "api/models/Policy/close-reason-invalid": "El motivo de cierre no es válido",
  "api/models/Policy/close-reason-invalid-description":
    "Elige un motivo de la lista de motivos de cierre. La nota admite hasta 2000 caracteres.",
  "api/models/Policy/close-reason-required": "Se requiere un motivo de cierre",
  "api/models/Policy/close-reason-required-description":
    "Elige por qué se cierra el caso antes de cerrarlo.",
  "api/models/Policy/comission-table-not-assigned":
    "Tabla de comisión no asignada",
  "api/models/Policy/comission-table-not-assigned-description":
    "Esta agencia no tiene una tabla de comisiones configurada para el ramo seleccionado. Por favor configúrala antes de crear una propuesta.",
  "api/models/Policy/continuation-source-mismatch": "Copia inválida",
  "api/models/Policy/continuation-source-mismatch-description":
    "El registro copiado no pertenece al mismo negocio.",
  "api/models/Policy/continuation-source-not-found":
    "Registro de origen no encontrado",
  "api/models/Policy/continuation-source-not-found-description":
    "El registro que se está copiando ya no existe.",
  "api/models/Policy/coverage-label-crop-duster-hull": "Casco (Fumigación)",
  "api/models/Policy/coverage-label-hangar-liability":
    "Responsabilidad Civil de Hangar",
  "api/models/Policy/coverage-label-hull": "Casco",
  "api/models/Policy/coverage-label-liability": "Responsabilidad Civil",
  "api/models/Policy/coverage-label-parts-and-spares": "Partes y Refacciones",
  "api/models/Policy/creation-change-needs-registration":
    "La cedente no está registrada con esta agencia",
  "api/models/Policy/creation-change-needs-registration-description":
    "Este cambio necesita un nuevo registro de la cedente con la agencia, que no se puede crear al editar una propuesta. Regístrala primero o elige otra cedente.",
  "api/models/Policy/creation-data-invalid": "Información general no válida",
  "api/models/Policy/creation-data-invalid-description":
    "Uno de los valores enviados no es válido. Las fechas usan el formato AAAA-MM-DD.",
  "api/models/Policy/creation-edit-not-proposal":
    "Aquí solo se puede editar una propuesta",
  "api/models/Policy/creation-edit-not-proposal-description":
    "Los datos de creación solo se pueden editar mientras el registro siga siendo una propuesta.",
  "api/models/Policy/creation-edit-row-not-updatable":
    "No puedes editar todos los registros de este caso",
  "api/models/Policy/creation-edit-row-not-updatable-description":
    "Cambiar los datos de creación reescribe todos los endosos del caso, y no tienes permiso para actualizar uno de ellos.",
  "api/models/Policy/creation-edit-stage-not-editable":
    "La propuesta no se puede editar en esta etapa",
  "api/models/Policy/creation-edit-stage-not-editable-description":
    "Los datos de creación solo se pueden editar en una etapa que lo declare editable.",
  "api/models/Policy/creation-field-not-editable":
    "Este campo no se puede cambiar",
  "api/models/Policy/creation-field-not-editable-description":
    "Aquí solo se pueden cambiar la agencia, la cedente, el suscriptor, las fechas y la moneda de una propuesta.",
  "api/models/Policy/creation-field-shared-description":
    "Un registro de esta propuesta también lo usa otro caso, por lo que este campo ya no se puede cambiar aquí.",
  "api/models/Policy/creation-step-inputs-missing":
    "Faltan selecciones previas",
  "api/models/Policy/creation-step-inputs-missing-description":
    "Este paso necesita la cedente y el ramo elegidos en los pasos anteriores. Regresa y complétalos.",
  "api/models/Policy/creation-step-not-editable":
    "Este paso no se puede editar",
  "api/models/Policy/creation-step-not-editable-description":
    "El tipo de póliza se elige al crear la propuesta y no se puede cambiar después.",
  "api/models/Policy/creation-step-unknown": "Paso de creación desconocido",
  "api/models/Policy/creation-step-unknown-description":
    "El formulario de nuevo negocio solicitó un paso desconocido. Recarga el formulario e inténtalo de nuevo.",
  "api/models/Policy/currency-not-eligible": "Moneda no disponible",
  "api/models/Policy/currency-not-eligible-description":
    "La moneda seleccionada no está habilitada para este contexto.",
  "api/models/Policy/declared-transition-required":
    "Esta acción solo se realiza desde su paso en el proceso",
  "api/models/Policy/declared-transition-required-description":
    "El proceso de este ramo realiza esta acción desde uno de sus pasos. Continúa desde la propuesta.",
  "api/models/Policy/delete-disabled": "Las propuestas no se pueden eliminar",
  "api/models/Policy/delete-disabled-description":
    "Tu empresa no permite eliminar propuestas. Cierra el caso con un motivo.",
  "api/models/Policy/deleted-not-writable":
    "Un caso no se puede eliminar editándolo",
  "api/models/Policy/deleted-not-writable-description":
    "La marca de eliminación la administra el servidor. Elimina el caso con la acción de eliminar.",
  "api/models/Policy/expiration-date-inconsistent-with-term":
    "Fecha de fin inválida",
  "api/models/Policy/expiration-date-inconsistent-with-term-description":
    "La fecha de fin de vigencia no coincide con la vigencia configurada.",
  "api/models/Policy/field-locked":
    "Este campo está bloqueado en la etapa actual",
  "api/models/Policy/field-locked-description":
    "La etapa actual de este caso no permite modificar: {{fields}}.",
  "api/models/Policy/helicopter-class-multi-turbine":
    "helicópteros multimotor de turbina",
  "api/models/Policy/helicopter-class-single-piston":
    "helicópteros monomotor de pistón",
  "api/models/Policy/helicopter-class-single-turbine":
    "helicópteros monomotor de turbina",
  "api/models/Policy/immutable-field": "El campo no se puede cambiar",
  "api/models/Policy/inception-date-before-today": "Fecha de inicio inválida",
  "api/models/Policy/inception-date-before-today-description":
    "La fecha de inicio de vigencia no puede ser anterior a hoy.",
  "api/models/Policy/invalid-new-business-payload":
    "Datos de propuesta inválidos",
  "api/models/Policy/invalid-new-business-payload-description":
    "Faltan campos obligatorios de la propuesta o son inválidos.",
  "api/models/Policy/line-of-business-not-editable":
    "El ramo no se puede cambiar",
  "api/models/Policy/line-of-business-not-editable-description":
    "El ramo se elige al crear la propuesta y no se puede cambiar después.",
  "api/models/Policy/line-of-business-not-eligible": "Ramo no disponible",
  "api/models/Policy/line-of-business-not-eligible-description":
    "El ramo seleccionado no está habilitado para este programa, agencia y cedente.",
  "api/models/Policy/motor-block-not-available": "Bloque no disponible",
  "api/models/Policy/motor-block-not-available-description":
    "El bloque de deducibles seleccionado no existe para el tipo de vehículo declarado (motocicletas solo ofrece el Bloque 1).",
  "api/models/Policy/motor-gm-limit-out-of-range":
    "Límite de gastos médicos fuera de rango",
  "api/models/Policy/motor-gm-limit-out-of-range-description":
    "El límite de gastos médicos elegido debe estar entre 1 y el límite de tabla para el tipo de vehículo.",
  "api/models/Policy/motor-gm-not-available":
    "Cobertura de gastos médicos no disponible",
  "api/models/Policy/motor-gm-not-available-description":
    "Los gastos médicos no se ofrecen para el tipo de vehículo declarado.",
  "api/models/Policy/motor-quote-missing-subject-matter":
    "Cotización no disponible",
  "api/models/Policy/motor-quote-missing-subject-matter-description":
    "La propuesta no tiene la información del vehículo o coberturas.",
  "api/models/Policy/motor-rc-limit-out-of-range":
    "Límite de RC fuera de rango",
  "api/models/Policy/motor-rc-limit-out-of-range-description":
    "El límite de RC elegido debe estar entre 1 y el límite de tabla para el tipo de vehículo.",
  "api/models/Policy/motor-rc-not-available": "Cobertura de RC no disponible",
  "api/models/Policy/motor-rc-not-available-description":
    "La responsabilidad civil no se ofrece para el tipo de vehículo declarado.",
  "api/models/Policy/motor-retention-at-ceiling":
    "La retención debe ser menor al 100%",
  "api/models/Policy/motor-retention-at-ceiling-description":
    "Una retención del 100% no cede riesgo a la capa XS, por lo que no hay nada que cotizar.",
  "api/models/Policy/motor-retention-too-low":
    "Retención por debajo del mínimo de la banda",
  "api/models/Policy/motor-retention-too-low-description":
    "La retención solicitada no puede ser menor al mínimo de la banda para el tipo de vehículo declarado.",
  "api/models/Policy/motor-value-out-of-range":
    "Suma asegurada fuera de la matriz de tarifas",
  "api/models/Policy/motor-value-out-of-range-description":
    "La suma asegurada está fuera de todas las bandas definidas para el tipo de vehículo declarado. Este riesgo no puede cotizarse.",
  "api/models/Policy/motor-vin-duplicate": "VIN ya cubierto",
  "api/models/Policy/motor-vin-duplicate-description":
    "Este VIN ya aparece en una cotización activa o póliza vigente en esta instancia.",
  "api/models/Policy/motor-vin-duplicate-own": "Ya cotizaste este VIN",
  "api/models/Policy/motor-vin-duplicate-own-description":
    "Ya tienes una cotización activa para este VIN — ábrela en lugar de crear una nueva.",
  "api/models/Policy/motor-vin-invalid": "VIN inválido",
  "api/models/Policy/motor-vin-invalid-description":
    "El VIN no pasó la validación (17 caracteres, sin I/O/Q, WMI válido y dígito verificador ISO 3779).",
  "api/models/Policy/motor-year-out-of-range":
    "Año del vehículo fuera de rango",
  "api/models/Policy/motor-year-out-of-range-description":
    "El año del vehículo debe estar entre 1900 y el próximo año.",
  "api/models/Policy/no-valid-transition": "Sin transición válida",
  "api/models/Policy/no-valid-transition-description":
    "No hay un paso siguiente disponible desde la etapa actual. Este es el último paso configurado del flujo.",
  "api/models/Policy/not-found": "Caso no encontrado",
  "api/models/Policy/not-found-description":
    "El caso ya no existe o se eliminó mientras trabajabas en él.",
  "api/models/Policy/not-implemented": "Aún no disponible",
  "api/models/Policy/not-implemented-description":
    "Esta operación todavía no está implementada.",
  "api/models/Policy/only-endorsements-can-be-duplicated":
    "Abre una propuesta específica para duplicarla.",
  "api/models/Policy/only-endorsements-can-be-endorsed":
    "Solo los endosos pueden ser endosados",
  "api/models/Policy/only-issued-policies-can-be-endorsed":
    "Solo las pólizas emitidas pueden ser endosadas",
  "api/models/Policy/only-proposals-can-be-duplicated":
    "Solo se pueden duplicar propuestas.",
  "api/models/Policy/only-proposals-can-be-issued":
    "Solo las propuestas pueden emitirse",
  "api/models/Policy/parent-id-not-found": "Padre no encontrado",
  "api/models/Policy/parent-id-not-found-description": "Padre no encontrado",
  "api/models/Policy/parent-not-found": "Padre no encontrado",
  "api/models/Policy/parent-not-found-description": "Padre no encontrado",
  "api/models/Policy/parent-policy-not-found": "Póliza padre no encontrada",
  "api/models/Policy/pipeline-has-no-entry-step":
    "El flujo no tiene un paso inicial",
  "api/models/Policy/pipeline-has-no-entry-step-description":
    "Este ramo se gestiona por flujo pero su flujo no tiene una etapa inicial ni un primer paso utilizable. No se puede iniciar una propuesta hasta que el flujo tenga una etapa inicial y al menos un paso de formulario.",
  "api/models/Policy/placement-requires-proposal":
    "Solo una propuesta puede completar su colocación",
  "api/models/Policy/placement-requires-proposal-description":
    "Este registro ya es una póliza emitida, por lo que su colocación no puede completarse de nuevo.",
  "api/models/Policy/policy-already-cancelled":
    "Esta póliza ya ha sido cancelada",
  "api/models/Policy/policy-id-is-required": "Es necesario el Id de la póliza",
  "api/models/Policy/policy-id-is-required-description":
    "Es necesario el Id de la póliza",
  "api/models/Policy/policy-id-not-found": "Póliza no encontrada",
  "api/models/Policy/policy-id-not-found-description":
    "No se encontró la póliza proporcionada",
  "api/models/Policy/policy-must-be-inforce-to-endorse":
    "La póliza debe estar en vigor para crear un endoso",
  "api/models/Policy/policy-not-inforce": "La póliza no está en vigor",
  "api/models/Policy/policy-type-not-allowed": "Tipo de póliza no permitido",
  "api/models/Policy/policy-type-not-allowed-description":
    "El tipo de póliza seleccionado no está habilitado para este programa y ramo.",
  "api/models/Policy/premium-family-hangar-liability":
    "Prima Neta Responsabilidad Civil de Hangar",
  "api/models/Policy/premium-family-hull": "Prima Neta Casco",
  "api/models/Policy/premium-family-liability":
    "Prima Neta Responsabilidad Civil",
  "api/models/Policy/premium-line-hull": "Prima Casco",
  "api/models/Policy/premium-line-liability-combined":
    "RC Límite Único y Combinado",
  "api/models/Policy/presentation-read-only":
    "La presentación es de solo lectura",
  "api/models/Policy/presentation-read-only-description":
    "El campo Presentación es calculado y no puede ser actualizado directamente",
  "api/models/Policy/program-mode-required": "No disponible en este portal",
  "api/models/Policy/program-mode-required-description":
    "Esta operación solo está disponible en los portales de programa.",
  "api/models/Policy/proposal-validity-expired": "Esta cotización ha expirado",
  "api/models/Policy/proposal-validity-expired-description":
    "La vigencia de la cotización terminó, por lo que ya no puede avanzar. Reactívala cuando aparezca como expirada.",
  "api/models/Policy/quote-bridge-not-found": "Cotización no configurada",
  "api/models/Policy/quote-bridge-not-found-description":
    "No hay un puente de cotización activo configurado para este ramo.",
  "api/models/Policy/quote-catalogue-unavailable": "Selección no disponible",
  "api/models/Policy/quote-catalogue-unavailable-description":
    "Una opción de catálogo seleccionada ya no está disponible.",
  "api/models/Policy/quote-leaf-lob-not-found": "Ramo no encontrado",
  "api/models/Policy/quote-leaf-lob-not-found-description":
    "El ramo resuelto no existe en esta instancia.",
  "api/models/Policy/quote-leaf-lob-unresolved":
    "Información de riesgo incompleta",
  "api/models/Policy/quote-leaf-lob-unresolved-description":
    "La información de riesgo capturada no resuelve a un ramo tarificable.",
  "api/models/Policy/quote-missing-subject-matter": "Cotización no disponible",
  "api/models/Policy/quote-missing-subject-matter-description":
    "La propuesta no tiene la información de riesgo requerida.",
  "api/models/Policy/quote-slip-hull-war-extortion-kidnap-text":
    "90% del 10% del valor acordado de la aeronave; 10% a cargo del asegurado",
  "api/models/Policy/quote-slip-missing-required":
    "Información requerida no disponible.",
  "api/models/Policy/quote-slip-spare-parts-cap-qualification-text":
    "Hasta 10% del valor del casco",
  "api/models/Policy/ramo-summary": "Seguro de Aviación — {{coverages}}",
  "api/models/Policy/ramo-title": "Seguro de Aviación",
  "api/models/Policy/reactivate-not-available":
    "Esta acción no está disponible en la etapa actual",
  "api/models/Policy/reactivate-not-available-description":
    "Solo una propuesta con la cotización expirada se puede re-activar.",
  "api/models/Policy/reactivate-target-not-initial-stage":
    "La transición de reactivación debe llevar a la etapa inicial del flujo",
  "api/models/Policy/renewal-already-linked":
    "Este caso ya tiene una renovación",
  "api/models/Policy/renewal-already-linked-description":
    "El caso anterior ya está vinculado a otra renovación. Desvincúlalo primero.",
  "api/models/Policy/report-not-applicable":
    "Este reporte no aplica para esta póliza.",
  "api/models/Policy/request-in-progress": "Solicitud en proceso",
  "api/models/Policy/request-in-progress-description":
    "Esta propuesta ya se está creando. Espera un momento.",
  "api/models/Policy/requester-case-not-open": "El caso ya no está abierto",
  "api/models/Policy/requester-case-not-open-description":
    "El solicitante solo puede cambiar mientras el caso está abierto, antes de cerrarse o emitirse.",
  "api/models/Policy/requester-entity-required": "Elige al nuevo solicitante",
  "api/models/Policy/requester-entity-required-description":
    "Se requiere al nuevo solicitante para mover el caso.",
  "api/models/Policy/requester-forbidden":
    "No puedes cambiar el solicitante de este caso",
  "api/models/Policy/requester-forbidden-description":
    "Tu rol o tu lugar en la estructura de la agencia no permite mover este caso.",
  "api/models/Policy/requester-not-eligible": "Suscriptor no elegible",
  "api/models/Policy/requester-not-eligible-description":
    "El suscriptor seleccionado no puede asignarse a este negocio.",
  "api/models/Policy/requester-reason-invalid": "El motivo no es válido",
  "api/models/Policy/requester-reason-invalid-description":
    "El motivo es un texto opcional de hasta 500 caracteres.",
  "api/models/Policy/requester-target-not-eligible":
    "Esa persona no puede ser solicitante de este caso",
  "api/models/Policy/requester-target-not-eligible-description":
    "Elige a un usuario activo de la misma agencia, dentro de tu propia área, que pueda solicitar casos.",
  "api/models/Policy/server-managed-field":
    "El campo lo administra el servidor",
  "api/models/Policy/server-managed-field-description":
    "Una póliza nueva siempre inicia como propuesta fuera de cualquier caso existente; su tipo y su padre no se pueden definir al crearla.",
  "api/models/Policy/slip-catalogue-entry-not-found":
    "Entrada de catálogo del slip no encontrada",
  "api/models/Policy/slip-catalogue-entry-not-found-description":
    "Una entrada de catálogo referenciada por la cotización ya no existe",
  "api/models/Policy/step-calculation-not-found":
    "El config.onSubmit.calculate de este paso nombra una acción que el modelo Policy no implementa.",
  "api/models/Policy/target-stage-not-found":
    "No se encontró la etapa de destino",
  "api/models/Policy/target-stage-not-found-description":
    "La etapa a la que lleva este movimiento no existe en el flujo de la póliza.",
  "api/models/Policy/term-rule-missing": "Reglas de vigencia no configuradas",
  "api/models/Policy/term-rule-missing-description":
    "El ramo no tiene configuración de vigencia. Contacta al administrador de la plataforma.",
  "api/models/Policy/title-read-only": "El título es de solo lectura",
  "api/models/Policy/title-read-only-description":
    "El campo Título es calculado y no puede ser actualizado directamente",
  "api/models/Policy/transition-method-not-granted":
    "No tienes autorización para realizar esta acción",
  "api/models/Policy/transition-method-not-granted-description":
    "Este movimiento ejecuta una acción para la que tu rol no tiene permiso.",
  "api/models/Policy/transition-not-available":
    "Esta acción no está disponible en la etapa actual",
  "api/models/Policy/transition-not-available-description":
    "La propuesta no puede realizar esta acción desde su etapa actual.",
  "api/models/Policy/warranty-crop-dusting":
    "Experiencia mínima del piloto: {{cropDustingHours}} horas fumigando y {{makeModelHours}} horas en marca y modelo.",
  "api/models/Policy/warranty-fixed-wing-multi-piston":
    "Para aviones multimotor de pistón, se ampara a cualquier piloto que tenga certificado de piloto emitido por la Dirección General de Aeronáutica Civil o sus equivalentes extranjeros, con un mínimo de {{totalHours}} horas de tiempo total como piloto al mando, incluyendo {{makeModelHours}} horas en marca y modelo.",
  "api/models/Policy/warranty-fixed-wing-single-piston":
    "Para aviones monomotor de pistón, se ampara a cualquier piloto que tenga certificado de piloto emitido por la Dirección General de Aeronáutica Civil o sus equivalentes extranjeros, con un mínimo de {{totalHours}} horas de tiempo total como piloto al mando, incluyendo {{makeModelHours}} horas en marca y modelo.",
  "api/models/Policy/warranty-fixed-wing-turbine":
    "Para aviones de turbina, se ampara a cualquier piloto que tenga certificado de piloto emitido por la Dirección General de Aeronáutica Civil o sus equivalentes extranjeros, con un mínimo de {{totalHours}} horas de tiempo total como piloto al mando, incluyendo {{makeModelHours}} horas en marca y modelo.",
  "api/models/Policy/warranty-helicopter":
    "Garantía de horas de pilotos para {{helicopterClass}}: mínimo {{totalHours}} horas totales y {{makeModelHours}} horas en marca y modelo.",
  "api/models/Policy/warranty-instructor-fixed-wing":
    "Cualquier piloto que tenga certificado de piloto instructor emitido por la Dirección General de Aeronáutica Civil o sus equivalentes extranjeros con una experiencia mínima de {{picHours}} horas de vuelo como piloto al mando, con al menos {{makeModelHours}} horas en marca y modelo.",
  "api/models/Policy/warranty-instructor-helicopter":
    "Cualquier piloto que tenga certificado de piloto instructor emitido por la Dirección General de Aeronáutica Civil o sus equivalentes extranjeros con una experiencia mínima de {{picHours}} horas de vuelo como piloto al mando, con al menos {{makeModelHours}} horas en marca y modelo.",
  "api/models/Policy/warranty-instructor-multiengine-addendum":
    "Para aeronaves Multimotor adicionalmente acreditar una experiencia de {{multiengineHours}} horas en Multimotor.",
  "api/models/Policy/warranty-student":
    "Experiencia mínima de {{dualHours}} horas en doble comando para el primer vuelo solo. No se autorizan vuelos solo para alumnos en aeronaves multimotor.",
  "api/models/PolicyDependantsRequest/find-or-create-member/age-limit-exceeded":
    "Rebasa el límite de edad",
  "api/models/PolicyDependantsRequest/find-or-create-member/age-limit-exceeded-description":
    "La edad máxima de aceptación es de 65 años de edad, por lo que no es posible agregar este dependiente.",
  "api/models/PolicyDependantsRequest/find-or-create-member/child-age-limit-exceeded":
    "Rebasa el límite de edad",
  "api/models/PolicyDependantsRequest/find-or-create-member/child-age-limit-exceeded-description":
    "La edad máxima de aceptación para hijos y dependientes es de 25 años de edad, por lo que no es posible agregar a esta persona.",
  "api/models/PolicyDependantsRequest/find-or-create-member/spouse-already-exists":
    "No puede haber más de un cónyuge",
  "api/models/PolicyDependantsRequest/find-or-create-member/spouse-already-exists-description":
    "Ya existe un cónyuge registrado para esta solicitud. Solo se permite un cónyuge por titular. Valide la información e intente nuevamente.",
  "api/models/PolicyFile/key-not-allowed":
    "La ubicación del archivo no es válida para esta póliza.",
  "api/models/PolicyFile/policy-not-readable":
    "No tienes permiso para acceder a esta póliza.",
  "api/models/PolicyFile/policy-not-readable-description":
    "La póliza no pertenece a ninguno de tus cedentes.",
  "api/models/PolicyFile/scope-field-immutable":
    "Los campos derivados de la póliza no se pueden modificar.",
  "api/models/PolicyPaymentAllocation/program-mismatch": "Programa distinto",
  "api/models/PolicyPaymentAllocation/program-mismatch-description":
    "El pago y el recibo pertenecen a programas distintos.",
  "api/models/PolicyQuote/missing-scope": "Error de alcance de cotización",
  "api/models/PolicyQuote/missing-scope-description":
    "La póliza no tiene información de compañía — contacte a soporte",
  "api/models/PolicyQuote/policy-id-is-required":
    "Es necesario el Id de la póliza",
  "api/models/PolicyQuote/policy-id-is-required-description":
    "Es necesario el Id de la póliza",
  "api/models/PolicyQuote/policy-not-found": "Póliza no encontrada",
  "api/models/PolicyQuote/policy-not-found-description": "Póliza no encontrada",
  "api/models/PolicyQuoteCoverage/coverage-definition-mismatch":
    "La definición de cobertura no coincide",
  "api/models/PolicyQuoteCoverage/coverage-definition-mismatch-description":
    "El CoverageDefinitionId proporcionado debe coincidir con el CoverageDefinitionId de la cobertura del objeto asegurado resuelta.",
  "api/models/PolicyQuoteCoverage/coverage-definition-not-found":
    "Definición de cobertura no encontrada",
  "api/models/PolicyQuoteCoverage/coverage-definition-not-found-description":
    "La definición de cobertura referenciada no existe.",
  "api/models/PolicyQuoteCoverage/duplicate-coverage":
    "Resultado de tarificación de cobertura duplicado",
  "api/models/PolicyQuoteCoverage/duplicate-coverage-description":
    "Ya existe un resultado de tarificación para esta cotización de póliza y cobertura del objeto asegurado.",
  "api/models/PolicyQuoteCoverage/policy-quote-id-is-required":
    "Se requiere la cotización de la póliza",
  "api/models/PolicyQuoteCoverage/policy-quote-id-is-required-description":
    "Proporciona el PolicyQuoteId al que pertenece este resultado de tarificación.",
  "api/models/PolicyQuoteCoverage/policy-quote-not-found":
    "Cotización de la póliza no encontrada",
  "api/models/PolicyQuoteCoverage/policy-quote-not-found-description":
    "La cotización de la póliza referenciada no existe.",
  "api/models/PolicyQuoteCoverage/subject-matter-coverage-id-is-required":
    "Se requiere la cobertura del objeto asegurado",
  "api/models/PolicyQuoteCoverage/subject-matter-coverage-id-is-required-description":
    "Proporciona el SubjectMatterCoverageId para el que se calculó este resultado de tarificación.",
  "api/models/PolicyQuoteCoverage/subject-matter-coverage-not-found":
    "Cobertura del objeto asegurado no encontrada",
  "api/models/PolicyQuoteCoverage/subject-matter-coverage-not-found-description":
    "La cobertura del objeto asegurado referenciada no existe.",
  "api/models/PolicySubjectMatter/cardinality-exceeded":
    "Ya no se admiten múltiples registros para este documento",
  "api/models/PolicySubjectMatter/cardinality-exceeded-description":
    'Este negocio tiene {{count}} registros de "{{slug}}"; solo los negocios con uno son elegibles para generar un nuevo slip de cotización',
  "api/models/PolicySubjectMatter/cross-program-link":
    "Vínculo entre programas",
  "api/models/PolicySubjectMatter/cross-program-link-description":
    "La materia asegurada pertenece a otro programa.",
  "api/models/PolicySubjectMatter/definition-not-found":
    "No se encontró la definición de sujeto de materia",
  "api/models/PolicySubjectMatter/definition-not-found-description":
    'No hay una definición de sujeto de materia configurada para "{{slug}}"',
  "api/models/PolicySubjectMatter/immutable-field":
    "El campo no se puede cambiar",
  "api/models/PolicySubjectMatter/instance-definition-mismatch":
    "El tipo de materia asegurada no coincide",
  "api/models/PolicySubjectMatter/instance-definition-mismatch-description":
    "La materia asegurada pertenece a una definición distinta a la que nombra este vínculo.",
  "api/models/PolicySubjectMatter/line-not-applicable": "No aplica a este ramo",
  "api/models/PolicySubjectMatter/line-not-applicable-description":
    "Los valores de esta materia asegurada no cumplen las condiciones del ramo de la póliza.",
  "api/models/PolicySubjectMatter/link-locked": "Vínculo bloqueado",
  "api/models/PolicySubjectMatter/link-locked-description":
    "Esta póliza ya está emitida, por lo que ya no pueden agregarse ni quitarse materias aseguradas vinculadas a ella",
  "api/models/PolicySubjectMatter/no-subject-matter":
    "Falta información requerida",
  "api/models/PolicySubjectMatter/no-subject-matter-description":
    'Este negocio no tiene "{{slug}}" registrado — complete la información requerida antes de generar este documento',
  "api/models/PolicySubjectMatter/subject-matter-claimed":
    "Este bien está en otra propuesta vigente o en una póliza emitida.",
  "api/models/PolicySubjectMatter/subject-matter-claimed-description":
    "Otra propuesta vigente o una póliza emitida ya tiene este bien. Elige otro o espera a que esa propuesta expire.",
  "api/models/PolicyTask/assignee-not-eligible": "Responsable no elegible",
  "api/models/PolicyTask/assignee-not-eligible-description":
    "Esta persona no puede tomar la tarea: debe ser un miembro activo y disponible de la compañía de la tarea con un rol permitido.",
  "api/models/PolicyTask/assignee-write-forbidden":
    "El responsable no se puede escribir directamente",
  "api/models/PolicyTask/assignee-write-forbidden-description":
    "Usa tomar o reasignar para cambiar el responsable de una tarea.",
  "api/models/PolicyTask/claim-forbidden": "No se puede tomar la tarea",
  "api/models/PolicyTask/claim-forbidden-description":
    "Solo puedes tomar una tarea para ti mismo.",
  "api/models/PolicyTask/entity-id-is-required": "Persona requerida",
  "api/models/PolicyTask/policy-id-is-required": "Póliza requerida",
  "api/models/PolicyTask/policy-id-is-required-description":
    "Una tarea debe pertenecer a una póliza.",
  "api/models/PolicyTask/policy-not-found": "Póliza no encontrada",
  "api/models/PolicyTask/policy-not-found-description":
    "La póliza de esta tarea no existe.",
  "api/models/PolicyTask/reason-invalid": "Motivo inválido",
  "api/models/PolicyTask/reason-invalid-description":
    "El motivo debe ser texto de máximo 500 caracteres.",
  "api/models/PolicyTask/reassign-entity-id-is-required-description":
    "Indica la persona a quien se reasigna la tarea.",
  "api/models/PolicyTask/rule-company-mismatch":
    "La cola pertenece a otra empresa",
  "api/models/PolicyTask/rule-company-mismatch-description":
    "La regla de asignación debe pertenecer a la empresa de la póliza.",
  "api/models/PolicyTask/task-closed": "Tarea cerrada",
  "api/models/PolicyTask/task-closed-description":
    "Una tarea completada o cancelada no se puede reasignar.",
  "api/models/PresentationRule/company-id-is-required":
    "La compañía es requerida",
  "api/models/PresentationRule/company-id-is-required-description":
    "Una regla de presentación debe pertenecer a una compañía",
  "api/models/PresentationRule/company-not-found": "Compañía no encontrada",
  "api/models/PresentationRule/company-not-found-description":
    "La compañía referenciada no existe",
  "api/models/PresentationRule/condition-blocked-pattern":
    "La condición contiene un patrón bloqueado",
  "api/models/PresentationRule/condition-blocked-pattern-description":
    "La condición hace referencia a una palabra clave no permitida",
  "api/models/PresentationRule/condition-too-long":
    "La condición es demasiado larga",
  "api/models/PresentationRule/condition-too-long-description":
    "La condición excede la longitud máxima permitida",
  "api/models/PresentationRule/icon-pair-mismatch": "Par de íconos incompleto",
  "api/models/PresentationRule/icon-pair-mismatch-description":
    "Icon e IconDark deben estar ambos definidos o ambos vacíos",
  "api/models/PresentationRule/invalid-condition": "Condición inválida",
  "api/models/PresentationRule/invalid-condition-description":
    "La condición no pudo analizarse como una expresión válida",
  "api/models/PresentationRule/invalid-target": "Destino inválido",
  "api/models/PresentationRule/invalid-target-description":
    "El destino debe ser uno de los destinos de presentación registrados",
  "api/models/PresentationRule/invalid-template": "Plantilla inválida",
  "api/models/PresentationRule/invalid-template-description":
    "La plantilla no pudo compilarse",
  "api/models/PresentationRule/lob-company-mismatch":
    "La línea de negocio pertenece a otra compañía",
  "api/models/PresentationRule/lob-company-mismatch-description":
    "La línea de negocio debe pertenecer a la misma compañía que la regla",
  "api/models/PresentationRule/lob-not-found": "Línea de negocio no encontrada",
  "api/models/PresentationRule/lob-not-found-description":
    "La línea de negocio referenciada no existe",
  "api/models/PresentationRule/name-required": "El nombre es requerido",
  "api/models/PresentationRule/name-required-description":
    "Una regla de presentación debe tener un nombre no vacío",
  "api/models/ProgramCedent/direct-requires-enabled":
    "Activa primero la cedente en el programa",
  "api/models/ProgramCedent/direct-requires-enabled-description":
    '"Sin agencia" solo puede estar activo mientras la cedente esté activa en el programa.',
  "api/models/ProgramCedent/engine-managed":
    "Las filas de disponibilidad las administra el sistema",
  "api/models/ProgramCedent/engine-managed-description":
    "Activa o desactiva la cedente; las filas no se pueden crear ni eliminar a mano.",
  "api/models/ProgramCedent/immutable-field": "El campo no se puede cambiar",
  "api/models/ProgramCedent/immutable-field-description":
    "Solo se pueden cambiar los interruptores de disponibilidad.",
  "api/models/ProgramCedent/invalid-arguments":
    "La solicitud de la lista no es válida",
  "api/models/ProgramCedent/invalid-arguments-description":
    "Revisa el identificador, el texto de búsqueda, el filtro, la página y el tamaño de página enviados.",
  "api/models/ProgramCedent/not-accessible": "No puedes ver estas cedentes",
  "api/models/ProgramCedent/not-accessible-description":
    "El programa o la agencia está fuera de tu acceso.",
  "api/models/ProgramCedentLineOfBusiness/already-exists":
    "El cedente ya tiene este ramo",
  "api/models/ProgramCedentLineOfBusiness/already-exists-description":
    "Edita el ramo que el cedente ya tiene en lugar de agregarlo de nuevo.",
  "api/models/ProgramCedentLineOfBusiness/immutable-field":
    "El campo no se puede cambiar",
  "api/models/ProgramCedentLineOfBusiness/line-in-use":
    "Este ramo está en uso y no se puede eliminar",
  "api/models/ProgramCedentLineOfBusiness/line-in-use-description":
    "Hay pólizas o propuestas de este cedente en este ramo. Deshabilítalo en su lugar: así deja de ofrecerse para negocio nuevo y el negocio existente no cambia.",
  "api/models/ProgramMembership/cedent-required":
    "Solo entidades legales cedentes canónicas pueden ser miembros del programa",
  "api/models/ProgramMembership/cedent-required-description":
    "Una membresía de programa debe referir a una entidad legal aseguradora canónica (no un alias).",
  "api/models/ProgramMembership/company-mismatch":
    "La cedente y el programa deben pertenecer a la misma compañía",
  "api/models/ProgramMembership/company-mismatch-description":
    "La cedente y el programa de una membresía deben pertenecer a la misma compañía.",
  "api/models/ProgramMembership/immutable":
    "Las membresías de programa no se pueden modificar",
  "api/models/ProgramMembership/immutable-description":
    "Una membresía de programa no se puede cambiar una vez creada; elimínela y cree una nueva.",
  "api/models/ProgramMembership/member-required":
    "Esta entidad no puede vincularse al programa como miembro",
  "api/models/ProgramMembership/member-required-description":
    "Un vínculo con el programa debe referir a una entidad existente que no sea la raíz de un programa ni una participación.",
  "api/models/ProgramMembership/program-root-required":
    "Las membresías deben referir a un programa",
  "api/models/ProgramMembership/program-root-required-description":
    "Una membresía de programa debe referir a una entidad que sea raíz de programa.",
  "api/models/Proposal/action-not-found": "Acción no encontrada",
  "api/models/Proposal/action-not-found-description":
    'El método "{{method}}" no existe en el modelo "{{model}}"',
  "api/models/QuoteBridge/lob-not-found": "Ramo no encontrado",
  "api/models/QuoteBridge/lob-not-found-description":
    "El ramo referenciado no existe.",
  "api/models/QuoteBridge/lob-required": "Ramo requerido",
  "api/models/QuoteBridge/lob-required-description":
    "Un puente de cotización debe pertenecer a un ramo.",
  "api/models/RegulatoryData/write-forbidden":
    "Los datos regulatorios solo los cambia la sincronización regulatoria",
  "api/models/RegulatoryData/write-forbidden-description":
    "Estos registros no se pueden crear, editar ni eliminar mediante la API.",
  "api/models/RelatedPartyDefinition/definition-id-is-required":
    "Se requiere la definición de objeto asegurado",
  "api/models/RelatedPartyDefinition/definition-id-is-required-description":
    "Proporciona el SubjectMatterDefinitionId al que pertenece este tercero relacionado.",
  "api/models/RelatedPartyDefinition/definition-not-found":
    "Definición de objeto asegurado no encontrada",
  "api/models/RelatedPartyDefinition/definition-not-found-description":
    "La definición de objeto asegurado referenciada no existe.",
  "api/models/RelatedPartyDefinition/duplicate-slug":
    "Slug de tercero relacionado duplicado",
  "api/models/RelatedPartyDefinition/duplicate-slug-description":
    "Ya existe una definición de tercero relacionado con este slug para esta definición de objeto asegurado y línea de negocio.",
  "api/models/RelatedPartyDefinition/line-of-business-below-proposal-start":
    "La línea de negocio está por debajo de una línea de negocio donde inician propuestas",
  "api/models/RelatedPartyDefinition/line-of-business-below-proposal-start-description":
    "Esta definición de tercero relacionado está declarada en una línea de negocio estrictamente por debajo de una que ya ancla un QuoteBridge activo. Decláela en esa línea de negocio o en una superior.",
  "api/models/RelatedPartyDefinition/line-of-business-id-is-required":
    "Se requiere la línea de negocio",
  "api/models/RelatedPartyDefinition/line-of-business-id-is-required-description":
    "Proporciona el LineOfBusinessId en el que se declara este tercero relacionado.",
  "api/models/RelatedPartyDefinition/line-of-business-not-found":
    "Línea de negocio no encontrada",
  "api/models/RelatedPartyDefinition/line-of-business-not-found-description":
    "La línea de negocio referenciada no existe.",
  "api/models/Role/ambiguous-definition-inheritance":
    "Herencia ambigua de definición de rol",
  "api/models/Role/ambiguous-definition-inheritance-description":
    "Más de una definición personalizada aplica a esta rama a la misma distancia por encima de la asignación; resuelve el conflicto antes de poder usarla.",
  "api/models/Role/definition-field-immutable":
    "La definición del rol no se puede cambiar",
  "api/models/Role/definition-field-immutable-description":
    "La familia, el propietario, el alcance y el nivel de un rol no pueden cambiar después de crearlo. Crea un rol nuevo.",
  "api/models/Role/definition-owner-invalid":
    "Propietario de definición de rol inválido",
  "api/models/Role/definition-owner-invalid-description":
    "Un rol que no es del sistema debe ser personalizado, o una definición personalizada con propietario.",
  "api/models/Role/family-mismatch":
    "La familia del rol no coincide con su alcance",
  "api/models/Role/family-mismatch-description":
    "La familia del rol se determina por su alcance y nivel y no puede tener otro valor.",
  "api/models/Role/family-not-derivable":
    "No se puede determinar la familia del rol",
  "api/models/Role/family-not-derivable-description":
    "Un rol personalizado necesita un alcance de compañía, cuenta, agencia o cedente y un nivel (administrador, gerente, empleado o usuario). No se admiten roles personalizados globales.",
  "api/models/Role/override-definition-reserved":
    "Las definiciones personalizadas se administran por separado",
  "api/models/Role/override-definition-reserved-description":
    "Las definiciones personalizadas y las especificaciones de permisos solo se pueden guardar mediante el servicio de definiciones de rol.",
  "api/models/Role/override-slug-conflict": "Conflicto de definición de rol",
  "api/models/Role/override-slug-conflict-description":
    "Otro rol ya usa el identificador de esta definición personalizada.",
  "api/models/Role/permission-spec-administrator-only":
    "Los modelos exclusivos de administrador no se pueden otorgar",
  "api/models/Role/permission-spec-administrator-only-description":
    "La especificación de permisos otorga acceso a un modelo que solo un administrador de la compañía puede alcanzar. Quita las acciones de modelo indicadas.",
  "api/models/Role/permission-spec-invalid":
    "Especificación de permisos inválida",
  "api/models/Role/permission-spec-invalid-description":
    "La especificación de permisos de la definición de rol no es válida. Revisa los errores indicados.",
  "api/models/Role/save-override-definition-invalid-body":
    "Se requieren una familia, un tipo de propietario y un propietario.",
  "api/models/Role/save-override-definition-invalid-body-description":
    'Proporciona FamilySlug, DefinitionOwnerType ("company" o "participation") y DefinitionOwnerId.',
  "api/models/Role/slug-reserved-namespace":
    "El slug del rol usa un carácter reservado",
  "api/models/Role/slug-reserved-namespace-description":
    'Un slug que contiene "~" está reservado para definiciones personalizadas (familia~tipo de propietario~id de propietario) y solo puede crearse mediante el servicio de definiciones de rol.',
  "api/models/Role/unknown-family": "Familia de rol desconocida",
  "api/models/Role/unknown-family-description":
    "Una definición personalizada debe indicar una familia de rol del sistema con alcance.",
  "api/models/RoleInheritance/override-inheritance-forbidden":
    "Las definiciones sobrescritas no pueden usar herencia de roles.",
  "api/models/RoleInheritance/override-inheritance-forbidden-description":
    "Una definición sobrescrita de compañía o participación no puede heredar de otro rol ni ser heredada por uno — la herencia es un concepto de rol de sistema.",
  "api/models/SHPolicy/agency-id-is-required":
    "Es necesario el Id de la agencia",
  "api/models/SHPolicy/agency-id-is-required-description":
    "Es necesario el Id de la agencia",
  "api/models/SHPolicy/agency-not-found": "Agencia no encontrada",
  "api/models/SHPolicy/agency-not-found-description": "Agencia no encontrada",
  "api/models/SHPolicy/comission-table-not-assigned":
    "Tabla de comisión no asignada",
  "api/models/SHPolicy/comission-table-not-assigned-description":
    "La agencia proporcionada no cuenta con una tabla de comisión asignada para este tipo de póliza. Por favor, asigna una tabla de comisión y vuelve a intentar.",
  "api/models/SHPolicyQuote/policy-id-is-required":
    "Es necesario el Id de la póliza",
  "api/models/SHPolicyQuote/policy-id-is-required-description":
    "Es necesario el Id de la póliza",
  "api/models/SHPolicyQuote/policy-not-found": "Póliza no encontrada",
  "api/models/SHPolicyQuote/policy-not-found-description":
    "Póliza no encontrada",
  "api/models/SubjectMatterAttribute/catalogue-not-found":
    "Definición de catálogo no encontrada",
  "api/models/SubjectMatterAttribute/catalogue-not-found-description":
    "La definición de catálogo referenciada no existe.",
  "api/models/SubjectMatterAttribute/coverage-definition-not-found":
    "Definición de cobertura no encontrada",
  "api/models/SubjectMatterAttribute/coverage-definition-not-found-description":
    "La definición de cobertura referenciada no existe.",
  "api/models/SubjectMatterAttribute/definition-not-found":
    "Definición de objeto asegurado no encontrada",
  "api/models/SubjectMatterAttribute/definition-not-found-description":
    "La definición de objeto asegurado referenciada no existe.",
  "api/models/SubjectMatterAttribute/identity-attribute-locked":
    "El atributo de identidad no se puede cambiar",
  "api/models/SubjectMatterAttribute/identity-attribute-locked-description":
    "Este atributo identifica un registro entre casos, por lo que no se puede renombrar, eliminar, volver de varios valores o no único, ni moverlo al alcance del anexo.",
  "api/models/SubjectMatterAttribute/invalid-derived":
    "Configuración de valor derivado no válida",
  "api/models/SubjectMatterAttribute/invalid-derived-description":
    "La configuración Derived de este atributo debe indicar un origen (from) que sea otro atributo de catálogo del mismo propietario y una ruta de saltos parent seguidos de name o attributes.<nombre>.",
  "api/models/SubjectMatterAttribute/invalid-entry-filter":
    "Configuración de filtro de entradas no válida",
  "api/models/SubjectMatterAttribute/invalid-entry-filter-description":
    "La configuración EntryFilter de este atributo debe ser una lista de reglas con la forma when (attribute, in) y require (entryAttribute, equals).",
  "api/models/SubjectMatterAttribute/invalid-unique-scope":
    "Configuración de alcance de unicidad no válida",
  "api/models/SubjectMatterAttribute/invalid-unique-scope-description":
    "La configuración UniqueScope de este atributo debe tener la forma kind (active-cases), excludeStages (lista de etapas distintas) y exemptRelation (PreviousPolicy o null).",
  "api/models/SubjectMatterAttribute/invalid-validator":
    "Configuración de validador no válida",
  "api/models/SubjectMatterAttribute/invalid-validator-description":
    "La configuración Validator de este atributo debe nombrar un validador registrado y dar su configuración como objeto.",
  "api/models/SubjectMatterAttribute/multiple-owners-set":
    "Solo se permite un propietario",
  "api/models/SubjectMatterAttribute/multiple-owners-set-description":
    "SubjectMatterDefinitionId, CoverageDefinitionId, RelatedPartyDefinitionId y ParentAttributeId son mutuamente excluyentes; solo se puede definir uno.",
  "api/models/SubjectMatterAttribute/owner-is-required":
    "Se requiere un propietario",
  "api/models/SubjectMatterAttribute/owner-is-required-description":
    "Define exactamente uno de SubjectMatterDefinitionId, CoverageDefinitionId, RelatedPartyDefinitionId o ParentAttributeId.",
  "api/models/SubjectMatterAttribute/parent-attribute-must-be-list":
    "El atributo padre debe ser de tipo lista",
  "api/models/SubjectMatterAttribute/parent-attribute-must-be-list-description":
    "ParentAttributeId debe hacer referencia a un atributo cuyo Type sea 'list'.",
  "api/models/SubjectMatterAttribute/parent-attribute-not-found":
    "Atributo padre no encontrado",
  "api/models/SubjectMatterAttribute/parent-attribute-not-found-description":
    "El atributo padre referenciado no existe.",
  "api/models/SubjectMatterAttribute/related-party-definition-not-found":
    "Definición de tercero relacionado no encontrada",
  "api/models/SubjectMatterAttribute/related-party-definition-not-found-description":
    "La definición de tercero relacionado referenciada no existe.",
  "api/models/SubjectMatterAttribute/storage-reference-server-managed":
    "La referencia de almacenamiento no se puede cambiar",
  "api/models/SubjectMatterAttribute/storage-reference-server-managed-description":
    "Si un atributo guarda referencias a archivos almacenados lo define la plataforma, no la API",
  "api/models/SubjectMatterAttribute/unique-multiple-conflict":
    "Único y múltiple son incompatibles",
  "api/models/SubjectMatterAttribute/unique-multiple-conflict-description":
    "Un atributo de valores múltiples no puede ser único: la unicidad solo se valida sobre valores individuales",
  "api/models/SubjectMatterCoverage/coverage-definition-id-is-required":
    "Se requiere la definición de cobertura",
  "api/models/SubjectMatterCoverage/coverage-definition-id-is-required-description":
    "Proporciona el CoverageDefinitionId que resuelve este registro.",
  "api/models/SubjectMatterCoverage/coverage-definition-not-applicable":
    "La definición de cobertura no aplica a esta instancia",
  "api/models/SubjectMatterCoverage/coverage-definition-not-applicable-description":
    "La definición de cobertura debe pertenecer a la definición de objeto asegurado de la instancia anfitriona.",
  "api/models/SubjectMatterCoverage/coverage-definition-not-found":
    "Definición de cobertura no encontrada",
  "api/models/SubjectMatterCoverage/coverage-definition-not-found-description":
    "La definición de cobertura referenciada no existe.",
  "api/models/SubjectMatterCoverage/coverage-definition-not-resolved-for-leaf-lob":
    "La definición de cobertura no resuelve para esta propuesta",
  "api/models/SubjectMatterCoverage/coverage-definition-not-resolved-for-leaf-lob-description":
    "El CoverageDefinitionId proporcionado no es el registro que resolveCoverageInheritance resuelve para el slug de esta cobertura en la línea de negocio hoja de la propuesta de la instancia anfitriona; un nivel más específico lo sobreescribe o excluye.",
  "api/models/SubjectMatterCoverage/duplicate-coverage": "Cobertura duplicada",
  "api/models/SubjectMatterCoverage/duplicate-coverage-description":
    "Esta cobertura ya fue creada para esta instancia de objeto asegurado.",
  "api/models/SubjectMatterCoverage/host-instance-not-found":
    "Instancia de objeto asegurado anfitriona no encontrada",
  "api/models/SubjectMatterCoverage/host-instance-not-found-description":
    "La instancia de objeto asegurado referenciada no existe.",
  "api/models/SubjectMatterCoverage/illegal-state-transition":
    "Transición de estado de cobertura inválida",
  "api/models/SubjectMatterCoverage/illegal-state-transition-description":
    "Esta cobertura no puede pasar de su estado actual al estado solicitado.",
  "api/models/SubjectMatterCoverage/subject-matter-instance-id-is-required":
    "Se requiere la instancia de objeto asegurado",
  "api/models/SubjectMatterCoverage/subject-matter-instance-id-is-required-description":
    "Proporciona el SubjectMatterInstanceId sobre el que se elige esta cobertura.",
  "api/models/SubjectMatterDefinition/endorsable-in-use":
    "No se puede desactivar Endosable",
  "api/models/SubjectMatterDefinition/endorsable-in-use-description":
    "Esta definición ya tiene endosos, por lo que desactivar Endosable los desbloquearía; la opción debe seguir activa",
  "api/models/SubjectMatterDefinition/identity-reuse-in-use":
    "La configuración de reutilización de identidad está en uso",
  "api/models/SubjectMatterDefinition/identity-reuse-in-use-description":
    "La configuración IdentityReuse no se puede cambiar ni quitar mientras la definición tenga instancias.",
  "api/models/SubjectMatterDefinition/invalid-form":
    "Formulario independiente inválido",
  "api/models/SubjectMatterDefinition/invalid-form-description":
    "Selecciona un formulario de objeto asegurado activo de esta compañía.",
  "api/models/SubjectMatterDefinition/invalid-identity-reuse":
    "Configuración de reutilización de identidad no válida",
  "api/models/SubjectMatterDefinition/invalid-identity-reuse-description":
    "La configuración IdentityReuse de esta definición debe estar vacía o nombrar un atributo de la definición con alcance de instancia, único y de un solo valor, y la definición debe ser endosable y requerir un contexto de póliza.",
  "api/models/SubjectMatterDefinition/invalid-owner-source":
    "Configuración de origen del propietario no válida",
  "api/models/SubjectMatterDefinition/invalid-owner-source-description":
    "La configuración OwnerSource de esta definición debe estar vacía o ser policyHolder.",
  "api/models/SubjectMatterDefinitionLOB/invalid-claim":
    "La configuración de siniestro es inválida",
  "api/models/SubjectMatterDefinitionLOB/invalid-claim-description":
    "La configuración de siniestro del objeto del seguro es inválida: {{problem}}.",
  "api/models/SubjectMatterDefinitionLOB/invalid-conditions":
    "Configuración de condiciones no válida",
  "api/models/SubjectMatterDefinitionLOB/invalid-conditions-description":
    "La configuración Conditions de este vínculo con el ramo debe ser una lista de condiciones con la forma attribute e in.",
  "api/models/SubjectMatterInstance/active-endorsement-missing":
    "Sin endoso activo",
  "api/models/SubjectMatterInstance/active-endorsement-missing-description":
    "Este objeto asegurado no tiene un endoso activo sobre el cual construir",
  "api/models/SubjectMatterInstance/attribute-not-writable":
    "Atributo no editable",
  "api/models/SubjectMatterInstance/attribute-not-writable-description":
    "Tu rol no puede modificar este atributo",
  "api/models/SubjectMatterInstance/attribute-validation-failed":
    "Error de validación",
  "api/models/SubjectMatterInstance/claim-locked":
    "Materia asegurada retenida por una póliza emitida",
  "api/models/SubjectMatterInstance/claim-locked-description":
    "Una póliza emitida retiene esta materia asegurada, por lo que ya no puede modificarse ni eliminarse",
  "api/models/SubjectMatterInstance/definition-not-endorsable":
    "Definición no endosable",
  "api/models/SubjectMatterInstance/definition-not-endorsable-description":
    "Esta definición de objeto asegurado no admite endosos",
  "api/models/SubjectMatterInstance/derived-conflict": "El valor es derivado",
  "api/models/SubjectMatterInstance/derived-conflict-description":
    "Este atributo se llena a partir de la entrada de catálogo seleccionada y no puede tener otro valor",
  "api/models/SubjectMatterInstance/endorse-invalid-attributes":
    "Atributos inválidos",
  "api/models/SubjectMatterInstance/endorse-invalid-attributes-description":
    "Los atributos a cambiar deben ser un objeto con valores",
  "api/models/SubjectMatterInstance/endorse-requires-root":
    "Se requiere el registro raíz",
  "api/models/SubjectMatterInstance/endorse-requires-root-description":
    "Un nuevo endoso se crea desde el registro raíz del objeto asegurado, no desde uno de sus endosos",
  "api/models/SubjectMatterInstance/endorsement-destroy-not-allowed":
    "Un endoso no puede eliminarse por separado",
  "api/models/SubjectMatterInstance/endorsement-destroy-not-allowed-description":
    "El historial de un registro endosable nunca se elimina por partes; elimine el registro para quitar todos sus endosos",
  "api/models/SubjectMatterInstance/endorsement-locked": "Endoso bloqueado",
  "api/models/SubjectMatterInstance/endorsement-locked-description":
    "Una póliza emitida está vinculada a este endoso, por lo que ya no puede modificarse; cree un nuevo endoso",
  "api/models/SubjectMatterInstance/endorsement-not-locked":
    "Endoso aún no emitido",
  "api/models/SubjectMatterInstance/endorsement-not-locked-description":
    "El endoso activo aún es un borrador; edítelo en lugar de crear uno nuevo",
  "api/models/SubjectMatterInstance/entry-not-applicable":
    "Opción no disponible",
  "api/models/SubjectMatterInstance/entry-not-applicable-description":
    "La entrada de catálogo seleccionada no aplica a los demás valores de este registro",
  "api/models/SubjectMatterInstance/identity-attribute-fixed":
    "El atributo de identidad no se puede cambiar",
  "api/models/SubjectMatterInstance/identity-attribute-fixed-description":
    "Esta matrícula pertenece a una aeronave registrada; para cotizar otra aeronave crea una nueva propuesta.",
  "api/models/SubjectMatterInstance/immutable-field":
    "El campo no se puede cambiar",
  "api/models/SubjectMatterInstance/linked-record":
    "El registro no se puede modificar aquí",
  "api/models/SubjectMatterInstance/linked-record-description":
    "Las operaciones independientes requieren un registro sin vínculos y solo pueden modificar sus atributos.",
  "api/models/SubjectMatterInstance/owner-must-be-policy-holder":
    "El propietario debe ser el contratante",
  "api/models/SubjectMatterInstance/owner-must-be-policy-holder-description":
    "El propietario de este objeto asegurado debe ser el contratante",
  "api/models/SubjectMatterInstance/parent-id-not-allowed":
    "Registro padre no permitido",
  "api/models/SubjectMatterInstance/parent-id-not-allowed-description":
    "No se puede indicar un registro padre al crear; cree el objeto asegurado y use la acción de endoso para agregar un endoso",
  "api/models/SubjectMatterInstance/pattern-mismatch": "Formato inválido",
  "api/models/SubjectMatterInstance/pattern-mismatch-description":
    "El valor no coincide con el formato requerido",
  "api/models/SubjectMatterInstance/policy-context-required":
    "Se requiere el contexto de la póliza",
  "api/models/SubjectMatterInstance/policy-context-required-description":
    "Este objeto asegurado debe crearse dentro del contexto de una póliza o cotización",
  "api/models/SubjectMatterInstance/policy-holder-required":
    "Se requiere el contratante de la póliza",
  "api/models/SubjectMatterInstance/policy-holder-required-description":
    "El contratante debe estar definido antes de crear este objeto asegurado",
  "api/models/SubjectMatterInstance/policy-modify-required": "No permitido",
  "api/models/SubjectMatterInstance/policy-modify-required-description":
    "No puedes modificar la materia asegurada de este negocio.",
  "api/models/SubjectMatterInstance/unknown-attribute": "Atributo desconocido",
  "api/models/SubjectMatterInstance/unknown-attribute-description":
    "El atributo enviado no está definido para esta materia",
  "api/models/SubjectMatterLink/cross-program-link": "Vínculo entre programas",
  "api/models/SubjectMatterLink/cross-program-link-description":
    "La materia asegurada pertenece a otro programa.",
  "api/models/SubjectMatterLink/immutable-field":
    "El campo no se puede cambiar",
  "api/models/SubjectMatterLink/instance-id-required": "Falta la instancia",
  "api/models/SubjectMatterLink/instance-id-required-description":
    "Se requieren las instancias origen y destino.",
  "api/models/SubjectMatterLink/relationship-required": "Falta la relación",
  "api/models/SubjectMatterLink/relationship-required-description":
    "Se requiere una relación para vincular las materias.",
  "api/models/SubjectMatterLink/source-not-found": "Origen no encontrado",
  "api/models/SubjectMatterLink/source-not-found-description":
    "No se encontró la instancia de materia origen.",
  "api/models/SubjectMatterLink/target-not-found": "Destino no encontrado",
  "api/models/SubjectMatterLink/target-not-found-description":
    "No se encontró la instancia de materia destino.",
  "api/models/SubjectMatterRelatedParty/host-instance-not-found":
    "Instancia de objeto asegurado anfitriona no encontrada",
  "api/models/SubjectMatterRelatedParty/host-instance-not-found-description":
    "La instancia de objeto asegurado referenciada no existe.",
  "api/models/SubjectMatterRelatedParty/related-party-definition-id-is-required":
    "Se requiere la definición de tercero relacionado",
  "api/models/SubjectMatterRelatedParty/related-party-definition-id-is-required-description":
    "Proporciona el RelatedPartyDefinitionId que adjunta este registro.",
  "api/models/SubjectMatterRelatedParty/related-party-definition-not-applicable":
    "La definición de tercero relacionado no aplica a esta instancia",
  "api/models/SubjectMatterRelatedParty/related-party-definition-not-applicable-description":
    "La definición de tercero relacionado debe pertenecer a la definición de objeto asegurado de la instancia anfitriona.",
  "api/models/SubjectMatterRelatedParty/related-party-definition-not-found":
    "Definición de tercero relacionado no encontrada",
  "api/models/SubjectMatterRelatedParty/related-party-definition-not-found-description":
    "La definición de tercero relacionado referenciada no existe.",
  "api/models/SubjectMatterRelatedParty/subject-matter-instance-id-is-required":
    "Se requiere la instancia de objeto asegurado",
  "api/models/SubjectMatterRelatedParty/subject-matter-instance-id-is-required-description":
    "Proporciona el SubjectMatterInstanceId al que se adjunta este tercero relacionado.",
  "api/models/Theme/invalid-hex-color": "Código de color hexadecimal inválido",
  "api/models/Theme/light-color-invalid-hex":
    "El color claro debe ser un código de color hexadecimal válido",
  "api/models/Theme/primary-color-invalid-hex":
    "El color primario debe ser un código de color hexadecimal válido",
  "api/models/Theme/scope-change-not-allowed":
    "Este registro no se puede mover a otra compañía.",
  "api/models/Theme/secondary-color-invalid-hex":
    "El color secundario debe ser un código de color hexadecimal válido",
  "api/models/Theme/tertiary-color-invalid-hex":
    "El color terciario debe ser un código de color hexadecimal válido",
  "api/models/Theme/text-color-invalid-hex":
    "El color de texto debe ser un código de color hexadecimal válido",
  "api/models/URL/agency-not-found": "Agencia no encontrada",
  "api/models/URL/agency-not-found-description":
    "No fue posible encontrar una agencia válida y existente con el Id proporcionado.",
  "api/models/URL/company-id-is-required": "Es necesario un CompanyId",
  "api/models/URL/company-id-is-required-description":
    "Es necesario proporcionar un Id de compañía válido para crear una nueva URL para la compañía.",
  "api/models/URL/company-id-required": "Es necesario el Id de la compañía",
  "api/models/URL/company-id-required-description":
    "Es necesario el Id de la compañía para crear la URL. Proporcione el CompanyId o el EntityId.",
  "api/models/URL/entity-not-found": "Entidad no encontrada",
  "api/models/URL/entity-not-found-description":
    "No fue posible encontrar una entidad válida y existente con el Id proporcionado.",
  "api/models/URL/program-root-required":
    "Un portal de programa debe estar vinculado a un programa",
  "api/models/URL/program-root-required-description":
    "En modo de programa, el AgencyId de una URL debe referir a una raíz de programa.",
  "api/models/UserAvailability/company-id-is-required": "Compañía requerida",
  "api/models/UserAvailability/company-id-is-required-description":
    "No se pudo determinar la compañía de la ausencia.",
  "api/models/UserAvailability/company-mismatch": "La compañía no coincide",
  "api/models/UserAvailability/company-mismatch-description":
    "La ausencia debe pertenecer a la compañía de la solicitud.",
  "api/models/UserAvailability/entity-id-is-required": "Persona requerida",
  "api/models/UserAvailability/entity-id-is-required-description":
    "Indica la persona a quien corresponde la ausencia.",
  "api/models/UserAvailability/entity-mismatch": "No es tu ausencia",
  "api/models/UserAvailability/entity-mismatch-description":
    "Solo puedes registrar ausencias para ti mismo.",
  "api/models/UserAvailability/entity-not-found": "Persona no encontrada",
  "api/models/UserAvailability/entity-not-found-description":
    "La persona no pertenece a esta compañía.",
  "api/models/UserAvailability/ids-are-immutable":
    "La persona y la compañía no se pueden cambiar",
  "api/models/UserAvailability/ids-are-immutable-description":
    "Elimina la ausencia y crea una nueva.",
  "api/models/UserAvailability/not-own-row": "No es tu ausencia",
  "api/models/UserAvailability/not-own-row-description":
    "Solo puedes modificar tus propias ausencias.",
  "api/models/UserAvailability/window-invalid": "Fechas de ausencia inválidas",
  "api/models/UserAvailability/window-invalid-description":
    "Ambas fechas deben ser válidas y el fin no puede ser anterior al inicio.",
  "api/models/Vehicle/entity-id-is-required":
    "Es necesario el Id de la entidad",
  "api/models/Vehicle/entity-id-is-required-description":
    "Es necesario el Id de la entidad al crear un nuevo Vehículo. Verifica el Id proporcionado e intenta de nuevo.",
  "api/models/Vehicle/entity-not-found": "Entidad no encontrada",
  "api/models/Vehicle/entity-not-found-description":
    "No se encontró la entidad con el Id proporcionado",
  "api/models/Vehicle/vin-already-exists": "El VIN ya está registrado",
  "api/models/Vehicle/vin-already-exists-description":
    "Ya existe un vehículo registrado con el VIN proporcionado. Por favor, verifica el VIN e intenta de nuevo.",
  "api/models/VehiclePolicy/agency-id-is-required":
    "Es necesario el Id de la agencia",
  "api/models/VehiclePolicy/agency-id-is-required-description":
    "Es necesario el Id de la agencia",
  "api/models/VehiclePolicy/agency-not-found": "Agencia no encontrada",
  "api/models/VehiclePolicy/agency-not-found-description":
    "Agencia no encontrada",
  "api/models/VehiclePolicy/comission-table-not-assigned":
    "Tabla de comisión no asignada",
  "api/models/VehiclePolicy/comission-table-not-assigned-description":
    "La agencia proporcionada no cuenta con una tabla de comisión asignada para este tipo de póliza. Por favor, asigna una tabla de comisión y vuelve a intentar.",
  "api/models/agency-id-is-required": "Es necesario el Id de la agencia",
  "api/models/agency-id-is-required-description":
    "Es necesario el Id de la agencia",
  "api/models/agency-not-found": "Agencia no encontrada",
  "api/models/agency-not-found-description":
    "La agencia especificada no fue encontrada",
  "api/models/business-id-is-required": "Es necesario el Id del negocio",
  "api/models/business-id-is-required-description":
    "Es necesario el Id del negocio para crear un periodo de negocio",
  "api/models/business-not-found": "Negocio no encontrado",
  "api/models/business-not-found-description":
    "El negocio especificado no fue encontrado",
  "api/models/comission-table-not-assigned": "Tabla de comisión no asignada",
  "api/models/could-not-create-or-find-business":
    "No se pudo crear o encontrar la empresa",
  "api/models/duplicate-value": "Valor duplicado",
  "api/models/duplicate-value-description":
    "Ya existe un registro con este valor",
  "api/models/entity-id-is-required": "Es necesario el Id de la entidad",
  "api/models/entity-id-is-required-description":
    "Es necesario el Id de la entidad al crear un nuevo correo electrónico de entidad",
  "api/models/entity-not-found": "Entidad no encontrada",
  "api/models/entity-not-found-description": "Entidad no encontrada",
  "api/models/id-is-required": "Es necesario el Id",
  "api/models/identifier-already-registered": "Identificador ya registrado",
  "api/models/identifier-already-registered-description":
    "Este identificador ya está registrado",
  "api/models/immutable-field-description":
    "Este campo no puede cambiar después de su creación.",
  "api/models/internal-error": "Error interno",
  "api/models/invalid-attribute-value": "Valor de atributo no válido",
  "api/models/invalid-attribute-value-description":
    "Un identificador único no puede contener caracteres de control o no imprimibles",
  "api/models/invalid-inforce-date": "Fecha de vigencia inválida",
  "api/models/invalid-inforce-date-description":
    "La fecha de vigencia proporcionada no es válida",
  "api/models/invalid-pattern-config": "Patrón de validación inválido",
  "api/models/invalid-pattern-config-description":
    "El atributo está configurado con un patrón inválido",
  "api/models/invalid-unique-scope": "Alcance de unicidad no válido",
  "api/models/invalid-unique-scope-description":
    "El alcance de unicidad guardado para este atributo es inválido",
  "api/models/line-of-business-is-required": "Es necesario el Ramo",
  "api/models/line-of-business-is-required-description": "Es necesario el Ramo",
  "api/models/lob-not-found": "Ramo no encontrado",
  "api/models/models-not-passed-in-options":
    "Error interno del sistema: los modelos no fueron pasados en las opciones. Por favor, contacte al administrador.",
  "api/models/module-disabled":
    "Este módulo no está habilitado para tu empresa.",
  "api/models/module-disabled-description":
    "Solicita a un administrador de la empresa que configure y active el módulo.",
  "api/models/quoting/deductible-reconciliation-no-prior-quote":
    "No hay una cotización previa para reconciliar",
  "api/models/quoting/deductible-reconciliation-no-prior-quote-description":
    "Este negocio no tiene una cotización previa del motor registrada, por lo que sus deducibles no pueden reconciliarse.",
  "api/models/quoting/deductible-reconciliation-no-steps-configured":
    "No hay pasos de resolución de deducibles configurados",
  "api/models/quoting/deductible-reconciliation-no-steps-configured-description":
    "El pipeline activo para esta línea de negocio no tiene pasos deductible_resolution para reconciliar.",
  "api/models/quoting/execution-error": "Error de ejecución del pipeline",
  "api/models/quoting/execution-error-description":
    "Ocurrió un error al ejecutar el pipeline de cotización",
  "api/models/quoting/expression-error": "Error de evaluación de expresión",
  "api/models/quoting/expression-error-description":
    "Ocurrió un error al evaluar la expresión de la fórmula",
  "api/models/quoting/fetch-related-invalid-model":
    "Referencia de modelo inválida",
  "api/models/quoting/fetch-related-invalid-model-description":
    "El modelo referenciado no existe en el sistema",
  "api/models/quoting/invalid-step-config":
    "Configuración de paso del pipeline inválida",
  "api/models/quoting/invalid-step-config-description":
    "La configuración del paso es inválida. Verifique los campos de configuración.",
  "api/models/quoting/lob-required": "Ramo requerido",
  "api/models/quoting/lob-required-description":
    "Se requiere LineOfBusinessId en la propuesta.",
  "api/models/quoting/mandatory-check-lob-required":
    "Se requiere una línea de negocio para la verificación de coberturas obligatorias",
  "api/models/quoting/mandatory-check-lob-required-description":
    "El paso de verificación de coberturas obligatorias requiere LineOfBusinessId en el contexto; se ejecutó antes de que la línea de negocio fuera resuelta.",
  "api/models/quoting/mandatory-coverage-missing":
    "Falta elegir una cobertura obligatoria",
  "api/models/quoting/mandatory-coverage-missing-description":
    "Estas coberturas obligatorias no han sido elegidas para esta propuesta: {{missingNames}}.",
  "api/models/quoting/pipeline-not-found": "No se encontró un pipeline activo",
  "api/models/quoting/pipeline-not-found-description":
    "No se encontró un pipeline de cotización activo para esta línea de negocio",
  "api/models/quoting/rate-not-found": "Tarifa no encontrada",
  "api/models/quoting/rate-not-found-description":
    "No se encontró una tarifa coincidente en la tabla de tarifas para el valor dado",
  "api/models/quoting/record-id-required":
    "Se requiere el identificador del registro de cotización",
  "api/models/quoting/record-id-required-description":
    "Este paso del pipeline requiere que el registro de cotización ya exista; se ejecutó antes de que el registro fuera creado.",
  "api/models/quoting/snapshot-cannot-be-deleted":
    "Los registros de snapshots de cotización son inmutables y no pueden ser eliminados",
  "api/models/quoting/snapshot-cannot-be-modified":
    "Los registros de snapshots de cotización son inmutables y no pueden ser actualizados",
  "api/models/quoting/snapshot-immutable":
    "Los snapshots de cotización no pueden ser modificados",
  "api/models/quoting/spare-parts-limit-exceeded":
    "Límite de repuestos excedido",
  "api/models/quoting/spare-parts-limit-exceeded-description":
    "El límite de repuestos excede el máximo permitido",
  "api/models/quoting/spare-parts-ratio-exceeded":
    "Ratio de repuestos excedido",
  "api/models/quoting/spare-parts-ratio-exceeded-description":
    "El ratio de límite de repuestos sobre valor de casco excede el máximo permitido",
  "api/models/quoting/validation-failed": "Validación fallida",
  "api/models/quoting/validation-failed-description":
    "Una condición de validación no fue cumplida",
  "api/models/quoting/warranty-premium-reconciliation-no-prior-quote":
    "No hay una cotización previa para reconciliar",
  "api/models/quoting/warranty-premium-reconciliation-no-prior-quote-description":
    "Este negocio no tiene una cotización previa del motor registrada, por lo que su presentación de garantía/prima no puede reconciliarse.",
  "api/models/quoting/warranty-premium-reconciliation-no-steps-configured":
    "No hay pasos de resolución de garantía/prima configurados",
  "api/models/quoting/warranty-premium-reconciliation-no-steps-configured-description":
    "El pipeline activo para este ramo no tiene pasos warranty_resolution/premium_lines para reconciliar.",
  "api/models/revision-conflict": "Este registro ha cambiado",
  "api/models/revision-conflict-description":
    "Recarga la versión más reciente antes de guardar tus cambios.",
  "api/models/revision-required": "Se requiere la revisión del registro",
  "api/models/revision-required-description":
    "Recarga el registro y envía la revisión que editaste.",
  "api/models/role/definition-management-reserved":
    "Solo los administradores de plataforma pueden gestionar definiciones de rol.",
  "api/models/role/definition-management-reserved-description":
    "Editar una definición de rol propiedad de una compañía o una participación requiere un administrador de esa compañía, o superAdmin.",
  "api/models/transaction-required-for-uniqueness":
    "La validación de unicidad necesita una transacción para ejecutarse de forma segura",
  "api/models/user-not-allowed-to-execute-method": "Acción no permitida",
  "api/models/user-not-allowed-to-execute-method-description":
    'No cuenta con los permisos necesarios para ejecutar el método "{{method}}" en el objeto "{{model}}". Por favor, contacte al administrador del sistema.',
  "api/not-implemented": "Aún no disponible",
  "api/not-implemented-description": "Esta operación aún no está disponible.",
  "api/platform/owner-not-configured":
    "Propietario de la plataforma no configurado",
  "api/platform/owner-not-configured-description":
    "La base de datos debe tener exactamente una compañía raíz activa para ser dueña de los datos compartidos de la plataforma.",
  "api/request/company-context-conflict": "Conflicto de contexto de compañía",
  "api/request/company-context-conflict-description":
    "La compañía solicitada no coincide con la de este dominio del portal.",
  "api/request/context-lookup-failed": "Servicio no disponible temporalmente",
  "api/request/context-lookup-failed-description":
    "No fue posible resolver el contexto de la solicitud. Inténtalo de nuevo en un momento.",
  "api/request/host-context-required": "Dirección del portal requerida",
  "api/request/host-context-required-description":
    "Esta solicitud no proviene de una dirección registrada del portal, por lo que no puede atenderse. Abre el portal desde su propia dirección e inténtalo de nuevo.",
  "api/request/idempotency-unavailable": "Servicio no disponible temporalmente",
  "api/request/idempotency-unavailable-description":
    "No fue posible proteger la solicitud contra envíos duplicados. Inténtalo de nuevo en un momento.",
  "api/request/include-not-allowed":
    "Solicitud de datos relacionados no válida",
  "api/request/include-not-allowed-description":
    "Una de las asociaciones solicitadas no está permitida.",
  "api/request/internal-error": "Algo salió mal",
  "api/request/internal-error-description":
    "Ocurrió un error inesperado. Por favor intenta de nuevo.",
  "api/request/invalid-instance": "Instancia inválida",
  "api/request/invalid-instance-description":
    "La instancia solicitada no es reconocida.",
  "api/request/mass-mutation-not-allowed": "Actualización masiva no permitida",
  "api/request/mass-mutation-not-allowed-description":
    "Este modelo no permite actualizar o eliminar varios registros a la vez a través de la API de datos.",
  "api/request/method-not-callable": "Método no disponible",
  "api/request/method-not-callable-description":
    "El método solicitado no está disponible a través de la API de datos.",
  "api/request/model-not-scoped": "Modelo no disponible",
  "api/request/model-not-scoped-description":
    "Este modelo no es accesible a través de la API de datos.",
  "api/request/payload-key-not-allowed": "Clave de contenido no permitida",
  "api/request/payload-key-not-allowed-description":
    "Una clave del contenido no puede nombrar una ruta dentro de un valor. Envía cada atributo como un valor completo.",
  "api/request/payload-not-allowed": "Contenido no permitido",
  "api/request/payload-not-allowed-description":
    "Este método no acepta contenido en la solicitud. Envía las opciones de consulta como params.",
  "api/request/program-access-denied": "Acceso al programa denegado",
  "api/request/program-access-denied-description":
    "No tienes acceso a este programa.",
  "api/request/program-context-required": "Se requiere contexto de programa",
  "api/request/program-context-required-description":
    "Esta acción requiere un contexto de programa y no fue posible resolver uno para esta solicitud.",
  "api/request/program-context-unavailable":
    "Contexto de programa no disponible",
  "api/request/program-context-unavailable-description":
    "Este dominio del portal no tiene un programa resoluble para la acción solicitada.",
  "api/request/query-attribute-not-readable": "Filtro u orden no disponible",
  "api/request/query-attribute-not-readable-description":
    "Esta solicitud filtra u ordena por información que tu rol no puede consultar. Quita ese filtro u orden e inténtalo de nuevo.",
  "api/request/query-key-not-allowed": "Consulta no permitida",
  "api/request/query-key-not-allowed-description":
    "Una o más claves de la consulta en esta solicitud no están permitidas.",
  "api/request/rate-limited": "Demasiadas solicitudes",
  "api/request/rate-limited-description":
    "Por favor espera antes de intentarlo de nuevo.",
  "api/request/reference-out-of-scope": "Registro referenciado no encontrado",
  "api/request/reference-out-of-scope-description":
    "El registro referenciado no existe, o está fuera del alcance de esta solicitud.",
  "api/request/reference-owner-model-not-allowed": "Propietario no permitido",
  "api/request/reference-owner-model-not-allowed-description":
    "El propietario de este registro no existe o no es de un tipo permitido.",
  "api/request/reference-owner-update-denied":
    "No puedes modificar al propietario de este registro",
  "api/request/reference-owner-update-denied-description":
    "Modificar este registro requiere permiso para actualizar a su propietario, y no lo tienes.",
  "api/request/stage-filter-forbidden": "Filtro de lista no permitido",
  "api/request/stage-filter-forbidden-description":
    "Tu rol no puede usar este filtro de lista.",
  "api/request/stage-filter-unavailable": "Filtro de lista aún no disponible",
  "api/request/stage-filter-unavailable-description":
    "Este filtro de lista aún no está disponible.",
  "api/request/stage-filter-unknown": "Filtro de lista no declarado",
  "api/request/stage-filter-unknown-description":
    "Ninguna etapa declara un filtro de lista con esa clave.",
  "api/request/stage-filter-value-invalid":
    "Valor de filtro de lista no válido",
  "api/request/stage-filter-value-invalid-description":
    "El valor no es uno de los que declara el filtro.",
  "api/request/stage-filters-invalid": "Filtros de lista no válidos",
  "api/request/stage-filters-invalid-description":
    "Los filtros de lista de esta solicitud no tienen un formato válido.",
  "api/request/write-params-not-allowed": "Opciones de consulta no permitidas",
  "api/request/write-params-not-allowed-description":
    "Este método escribe datos y no acepta opciones de consulta de lectura como include, attributes, order o limit.",
  "api/services/CognitoUserService/email-is-required":
    "Es necesario el correo electrónico",
  "api/services/CognitoUserService/email-is-required-description":
    "Es necesario proporcionar un correo electrónico válido para continuar con la generación del usuario.",
  "api/services/CognitoUserService/user-creation-failed":
    "Error al crear el usuario",
  "api/services/CognitoUserService/user-creation-failed-description":
    "Error al crear el usuario",
  "api/services/notification-template-missing":
    "No se encontró la plantilla de notificación.",
  "api/services/notification-template-missing-description":
    "La clave de la plantilla de notificación solicitada no tiene traducción.",
  "api/services/notification-unavailable":
    "Las notificaciones no están disponibles; intenta más tarde.",
  "api/services/notification-unavailable-description":
    "No hay un remitente configurado para las notificaciones transaccionales.",
  "api/utils/SubjectMatterEngine/leaf-line-of-business-not-found":
    "Ramo no encontrado",
  "api/utils/SubjectMatterEngine/leaf-line-of-business-not-found-description":
    "El ramo hoja referenciado no existe.",
  "api/utils/generate-model-id-error": "Error al generar el Id del modelo",
  "catalogue-record-types/car": "Auto",
  "catalogue-record-types/motorcycle": "Motocicleta",
  "catalogue-record-types/pickup": "Pickup",
  "catalogue-sources/gnp-mx": "GNP",
  "catalogue-sources/qualitas-mx": "Quálitas",
  "cdn/invalid-expiry": "Vigencia de enlace inválida.",
  "common/cancel": "Cancelar",
  "common/delete": "Eliminar",
  "forms/assignExternalCatalogueCode/title": "Asignar código de catálogo",
  "forms/config/day": "Días",
  "forms/config/expiration-editable": "Vencimiento editable",
  "forms/config/inception-offset-days":
    "Desfase predeterminado de inicio (días)",
  "forms/config/inherit": "Heredar",
  "forms/config/max-term-amount": "Plazo máximo",
  "forms/config/min-term-amount": "Plazo mínimo",
  "forms/config/month": "Meses",
  "forms/config/retroactive-allowed": "Permitir inicio retroactivo",
  "forms/config/term-amount": "Plazo",
  "forms/config/term-mode": "Tipo de vigencia",
  "forms/config/term-mode-bounded": "Acotada",
  "forms/config/term-mode-fixed": "Fija",
  "forms/config/term-mode-free": "Libre",
  "forms/config/term-unit": "Unidad",
  "forms/config/year": "Años",
  "forms/configParticipationLinesOfBusiness/title": "Líneas de negocio",
  "forms/createParticipation/alias": "Alias",
  "forms/createParticipation/commercial-name": "Nombre comercial",
  "forms/createParticipation/country": "País",
  "forms/createParticipation/existing-organization": "Organización existente",
  "forms/createParticipation/identity-mode": "Identidad",
  "forms/createParticipation/incorporation-date": "Fecha de constitución",
  "forms/createParticipation/legal-name": "Razón social",
  "forms/createParticipation/lookup-outcome": "Resultado de la búsqueda",
  "forms/createParticipation/lookup-token": "Token de búsqueda",
  "forms/createParticipation/mode-existing":
    "Seleccionar una organización existente",
  "forms/createParticipation/mode-lookup": "Tengo el identificador oficial",
  "forms/createParticipation/mode-new": "Crear sin identificador",
  "forms/createParticipation/parents": "Padres",
  "forms/createParticipation/participation-level": "Nivel de participación",
  "forms/createParticipation/tax-id": "Identificador fiscal",
  "forms/createParticipation/validation/required": "Este campo es requerido",
  "forms/createProposal/agency": "Agencia",
  "forms/createProposal/currency": "Moneda",
  "forms/createProposal/empty/no-common-currency":
    "No hay una moneda común para esta agencia y cedente.",
  "forms/createProposal/empty/no-eligible-agency":
    "No tienes agencias disponibles para crear propuestas en este programa.",
  "forms/createProposal/empty/no-eligible-cedent":
    "No hay cedentes disponibles. Regístralos desde Cedentes.",
  "forms/createProposal/empty/no-eligible-line-of-business":
    "Este cedente no tiene ramos elegibles en este programa.",
  "forms/createProposal/empty/not-authorized":
    "No tienes autorización para crear propuestas en este programa.",
  "forms/createProposal/empty/term-rule-missing":
    "El ramo no tiene reglas de vigencia configuradas. Contacta al administrador de la plataforma.",
  "forms/createProposal/expiration-date": "Fecha de Vencimiento",
  "forms/createProposal/in-force-date": "Fecha de Inicio",
  "forms/createProposal/line-of-business": "Ramo",
  "forms/createProposal/policy-holder": "Asegurado",
  "forms/createProposal/policy-type": "Tipo de Póliza",
  "forms/createProposal/policy-type-new": "Nueva",
  "forms/createProposal/policy-type-renewal": "Renovación",
  "forms/createProposal/previous-policy": "Póliza Anterior",
  "forms/createProposal/requester": "Solicitante",
  "forms/createProposal/title": "Nueva propuesta",
  "forms/createProposal/validation/invalid-date": "Debe ser una fecha válida",
  "forms/createProposal/validation/required": "Este campo es requerido",
  "forms/editExternalCatalogue/title": "Editar catálogo externo",
  "forms/editExternalCatalogueCode/title": "Editar código",
  "forms/editLineOfBusinessCurrency/title": "Moneda permitida",
  "forms/editLineOfBusinessTermRule/title": "Regla de vigencia",
  "forms/editParticipationLineOfBusiness/title":
    "Línea de negocio de la agencia",
  "forms/editProgramCedentLineOfBusiness/title": "Línea de negocio del cedente",
  "forms/registration/group-general-label": "Datos generales",
  "forms/registration/group-identity-hint":
    "12 caracteres para persona moral. Se valida el formato y el dígito verificador; no se consulta el SAT.",
  "forms/registration/group-identity-label": "Identidad",
  "forms/registration/identifier": "Identificador oficial",
  "forms/registration/identifier-optional-hint": "Opcional · sin validación",
  "forms/registration/identifier-required": "Captura el identificador",
  "forms/registration/lookup-required":
    "Espera a que termine la búsqueda del identificador",
  "forms/registration/reused-existing-record":
    "Ya existía un registro con ese identificador; se reutilizó.",
  "forms/registration/subtitle":
    "Se busca primero por RFC; si ya existe, se reutiliza.",
  "forms/registration/subtitle-direct":
    "Registra la aseguradora con su razón social. Si capturas un identificador fiscal que ya existe, se reutiliza ese registro.",
  "forms/registration/title-cedent": "Registrar cedente",
  "forms/registration/title-insurer": "Registrar aseguradora",
  "forms/registration/unavailable":
    "El registro no está disponible en este momento. Contacta a tu administrador.",
  "forms/reparentParticipation/participation-id": "Participación",
  "hello-world": "Hola Mundo",
  "hyperseguros-web/about/acerca-de-nosotros/meta-description":
    "Diseño, colocación y operación en partes iguales, con autorización CNSF y tecnología propia. Quiénes somos y cómo trabajamos con agentes y empresas.",
  "hyperseguros-web/about/acerca-de-nosotros/meta-title":
    "Hyper - Acerca de nosotros, agencia wholesale de seguros",
  "hyperseguros-web/about/ahora-somos-hyper/heading-emphasis": "Hyper",
  "hyperseguros-web/about/ahora-somos-hyper/heading-muted": "Ahora somos",
  "hyperseguros-web/about/ahora-somos-hyper/meta-description":
    "HyperSeguros ahora es Hyper: mismo equipo y misma misión, hoy en wholesale de seguros y fianzas, tecnología propia y servicios como agregadores.",
  "hyperseguros-web/about/ahora-somos-hyper/meta-title":
    "Hyper - Nuevo nombre, misma misión",
  "hyperseguros-web/about/ahora-somos-hyper/pill": "Ahora somos Hyper",
  "hyperseguros-web/about/ahora-somos-hyper/tagline":
    "Quitamos «Seguros» del nombre, no del trabajo. Mismo equipo, misma misión… menos letras.",
  "hyperseguros-web/about/ahora-somos-hyper/video-captions": "Subtítulos",
  "hyperseguros-web/about/ahora-somos-hyper/video-close": "Cerrar video",
  "hyperseguros-web/about/ahora-somos-hyper/video-cta": "Ver el video",
  "hyperseguros-web/about/ahora-somos-hyper/video-exit-fullscreen":
    "Salir de pantalla completa",
  "hyperseguros-web/about/ahora-somos-hyper/video-fullscreen":
    "Pantalla completa",
  "hyperseguros-web/about/ahora-somos-hyper/video-mute": "Silenciar",
  "hyperseguros-web/about/ahora-somos-hyper/video-pause": "Pausar video",
  "hyperseguros-web/about/ahora-somos-hyper/video-play": "Reproducir video",
  "hyperseguros-web/about/ahora-somos-hyper/video-seek": "Posición del video",
  "hyperseguros-web/about/ahora-somos-hyper/video-unmute": "Activar sonido",
  "hyperseguros-web/about/ahora-somos-hyper/video-volume": "Volumen",
  "hyperseguros-web/about/heading-emphasis": "Y con la velocidad de nunca",
  "hyperseguros-web/about/heading-muted":
    "Administramos riesgo con el rigor de siempre.",
  "hyperseguros-web/about/pill": "Acerca de Hyper",
  "hyperseguros-web/about/tagline":
    "Diseñamos, colocamos y operamos el negocio de agentes y productores. Tú te quedas con la relación; nosotros con el papeleo.",
  "hyperseguros-web/about/wholesale-agentes-y-productores/meta-description":
    "Coloca cualquier ramo sin montar la operación: respaldo técnico en la venta, acceso al mercado correcto y toda la administración de la póliza.",
  "hyperseguros-web/about/wholesale-agentes-y-productores/meta-title":
    "Hyper - Wholesale para agentes y productores",
  "hyperseguros-web/about/wholesale-seguros/meta-description":
    "El mayorista que está entre el agente y la aseguradora: qué hace, en qué se distingue de un promotor y por qué la cartera sigue siendo del agente.",
  "hyperseguros-web/about/wholesale-seguros/meta-title":
    "Hyper - ¿Qué es un wholesale de seguros?",
  "hyperseguros-web/agents/heading-emphasis": "Di que sí",
  "hyperseguros-web/agents/heading-muted":
    "Tu cliente te pidió un seguro de aviación.",
  "hyperseguros-web/agents/tagline":
    "Un agente que opera sus propias pólizas es un agente que no está vendiendo. Lo decimos con cariño y con un equipo de operación.",
  "hyperseguros-web/common/rail/next": "Siguiente",
  "hyperseguros-web/common/rail/previous": "Anterior",
  "hyperseguros-web/footer/legal/copyright":
    "© {{year}} Hyper. Todos los derechos reservados.",
  "hyperseguros-web/footer/links/folleto-intermediacion":
    "Folleto Informativo de Intermediación",
  "hyperseguros-web/footer/links/privacidad": "Aviso de Privacidad",
  "hyperseguros-web/footer/links/terminos": "Términos y Condiciones",
  "hyperseguros-web/home/actions/primary": "Trabajemos juntos",
  "hyperseguros-web/home/actions/secondary": "Ver seguros",
  "hyperseguros-web/home/figures/fianzas": "fianzas",
  "hyperseguros-web/home/figures/industrias": "industrias",
  "hyperseguros-web/home/figures/programas": "programas",
  "hyperseguros-web/home/figures/seguros": "seguros",
  "hyperseguros-web/home/heading-emphasis": "juntos",
  "hyperseguros-web/home/heading-muted": "Administramos riesgo",
  "hyperseguros-web/home/meta-description":
    "Agencia wholesale de seguros y fianzas en México. Diseñamos, colocamos y operamos la cobertura de empresas, agentes y brokers en todos los ramos.",
  "hyperseguros-web/home/meta-title":
    "Hyper - Seguros y fianzas para empresas en México",
  "hyperseguros-web/home/read-more": "Leer más",
  "hyperseguros-web/home/tagline":
    "Somos el wholesale de seguros que te ayuda a diseñar y operar programas de seguros — y el que te explica la letra pequeña sin dormirte.",
  "hyperseguros-web/hubs/fianzas/heading-emphasis": "Un solo expediente",
  "hyperseguros-web/hubs/fianzas/heading-muted": "Once fianzas.",
  "hyperseguros-web/hubs/fianzas/meta-description":
    "Once fianzas en un solo expediente: cumplimiento, anticipo, sostenimiento de oferta, vicios ocultos, fidelidad, judiciales y de crédito, en todo México.",
  "hyperseguros-web/hubs/fianzas/meta-title":
    "Hyper - Fianzas para empresas en México",
  "hyperseguros-web/hubs/fianzas/tagline":
    "Administrativas, de fidelidad, judiciales y de crédito, con la afianzadora correcta y el texto exacto que el beneficiario pide. El expediente se arma una vez; las fianzas salen en horas.",
  "hyperseguros-web/hubs/industrias/heading-emphasis":
    "Nosotros conocemos los veinticuatro",
  "hyperseguros-web/hubs/industrias/heading-muted":
    "Cada industria tiene su riesgo favorito.",
  "hyperseguros-web/hubs/industrias/meta-description":
    "Veinticuatro sectores con su propio perfil de riesgo, de agro a transporte. Coberturas y fianzas escritas para cómo opera cada industria en México.",
  "hyperseguros-web/hubs/industrias/meta-title":
    "Hyper - Seguros por industria en México",
  "hyperseguros-web/hubs/industrias/tagline":
    "Veinticuatro sectores con sus riesgos, sus contratos y su combinación de seguros y fianzas. Escrito para México, con productos con nombre propio y no con un formulario.",
  "hyperseguros-web/hubs/programas/heading-emphasis":
    "que se explican en una sola junta",
  "hyperseguros-web/hubs/programas/heading-muted":
    "Un programa es varios seguros",
  "hyperseguros-web/hubs/programas/meta-description":
    "Varios seguros que resuelven un mismo problema y se operan como uno. Programas para empresas, escuelas, bancos, cadenas y el sector público.",
  "hyperseguros-web/hubs/programas/meta-title":
    "Hyper - Programas de seguros a la medida",
  "hyperseguros-web/hubs/programas/tagline":
    "Ocho programas para el sector privado y el sector público: beneficios, escuelas, bancos, inventarios, licitaciones, vida institucional, patrimonio y catástrofe. Diseñados como uno, operados como uno.",
  "hyperseguros-web/hubs/seguros/heading-emphasis": "Cero aburrido",
  "hyperseguros-web/hubs/seguros/heading-muted": "Riesgo serio.",
  "hyperseguros-web/hubs/seguros/meta-description":
    "Ocho familias y cuarenta seguros para empresas: vida, salud, accidentes, daños, responsabilidad civil, transporte, especialidades y paramétricos.",
  "hyperseguros-web/hubs/seguros/meta-title":
    "Hyper - Seguros empresariales en México",
  "hyperseguros-web/hubs/seguros/tagline":
    "Personas, daños, responsabilidad civil, paramétricos, transportes y especialidades: cuarenta seguros diseñados, colocados y operados por el mismo equipo. Elige el tuyo o dinos cuál te falta.",
  "hyperseguros-web/industries/agro-alimentos-y-bebidas/heading-emphasis":
    "Nosotros aseguramos el trayecto",
  "hyperseguros-web/industries/agro-alimentos-y-bebidas/heading-muted":
    "Todos hablan de la granja a la mesa.",
  "hyperseguros-web/industries/agro-alimentos-y-bebidas/meta-description":
    "Del campo al anaquel, cada eslabón con su póliza: productores, plantas procesadoras, embotelladoras, distribuidores y exportadores, con daños y fianzas.",
  "hyperseguros-web/industries/agro-alimentos-y-bebidas/meta-title":
    "Hyper - Seguros para agro, alimentos y bebidas",
  "hyperseguros-web/industries/agro-alimentos-y-bebidas/name":
    "Agro, alimentos y bebidas",
  "hyperseguros-web/industries/agro-alimentos-y-bebidas/tagline":
    "Cultivos, ganado, plantas, flotas, lotes y retiros de producto, con un equipo que sabe la diferencia entre una helada y una plaga. Y entre un endoso y un retiro.",
  "hyperseguros-web/industries/arte-joyas-y-valores/heading-emphasis":
    "Lo que no tiene precio también tiene valor convenido",
  "hyperseguros-web/industries/arte-joyas-y-valores/heading-muted":
    "Museos, galerías, joyeros y bóvedas.",
  "hyperseguros-web/industries/arte-joyas-y-valores/meta-description":
    "Museos, galerías, casas de subasta, joyeros y transportadoras de valores: lo que no se repone, asegurado a valor convenido, en exhibición y en tránsito.",
  "hyperseguros-web/industries/arte-joyas-y-valores/meta-title":
    "Hyper - Seguros para arte, joyas y valores",
  "hyperseguros-web/industries/arte-joyas-y-valores/name":
    "Obras de arte, joyas y valores (specie)",
  "hyperseguros-web/industries/arte-joyas-y-valores/tagline":
    "Obras, colecciones, joyas, relojes, metales y valores, a valor convenido y clavo a clavo. Colocado con mercados de arte de Londres, con avalúos y discreción.",
  "hyperseguros-web/industries/aseguradoras-y-reaseguro/heading-emphasis":
    "Somos ese alguien",
  "hyperseguros-web/industries/aseguradoras-y-reaseguro/heading-muted":
    "Las aseguradoras también necesitan quien les traiga negocio bien armado.",
  "hyperseguros-web/industries/aseguradoras-y-reaseguro/meta-description":
    "Para aseguradoras, afianzadoras, reaseguradoras e insurtech: capacidad donde no la hay, negocio bien armado y las coberturas del propio sector.",
  "hyperseguros-web/industries/aseguradoras-y-reaseguro/meta-title":
    "Hyper - Seguros para aseguradoras y reaseguro",
  "hyperseguros-web/industries/aseguradoras-y-reaseguro/name":
    "Aseguradoras y reaseguro",
  "hyperseguros-web/industries/aseguradoras-y-reaseguro/tagline":
    "Reaseguro facultativo, programas de afinidad, suscripción delegada y negocios que llegan con expediente completo. Trabajamos para el agente; la aseguradora lo nota.",
  "hyperseguros-web/industries/automotriz/heading-emphasis":
    "La cadena que sí se asegura completa",
  "hyperseguros-web/industries/automotriz/heading-muted":
    "Armadoras, distribuidores y financieras.",
  "hyperseguros-web/industries/automotriz/meta-description":
    "Del ensamble a la entrega de llaves: armadoras, proveedores de autopartes, distribuidores, financieras, arrendadoras y flotas, con daños y transporte.",
  "hyperseguros-web/industries/automotriz/meta-title":
    "Hyper - Seguros para la industria automotriz",
  "hyperseguros-web/industries/automotriz/name": "Automotriz",
  "hyperseguros-web/industries/automotriz/tagline":
    "Flotillas, plan piso, programas de agencia, retiro de producto y responsabilidad del proveedor. Del ensamble a la entrega de llaves, sin que el seguro se quede en el lote.",
  "hyperseguros-web/industries/aviacion-y-espacio/heading-emphasis":
    "Nosotros decimos con qué mercado",
  "hyperseguros-web/industries/aviacion-y-espacio/heading-muted":
    "Un ramo donde casi nadie dice que sí.",
  "hyperseguros-web/industries/aviacion-y-espacio/meta-description":
    "De la avioneta agrícola al satélite: operadores ejecutivos, aerolíneas, aviación agrícola, aeropuertos, FBOs, talleres de mantenimiento y escuelas de vuelo.",
  "hyperseguros-web/industries/aviacion-y-espacio/meta-title":
    "Hyper - Seguros para aviación y espacio",
  "hyperseguros-web/industries/aviacion-y-espacio/name": "Aviación y espacio",
  "hyperseguros-web/industries/aviacion-y-espacio/tagline":
    "Casco, RC, guerra, hangares, aeropuertos y drones, colocados con mercados especializados y operados desde México como cualquier otra póliza.",
  "hyperseguros-web/industries/bienes-raices/heading-emphasis":
    "Es una póliza por cada uno, o una para todos",
  "hyperseguros-web/industries/bienes-raices/heading-muted":
    "Un portafolio inmobiliario no es un edificio.",
  "hyperseguros-web/industries/bienes-raices/meta-description":
    "El activo, la renta y la responsabilidad de recibir gente: propietarios, desarrolladores, fondos y fibras, administradores y parques industriales.",
  "hyperseguros-web/industries/bienes-raices/meta-title":
    "Hyper - Seguros para bienes raíces",
  "hyperseguros-web/industries/bienes-raices/name": "Bienes raíces",
  "hyperseguros-web/industries/bienes-raices/tagline":
    "Daños, pérdida de rentas, RC y la cobertura catastrófica que en México decide el valor del activo. Un programa para el portafolio, no por predio.",
  "hyperseguros-web/industries/ciencias-de-la-vida/heading-emphasis":
    "El ramo donde la letra chica también se regula",
  "hyperseguros-web/industries/ciencias-de-la-vida/heading-muted":
    "COFEPRIS, ensayos clínicos y retiros de producto.",
  "hyperseguros-web/industries/ciencias-de-la-vida/meta-description":
    "Producto, ensayo, planta y lote en un sector regulado por COFEPRIS: farmacéuticas, biotecnología, dispositivos médicos, laboratorios y distribuidores.",
  "hyperseguros-web/industries/ciencias-de-la-vida/meta-title":
    "Hyper - Seguros para ciencias de la vida y farma",
  "hyperseguros-web/industries/ciencias-de-la-vida/name":
    "Ciencias de la vida, farma y química",
  "hyperseguros-web/industries/ciencias-de-la-vida/tagline":
    "Farmacéuticas, biotecnológicas, dispositivos médicos y laboratorios, con RC de producto, ensayos clínicos, retiro, cyber y carga refrigerada. Regulado, y aun así entendible.",
  "hyperseguros-web/industries/construccion/heading-emphasis":
    "Nosotros ponemos las dos primeras",
  "hyperseguros-web/industries/construccion/heading-muted":
    "Cada obra exige fianzas, pólizas y paciencia.",
  "hyperseguros-web/industries/construccion/meta-description":
    "De la licitación a la entrega, con un solo equipo: constructoras, contratistas EPC, subcontratistas, desarrolladores y concesionarios de obra.",
  "hyperseguros-web/industries/construccion/meta-title":
    "Hyper - Seguros y fianzas para construcción",
  "hyperseguros-web/industries/construccion/name":
    "Construcción, ingeniería e infraestructura",
  "hyperseguros-web/industries/construccion/tagline":
    "Sostenimiento, cumplimiento, anticipo, vicios ocultos, Construcción Todo Riesgo, equipo y RC: todo el ciclo de una obra con un solo equipo. La junta de avance de los lunes sigue siendo tuya.",
  "hyperseguros-web/industries/deportes/heading-emphasis":
    "Aseguramos todo menos el marcador",
  "hyperseguros-web/industries/deportes/heading-muted":
    "Clubes, ligas, estadios y atletas.",
  "hyperseguros-web/industries/deportes/meta-description":
    "Deportistas, recintos, eventos y federaciones: clubes y equipos profesionales, ligas, estadios y arenas, promotores, gimnasios y academias deportivas.",
  "hyperseguros-web/industries/deportes/meta-title":
    "Hyper - Seguros para clubes y deportes",
  "hyperseguros-web/industries/deportes/name": "Deportes",
  "hyperseguros-web/industries/deportes/tagline":
    "Accidentes para deportistas, cancelación de eventos, RC de recintos y D&O de federaciones. Aceptamos disciplinas y calendarios que a otras pólizas les dan miedo.",
  "hyperseguros-web/industries/ecuestre/heading-emphasis":
    "Un ramo con más pedigrí que pólizas",
  "hyperseguros-web/industries/ecuestre/heading-muted":
    "Caballos, criaderos, hipódromos y escuelas.",
  "hyperseguros-web/industries/ecuestre/meta-description":
    "El caballo, el jinete, el establo y la pista: criaderos y haras, clubes hípicos, escuelas, hipódromos, propietarios de competencia y transportistas.",
  "hyperseguros-web/industries/ecuestre/meta-title":
    "Hyper - Seguros para la industria ecuestre",
  "hyperseguros-web/industries/ecuestre/name": "Ecuestre / equino",
  "hyperseguros-web/industries/ecuestre/tagline":
    "Mortalidad y accidentes de caballos, RC de instalaciones, accidentes de jinetes y transporte de animales. Un nicho que casi nadie suscribe y que nosotros sí colocamos.",
  "hyperseguros-web/industries/educacion/heading-emphasis":
    "Que el seguro no sea el tema de ninguna",
  "hyperseguros-web/industries/educacion/heading-muted":
    "Colegios y universidades tienen muchas juntas de consejo.",
  "hyperseguros-web/industries/educacion/meta-description":
    "Alumnos, maestros, planteles y patronatos: colegios privados, universidades, guarderías, redes educativas e instituciones públicas de educación.",
  "hyperseguros-web/industries/educacion/meta-title":
    "Hyper - Seguros para colegios y universidades",
  "hyperseguros-web/industries/educacion/name": "Educación",
  "hyperseguros-web/industries/educacion/tagline":
    "Accidentes escolares, orfandad, RC del plantel, daños al inmueble y D&O del patronato, armados como un programa escolar integral. Del recreo al consejo directivo.",
  "hyperseguros-web/industries/energia/heading-emphasis":
    "Las pólizas, en capas de reaseguro",
  "hyperseguros-web/industries/energia/heading-muted":
    "En energía los riesgos se miden en megawatts.",
  "hyperseguros-web/industries/energia/meta-description":
    "Plantas, parques, ductos y contratos: generadores renovables, petróleo, gas y petroquímica, distribución, estaciones de servicio y contratistas.",
  "hyperseguros-web/industries/energia/meta-title":
    "Hyper - Seguros para el sector energía",
  "hyperseguros-web/industries/energia/name": "Energía y recursos naturales",
  "hyperseguros-web/industries/energia/tagline":
    "Daños, ingeniería, interrupción, RC ambiental, riesgo político y SRCC, colocados con reaseguro internacional. Para plantas, parques, ductos y contratos con quien regula.",
  "hyperseguros-web/industries/hoteleria-y-turismo/heading-emphasis":
    "El programa lo sabe",
  "hyperseguros-web/industries/hoteleria-y-turismo/heading-muted":
    "La temporada alta empieza cuando termina la de huracanes.",
  "hyperseguros-web/industries/hoteleria-y-turismo/meta-description":
    "El hotel, el huésped, la actividad y la fecha: hoteles y resorts, operadoras turísticas y de aventura, parques, recintos, restaurantes y marinas.",
  "hyperseguros-web/industries/hoteleria-y-turismo/meta-title":
    "Hyper - Seguros para hotelería y turismo",
  "hyperseguros-web/industries/hoteleria-y-turismo/name":
    "Hotelería, turismo y entretenimiento",
  "hyperseguros-web/industries/hoteleria-y-turismo/tagline":
    "Daños con hidrometeorológicos, paramétrico de huracán, RC de huéspedes, cancelación de eventos y accidentes para actividades. Para hoteles, resorts, operadoras y recintos que viven del calendario.",
  "hyperseguros-web/industries/instituciones-financieras/heading-emphasis":
    "Nosotros lo armamos para que además sirva",
  "hyperseguros-web/industries/instituciones-financieras/heading-muted":
    "El regulador ya te pidió el seguro.",
  "hyperseguros-web/industries/instituciones-financieras/meta-description":
    "El dinero, los datos, el consejo y la cartera: bancos y grupos financieros, SOFOMes, SOFIPOs y cajas, fintechs, casas de bolsa y administradoras.",
  "hyperseguros-web/industries/instituciones-financieras/meta-title":
    "Hyper - Seguros para instituciones financieras",
  "hyperseguros-web/industries/instituciones-financieras/name":
    "Instituciones financieras",
  "hyperseguros-web/industries/instituciones-financieras/tagline":
    "Bankers Blanket Bond, D&O, E&O, cyber, fidelidad y protección de carteras con vida deudores. Para bancos, SOFOMes, fintechs, cajas y aseguradoras.",
  "hyperseguros-web/industries/manufactura/heading-emphasis":
    "El programa de seguros también debería",
  "hyperseguros-web/industries/manufactura/heading-muted":
    "La planta tiene un plan de mantenimiento.",
  "hyperseguros-web/industries/manufactura/meta-description":
    "La planta, la línea, el lote y el camión: maquiladoras, proveedores automotrices y aeroespaciales, alimentos, químicos, metalmecánica y plásticos.",
  "hyperseguros-web/industries/manufactura/meta-title":
    "Hyper - Seguros para manufactura y maquila",
  "hyperseguros-web/industries/manufactura/name": "Manufactura e industria",
  "hyperseguros-web/industries/manufactura/tagline":
    "Daños con rotura de maquinaria, interrupción de negocio, RC producto y retiro, ambiental, carga y flotillas. Para plantas, maquiladoras y proveedores, con ingeniería de riesgos que sí visita la planta.",
  "hyperseguros-web/industries/maritimo/heading-emphasis":
    "Nosotros las explicamos en español",
  "hyperseguros-web/industries/maritimo/heading-muted":
    "En el mar las pólizas se escriben en inglés.",
  "hyperseguros-web/industries/maritimo/meta-description":
    "El buque, el armador, el puerto y la carga: navieras y armadores, puertos y terminales, agentes navieros, flotas pesqueras, astilleros y marinas.",
  "hyperseguros-web/industries/maritimo/meta-title":
    "Hyper - Seguros para el sector marítimo",
  "hyperseguros-web/industries/maritimo/name": "Marítimo",
  "hyperseguros-web/industries/maritimo/tagline":
    "Casco y maquinaria, P&I, RC portuaria, carga y contaminación, colocados con mercados de Londres y operados desde México. Para navieras, puertos, pesqueras, astilleros y yates.",
  "hyperseguros-web/industries/mineria/heading-emphasis":
    "Cada etapa con su póliza y su fianza",
  "hyperseguros-web/industries/mineria/heading-muted":
    "Exploración, extracción, cierre.",
  "hyperseguros-web/industries/mineria/meta-description":
    "Tajo, planta, presas, equipo y concesión, de la exploración al cierre: operadoras, contratistas mineros, proveedores y plantas de beneficio.",
  "hyperseguros-web/industries/mineria/meta-title":
    "Hyper - Seguros y fianzas para minería",
  "hyperseguros-web/industries/mineria/name": "Minería",
  "hyperseguros-web/industries/mineria/tagline":
    "Daños en tajo y planta, equipo pesado, RC ambiental, interrupción, riesgo político y las garantías que la concesión exige. Para minas, contratistas y proveedores en zonas donde el ajustador tarda en llegar.",
  "hyperseguros-web/industries/private-equity/heading-emphasis":
    "Nosotros aseguramos la compra, las empresas y al consejo",
  "hyperseguros-web/industries/private-equity/heading-muted":
    "Un fondo compra empresas.",
  "hyperseguros-web/industries/private-equity/meta-description":
    "La compra, las empresas del portafolio y el consejo: fondos de capital privado, venture capital, family offices, fondos de deuda y asesores de M&A.",
  "hyperseguros-web/industries/private-equity/meta-title":
    "Hyper - Seguros para private equity y fondos",
  "hyperseguros-web/industries/private-equity/name":
    "Private equity / patrocinadores financieros",
  "hyperseguros-web/industries/private-equity/tagline":
    "D&O, garantías y declaraciones (W&I), cyber y programas para el portafolio completo, con la debida diligencia de seguros antes de cerrar. Para fondos, family offices y patrocinadores.",
  "hyperseguros-web/industries/retail-y-consumo/heading-emphasis":
    "El programa lo sigue",
  "hyperseguros-web/industries/retail-y-consumo/heading-muted":
    "El inventario se mueve todo el día.",
  "hyperseguros-web/industries/retail-y-consumo/meta-description":
    "La tienda, el anaquel, el camión y la caja: cadenas y departamentales, supermercados, franquicias, e-commerce, última milla y marcas de consumo.",
  "hyperseguros-web/industries/retail-y-consumo/meta-title":
    "Hyper - Seguros para retail y consumo",
  "hyperseguros-web/industries/retail-y-consumo/name": "Retail y consumo",
  "hyperseguros-web/industries/retail-y-consumo/tagline":
    "Daños multi-sucursal, stock throughput, RC producto y retiro, SRCC, crimen y flotillas de reparto. Para cadenas, franquicias, e-commerce y distribuidores con muchos puntos de venta.",
  "hyperseguros-web/industries/salud/heading-emphasis": "Este es el de seguros",
  "hyperseguros-web/industries/salud/heading-muted":
    "Un hospital tiene protocolos para todo.",
  "hyperseguros-web/industries/salud/meta-description":
    "El acto médico, el hospital, el expediente y el personal: hospitales privados, clínicas, grupos médicos, laboratorios, imagen y ambulancias.",
  "hyperseguros-web/industries/salud/meta-title":
    "Hyper - Seguros para hospitales y sector salud",
  "hyperseguros-web/industries/salud/name": "Salud",
  "hyperseguros-web/industries/salud/tagline":
    "RC médica, RC del hospital, cyber para expedientes clínicos, daños y equipo médico, D&O y beneficios para el personal. Para hospitales, clínicas, laboratorios y grupos médicos.",
  "hyperseguros-web/industries/sector-publico/heading-emphasis":
    "La ley pide que alguien los entienda",
  "hyperseguros-web/industries/sector-publico/heading-muted":
    "La licitación pide seguros.",
  "hyperseguros-web/industries/sector-publico/meta-description":
    "Bienes, personas y servidores públicos, por licitación: dependencias federales, gobiernos estatales, municipios y organismos descentralizados.",
  "hyperseguros-web/industries/sector-publico/meta-title":
    "Hyper - Seguros para el sector público",
  "hyperseguros-web/industries/sector-publico/name":
    "Sector Público (Gobierno)",
  "hyperseguros-web/industries/sector-publico/tagline":
    "Pólizas patrimoniales, vida institucional, RC de servidores públicos, paramétricos y asesoría externa en materia de seguros. Para dependencias, estados, municipios y organismos que compran por licitación.",
  "hyperseguros-web/industries/servicios-profesionales/heading-emphasis":
    "Y de una póliza que casi nunca mencionan",
  "hyperseguros-web/industries/servicios-profesionales/heading-muted":
    "Despachos, consultoras y firmas viven de su reputación.",
  "hyperseguros-web/industries/servicios-profesionales/meta-description":
    "El criterio, el equipo y la firma: despachos de abogados y notarías, contadores y auditores, arquitectos e ingenieros, consultoras y valuadores.",
  "hyperseguros-web/industries/servicios-profesionales/meta-title":
    "Hyper - Seguros para servicios profesionales",
  "hyperseguros-web/industries/servicios-profesionales/name":
    "Servicios profesionales",
  "hyperseguros-web/industries/servicios-profesionales/tagline":
    "RC profesional, E&O, cyber, D&O y beneficios para el equipo. Para abogados, contadores, arquitectos, ingenieros, consultores y agentes que firman lo que dicen.",
  "hyperseguros-web/industries/tecnologia-medios-y-telecomunicaciones/heading-emphasis":
    "Tienen contratos, datos y un consejo",
  "hyperseguros-web/industries/tecnologia-medios-y-telecomunicaciones/heading-muted":
    "Las empresas de tecnología no tienen fábrica.",
  "hyperseguros-web/industries/tecnologia-medios-y-telecomunicaciones/meta-description":
    "Contratos, datos, contenido y consejo: software y SaaS, fintech y plataformas, agencias y productoras, medios, telecomunicaciones y centros de datos.",
  "hyperseguros-web/industries/tecnologia-medios-y-telecomunicaciones/meta-title":
    "Hyper - Seguros para tecnología, medios y telecom",
  "hyperseguros-web/industries/tecnologia-medios-y-telecomunicaciones/name":
    "Tecnología, medios y telecomunicaciones",
  "hyperseguros-web/industries/tecnologia-medios-y-telecomunicaciones/tagline":
    "E&O, cyber, D&O, propiedad intelectual y medios, con wordings internacionales para clientes que exigen coberturas con nombre. Para software, fintech, medios, agencias y telecom.",
  "hyperseguros-web/industries/transporte-y-logistica/heading-emphasis":
    "Y respondes por ella hasta que alguien firma de recibido",
  "hyperseguros-web/industries/transporte-y-logistica/heading-muted":
    "Mueves mercancía de otros.",
  "hyperseguros-web/industries/transporte-y-logistica/meta-description":
    "La unidad, la carga, el conductor y el cliente que reclama: autotransporte, operadores logísticos y 3PL, freight forwarders, almacenes y última milla.",
  "hyperseguros-web/industries/transporte-y-logistica/meta-title":
    "Hyper - Seguros para transporte y logística",
  "hyperseguros-web/industries/transporte-y-logistica/name":
    "Transporte y logística",
  "hyperseguros-web/industries/transporte-y-logistica/tagline":
    "Flotillas, carga, RC del transportista, equipo, fianzas viales y stock throughput. Para transportistas, operadores logísticos, freight forwarders y almacenes, con altas y bajas que salen el mismo día.",
  "hyperseguros-web/legal/folleto-informativo-intermediacion/meta-description":
    "El folleto que la CNSF exige a todo intermediario: cómo está autorizado Hyper, cómo se le remunera y con qué aseguradoras y afianzadoras intermedia.",
  "hyperseguros-web/legal/folleto-informativo-intermediacion/meta-title":
    "Hyper - Folleto Informativo de Intermediación",
  "hyperseguros-web/legal/folleto-intermediacion/asesoria":
    "Hyper tiene la obligación de brindar a sus clientes una adecuada asesoría para celebrar, conservar o modificar los contratos de seguro, según la mejor conveniencia de los contratantes. Para tal efecto le proporcionará información precisa con relación a los productos, así como respecto a las coberturas, primas, condiciones, exclusiones, riesgos, beneficios, obligaciones y derechos, con el fin de que cuente con los elementos necesarios para evaluar adecuadamente los diferentes productos que se le ofrecen, respetando en todo momento su libertad de elección.",
  "hyperseguros-web/legal/folleto-intermediacion/companias-heading":
    "Compañías de Seguros y/o Fianzas con las que intermediamos:",
  "hyperseguros-web/legal/folleto-intermediacion/entrega-intro":
    "Una vez aceptada la solicitud de cobertura (o si ya lo hubiere hecho), le haremos entrega digital de la siguiente documentación:",
  "hyperseguros-web/legal/folleto-intermediacion/entrega-items":
    "La carátula de la póliza adquirida correspondiente.\nLas condiciones generales y la demás documentación relacionada con el seguro o la fianza contratada.\nEl/los recibo(s) expedido por la Institución de Seguros o de Fianzas correspondiente para efectuar el pago de las primas, explicando claramente los elementos que debe contener para su plena validez.",
  "hyperseguros-web/legal/folleto-intermediacion/exhorto-intro":
    "Por último, le exhortamos que usted como contratante:",
  "hyperseguros-web/legal/folleto-intermediacion/exhorto-items":
    "Verifique que la documentación concuerde con su solicitud y que dicha documentación contenga en su caso, el registro del producto ante la CNSF.\nVerifique en la Página Web de la CNSF los datos de la cédula y autorización, así como las sanciones que, en su caso, la CNSF nos llegue a imponer.",
  "hyperseguros-web/legal/folleto-intermediacion/informacion-adicional-intro":
    "Adicionalmente, Hyper le da a conocer la siguiente información referente a nuestra actividad:",
  "hyperseguros-web/legal/folleto-intermediacion/informacion-adicional-items":
    "Por ningún motivo ofrezca o acceda a entregar a Hyper, sus ejecutivos y/o empleados dinero o contraprestación alguna (sin perjuicio de la comisión que éste reciba de las Instituciones por los servicios que preste o por servicios distintos a la intermediación).\nPor ningún motivo acepte recibos provisionales, informales o personales de Hyper, sus ejecutivos y/o empleados.\nPor ningún motivo entregue anticipos por concepto de la contratación del seguro o de una cobertura adicional.\nVerifique al momento de la contratación que la documentación concuerda con su solicitud y que dicha documentación contenga, en su caso, el registro del producto ante la CNSF.\nHyper, sus ejecutivos y/o empleados, carecen de facultades para aceptar riesgos y suscribir o modificar pólizas, ya que no son Aseguradora, Afianzadora ni Agentes Mandatarios.",
  "hyperseguros-web/legal/folleto-intermediacion/intro":
    "En cumplimiento a lo establecido en el apartado 32.12.5 de la Circular Única de Seguros y de Fianzas (CUSF) emitida por la Comisión Nacional de Seguros y Fianzas (CNSF), Hyper Seguros México Agente de Seguros y de Fianzas S.A. de C.V. (Hyper) le da a conocer la siguiente información referente a nuestra actividad como Agente de Seguros y de Fianzas.",
  "hyperseguros-web/legal/folleto-intermediacion/posventa-intro":
    "En el proceso posterior a la venta de los productos de seguros y/o de fianzas, en Hyper:",
  "hyperseguros-web/legal/folleto-intermediacion/posventa-items":
    "Estaremos atentos a los cambios en su perfil de riesgo, con el propósito de brindarle, en su caso, la asesoría o recomendaciones para adecuar sus coberturas a dichos cambios.\nLe proporcionaremos cualquier información relevante respecto a la evolución de la póliza que haya adquirido.\nLo apoyaremos en el proceso de reclamación o de posibles quejas ante las Aseguradoras y/o Afianzadoras.",
  "hyperseguros-web/legal/folleto-intermediacion/quienes-somos":
    "Hyper es un Agente de Seguros Persona Física legalmente autorizado por la Comisión Nacional de Seguros y Fianzas (CNSF) para desarrollar la intermediación de seguros, actividad que realiza bajo el marco legal, con compromiso y sentido de responsabilidad; guardando en todo momento la confidencialidad de la información de nuestros clientes, contando con un seguro de Responsabilidad Civil por errores u omisiones para el desarrollo de sus actividades, que permite garantizar el debido cumplimiento de sus servicios como agente de seguros y de fianzas persona moral.",
  "hyperseguros-web/legal/folleto-intermediacion/transparencia-intro":
    "En virtud de que una de nuestras responsabilidades consiste en el asesoramiento para celebrar, conservar o modificar los contratos de seguros o de fianzas según la mejor conveniencia de los contratantes, y con el propósito de fortalecer la transparencia en el ejercicio de nuestras actividades de intermediación proveyendo de información para prevenir posibles conflictos de intereses, Hyper le informa lo siguiente:",
  "hyperseguros-web/legal/folleto-intermediacion/transparencia-items":
    "Contamos con las debidas autorizaciones emitidas por la Comisión Nacional de Seguros y de Fianzas (CNSF), para intermediar seguros y/o fianzas a través de sus Apoderados, mismos que se identificarán ante usted con su nombre completo, tipo de autorización, número y vigencia de su cédula.\nQue en las propuestas que le entreguemos le daremos a conocer los datos de las Aseguradoras y Afianzadoras que estemos considerando para dicha cotización.\nQue en la propuesta que le presentemos se incluirá una evaluación de sus necesidades de aseguramiento y/o afianzamiento, basadas en un análisis de su perfil y aversión al riesgo, incluyendo las características de los productos que le estemos ofreciendo para que cuenten con elementos necesarios de evaluación de las diferentes opiniones de aseguramiento y/o afianzamiento, incluyendo la liga de las diferentes compañías consideradas en la propuesta que puedan verificar las Condiciones Generales aplicables en las que podrán verificar términos, exclusiones, así como el alcance real de las coberturas requeridas. En la propuesta que le sea entregada, se le darán a conocer los datos de aquellas Aseguradoras y/o Afianzadoras que hayamos tomado en consideración para emitir dicha cotización. Así como, las condiciones, exclusiones, riesgos, beneficios, obligaciones y derechos más relevantes, con el fin de que cuente con los elementos necesarios para evaluar adecuadamente los diferentes productos ofrecidos.\nContamos con un Seguro de Responsabilidad Civil por errores y omisiones, para garantizar el cumplimiento de las responsabilidades en las que pudiésemos incurrir en razón de nuestras actividades como Agente.",
  "hyperseguros-web/legal/nav/title": "Legal",
  "hyperseguros-web/legal/privacidad/arco-body":
    "Usted tiene derecho a conocer los datos personales que tenemos, para qué los utilizamos y las condiciones del uso que les damos (Acceso). Asimismo, es su derecho solicitar la corrección de su información personal en caso de que esté desactualizada, sea inexacta o incompleta (Rectificación); que la eliminemos de nuestros registros o bases de datos cuando considere que la misma no está siendo utilizada adecuadamente (Cancelación); así como oponerse al uso de sus datos personales para fines específicos (Oposición). Estos derechos se conocen como derechos ARCO.\n\nPara ejercer sus derechos ARCO envíe su solicitud al Departamento de Protección de Datos Personales de Hyper, en privacidad@hyper.mx. La solicitud debe incluir: (i) su nombre y un domicilio o correo electrónico para recibir la respuesta; (ii) copia de su identificación oficial o, si actúa por medio de representante, la de este y el documento que acredite la representación; (iii) la descripción clara de los datos sobre los que desea ejercer el derecho, salvo que se trate de acceso; (iv) el derecho que desea ejercer o lo que solicita, y (v) cualquier documento que facilite localizar sus datos. Si solicita una rectificación, indique la corrección y acompañe la documentación que la sustente.\n\nLe comunicaremos nuestra respuesta en un máximo de 20 días hábiles contados desde que recibamos su solicitud y, si resulta procedente, la haremos efectiva dentro de los 15 días hábiles siguientes. Estos plazos pueden ampliarse una sola vez por un periodo igual cuando las circunstancias lo justifiquen. Le entregaremos la información por correo electrónico en formato digital, incluidas copias de las grabaciones y conversaciones que le correspondan. El ejercicio de estos derechos es gratuito; solo podrán cobrarse los costos de reproducción o envío.",
  "hyperseguros-web/legal/privacidad/arco-heading":
    "Acceso, Rectificación, Cancelación u Oposición al Tratamiento de sus Datos Personales (Derechos ARCO)",
  "hyperseguros-web/legal/privacidad/cambios-body":
    "El presente Aviso de Privacidad puede sufrir modificaciones, cambios o actualizaciones derivadas de nuevos requerimientos legales; de nuestras propias necesidades por los productos o servicios que ofrecemos; de nuestras prácticas de privacidad; de cambios en nuestro modelo de negocio, o por otras causas.\n\nHyper le informará sobre cualquier cambio a este aviso a través de www.hyper.mx/legal/privacidad y por correo electrónico a sus clientes.",
  "hyperseguros-web/legal/privacidad/cambios-heading":
    "Cambios en este Aviso de Privacidad",
  "hyperseguros-web/legal/privacidad/companias-heading":
    "Las compañías de seguros y/o fianzas con las que, de forma enunciativa más no limitativa, sus datos pueden ser compartidos son:",
  "hyperseguros-web/legal/privacidad/conservacion-col-informacion":
    "Información",
  "hyperseguros-web/legal/privacidad/conservacion-col-plazo": "Plazo",
  "hyperseguros-web/legal/privacidad/conservacion-heading":
    "Plazos de conservación",
  "hyperseguros-web/legal/privacidad/conservacion-intro":
    "Hyper conserva sus datos durante el tiempo necesario para las finalidades de este aviso y para cumplir sus obligaciones legales. Concluido ese plazo, los datos se bloquean y después se suprimen de forma segura.",
  "hyperseguros-web/legal/privacidad/conservacion-row-1-informacion":
    "Grabaciones de llamadas y conversaciones de WhatsApp",
  "hyperseguros-web/legal/privacidad/conservacion-row-1-plazo":
    "10 años desde la fecha de la comunicación",
  "hyperseguros-web/legal/privacidad/conservacion-row-2-informacion":
    "Archivos que Usted nos envíe",
  "hyperseguros-web/legal/privacidad/conservacion-row-2-plazo":
    "Se integran a su expediente y se conservan 10 años después de terminada su relación con Hyper",
  "hyperseguros-web/legal/privacidad/conservacion-row-3-informacion":
    "Registro de las comunicaciones",
  "hyperseguros-web/legal/privacidad/conservacion-row-3-plazo":
    "El mismo plazo que la grabación o conversación a la que corresponde",
  "hyperseguros-web/legal/privacidad/conservacion-suspension":
    "Estos plazos se suspenden mientras exista un procedimiento, reclamación o requerimiento de autoridad relacionado con la información.",
  "hyperseguros-web/legal/privacidad/cookies-body":
    "Le informamos que en nuestra página de internet utilizamos cookies, web beacons u otras tecnologías, a través de las cuales es posible monitorear su comportamiento como usuario de internet, así como brindarle un mejor servicio y experiencia al navegar en nuestra página, así como para ofrecerle nuevos productos y servicios basados en sus preferencias.\n\nLos datos personales que recabamos a través de estas tecnologías de rastreo son los siguientes: horario de navegación, tiempo de navegación en nuestra página de internet, secciones consultadas, y páginas de Internet accedidas previo a la nuestra.",
  "hyperseguros-web/legal/privacidad/cookies-heading":
    "Tecnologías de rastreo en nuestro portal de internet",
  "hyperseguros-web/legal/privacidad/datos-financieros":
    "**Datos financieros y patrimoniales.** Hyper trata datos como la cuenta CLABE para el pago de indemnizaciones o reembolsos, estados de cuenta y comprobantes de pago únicamente para las finalidades primarias de este aviso. Su tratamiento no requiere consentimiento adicional, por ser necesario para cumplir el contrato de seguro y su relación con Hyper (artículo 9, fracción IV de la LFPDPPP).",
  "hyperseguros-web/legal/privacidad/datos-recabados-heading":
    "Datos Personales que Recabamos",
  "hyperseguros-web/legal/privacidad/datos-recabados-intro":
    "Para llevar a cabo las finalidades descritas en el presente Aviso de Privacidad, utilizaremos los datos personales siguientes:",
  "hyperseguros-web/legal/privacidad/datos-recabados-items":
    "Datos de identificación.\nDatos de contacto.\nDatos laborales.\nDatos patrimoniales y/o financieros.\nNúmero telefónico desde el que nos llama o escribe y, en su caso, su nombre de perfil de WhatsApp.\nVoz, contenida en la grabación de las llamadas y en las notas de voz que nos envíe. Hyper no utiliza su voz para identificarle mediante reconocimiento biométrico.\nContenido de las comunicaciones: lo que Usted nos diga en las llamadas y nos escriba por WhatsApp.\nArchivos que nos envíe o que le enviemos por WhatsApp, como fotografías, documentos PDF, identificaciones, comprobantes y notas de voz.\nRegistro de las comunicaciones: número telefónico, fecha y hora, duración, canal, área u opción del menú elegida y ejecutivo que le atendió.",
  "hyperseguros-web/legal/privacidad/datos-sensibles-1":
    "**Datos personales sensibles.** Para algunas finalidades primarias, en particular la contratación de seguros de personas (vida, gastos médicos y accidentes) y la atención de siniestros, Hyper trata datos personales sensibles, como información sobre su estado de salud presente o pasado, diagnósticos, tratamientos, informes médicos, facturas de servicios médicos y certificados de defunción. Estos datos pueden estar contenidos en lo que Usted nos diga en una llamada grabada, en los mensajes que nos escriba por WhatsApp o en los archivos que nos envíe por ese medio.",
  "hyperseguros-web/legal/privacidad/datos-sensibles-2":
    "Hyper tratará estos datos únicamente para las finalidades primarias de este aviso. Su tratamiento no requiere consentimiento, por ser necesario para ejercer los derechos y cumplir las obligaciones derivadas del contrato de seguro y de su relación de intermediación con Hyper (artículo 9, fracción IV de la LFPDPPP). Tratándose de personas que no tienen una relación directa con Hyper, como asegurados de pólizas colectivas o beneficiarios, el tratamiento se apoya en el consentimiento que otorgan por escrito en la solicitud de seguro o en el formato de reclamación de la aseguradora. Los integrará a su expediente con medidas de seguridad reforzadas y los conservará en un único repositorio durante el plazo indicado en la sección de conservación. Le pedimos no enviar por WhatsApp información de salud distinta de la que el ejecutivo le solicite para su trámite.",
  "hyperseguros-web/legal/privacidad/datos-terceros":
    "**Datos de terceros.** Si Usted nos proporciona datos de otras personas (asegurados, beneficiarios, dependientes o personas fallecidas), declara contar con la facultad o autorización para hacerlo y se obliga a darles a conocer este aviso.",
  "hyperseguros-web/legal/privacidad/finalidades-primarias-heading":
    "Finalidades primarias",
  "hyperseguros-web/legal/privacidad/finalidades-primarias-intro":
    "Son necesarias para la relación jurídica entre Usted y Hyper:",
  "hyperseguros-web/legal/privacidad/finalidades-primarias-items":
    "Proveer los servicios y/o productos que Hyper ofrece, así como realizar evaluaciones periódicas de los mismos, a efecto de mejorar su calidad.\nDar cumplimiento a las obligaciones contraídas con los clientes.\nElaborar y realizar la cobranza de la(s) póliza(s) de seguro y/o fianzas.\nElaborar y entregar el/los recibo(s) fiscal(es) correspondiente(s).\nRealizar la renovación de las pólizas respectivas.\nApoyar y dar seguimiento en caso de siniestro.\nInformar sobre cualquier cambio respecto de la póliza.\nAtender las llamadas telefónicas y conversaciones por WhatsApp que Usted inicie o que Hyper inicie con Usted, canalizarlas al área que corresponda y darles seguimiento, y enviarle por correo electrónico, llamada telefónica o WhatsApp avisos administrativos sobre sus pólizas, fianzas y trámites, como renovaciones, cobranza, siniestros y cambios.\nIdentificarle y verificar su identidad antes de proporcionarle información sobre pólizas, fianzas, siniestros o trámites.\nRecibir, revisar e integrar a su expediente los documentos, fotografías, notas de voz y demás archivos que Usted nos envíe, y enviarle los documentos relacionados con sus pólizas, fianzas y trámites.\nGrabar las llamadas y conservar las conversaciones de WhatsApp para dejar constancia de sus solicitudes, instrucciones, aceptaciones y acuerdos, y utilizarlas como evidencia ante la aseguradora o afianzadora, la CONDUSEF, la CNSF u otra autoridad, o para la defensa de sus derechos o de los de Hyper.\nSupervisar y evaluar la calidad de la atención que recibe de nuestros ejecutivos.\nCumplir las obligaciones legales y regulatorias de Hyper como agente de seguros y de fianzas, incluidas las de identificación de clientes y prevención de operaciones con recursos de procedencia ilícita.\nPrevenir fraudes y suplantaciones de identidad y proteger la seguridad de nuestros canales de comunicación.\nAtender y solucionar sus aclaraciones y quejas.\nIdentificar a las personas que ingresan a las instalaciones de Hyper, por razones de seguridad y vigilancia.",
  "hyperseguros-web/legal/privacidad/finalidades-secundarias-aceptacion":
    "Al solicitar o contratar un producto o servicio con Hyper, se entiende que Usted acepta estas finalidades si no manifiesta su negativa. Para fines comerciales Hyper solo utiliza sus datos de contacto, nunca datos de salud ni financieros.",
  "hyperseguros-web/legal/privacidad/finalidades-secundarias-baja":
    "Puede negarse o darse de baja en cualquier momento y sin costo: escribiendo a privacidad@hyper.mx, diciéndoselo al ejecutivo durante una llamada, escribiendo BAJA en nuestro WhatsApp o mediante el enlace incluido en nuestros correos. Su baja se aplicará en todos los canales en un máximo de 5 días hábiles y le enviaremos una constancia. Su negativa no será motivo para negarle los servicios y productos que solicita o contrata con nosotros.",
  "hyperseguros-web/legal/privacidad/finalidades-secundarias-celular":
    "Al proporcionarnos su número celular, Usted acepta que Hyper le contacte en ese número, incluso por WhatsApp, para las finalidades de este aviso. Si Usted no llega a contratar ningún producto, dejaremos de enviarle información comercial 24 meses después de su último contacto con Hyper.",
  "hyperseguros-web/legal/privacidad/finalidades-secundarias-heading":
    "Finalidades secundarias",
  "hyperseguros-web/legal/privacidad/finalidades-secundarias-items":
    "Informarle sobre productos y servicios relacionados con los que Usted solicitó o tiene contratados, por correo electrónico, llamada telefónica o WhatsApp.\nInvitarle a responder encuestas de satisfacción.\nReclutar y contratar personal directa o indirectamente por Hyper.\nRealizar comunicaciones internas, impresas o digitales, para incentivar el desempeño del personal de Hyper.",
  "hyperseguros-web/legal/privacidad/intro":
    'En cumplimiento de la Ley Federal de Protección de Datos Personales en Posesión de los Particulares publicada en el Diario Oficial de la Federación el 20 de marzo de 2025 (en lo sucesivo "LFPDPPP"), su Reglamento y demás disposiciones aplicables, Hyper Seguros México Agente de Seguros y de Fianzas, S.A. de C.V. ("Hyper"), con domicilio en Panzacola 62, Barrio Santa Catarina, Coyoacán, C.P. 04010, Ciudad de México, México, es el responsable del uso y protección de sus datos personales y al respecto le informamos lo siguiente:',
  "hyperseguros-web/legal/privacidad/limitacion-baja":
    "Para limitar el uso de sus datos, incluidas las transferencias que no sean necesarias para su servicio, escriba a privacidad@hyper.mx. Para dejar de recibir mensajes promocionales y encuestas por WhatsApp, escriba BAJA en cualquier momento.",
  "hyperseguros-web/legal/privacidad/limitacion-heading":
    "Limitación del Uso o Divulgación de sus Datos Personales",
  "hyperseguros-web/legal/privacidad/limitacion-intro":
    "Con objeto de que Usted pueda limitar el uso y divulgación de su información personal, le ofrecemos los siguientes medios:",
  "hyperseguros-web/legal/privacidad/limitacion-items":
    'Su inscripción en el Registro Público de Usuarios que No Deseen Información Publicitaria de Productos y Servicios Financieros (REUS), que está a cargo de la Comisión Nacional para la Protección y Defensa de los Usuarios de Servicios Financieros (en lo sucesivo "Condusef"). Para mayor información sobre este registro, Usted puede consultar la página de internet de la Condusef, o bien ponerse en contacto directo con esta.\nPara mayor información enviar un correo electrónico a la siguiente dirección: privacidad@hyper.mx',
  "hyperseguros-web/legal/privacidad/meta-description":
    "Aviso de privacidad de Hyper: qué datos personales recabamos, para qué los usamos, a quién los transferimos y cómo ejercer tus derechos ARCO.",
  "hyperseguros-web/legal/privacidad/meta-title": "Hyper - Aviso de Privacidad",
  "hyperseguros-web/legal/privacidad/proveedores-heading":
    "Proveedores que tratan sus datos por cuenta de Hyper",
  "hyperseguros-web/legal/privacidad/proveedores-intro":
    "Para operar nuestros canales de atención, Hyper se apoya en proveedores que tratan datos personales únicamente por cuenta de Hyper y conforme a sus instrucciones, en calidad de personas encargadas en términos de la LFPDPPP:",
  "hyperseguros-web/legal/privacidad/proveedores-items":
    "**Amazon Web Services:** aloja de forma cifrada las grabaciones de llamadas, las conversaciones de WhatsApp, los archivos adjuntos y el registro de comunicaciones, en servidores ubicados en los Estados Unidos de América.\n**Meta (WhatsApp Business Platform):** transmite los mensajes de WhatsApp entre Usted y Hyper y los conserva temporalmente solo para ese fin, en centros de datos que pueden ubicarse fuera de México.",
  "hyperseguros-web/legal/privacidad/proveedores-outro":
    "Estos proveedores están obligados por contrato a guardar confidencialidad, a aplicar medidas de seguridad y a no utilizar sus datos para fines propios. Hyper no les autoriza a usar sus datos con fines de publicidad o medición. La comunicación de datos a personas encargadas no constituye una transferencia, por lo que no requiere su consentimiento. Hyper podrá apoyarse en otros proveedores de tecnología que actúen como personas encargadas en las mismas condiciones.",
  "hyperseguros-web/legal/privacidad/reaseguro-intro":
    "Adicionalmente, los intermediarios de Reaseguro con los que, de forma enunciativa más no limitativa, sus datos pueden ser compartidos son:",
  "hyperseguros-web/legal/privacidad/revocacion-body":
    "Usted puede revocar en cualquier momento, sin efectos retroactivos, el consentimiento que nos haya otorgado, enviando su solicitud a privacidad@hyper.mx con los requisitos señalados para los derechos ARCO. Si otorgó su consentimiento por WhatsApp, también puede revocarlo por ese medio. Le responderemos en los mismos plazos. La revocación no procede cuando el tratamiento es necesario para cumplir una obligación legal, y puede implicar que no podamos continuar con el servicio o trámite que nos solicitó.",
  "hyperseguros-web/legal/privacidad/revocacion-heading":
    "Revocación del consentimiento",
  "hyperseguros-web/legal/privacidad/seguridad-body":
    "Las grabaciones, conversaciones, archivos y registros se almacenan cifrados, con acceso restringido al personal que los requiere para sus funciones y registro de cada acceso. Si ocurre una vulneración de seguridad que afecte de forma significativa sus derechos patrimoniales o morales, se lo informaremos de inmediato.",
  "hyperseguros-web/legal/privacidad/seguridad-heading": "Medidas de seguridad",
  "hyperseguros-web/legal/privacidad/telefono-body":
    "Hyper graba todas las llamadas que Usted realice a nuestros números y las que nuestros ejecutivos le hagan, y conserva el contenido completo de las conversaciones por WhatsApp, incluidos los archivos que se intercambien. En las llamadas que Usted realice a nuestros números, se lo recordaremos antes de conectarle con un ejecutivo.\n\nLa grabación y la conservación son necesarias para atender y dar seguimiento a su trámite y para dejar constancia de lo solicitado y acordado.\n\nNuestros ejecutivos nunca le pedirán por teléfono o WhatsApp contraseñas, claves de acceso ni números completos de tarjetas bancarias.\n\nEl uso que Usted haga de la aplicación WhatsApp se rige además por los términos y la política de privacidad de WhatsApp, que Hyper no controla.",
  "hyperseguros-web/legal/privacidad/telefono-heading":
    "Atención por teléfono y WhatsApp",
  "hyperseguros-web/legal/privacidad/transferencia-base-legal":
    "Las transferencias descritas en esta sección no requieren su consentimiento, por ser necesarias para cumplir la relación jurídica entre Usted y Hyper o los contratos celebrados en su interés, por realizarse a sociedades del mismo grupo que operan bajo los mismos procesos y políticas internas, o por estar previstas en una ley (artículo 36, fracciones I, III, IV y VII de la LFPDPPP). Hyper comunicará a los receptores este aviso de privacidad y las finalidades a las que Usted sujetó el tratamiento.",
  "hyperseguros-web/legal/privacidad/transferencia-heading":
    "Transferencia de Datos Personales",
  "hyperseguros-web/legal/privacidad/transferencia-intro":
    "Le informamos que sus datos personales pueden ser transferidos y tratados dentro y fuera del país, por personas distintas a Hyper. En ese sentido, su información puede ser compartida con nuestros socios de negocio: Aseguradoras, Afianzadoras y otras empresas del sector asegurador, para gestionar los servicios que prestamos.",
  "hyperseguros-web/legal/privacidad/transferencia-sector":
    "Asimismo, Hyper podrá compartir sus datos con otras empresas del sector asegurador que intervienen en la atención de su póliza, fianza o siniestro, como ajustadores de siniestros, agencias de suscripción de reaseguro y evaluadores o inspectores de riesgo, únicamente para esa finalidad.",
  "hyperseguros-web/legal/privacidad/transferencia-tramite":
    "Cuando sea necesario para la atención de su póliza, fianza, siniestro o reclamación, Hyper podrá compartir con la aseguradora o afianzadora que corresponda y, en su caso, con el intermediario de reaseguro, las grabaciones, conversaciones y documentos relacionados con su trámite.",
  "hyperseguros-web/legal/privacidad/ultima-actualizacion":
    "Última actualización: 5 de noviembre de 2026",
  "hyperseguros-web/legal/privacidad/uso-heading":
    "Uso de sus datos personales",
  "hyperseguros-web/legal/privacidad/uso-intro":
    "Los datos personales que recabamos de Usted, los utilizaremos para las siguientes finalidades:",
  "hyperseguros-web/legal/terminos/aceptacion-body":
    "Al acceder, navegar o utilizar el Sitio, Usted manifiesta que ha leído, entiende y acepta quedar obligado por estos Términos, así como por el Aviso de Privacidad de Hyper. Si no está de acuerdo con ellos, le solicitamos abstenerse de utilizar el Sitio.\n\nEl uso del Sitio implica el consentimiento expreso de Usted para que los presentes Términos le sean aplicables, sin perjuicio de los términos particulares que se establezcan para servicios específicos.",
  "hyperseguros-web/legal/terminos/aceptacion-heading":
    "1. Aceptación de los Términos",
  "hyperseguros-web/legal/terminos/cambios-body":
    "Hyper podrá modificar estos Términos en cualquier momento. Las modificaciones entrarán en vigor a partir de su publicación en el Sitio, por lo que le recomendamos revisarlos periódicamente. El uso continuado del Sitio después de su publicación implica la aceptación de los Términos modificados.",
  "hyperseguros-web/legal/terminos/cambios-heading":
    "19. Modificaciones a los Términos",
  "hyperseguros-web/legal/terminos/cookies-body":
    "El Sitio utiliza cookies, web beacons y otras tecnologías similares, en los términos descritos en el Aviso de Privacidad de Hyper, disponible en www.hyper.mx/legal/privacidad. Al navegar en el Sitio, Usted reconoce su uso conforme a dicho aviso.\n\nUsted puede configurar su navegador para limitar o deshabilitar estas tecnologías, lo cual podría afectar algunas funcionalidades del Sitio.",
  "hyperseguros-web/legal/terminos/cookies-heading":
    "12. Cookies y tecnologías similares",
  "hyperseguros-web/legal/terminos/cotizaciones-body":
    "Las cotizaciones, propuestas o estimaciones de prima que Hyper le proporcione son indicativas y se elaboran con la información que Usted entregue. Quedan sujetas a la revisión y aceptación de la Aseguradora o Afianzadora correspondiente, por lo que pueden variar o no llegar a concretarse.\n\nEl contrato de seguro o de fianza se perfecciona únicamente cuando la Aseguradora o Afianzadora emite la póliza o fianza respectiva. Las condiciones generales, particulares y especiales de la póliza o fianza emitida son las que rigen la relación entre Usted y la Aseguradora o Afianzadora, y prevalecen sobre cualquier información publicada en el Sitio.\n\nUsted es responsable de la veracidad y suficiencia de la información que proporcione para cotizar o contratar. La omisión o inexactitud de datos puede afectar la aceptación del riesgo, el importe de la prima o el pago de una reclamación conforme a la ley aplicable.",
  "hyperseguros-web/legal/terminos/cotizaciones-heading":
    "6. Cotizaciones y contratación",
  "hyperseguros-web/legal/terminos/cuentas-body":
    "El acceso a Hypernet y a HyperSign se realiza mediante credenciales personales e intransferibles. Usted es el único responsable de conservarlas de forma confidencial, de todas las operaciones que se realicen con ellas y de notificar de inmediato a Hyper cualquier uso no autorizado o sospecha de este.\n\nUsted reconoce y acepta que los datos de acceso, los códigos de verificación y los mecanismos de autenticación y de firma electrónica que Hyper ponga a su disposición sustituyen a su firma autógrafa y producen los mismos efectos que ésta, de conformidad con lo dispuesto en el Código de Comercio y demás legislación aplicable en materia de mensajes de datos y firma electrónica. Los documentos y consentimientos otorgados por estos medios le son plenamente oponibles y podrán conservarse en formato electrónico.\n\nHyper podrá suspender o cancelar el acceso a estas herramientas cuando detecte un uso indebido, un incumplimiento de estos Términos o un riesgo para la seguridad de la información.",
  "hyperseguros-web/legal/terminos/cuentas-heading":
    "7. Hypernet, HyperSign y credenciales de acceso",
  "hyperseguros-web/legal/terminos/datos-body":
    "El tratamiento de los datos personales que Usted proporcione a través del Sitio, de Hypernet o de HyperSign se rige por el Aviso de Privacidad de Hyper, disponible en www.hyper.mx/legal/privacidad. Para cualquier asunto relacionado con sus datos personales o con el ejercicio de sus derechos ARCO, puede escribir a privacidad@hyper.mx.",
  "hyperseguros-web/legal/terminos/datos-heading":
    "17. Protección de datos personales",
  "hyperseguros-web/legal/terminos/definiciones-heading": "2. Definiciones",
  "hyperseguros-web/legal/terminos/definiciones-intro":
    "Para efectos de estos Términos, se entenderá por:",
  "hyperseguros-web/legal/terminos/definiciones-items":
    "Hyper: Hyper Seguros México Agente de Seguros y de Fianzas S.A. de C.V.\nSitio: el sitio web www.hyper.mx y sus páginas, contenidos y funcionalidades.\nUsuario o Usted: toda persona que accede o utiliza el Sitio.\nHypernet: la plataforma de Hyper para clientes y agentes, disponible en https://portal.hyper.mx.\nHyperSign: la herramienta de firma electrónica de Hyper.\nAseguradoras y Afianzadoras: las instituciones de seguros y de fianzas autorizadas que emiten las pólizas y fianzas intermediadas por Hyper.\nContenido: textos, imágenes, gráficos, logotipos, marcas, diseños, software y cualquier otro material publicado en el Sitio.",
  "hyperseguros-web/legal/terminos/disponibilidad-body":
    "Hyper podrá modificar, suspender o descontinuar, de forma temporal o definitiva, el Sitio, Hypernet, HyperSign o cualquiera de sus funcionalidades, así como realizar ventanas de mantenimiento, sin necesidad de aviso previo y sin responsabilidad para Hyper.\n\nHyper no está obligado a mantener disponible ninguna funcionalidad ni contenido en particular, ni a que el Sitio o las plataformas operen de manera ininterrumpida.",
  "hyperseguros-web/legal/terminos/disponibilidad-heading":
    "8. Disponibilidad y cambios del Sitio y de las plataformas",
  "hyperseguros-web/legal/terminos/enlaces-body":
    "El Sitio puede contener enlaces a sitios o servicios de terceros, incluidos los de Aseguradoras y Afianzadoras. Hyper no controla ni respalda esos sitios, no es responsable de su contenido, disponibilidad o políticas, y su consulta se realiza bajo el propio riesgo de Usted y conforme a los términos de cada tercero.",
  "hyperseguros-web/legal/terminos/enlaces-heading":
    "11. Enlaces a sitios de terceros",
  "hyperseguros-web/legal/terminos/garantias-body":
    'En la medida permitida por la ley, el Sitio y su Contenido se proporcionan "tal cual" y "según disponibilidad", sin garantías de ninguna clase, expresas o implícitas, incluidas las de exactitud, idoneidad para un fin determinado o disponibilidad continua, sin perjuicio de lo señalado en la sección 5.\n\nNada de lo dispuesto en esta sección excluye los derechos que la legislación aplicable reconozca a Usted como usuario de servicios financieros.',
  "hyperseguros-web/legal/terminos/garantias-heading":
    "13. Exclusión de garantías",
  "hyperseguros-web/legal/terminos/generales-body":
    "Si alguna disposición de estos Términos se declara inválida o inaplicable, las demás conservarán su plena validez (divisibilidad). La falta de ejercicio de un derecho por parte de Hyper no implica su renuncia.\n\nEstos Términos, junto con el Aviso de Privacidad y los términos específicos que, en su caso, se establezcan para Hypernet o HyperSign, constituyen el acuerdo completo entre Usted y Hyper respecto del uso del Sitio.",
  "hyperseguros-web/legal/terminos/generales-heading":
    "20. Disposiciones generales",
  "hyperseguros-web/legal/terminos/indemnizacion-body":
    "Usted se obliga a sacar en paz y a salvo a Hyper, sus funcionarios, empleados y representantes, de cualquier reclamación, daño, pérdida o gasto, incluidos honorarios razonables de abogados, que deriven del incumplimiento de estos Términos o del uso ilícito del Sitio, de Hypernet o de HyperSign por parte de Usted.",
  "hyperseguros-web/legal/terminos/indemnizacion-heading": "15. Indemnización",
  "hyperseguros-web/legal/terminos/informativo-body":
    "La información publicada en el Sitio sobre seguros, fianzas, coberturas, industrias y servicios tiene carácter meramente informativo y de orientación general. No constituye una oferta vinculante, una recomendación personalizada, asesoría legal, fiscal o financiera, ni una promesa de aceptación del riesgo o de emisión de póliza o fianza alguna.\n\nHyper procura que la información del Sitio sea vigente y precisa, pero no garantiza que se encuentre libre de errores u omisiones y podrá actualizarla o modificarla en cualquier momento sin previo aviso.",
  "hyperseguros-web/legal/terminos/informativo-heading":
    "5. Carácter informativo del Sitio",
  "hyperseguros-web/legal/terminos/intro":
    'Los presentes Términos y Condiciones de Uso (los "Términos") regulan el acceso y el uso del sitio web www.hyper.mx (el "Sitio"), propiedad de Hyper Seguros México Agente de Seguros y de Fianzas S.A. de C.V. (Hyper), con domicilio en Panzacola 62, Barrio Santa Catarina, Coyoacán, C.P. 04010, Ciudad de México, México. Le pedimos leerlos con atención antes de utilizar el Sitio.',
  "hyperseguros-web/legal/terminos/ley-body":
    "Estos Términos se rigen por las leyes federales de los Estados Unidos Mexicanos. Para su interpretación y cumplimiento, Usted y Hyper se someten a la jurisdicción de los tribunales competentes de la Ciudad de México, renunciando a cualquier otro fuero que pudiera corresponderles por razón de su domicilio presente o futuro.",
  "hyperseguros-web/legal/terminos/ley-heading":
    "21. Legislación aplicable y jurisdicción",
  "hyperseguros-web/legal/terminos/meta-description":
    "Términos y condiciones del sitio de Hyper: uso permitido, cotizaciones, contratación con aseguradoras, Hypernet y HyperSign, responsabilidad y ley aplicable.",
  "hyperseguros-web/legal/terminos/meta-title":
    "Hyper - Términos y Condiciones",
  "hyperseguros-web/legal/terminos/propiedad-body":
    '"Hyper", los logotipos, las marcas, los nombres comerciales, los diseños, los textos, las imágenes, el software y demás Contenido del Sitio son propiedad de Hyper o se utilizan con autorización de sus titulares, y están protegidos por la Ley Federal del Derecho de Autor, la Ley Federal de Protección a la Propiedad Industrial y demás disposiciones aplicables.\n\nEstos Términos no le otorgan licencia ni derecho alguno sobre dichos elementos, salvo el uso personal y no comercial del Sitio. Queda prohibida su reproducción, modificación, distribución, comunicación pública o cualquier otro uso sin autorización previa y por escrito de Hyper.',
  "hyperseguros-web/legal/terminos/propiedad-heading":
    "9. Propiedad intelectual",
  "hyperseguros-web/legal/terminos/quejas-body":
    "Si tiene una duda, queja o aclaración sobre los servicios de intermediación de Hyper o sobre una póliza o fianza, Hyper lo apoyará en su atención ante la Aseguradora o Afianzadora correspondiente.\n\nAdicionalmente, Usted puede acudir a la Unidad Especializada de Atención de Consultas y Reclamaciones (UNE) de la Aseguradora o Afianzadora de que se trate y, en su caso, a la Comisión Nacional para la Protección y Defensa de los Usuarios de Servicios Financieros (CONDUSEF), conforme a la legislación aplicable.",
  "hyperseguros-web/legal/terminos/quejas-heading": "18. Quejas y aclaraciones",
  "hyperseguros-web/legal/terminos/quienes-somos-body":
    "Hyper es un agente de seguros y de fianzas autorizado por la Comisión Nacional de Seguros y Fianzas (CNSF). Hyper interviene como intermediario entre Usted y las Aseguradoras y Afianzadoras: no asume los riesgos ni emite pólizas o fianzas por cuenta propia.\n\nLa cobertura, las condiciones, las exclusiones y el resto de las obligaciones derivadas de un seguro o de una fianza corresponden exclusivamente a la Aseguradora o Afianzadora que los emite. Encontrará mayor información sobre nuestra actividad como intermediarios en el Folleto Informativo de Intermediación, disponible en www.hyper.mx/legal/folleto-informativo-intermediacion.",
  "hyperseguros-web/legal/terminos/quienes-somos-heading":
    "3. Quiénes somos y nuestra naturaleza regulatoria",
  "hyperseguros-web/legal/terminos/responsabilidad-cierre":
    "Lo anterior no limita la responsabilidad que Hyper tenga conforme a la legislación aplicable en su carácter de agente de seguros y de fianzas.",
  "hyperseguros-web/legal/terminos/responsabilidad-heading":
    "14. Limitación de responsabilidad",
  "hyperseguros-web/legal/terminos/responsabilidad-intro":
    "En la máxima medida permitida por la ley, Hyper no será responsable por:",
  "hyperseguros-web/legal/terminos/responsabilidad-items":
    "Interrupciones, fallas o indisponibilidad del Sitio, de Hypernet o de HyperSign, cuando deriven de causas ajenas a su control o de mantenimiento.\nDaños derivados de virus u otros elementos dañinos que, a pesar de sus medidas de seguridad, pudieran afectar el equipo de Usted al utilizar el Sitio.\nLa decisión de contratar o no un seguro o una fianza con base únicamente en la información general del Sitio.\nLa aceptación del riesgo, las condiciones, el pago de siniestros y demás obligaciones que correspondan a la Aseguradora o Afianzadora emisora.\nEl uso indebido de las credenciales de acceso por causas imputables a Usted.",
  "hyperseguros-web/legal/terminos/sugerencias-body":
    "Las ideas, sugerencias o comentarios que Usted envíe a Hyper sobre el Sitio o sus servicios podrán ser utilizados por Hyper libremente y sin obligación de contraprestación, compensación o reconocimiento alguno a su favor.\n\nEstos medios no deben utilizarse para enviar datos personales; el tratamiento de cualquier dato personal se rige exclusivamente por el Aviso de Privacidad de Hyper.",
  "hyperseguros-web/legal/terminos/sugerencias-heading":
    "10. Sugerencias y comentarios",
  "hyperseguros-web/legal/terminos/ultima-actualizacion":
    "Última actualización: 29 de septiembre de 2026",
  "hyperseguros-web/legal/terminos/uso-heading": "4. Uso del Sitio",
  "hyperseguros-web/legal/terminos/uso-intro":
    "Usted se obliga a utilizar el Sitio de forma lícita, de buena fe y conforme a estos Términos. Queda prohibido, de manera enunciativa más no limitativa:",
  "hyperseguros-web/legal/terminos/uso-items":
    "Utilizar el Sitio para fines ilícitos, fraudulentos o contrarios a la moral y al orden público.\nProporcionar información falsa, inexacta o de terceros sin su autorización.\nIntentar acceder sin autorización a sistemas, cuentas, redes o bases de datos de Hyper o de terceros.\nIntroducir virus, código malicioso o cualquier elemento que dañe, sobrecargue o interfiera con el funcionamiento del Sitio.\nExtraer, copiar o recopilar contenidos o datos del Sitio de forma automatizada, salvo autorización previa y por escrito de Hyper.\nSuplantar la identidad de otra persona o hacerse pasar por representante de Hyper, de una Aseguradora o de una Afianzadora.\nReproducir, distribuir o explotar comercialmente el Sitio o su Contenido sin autorización.",
  "hyperseguros-web/legal/terminos/vigencia-body":
    "Estos Términos se encuentran vigentes mientras Usted utilice el Sitio. Hyper podrá restringir, suspender o cancelar su acceso al Sitio o a las plataformas en caso de incumplimiento de estos Términos, sin perjuicio de las demás acciones que legalmente le correspondan.\n\nLas disposiciones que por su naturaleza deban subsistir a la terminación, entre ellas las relativas a propiedad intelectual, limitación de responsabilidad, indemnización y jurisdicción, continuarán vigentes.",
  "hyperseguros-web/legal/terminos/vigencia-heading":
    "16. Vigencia y terminación",
  "hyperseguros-web/nav/a11y/back": "Atrás",
  "hyperseguros-web/nav/a11y/close-menu": "Cerrar menú",
  "hyperseguros-web/nav/a11y/main-menu": "Menú principal",
  "hyperseguros-web/nav/a11y/open-menu": "Abrir menú",
  "hyperseguros-web/nav/cta/hypernet": "HyperNet",
  "hyperseguros-web/nav/fianzas": "Fianzas",
  "hyperseguros-web/nav/groups/accidentes": "Accidentes",
  "hyperseguros-web/nav/groups/administrativas": "Administrativas",
  "hyperseguros-web/nav/groups/credito": "Crédito",
  "hyperseguros-web/nav/groups/danos": "Daños",
  "hyperseguros-web/nav/groups/especializados": "Especializados",
  "hyperseguros-web/nav/groups/fidelidad": "Fidelidad",
  "hyperseguros-web/nav/groups/judiciales": "Judiciales",
  "hyperseguros-web/nav/groups/nosotros": "Nosotros",
  "hyperseguros-web/nav/groups/parametricos": "Paramétricos",
  "hyperseguros-web/nav/groups/personas": "Personas",
  "hyperseguros-web/nav/groups/por-industria": "Por industria",
  "hyperseguros-web/nav/groups/responsabilidad-civil": "Responsabilidad Civil",
  "hyperseguros-web/nav/groups/salud": "Salud",
  "hyperseguros-web/nav/groups/sector-privado": "Sector Privado",
  "hyperseguros-web/nav/groups/sector-publico": "Sector Público",
  "hyperseguros-web/nav/groups/tecnologia": "Tecnología",
  "hyperseguros-web/nav/groups/transportes": "Transportes",
  "hyperseguros-web/nav/groups/vida": "Vida",
  "hyperseguros-web/nav/groups/wholesale": "Wholesale",
  "hyperseguros-web/nav/industrias": "Industrias",
  "hyperseguros-web/nav/items/accidentes": "Accidentes",
  "hyperseguros-web/nav/items/accidentes-escolares": "Accidentes Escolares",
  "hyperseguros-web/nav/items/accidentes-laborales": "Accidentes Laborales",
  "hyperseguros-web/nav/items/acerca-de-nosotros": "Acerca de nosotros",
  "hyperseguros-web/nav/items/agentes-y-productores": "Agentes y productores",
  "hyperseguros-web/nav/items/anticipo": "Anticipo",
  "hyperseguros-web/nav/items/arte": "Arte",
  "hyperseguros-web/nav/items/asesoria-externa-en-materias-de-seguros":
    "Asesoría Externa en Materia de Seguros",
  "hyperseguros-web/nav/items/autos": "Autos",
  "hyperseguros-web/nav/items/aviacion": "Aviación",
  "hyperseguros-web/nav/items/bankers-blanket-bond":
    "Bankers Blanket Bond (BBB)",
  "hyperseguros-web/nav/items/beneficios-para-empleados":
    "Beneficios para Empleados",
  "hyperseguros-web/nav/items/cancelacion-de-eventos": "Cancelación de Eventos",
  "hyperseguros-web/nav/items/carga": "Carga",
  "hyperseguros-web/nav/items/colectiva": "Colectiva",
  "hyperseguros-web/nav/items/compra-venta": "Compra-Venta",
  "hyperseguros-web/nav/items/construccion-todo-riesgo":
    "Construcción Todo Riesgo",
  "hyperseguros-web/nav/items/contacto": "Contacto",
  "hyperseguros-web/nav/items/crime": "Crimen",
  "hyperseguros-web/nav/items/cumplimiento": "Cumplimiento",
  "hyperseguros-web/nav/items/cyber": "Cyber",
  "hyperseguros-web/nav/items/d-o": "Directores y Funcionarios (D&O)",
  "hyperseguros-web/nav/items/deportivo": "Deportivo",
  "hyperseguros-web/nav/items/deudores": "Deudores",
  "hyperseguros-web/nav/items/e-o": "Errores y Omisiones (E&O)",
  "hyperseguros-web/nav/items/ecoturismo": "Ecoturismo",
  "hyperseguros-web/nav/items/equipo-pesado": "Equipo Pesado",
  "hyperseguros-web/nav/items/eventos": "Eventos",
  "hyperseguros-web/nav/items/flotillas": "Flotillas",
  "hyperseguros-web/nav/items/gastos-medicos": "Gastos Médicos",
  "hyperseguros-web/nav/items/gastos-medicos-mayores": "Gastos Médicos Mayores",
  "hyperseguros-web/nav/items/huracan": "Huracán",
  "hyperseguros-web/nav/items/hypernet": "HyperNet",
  "hyperseguros-web/nav/items/hypersign": "HyperSign",
  "hyperseguros-web/nav/items/indemnizatorios": "Indemnizatorios",
  "hyperseguros-web/nav/items/individual": "Individual",
  "hyperseguros-web/nav/items/interrupcion-de-negocio":
    "Interrupción de Negocio",
  "hyperseguros-web/nav/items/inundacion": "Inundación",
  "hyperseguros-web/nav/items/maritimo": "Marítimo",
  "hyperseguros-web/nav/items/no-penales": "No Penales",
  "hyperseguros-web/nav/items/orfandad": "Orfandad",
  "hyperseguros-web/nav/items/paquete-empresarial":
    "Paquete Empresarial (PYMES)",
  "hyperseguros-web/nav/items/penales": "Penales",
  "hyperseguros-web/nav/items/polizas-patrimoniales": "Pólizas Patrimoniales",
  "hyperseguros-web/nav/items/programas-de-afinidad": "Programas de Afinidad",
  "hyperseguros-web/nav/items/propiedad-todo-riesgo": "Propiedad Todo Riesgo",
  "hyperseguros-web/nav/items/rc-ambiental": "RC Ambiental y Contaminación",
  "hyperseguros-web/nav/items/rc-funcionarios-publicos":
    "RC Funcionarios Públicos",
  "hyperseguros-web/nav/items/rc-general": "RC General",
  "hyperseguros-web/nav/items/rc-medica-malpraxis": "RC Médica (Malpraxis)",
  "hyperseguros-web/nav/items/rc-producto-y-retiro":
    "RC Producto y Retiro de Producto",
  "hyperseguros-web/nav/items/rc-profesional": "RC Profesional",
  "hyperseguros-web/nav/items/riesgo-politico": "Riesgo Político",
  "hyperseguros-web/nav/items/seguro-de-salud": "Seguro de Salud",
  "hyperseguros-web/nav/items/seguro-de-vida-institucional":
    "Seguro de Vida Institucional",
  "hyperseguros-web/nav/items/seguro-escolar-integral":
    "Seguro Escolar Integral",
  "hyperseguros-web/nav/items/seguros-parametricos": "Seguros Paramétricos",
  "hyperseguros-web/nav/items/sostenimiento-de-oferta":
    "Sostenimiento de Oferta",
  "hyperseguros-web/nav/items/srcc": "SRCC",
  "hyperseguros-web/nav/items/stock-throughput": "Stock Throughput",
  "hyperseguros-web/nav/items/suministro": "Suministro",
  "hyperseguros-web/nav/items/terremoto": "Terremoto",
  "hyperseguros-web/nav/items/viales": "Viales",
  "hyperseguros-web/nav/items/vicios-ocultos": "Vicios Ocultos",
  "hyperseguros-web/nav/items/vida-grupo": "Vida Grupo",
  "hyperseguros-web/nav/items/wholesale-de-seguros": "Wholesale de seguros",
  "hyperseguros-web/nav/nosotros": "Nosotros",
  "hyperseguros-web/nav/programas": "Programas",
  "hyperseguros-web/nav/seguros": "Seguros",
  "hyperseguros-web/products/accidentes-afinidad/heading-emphasis":
    "Luce en cerca de 500 hospitales",
  "hyperseguros-web/products/accidentes-afinidad/heading-muted":
    "El beneficio que no luce en el folleto de tu membresía.",
  "hyperseguros-web/products/accidentes-afinidad/meta-description":
    "El beneficio de accidentes que ya viene incluido en tu membresía o servicio: muerte accidental, gastos médicos y funerarios para toda tu base de clientes.",
  "hyperseguros-web/products/accidentes-afinidad/meta-title":
    "Hyper - Seguro de accidentes de afinidad",
  "hyperseguros-web/products/accidentes-afinidad/tagline":
    "Sin solicitud individual ni cuestionario médico. Alta por layout, certificado por afiliado y beneficios que no se olvidan una vez que los usan.",
  "hyperseguros-web/products/accidentes-deportivo/heading-emphasis":
    "Nadie se da de baja por tenerlo",
  "hyperseguros-web/products/accidentes-deportivo/heading-muted":
    "Nadie se inscribe al club por el seguro.",
  "hyperseguros-web/products/accidentes-deportivo/meta-description":
    "Deportistas y personal cubiertos en la cancha, el gimnasio y la alberca: gastos médicos por accidente, renta diaria por hospitalización y pérdidas orgánicas.",
  "hyperseguros-web/products/accidentes-deportivo/meta-title":
    "Hyper - Seguro de accidentes deportivos",
  "hyperseguros-web/products/accidentes-deportivo/tagline":
    "Cubrimos entrenamientos, competencias y traslados. Lo único que no cubrimos es la excusa de que el seguro era muy complicado.",
  "hyperseguros-web/products/accidentes-ecoturismo/heading-emphasis":
    "La cobertura sube sin quejarse",
  "hyperseguros-web/products/accidentes-ecoturismo/heading-muted":
    "Del punto de encuentro a la cima y de regreso.",
  "hyperseguros-web/products/accidentes-ecoturismo/meta-description":
    "Turistas, asistentes y guías cubiertos de ida y de regreso: montaña, escalada, ciclismo, cabalgata y temazcal, con gastos médicos por accidente incluidos.",
  "hyperseguros-web/products/accidentes-ecoturismo/meta-title":
    "Hyper - Seguro de accidentes para ecoturismo",
  "hyperseguros-web/products/accidentes-ecoturismo/tagline":
    "Tirolesa, buceo, cuatrimotos, temazcal: aceptamos actividades que otras pólizas prefieren ver en foto.",
  "hyperseguros-web/products/accidentes-escolares/heading-emphasis":
    "para no tener que explicar nada después",
  "hyperseguros-web/products/accidentes-escolares/heading-muted":
    "El seguro que tu escuela contrata",
  "hyperseguros-web/products/accidentes-escolares/meta-description":
    "Cobertura de accidentes para alumnos, docentes y personal, dentro y fuera del plantel: muerte accidental, gastos médicos, pérdidas orgánicas y funerarios.",
  "hyperseguros-web/products/accidentes-escolares/meta-title":
    "Hyper - Seguro de accidentes escolares",
  "hyperseguros-web/products/accidentes-escolares/tagline":
    "Del recreo al camión escolar y hasta la clase en línea: resuelto antes de que alguien tenga que explicarlo en el consejo directivo.",
  "hyperseguros-web/products/accidentes-eventos/heading-emphasis":
    "pero llega antes que todos",
  "hyperseguros-web/products/accidentes-eventos/heading-muted":
    "El único invitado que no aparece en la lista,",
  "hyperseguros-web/products/accidentes-eventos/meta-description":
    "Público, participantes y staff cubiertos antes, durante y después del evento: muerte accidental, gastos médicos y renta diaria por hospitalización.",
  "hyperseguros-web/products/accidentes-eventos/meta-title":
    "Hyper - Seguro de accidentes para eventos",
  "hyperseguros-web/products/accidentes-eventos/tagline":
    "Conciertos, congresos, expos, festivales: aseguramos al público y al staff, aunque nadie vaya a aplaudir por eso.",
  "hyperseguros-web/products/accidentes-laborales/heading-emphasis":
    "La cuenta del hospital, no",
  "hyperseguros-web/products/accidentes-laborales/heading-muted":
    "El papeleo del accidente puede esperar.",
  "hyperseguros-web/products/accidentes-laborales/meta-description":
    "Accidentes para toda la plantilla y en cualquier industria: muerte accidental, gastos médicos, pérdidas orgánicas y anticipo de la suma asegurada.",
  "hyperseguros-web/products/accidentes-laborales/meta-title":
    "Hyper - Seguro de accidentes laborales",
  "hyperseguros-web/products/accidentes-laborales/tagline":
    "Otras aseguradoras piden explicaciones antes de atender. Aquí se atiende primero, en cerca de 500 hospitales, las 24 horas.",
  "hyperseguros-web/products/afinidad/heading-emphasis":
    "que tus clientes sí quieren leer",
  "hyperseguros-web/products/afinidad/heading-muted": "La letra chica",
  "hyperseguros-web/products/afinidad/meta-description":
    "El seguro de vida que ya viene incluido en tu producto o membresía: fallecimiento, gastos funerarios, invalidez total y permanente y graves enfermedades.",
  "hyperseguros-web/products/afinidad/meta-title":
    "Hyper - Seguro de vida de afinidad",
  "hyperseguros-web/products/afinidad/tagline":
    "Es el beneficio que tu programa no anuncia en el folleto. Y el que tus clientes agradecen encontrar.",
  "hyperseguros-web/products/arte/heading-emphasis":
    "Pero se asegura a valor convenido",
  "hyperseguros-web/products/arte/heading-muted": "Una obra no se repone.",
  "hyperseguros-web/products/arte/meta-description":
    "Obras, colecciones, joyas y valores a valor convenido: todo riesgo clavo a clavo, exposiciones y préstamos, tránsito, embalaje y depreciación.",
  "hyperseguros-web/products/arte/meta-title":
    "Hyper - Seguro de arte, joyas y valores",
  "hyperseguros-web/products/arte/tagline":
    "Obras de arte, colecciones, joyas y valores en exhibición, tránsito y depósito, a valor convenido y con cobertura clavo a clavo. Para museos, galerías, coleccionistas y casas de subasta.",
  "hyperseguros-web/products/autos/heading-emphasis": "Nosotros sí lo leímos",
  "hyperseguros-web/products/autos/heading-muted":
    "El seguro que todos tienen y nadie ha leído.",
  "hyperseguros-web/products/autos/meta-description":
    "Daños, robo total y terceros, en cobertura amplia, limitada o solo RC: gastos médicos a ocupantes, asistencia legal y vial, y RC en Estados Unidos.",
  "hyperseguros-web/products/autos/meta-title":
    "Hyper - Seguro de auto para empresas",
  "hyperseguros-web/products/autos/tagline":
    "Para agentes que colocan autos y programas que los incluyen: cotización, emisión y siniestros por Hypernet. La póliza más común, operada como si no lo fuera.",
  "hyperseguros-web/products/aviacion/heading-emphasis":
    "Ni sin casco y responsabilidad civil",
  "hyperseguros-web/products/aviacion/heading-muted":
    "Nadie despega sin plan de vuelo.",
  "hyperseguros-web/products/aviacion/meta-description":
    "Casco, responsabilidad civil a pasajeros y terceros y riesgos de guerra, en el aire y en tierra: tripulación, refacciones, hangares y aeródromos.",
  "hyperseguros-web/products/aviacion/meta-title":
    "Hyper - Seguro de aviación: casco y RC",
  "hyperseguros-web/products/aviacion/tagline":
    "Aeronaves ejecutivas, comerciales, agrícolas y drones, con casco, RC y guerra colocados con reaseguro especializado. Un ramo raro, operado sin rareza.",
  "hyperseguros-web/products/cancelacion-de-eventos/heading-emphasis":
    "Este es el plan para cuando el B tampoco sale",
  "hyperseguros-web/products/cancelacion-de-eventos/heading-muted":
    "Todo evento tiene plan B.",
  "hyperseguros-web/products/cancelacion-de-eventos/meta-description":
    "Meses de producción y una sola fecha: cancelación, posposición, abandono, gastos comprometidos, no presentación del artista y clima adverso.",
  "hyperseguros-web/products/cancelacion-de-eventos/meta-title":
    "Hyper - Seguro de cancelación de eventos",
  "hyperseguros-web/products/cancelacion-de-eventos/tagline":
    "Cancelación, posposición, abandono y no presentación del artista, por causas fuera de tu control. Cubre los gastos comprometidos y la utilidad que el evento iba a dejar.",
  "hyperseguros-web/products/carga/heading-emphasis":
    "La póliza, por toda la carga",
  "hyperseguros-web/products/carga/heading-muted":
    "El transportista responde por poco.",
  "hyperseguros-web/products/carga/meta-description":
    "La mercancía desde que sale hasta que alguien firma de recibido: riesgos ordinarios de tránsito, robo, maniobras, bodega a bodega y refrigeración.",
  "hyperseguros-web/products/carga/meta-title":
    "Hyper - Seguro de transporte de carga",
  "hyperseguros-web/products/carga/tagline":
    "Riesgos ordinarios de tránsito, robo, maniobras y estadías, de bodega a bodega y de frontera a frontera. Por embarque o con póliza anual a declaración.",
  "hyperseguros-web/products/common/coming-soon":
    "Estamos preparando el contenido de esta sección. Vuelve pronto para conocer todos los detalles.",
  "hyperseguros-web/products/construccion-todo-riesgo/heading-emphasis":
    "El banco, sí",
  "hyperseguros-web/products/construccion-todo-riesgo/heading-muted":
    "Nadie pone la primera piedra pensando en el seguro.",
  "hyperseguros-web/products/construccion-todo-riesgo/meta-description":
    "De la excavación a la entrega y el mantenimiento: obra civil, montaje, terremoto en obra, responsabilidad civil cruzada y maquinaria de contratistas.",
  "hyperseguros-web/products/construccion-todo-riesgo/meta-title":
    "Hyper - Seguro de construcción todo riesgo (CAR)",
  "hyperseguros-web/products/construccion-todo-riesgo/tagline":
    "Obra civil, montaje, equipo y responsabilidad civil cruzada en una sola póliza. Desde la excavación hasta el mantenimiento, sin que nadie tenga que descifrar tres contratos.",
  "hyperseguros-web/products/crime/heading-emphasis":
    "La póliza confía en la auditoría",
  "hyperseguros-web/products/crime/heading-muted": "Confías en tu equipo.",
  "hyperseguros-web/products/crime/meta-description":
    "Por el dinero que sale sin que nadie lo vea salir: infidelidad de empleados, falsificación, fraude informático, ingeniería social y valores en tránsito.",
  "hyperseguros-web/products/crime/meta-title":
    "Hyper - Seguro de crimen y fraude empresarial",
  "hyperseguros-web/products/crime/tagline":
    "Infidelidad de empleados, falsificación, fraude electrónico, ingeniería social y dinero en tránsito. Para pérdidas que no aparecen en el inventario sino en el estado de cuenta.",
  "hyperseguros-web/products/cyber/heading-emphasis":
    "Esta es la póliza para cuando no alcanza",
  "hyperseguros-web/products/cyber/heading-muted":
    "Tu empresa ya tiene firewall.",
  "hyperseguros-web/products/cyber/meta-description":
    "El incidente completo desde la primera llamada: respuesta, restauración de datos, interrupción del negocio, ransomware y responsabilidad por privacidad.",
  "hyperseguros-web/products/cyber/meta-title":
    "Hyper - Seguro de ciberriesgos para empresas",
  "hyperseguros-web/products/cyber/tagline":
    "Respuesta a incidentes, restauración de datos, interrupción del negocio, extorsión y responsabilidad frente a terceros. Con un equipo forense en la línea antes que el abogado.",
  "hyperseguros-web/products/deudores/heading-emphasis":
    "Sin volverte experto en pólizas de vida",
  "hyperseguros-web/products/deudores/heading-muted": "Blindamos tu cartera.",
  "hyperseguros-web/products/deudores/meta-description":
    "Blinda tu cartera de crédito sin volverte experto en pólizas de vida: fallecimiento, invalidez total y permanente y desempleo, cubiertos sobre el saldo.",
  "hyperseguros-web/products/deudores/meta-title":
    "Hyper - Seguro de vida para deudores",
  "hyperseguros-web/products/deudores/tagline":
    "El comité de crédito ya tiene suficientes temas aburridos. Que un crédito impago no sea uno más.",
  "hyperseguros-web/products/dno/heading-emphasis":
    "Los buenos preguntan si hay",
  "hyperseguros-web/products/dno/heading-muted":
    "Nadie acepta un puesto en el consejo por el seguro.",
  "hyperseguros-web/products/dno/meta-description":
    "El patrimonio de quien decide: lados A, B y C, defensa legal e investigaciones, prácticas laborales (EPL) y consejeros externos e independientes.",
  "hyperseguros-web/products/dno/meta-title":
    "Hyper - Seguro D&O para consejeros y directivos",
  "hyperseguros-web/products/dno/tagline":
    "Protege el patrimonio personal de quien decide en la empresa: defensa, investigaciones y reclamaciones de accionistas, autoridades y empleados. La póliza que el consejo debería aprobar antes que el presupuesto.",
  "hyperseguros-web/products/eno/heading-emphasis": "Es una cobertura",
  "hyperseguros-web/products/eno/heading-muted":
    "«Errores y omisiones» suena a disculpa.",
  "hyperseguros-web/products/eno/meta-description":
    "Por el servicio que vendes y el contrato que firmaste: fallas en el servicio, incumplimiento, defensa legal, propiedad intelectual y subcontratistas.",
  "hyperseguros-web/products/eno/meta-title":
    "Hyper - Seguro E&O de errores y omisiones",
  "hyperseguros-web/products/eno/tagline":
    "Cubre las reclamaciones por fallas en el servicio que vendes: software, consultoría, intermediación, publicidad. Con defensa legal desde el primer correo del abogado del cliente.",
  "hyperseguros-web/products/equipo-pesado/heading-emphasis":
    "Aseguramos lo que no tiene placas",
  "hyperseguros-web/products/equipo-pesado/heading-muted":
    "Grúas, excavadoras, tractores.",
  "hyperseguros-web/products/equipo-pesado/meta-description":
    "Grúas, excavadoras y tractores en obra, en traslado y en el patio: daños físicos en operación, robo total, riesgos catastróficos y equipo arrendado.",
  "hyperseguros-web/products/equipo-pesado/meta-title":
    "Hyper - Seguro de maquinaria y equipo pesado",
  "hyperseguros-web/products/equipo-pesado/tagline":
    "Equipo de contratistas propio o arrendado, en operación, en obra y en traslado. El seguro sigue a la máquina, no a la dirección.",
  "hyperseguros-web/products/fianzas-anticipo/heading-emphasis":
    "La fianza es la razón por la que confían",
  "hyperseguros-web/products/fianzas-anticipo/heading-muted":
    "Te dan el dinero antes de empezar.",
  "hyperseguros-web/products/fianzas-anticipo/meta-description":
    "La garantía de que el anticipo se convierte en obra: aplicación del anticipo, amortización conforme a contrato y devolución del saldo no amortizado.",
  "hyperseguros-web/products/fianzas-anticipo/meta-title":
    "Hyper - Fianza de anticipo",
  "hyperseguros-web/products/fianzas-anticipo/tagline":
    "Garantiza al cliente que el anticipo se aplicará a la obra o al pedido y, si no, que se le devolverá. Se amortiza conforme avanzas: el saldo garantizado baja con cada estimación.",
  "hyperseguros-web/products/fianzas-credito-compra-venta/heading-emphasis":
    "O una fianza, que es más rápida",
  "hyperseguros-web/products/fianzas-credito-compra-venta/heading-muted":
    "Comprar a plazos requiere confianza.",
  "hyperseguros-web/products/fianzas-credito-compra-venta/meta-description":
    "La garantía de que el comprador va a pagar los plazos: pago del precio, saldo insoluto, intereses y accesorios sobre un bien vendido a crédito.",
  "hyperseguros-web/products/fianzas-credito-compra-venta/meta-title":
    "Hyper - Fianza de crédito compraventa",
  "hyperseguros-web/products/fianzas-credito-compra-venta/tagline":
    "Garantiza al vendedor el pago del precio pactado en una compraventa a plazos: maquinaria, equipo, vehículos, inmuebles. Si el comprador no paga, la afianzadora lo hace y después cobra.",
  "hyperseguros-web/products/fianzas-credito-suministro/heading-emphasis":
    "La fianza cubre los noventa",
  "hyperseguros-web/products/fianzas-credito-suministro/heading-muted":
    "Entregas hoy y cobras en noventa días.",
  "hyperseguros-web/products/fianzas-credito-suministro/meta-description":
    "La garantía de que el proveedor va a cobrar: pago de las facturas, saldo de la línea de crédito, intereses y accesorios en ventas a crédito entre empresas.",
  "hyperseguros-web/products/fianzas-credito-suministro/meta-title":
    "Hyper - Fianza de crédito de suministro",
  "hyperseguros-web/products/fianzas-credito-suministro/tagline":
    "Garantiza al proveedor el pago de los bienes o servicios suministrados a crédito cuando el comprador no paga. El comprador la contrata; el proveedor la exige.",
  "hyperseguros-web/products/fianzas-cumplimiento/heading-emphasis":
    "Y que nadie explica en ninguno",
  "hyperseguros-web/products/fianzas-cumplimiento/heading-muted":
    "La fianza que te piden en cada contrato.",
  "hyperseguros-web/products/fianzas-cumplimiento/meta-description":
    "La garantía de que harás lo que firmaste: cumplimiento del contrato, penas convencionales y las obligaciones laborales y fiscales derivadas.",
  "hyperseguros-web/products/fianzas-cumplimiento/meta-title":
    "Hyper - Fianza de cumplimiento",
  "hyperseguros-web/products/fianzas-cumplimiento/tagline":
    "Garantiza al beneficiario que cumplirás el contrato en tiempo y forma. Si no, la afianzadora paga y después platica contigo.",
  "hyperseguros-web/products/fianzas-fidelidad-colectiva/heading-emphasis":
    "Y ningún nombre que actualizar cada mes",
  "hyperseguros-web/products/fianzas-fidelidad-colectiva/heading-muted":
    "Todos los empleados, una sola fianza.",
  "hyperseguros-web/products/fianzas-fidelidad-colectiva/meta-description":
    "Todos los puestos de confianza en una sola fianza, sin nombres que actualizar cada mes: robo, fraude, abuso de confianza y complicidad de empleados.",
  "hyperseguros-web/products/fianzas-fidelidad-colectiva/meta-title":
    "Hyper - Fianza de fidelidad colectiva",
  "hyperseguros-web/products/fianzas-fidelidad-colectiva/tagline":
    "Garantiza a la empresa el pago de las pérdidas por robo, fraude o abuso de confianza de cualquiera de sus empleados, sin nombrarlos uno por uno. Cubre puestos, no personas.",
  "hyperseguros-web/products/fianzas-fidelidad-individual/heading-emphasis":
    "Una fianza lleva su nombre",
  "hyperseguros-web/products/fianzas-fidelidad-individual/heading-muted":
    "Una persona maneja el dinero.",
  "hyperseguros-web/products/fianzas-fidelidad-individual/meta-description":
    "Un puesto de confianza, con nombre y apellido: robo y sustracción, fraude, abuso de confianza y complicidad, por quien sí maneja el dinero de la empresa.",
  "hyperseguros-web/products/fianzas-fidelidad-individual/meta-title":
    "Hyper - Fianza de fidelidad individual",
  "hyperseguros-web/products/fianzas-fidelidad-individual/tagline":
    "Garantiza a la empresa contra el robo, el fraude o el abuso de confianza de un empleado específico: el tesorero, el cobrador, el gerente de sucursal. Con su nombre, su puesto y su suma.",
  "hyperseguros-web/products/fianzas-judiciales-no-penales/heading-emphasis":
    "Y no acepta tu palabra",
  "hyperseguros-web/products/fianzas-judiciales-no-penales/heading-muted":
    "Un juez pide garantía.",
  "hyperseguros-web/products/fianzas-judiciales-no-penales/meta-description":
    "La garantía que pide un juez civil, familiar o de amparo: pensión alimenticia, albaceas, tutores y depositarios, y suspensión del acto reclamado.",
  "hyperseguros-web/products/fianzas-judiciales-no-penales/meta-title":
    "Hyper - Fianza judicial no penal",
  "hyperseguros-web/products/fianzas-judiciales-no-penales/tagline":
    "Garantiza las obligaciones que un juez civil, familiar, mercantil o de amparo te impone durante un juicio: pensiones alimenticias, manejo de albacea, suspensión del acto reclamado, daños por medidas cautelares. Se emite en horas, porque el plazo judicial no espera.",
  "hyperseguros-web/products/fianzas-judiciales-penales/heading-emphasis":
    "Sin vender la casa para garantizarlo",
  "hyperseguros-web/products/fianzas-judiciales-penales/heading-muted":
    "Para enfrentar el proceso en libertad.",
  "hyperseguros-web/products/fianzas-judiciales-penales/meta-description":
    "La garantía para enfrentar el proceso en libertad: garantía económica, reparación del daño y sanciones pecuniarias que ordene un juez penal.",
  "hyperseguros-web/products/fianzas-judiciales-penales/meta-title":
    "Hyper - Fianza judicial penal",
  "hyperseguros-web/products/fianzas-judiciales-penales/tagline":
    "Garantiza la libertad condicional, la reparación del daño y las sanciones económicas que un juez penal fije como medida cautelar. Se tramita de inmediato, porque en un proceso penal las horas cuentan.",
  "hyperseguros-web/products/fianzas-judiciales-viales/heading-emphasis":
    "Y no un expediente",
  "hyperseguros-web/products/fianzas-judiciales-viales/heading-muted":
    "Para que un choque siga siendo un choque.",
  "hyperseguros-web/products/fianzas-judiciales-viales/meta-description":
    "La garantía para el conductor, contratada antes del accidente: libertad del conductor, reparación del daño y sanciones pecuniarias tras un choque.",
  "hyperseguros-web/products/fianzas-judiciales-viales/meta-title":
    "Hyper - Fianza judicial vial",
  "hyperseguros-web/products/fianzas-judiciales-viales/tagline":
    "Garantiza la libertad del conductor y la reparación del daño cuando un accidente de tránsito deriva en un proceso penal. Se contrata antes, por vigencia anual, y se activa el día que hace falta.",
  "hyperseguros-web/products/fianzas-sostenimiento-de-oferta/heading-emphasis":
    "Que la fianza no sea la parte difícil",
  "hyperseguros-web/products/fianzas-sostenimiento-de-oferta/heading-muted":
    "Participar en una licitación ya cuesta.",
  "hyperseguros-web/products/fianzas-sostenimiento-de-oferta/meta-description":
    "La garantía de que tu propuesta va en serio: sostenimiento de precios y condiciones, firma del contrato y entrega de la fianza de cumplimiento.",
  "hyperseguros-web/products/fianzas-sostenimiento-de-oferta/meta-title":
    "Hyper - Fianza de sostenimiento de oferta",
  "hyperseguros-web/products/fianzas-sostenimiento-de-oferta/tagline":
    "Garantiza que, si ganas, firmarás el contrato y entregarás la fianza de cumplimiento. La tramitamos en horas, porque las convocatorias no esperan.",
  "hyperseguros-web/products/fianzas-vicios-ocultos/heading-emphasis":
    "La fianza de vicios ocultos, sí",
  "hyperseguros-web/products/fianzas-vicios-ocultos/heading-muted":
    "El acta de entrega no cierra el contrato.",
  "hyperseguros-web/products/fianzas-vicios-ocultos/meta-description":
    "La garantía de calidad después de la entrega: vicios ocultos, defectos de calidad y la reparación o reposición de lo que ya fue entregado y recibido.",
  "hyperseguros-web/products/fianzas-vicios-ocultos/meta-title":
    "Hyper - Fianza de vicios ocultos",
  "hyperseguros-web/products/fianzas-vicios-ocultos/tagline":
    "Garantiza la calidad de la obra o del bien entregado durante el plazo que fija el contrato. El cliente firma la entrega tranquilo; tú cobras el finiquito.",
  "hyperseguros-web/products/flotillas/heading-emphasis":
    "Tu póliza no debería",
  "hyperseguros-web/products/flotillas/heading-muted":
    "Tu flotilla se mueve todos los días.",
  "hyperseguros-web/products/flotillas/meta-description":
    "Todas las unidades en una póliza y un solo vencimiento: daños y robo total, responsabilidad civil, RC de la carga y cruzada, y RC en Estados Unidos.",
  "hyperseguros-web/products/flotillas/meta-title":
    "Hyper - Seguro de flotillas vehiculares",
  "hyperseguros-web/products/flotillas/tagline":
    "Una póliza para toda la flota, con altas y bajas por Hypernet, siniestralidad por unidad y RC en carretera federal desde el día uno.",
  "hyperseguros-web/products/gmm/heading-emphasis": "Y por la que nadie se va",
  "hyperseguros-web/products/gmm/heading-muted":
    "La prestación por la que sí preguntan en la entrevista.",
  "hyperseguros-web/products/gmm/meta-description":
    "El hospital privado sin la parte de la caja: hospitalización y cirugía, honorarios, estudios, medicamentos, maternidad y emergencia en el extranjero.",
  "hyperseguros-web/products/gmm/meta-title":
    "Hyper - Seguro de gastos médicos mayores (GMM)",
  "hyperseguros-web/products/gmm/tagline":
    "Red hospitalaria, pago directo y un deducible que se entiende a la primera. Lo demás es letra chica, y también la leemos.",
  "hyperseguros-web/products/huracan/heading-emphasis":
    "Solo un dato: la categoría",
  "hyperseguros-web/products/huracan/heading-muted":
    "Sin ajustador, sin inventario de daños, sin discusión.",
  "hyperseguros-web/products/huracan/meta-description":
    "Sin ajustador y sin inventario de daños: una categoría, una zona y una suma escritas en la póliza, con el pago en días tras la medición oficial.",
  "hyperseguros-web/products/huracan/meta-title":
    "Hyper - Seguro paramétrico de huracán",
  "hyperseguros-web/products/huracan/tagline":
    "Si el viento alcanza la categoría pactada en tu zona, el pago sale en días, no en meses. Para cuando la temporada todavía no termina.",
  "hyperseguros-web/products/interrupcion-de-negocio/heading-emphasis":
    "Y que entonces ya no se vende",
  "hyperseguros-web/products/interrupcion-de-negocio/heading-muted":
    "La cobertura que nadie compra hasta que la necesita.",
  "hyperseguros-web/products/interrupcion-de-negocio/meta-description":
    "Los ingresos que se detienen cuando la operación se detiene: utilidad bruta, gastos fijos y nómina, gastos extraordinarios e interrupción contingente.",
  "hyperseguros-web/products/interrupcion-de-negocio/meta-title":
    "Hyper - Seguro de interrupción de negocio",
  "hyperseguros-web/products/interrupcion-de-negocio/tagline":
    "Cubre lo que el seguro de daños no ve: los meses sin ingresos. El plazo lo definimos contigo, con calculadora y sin optimismo.",
  "hyperseguros-web/products/inundacion/heading-emphasis":
    "que no te pide fotos del daño",
  "hyperseguros-web/products/inundacion/heading-muted":
    "La única cobertura de inundación",
  "hyperseguros-web/products/inundacion/meta-description":
    "Un nivel de agua, una zona y una suma: el detonador se mide con datos oficiales de precipitación o del río y el pago llega en días, sin fotos del daño.",
  "hyperseguros-web/products/inundacion/meta-title":
    "Hyper - Seguro paramétrico de inundación",
  "hyperseguros-web/products/inundacion/tagline":
    "Cuando la lluvia o el nivel del río cruzan el umbral pactado, el pago sale. Para zonas y negocios donde el seguro tradicional de inundación cuesta demasiado o no existe.",
  "hyperseguros-web/products/maritimo/heading-emphasis":
    "Para lo que flota, lo que carga y lo que atraca",
  "hyperseguros-web/products/maritimo/heading-muted":
    "Casco, maquinaria y P&I.",
  "hyperseguros-web/products/maritimo/meta-description":
    "El buque, el armador y el puerto: casco y maquinaria, protección e indemnización (P&I), RC de puertos y operadores, y riesgos de guerra y huelgas.",
  "hyperseguros-web/products/maritimo/meta-title":
    "Hyper - Seguro marítimo: casco y P&I",
  "hyperseguros-web/products/maritimo/tagline":
    "Casco y maquinaria, protección e indemnización y responsabilidad civil de puertos y operadores. Colocado con los mercados que sí entienden de barcos.",
  "hyperseguros-web/products/medmal/heading-emphasis":
    "y aun así reciben una demanda",
  "hyperseguros-web/products/medmal/heading-muted":
    "Para hospitales y médicos que hacen todo bien",
  "hyperseguros-web/products/medmal/meta-description":
    "Para hospitales, clínicas y médicos: responsabilidad civil profesional, defensa legal, conciliación ante CONAMED, daño moral y telemedicina.",
  "hyperseguros-web/products/medmal/meta-title":
    "Hyper - Seguro de responsabilidad civil médica",
  "hyperseguros-web/products/medmal/tagline":
    "Cubre la responsabilidad civil profesional de médicos, clínicas y hospitales, con defensa legal y acompañamiento ante CONAMED. Tú atiendes pacientes; nosotros atendemos la reclamación.",
  "hyperseguros-web/products/orfandad/heading-emphasis":
    "entre ser escuela y ser cobrador",
  "hyperseguros-web/products/orfandad/heading-muted":
    "Para que un colegio no tenga que elegir",
  "hyperseguros-web/products/orfandad/meta-description":
    "Certeza educativa para el colegio y la familia: fallecimiento, invalidez total y permanente y desempleo, en modalidad individual, mancomunada o solidaria.",
  "hyperseguros-web/products/orfandad/meta-title":
    "Hyper - Seguro de orfandad para colegios",
  "hyperseguros-web/products/orfandad/tagline":
    "Nadie arma el presupuesto escolar pensando en esto. Por eso conviene dejarlo resuelto antes de que alguien tenga que pedirlo.",
  "hyperseguros-web/products/paquete-empresarial/heading-emphasis":
    "Tiene esta póliza",
  "hyperseguros-web/products/paquete-empresarial/heading-muted":
    "Para el negocio que no tiene departamento de riesgos.",
  "hyperseguros-web/products/paquete-empresarial/meta-description":
    "Un negocio, una póliza: incendio de edificio y contenidos, robo con violencia, responsabilidad civil general, cristales, dinero y equipo electrónico.",
  "hyperseguros-web/products/paquete-empresarial/meta-title":
    "Hyper - Seguro de paquete empresarial para PYMES",
  "hyperseguros-web/products/paquete-empresarial/tagline":
    "Un paquete no es un descuento: es una póliza pensada para un negocio que tiene mejores cosas que hacer que leer nueve pólizas.",
  "hyperseguros-web/products/propiedad-todo-riesgo/heading-emphasis":
    "Nosotros leemos las excepciones",
  "hyperseguros-web/products/propiedad-todo-riesgo/heading-muted":
    "Todo riesgo se llama así por una razón.",
  "hyperseguros-web/products/propiedad-todo-riesgo/meta-description":
    "Edificio, contenidos y todo lo que hay dentro: incendio y rayo, terremoto, riesgos hidrometeorológicos, robo con violencia y rotura de maquinaria.",
  "hyperseguros-web/products/propiedad-todo-riesgo/meta-title":
    "Hyper - Seguro de propiedad todo riesgo",
  "hyperseguros-web/products/propiedad-todo-riesgo/tagline":
    "En México asegurar un inmueble sin sismo ni hidrometeorológicos es asegurar la mitad. Nosotros aseguramos el edificio completo.",
  "hyperseguros-web/products/rc-ambiental/heading-emphasis":
    "La garantía, desde que la contratas",
  "hyperseguros-web/products/rc-ambiental/heading-muted":
    "La Ley Federal de Responsabilidad Ambiental existe desde 2013.",
  "hyperseguros-web/products/rc-ambiental/meta-description":
    "Por la contaminación, la limpieza y la Ley Federal de Responsabilidad Ambiental: daños a la biodiversidad, remediación, transporte y defensa legal.",
  "hyperseguros-web/products/rc-ambiental/meta-title":
    "Hyper - Seguro de responsabilidad civil ambiental",
  "hyperseguros-web/products/rc-ambiental/tagline":
    "Contaminación súbita y gradual, costos de limpieza, daños a terceros y a la biodiversidad, con defensa legal. La garantía financiera que la LFRA pide, sin adivinar cuánto.",
  "hyperseguros-web/products/rc-funcionarios-publicos/heading-emphasis":
    "Firmar un oficio, tampoco",
  "hyperseguros-web/products/rc-funcionarios-publicos/heading-muted":
    "Servir al público no debería costar el patrimonio.",
  "hyperseguros-web/products/rc-funcionarios-publicos/meta-description":
    "Para quien decide con presupuesto ajeno: responsabilidad patrimonial, defensa legal, procedimientos de responsabilidad administrativa, penal y fiscal.",
  "hyperseguros-web/products/rc-funcionarios-publicos/meta-title":
    "Hyper - RC para funcionarios públicos",
  "hyperseguros-web/products/rc-funcionarios-publicos/tagline":
    "Defensa legal y responsabilidad patrimonial para quien toma decisiones en el gobierno. Porque la Ley de Responsabilidades no viene con instructivo.",
  "hyperseguros-web/products/rc-general/heading-emphasis":
    "Hasta que uno de ellos te demanda",
  "hyperseguros-web/products/rc-general/heading-muted":
    "«Terceros» es la palabra más aburrida del seguro.",
  "hyperseguros-web/products/rc-general/meta-description":
    "Por lo que tu operación le cause a los demás: RC de actividades e inmuebles, productos, patronal, contractual, arrendatario y contaminación súbita.",
  "hyperseguros-web/products/rc-general/meta-title":
    "Hyper - Seguro de responsabilidad civil general",
  "hyperseguros-web/products/rc-general/tagline":
    "Cubre lo que tu operación le pueda causar a la gente y a los bienes de otros, y paga la defensa cuando alguien decide que fue tu culpa.",
  "hyperseguros-web/products/rc-producto-y-retiro/heading-emphasis":
    "Cuesta como una crisis",
  "hyperseguros-web/products/rc-producto-y-retiro/heading-muted":
    "«Retiro voluntario de producto» suena a trámite.",
  "hyperseguros-web/products/rc-producto-y-retiro/meta-description":
    "Por lo que tu producto cause y por lo que cuesta retirarlo: daños a terceros, productos exportados, gastos de retiro y pérdida de utilidades.",
  "hyperseguros-web/products/rc-producto-y-retiro/meta-title":
    "Hyper - RC de producto y retiro del mercado",
  "hyperseguros-web/products/rc-producto-y-retiro/tagline":
    "Cubre lo que tu producto le cause a alguien y lo que cuesta sacarlo de los anaqueles. Alimentos, autopartes, cosméticos, farma: todo lo que lleva lote.",
  "hyperseguros-web/products/rc-profesional/heading-emphasis":
    "Pero nadie firma un contrato grande sin ella",
  "hyperseguros-web/products/rc-profesional/heading-muted":
    "Nadie contrata a un despacho por su póliza de RC.",
  "hyperseguros-web/products/rc-profesional/meta-description":
    "Por lo que aconsejas, calculas y firmas: errores, omisiones y negligencia, defensa legal y pérdida de documentos, para despachos y profesionistas.",
  "hyperseguros-web/products/rc-profesional/meta-title":
    "Hyper - Seguro de responsabilidad civil profesional",
  "hyperseguros-web/products/rc-profesional/tagline":
    "Para quienes viven de dar consejos, dictámenes y planos. Cuando el cliente dice que el consejo salió caro, esta póliza paga la conversación.",
  "hyperseguros-web/products/riesgo-politico/heading-emphasis":
    "Que el gobierno de allá no la cambie",
  "hyperseguros-web/products/riesgo-politico/heading-muted":
    "Invertir fuera es una decisión de negocio.",
  "hyperseguros-web/products/riesgo-politico/meta-description":
    "Para cuando el que cambia las reglas es el gobierno: expropiación, inconvertibilidad, violencia política e incumplimiento de contrato gubernamental.",
  "hyperseguros-web/products/riesgo-politico/meta-title":
    "Hyper - Seguro de riesgo político",
  "hyperseguros-web/products/riesgo-politico/tagline":
    "Protege inversiones, contratos y financiamientos frente a expropiación, restricciones cambiarias, violencia política e incumplimientos de gobierno. Para cuando la política deja de ser una noticia y se vuelve un siniestro.",
  "hyperseguros-web/products/salud-indemnizatorios/heading-emphasis":
    "y no te pregunta en qué lo gastas",
  "hyperseguros-web/products/salud-indemnizatorios/heading-muted":
    "Un seguro médico que te da el dinero",
  "hyperseguros-web/products/salud-indemnizatorios/meta-description":
    "Al diagnóstico, una suma fija que tú decides en qué gastar: lista cerrada de padecimientos graves, cirugías frecuentes, emergencias y traumatismos.",
  "hyperseguros-web/products/salud-indemnizatorios/meta-title":
    "Hyper - Seguro médico indemnizatorio",
  "hyperseguros-web/products/salud-indemnizatorios/tagline":
    "Al diagnóstico, una suma fija en tu cuenta. Hospital público o privado, tú decides. Nosotros no opinamos.",
  "hyperseguros-web/products/seguro-de-salud/heading-emphasis":
    "Para que siga sin pasar",
  "hyperseguros-web/products/seguro-de-salud/heading-muted":
    "El seguro que se usa cuando no pasa nada.",
  "hyperseguros-web/products/seguro-de-salud/meta-description":
    "Consultas, laboratorio y chequeos sin esperar a la emergencia: medicina preventiva, urgencias de primer contacto, medicamentos, dental y visión.",
  "hyperseguros-web/products/seguro-de-salud/meta-title":
    "Hyper - Seguro de salud y medicina preventiva",
  "hyperseguros-web/products/seguro-de-salud/tagline":
    "Consultas, laboratorio y medicina preventiva con red propia. Es el seguro que tu equipo usa cada mes, no cada crisis.",
  "hyperseguros-web/products/srcc/heading-emphasis":
    "La exclusión que tu póliza de daños trae de fábrica",
  "hyperseguros-web/products/srcc/heading-muted":
    "Bloqueos, saqueos, disturbios.",
  "hyperseguros-web/products/srcc/meta-description":
    "La exclusión que tu póliza de daños trae de fábrica: huelgas y paros, motines, vandalismo, bloqueos, terrorismo y las pérdidas consecuenciales.",
  "hyperseguros-web/products/srcc/meta-title":
    "Hyper - Seguro SRCC: huelgas, motines y disturbios",
  "hyperseguros-web/products/srcc/tagline":
    "Huelgas, motines, saqueos y actos malintencionados, cubiertos como extensión o póliza independiente. Una exclusión menos en tu programa de daños.",
  "hyperseguros-web/products/terremoto/heading-emphasis":
    "Porque no hay ajustador",
  "hyperseguros-web/products/terremoto/heading-muted":
    "El único seguro de sismo que no discute con el ajustador.",
  "hyperseguros-web/products/terremoto/meta-description":
    "Una magnitud, una distancia y una suma: el pago se detona con la medición oficial del sismo y llega en días, sin ajustador y sin inventario de daños.",
  "hyperseguros-web/products/terremoto/meta-title":
    "Hyper - Seguro paramétrico de terremoto",
  "hyperseguros-web/products/terremoto/tagline":
    "Magnitud, profundidad y distancia al epicentro definen el pago; el Servicio Sismológico lo confirma. Liquidez en días para reconstruir mientras el seguro tradicional apenas empieza a ajustar.",
  "hyperseguros-web/products/vida-grupo/heading-emphasis":
    "pero siempre agradece tener",
  "hyperseguros-web/products/vida-grupo/heading-muted":
    "La prestación que tu equipo no pidió,",
  "hyperseguros-web/products/vida-grupo/meta-description":
    "La prestación que sostiene a la plantilla: fallecimiento, gastos funerarios, pérdidas orgánicas, invalidez total y permanente y graves enfermedades.",
  "hyperseguros-web/products/vida-grupo/meta-title":
    "Hyper - Seguro de vida grupo para empresas",
  "hyperseguros-web/products/vida-grupo/tagline":
    "Sabemos que no es el tema más ameno de la junta. Pero es el que tu equipo recuerda cuando importa.",
  "hyperseguros-web/programs/asesoria-externa-en-materias-de-seguros/heading-emphasis":
    "Que sea alguien que entiende de seguros",
  "hyperseguros-web/programs/asesoria-externa-en-materias-de-seguros/heading-muted":
    "Las bases de licitación las escribe alguien.",
  "hyperseguros-web/programs/asesoria-externa-en-materias-de-seguros/meta-description":
    "Diagnóstico, bases de licitación, evaluación de propuestas y administración del programa, para dependencias, estados, municipios y organismos públicos.",
  "hyperseguros-web/programs/asesoria-externa-en-materias-de-seguros/meta-title":
    "Hyper - Asesoría externa en materia de seguros",
  "hyperseguros-web/programs/asesoria-externa-en-materias-de-seguros/tagline":
    "Diagnóstico del programa de aseguramiento, bases de licitación, evaluación de propuestas, administración de pólizas y siniestros para dependencias, estados y municipios. Registrados ante la CNSF como asesor externo, contratados por licitación.",
  "hyperseguros-web/programs/bankers-blanket-bond/heading-emphasis":
    "y casi ningún consejo ha leído",
  "hyperseguros-web/programs/bankers-blanket-bond/heading-muted":
    "El seguro que todo banco tiene",
  "hyperseguros-web/programs/bankers-blanket-bond/meta-description":
    "La póliza global de fidelidad bancaria, módulo por módulo: para bancos, SOFOMes, SOFIPOs, casas de bolsa, fintechs y transportadoras de valores.",
  "hyperseguros-web/programs/bankers-blanket-bond/meta-title":
    "Hyper - Bankers Blanket Bond (BBB) en México",
  "hyperseguros-web/programs/bankers-blanket-bond/tagline":
    "Infidelidad de empleados, dinero en local y en tránsito, falsificación, fraude informático y responsabilidad profesional en un programa para bancos, SOFOMes, cajas y fintechs. Con los módulos que CNBV espera y los que la operación necesita.",
  "hyperseguros-web/programs/beneficios-para-empleados/heading-emphasis":
    "Un programa que Recursos Humanos sí puede explicar",
  "hyperseguros-web/programs/beneficios-para-empleados/heading-muted":
    "Vida, gastos médicos y accidentes.",
  "hyperseguros-web/programs/beneficios-para-empleados/meta-description":
    "Vida, gastos médicos y accidentes en un solo programa, con una junta y un layout: para empresas medianas y grandes, PyMEs, corporativos y despachos.",
  "hyperseguros-web/programs/beneficios-para-empleados/meta-title":
    "Hyper - Programa de beneficios para empleados",
  "hyperseguros-web/programs/beneficios-para-empleados/tagline":
    "Vida Grupo, GMM, accidentes e indemnizatorios diseñados como un solo programa, con una renovación, un layout y un solo interlocutor. Lo que el equipo recuerda cuando importa, sin que RH tenga que recordarlo.",
  "hyperseguros-web/programs/polizas-patrimoniales/heading-emphasis":
    "Solo que por licitación",
  "hyperseguros-web/programs/polizas-patrimoniales/heading-muted":
    "Los bienes de la nación también se aseguran.",
  "hyperseguros-web/programs/polizas-patrimoniales/meta-description":
    "Los bienes públicos en un programa integral con inventario real: dependencias federales, gobiernos estatales, municipios y organismos de agua.",
  "hyperseguros-web/programs/polizas-patrimoniales/meta-title":
    "Hyper - Pólizas patrimoniales para el sector público",
  "hyperseguros-web/programs/polizas-patrimoniales/tagline":
    "Inmuebles, contenidos, flotas, equipo, infraestructura y responsabilidad civil de dependencias, estados y municipios en un programa integral con reaseguro. Diseñado con el inventario real y licitado con bases que las aseguradoras pueden cotizar.",
  "hyperseguros-web/programs/seguro-de-vida-institucional/heading-emphasis":
    "Y que se licita cada año como si fuera nueva",
  "hyperseguros-web/programs/seguro-de-vida-institucional/heading-muted":
    "La prestación que el contrato colectivo exige.",
  "hyperseguros-web/programs/seguro-de-vida-institucional/meta-description":
    "La prestación de vida para servidores públicos, licitada y operada cada año: dependencias, estados, municipios, organismos y empresas del Estado.",
  "hyperseguros-web/programs/seguro-de-vida-institucional/meta-title":
    "Hyper - Seguro de vida institucional",
  "hyperseguros-web/programs/seguro-de-vida-institucional/tagline":
    "Vida colectiva para servidores públicos con las sumas, coberturas y beneficiarios que marcan la ley y el contrato colectivo. Bases que sí se pueden evaluar, layouts que sí se pueden cargar y siniestros que sí se pagan.",
  "hyperseguros-web/programs/seguro-escolar-integral/heading-emphasis":
    "Un solo programa para toda la escuela",
  "hyperseguros-web/programs/seguro-escolar-integral/heading-muted":
    "Del recreo al consejo directivo.",
  "hyperseguros-web/programs/seguro-escolar-integral/meta-description":
    "Alumnos, familias, plantel y personal en un solo programa: colegios privados, universidades, guarderías, redes educativas y escuelas deportivas.",
  "hyperseguros-web/programs/seguro-escolar-integral/meta-title":
    "Hyper - Seguro escolar integral",
  "hyperseguros-web/programs/seguro-escolar-integral/tagline":
    "Accidentes escolares, orfandad, RC del plantel, daños al inmueble y beneficios para maestros, armados para que la escuela los explique en una junta de padres y los opere con un layout.",
  "hyperseguros-web/programs/seguros-parametricos/heading-emphasis":
    "El pago paramétrico, no",
  "hyperseguros-web/programs/seguros-parametricos/heading-muted":
    "Después del huracán, la declaratoria tarda.",
  "hyperseguros-web/programs/seguros-parametricos/meta-description":
    "Huracán, terremoto e inundación con pago en días para estados y municipios: la liquidez que llega antes que la declaratoria de emergencia federal.",
  "hyperseguros-web/programs/seguros-parametricos/meta-title":
    "Hyper - Programa de seguros paramétricos",
  "hyperseguros-web/programs/seguros-parametricos/tagline":
    "Huracán, terremoto e inundación con detonadores públicos y pago en días, para estados y municipios que necesitan liquidez antes de la declaratoria. El mismo mecanismo que usa el seguro catastrófico federal, a la escala del presupuesto local.",
  "hyperseguros-web/programs/stock-throughput/heading-emphasis":
    "Esta póliza tampoco necesita saberlo",
  "hyperseguros-web/programs/stock-throughput/heading-muted":
    "Tu inventario no sabe si está en tránsito o en bodega.",
  "hyperseguros-web/programs/stock-throughput/meta-description":
    "Una sola póliza para el inventario, de la materia prima al punto de venta: fabricantes, distribuidores, retailers, importadores y operadores logísticos.",
  "hyperseguros-web/programs/stock-throughput/meta-title":
    "Hyper - Stock Throughput: inventario y tránsito",
  "hyperseguros-web/programs/stock-throughput/tagline":
    "Una sola póliza para la mercancía desde la materia prima hasta el punto de venta: en planta, en tránsito, en almacén propio o de terceros. Sin huecos entre la póliza de carga y la de daños, y a valor de venta.",
  "hyperseguros-web/wholesale/heading-emphasis": "Nosotros somos ese trabajo",
  "hyperseguros-web/wholesale/heading-muted":
    "Entre tú y la aseguradora hay mucho trabajo.",
  "hyperseguros-web/wholesale/tagline":
    "Un wholesale es lo que pasa cuando alguien decide que operar seguros también merecía hacerse bien.",
  "legal-limit-exceeded": "Límite de Responsabilidad Civil excedido",
  "legal-limit-exceeded-description":
    "El límite de todas las coberturas de Responsabilidad Civil no pueden exceder USD $ 5,000,000, verifique la información e intente de nuevo.",
  "mock-error": "mock-error",
  "mock/error-message-string": "mock/error-message-string",
  "mock/error-name": "mock/error-name",
  "not-authorized": "No Autorizado",
  "not-authorized-to-create-object":
    "No tienes permiso para guardar esta información. Si necesitas acceso, contacta a tu administrador. (Ref.: {{modelName}})",
  "not-authorized-to-delete-object":
    "No tienes permiso para eliminar esta información. Si necesitas acceso, contacta a tu administrador. (Ref.: {{modelName}})",
  "not-authorized-to-list-object":
    "No tienes permiso para ver esta información. Si necesitas acceso, contacta a tu administrador. (Ref.: {{modelName}})",
  "not-authorized-to-read-object":
    "No tienes permiso para consultar esta información. Si necesitas acceso, contacta a tu administrador. (Ref.: {{modelName}})",
  "not-authorized-to-update-object":
    "No tienes permiso para actualizar esta información. Si necesitas acceso, contacta a tu administrador. (Ref.: {{modelName}})",
  "notifications/agency-admin-missing/body":
    "Se dio de baja a un usuario y {{openCases}} caso(s) abierto(s) no pudieron traspasarse porque su agencia no tiene una dirección activa.\n\nAsigna cada caso a un solicitante de la agencia desde la pantalla del caso.",
  "notifications/agency-admin-missing/subject":
    "Casos sin dirección de agencia tras una baja de usuario",
  "notifications/agency-admin-missing/summary":
    "{{openCases}} caso(s) abierto(s) de un usuario dado de baja quedaron sin cambio.",
  "notifications/agency-admin-missing/title": "Casos sin dirección de agencia",
  "notifications/catalogue-update-failed/body":
    "La actualización de los años modelo {{fromYear}} a {{toYear}} falló: {{failedPortions}} de {{totalPortions}} partes no se completaron. Las versiones existentes y su disponibilidad no cambiaron.\n\nAbre Actualizaciones en el portal para ver el detalle y vuelve a intentarlo.",
  "notifications/catalogue-update-failed/subject":
    "Falló la actualización del catálogo de vehículos ({{fromYear}}-{{toYear}})",
  "notifications/catalogue-update-failed/summary":
    "Ninguna parte de la actualización se completó (fallaron {{failedPortions}} de {{totalPortions}}).",
  "notifications/catalogue-update-failed/title":
    "Falló la actualización del catálogo de vehículos",
  "notifications/catalogue-update-partial/body":
    "La actualización de los años modelo {{fromYear}} a {{toYear}} tuvo un resultado parcial: {{failedPortions}} de {{totalPortions}} partes no se completaron y el resto se guardó ({{new}} versiones nuevas y {{updated}} actualizadas).\n\nAbre Actualizaciones en el portal para ver qué partes fallaron y vuelve a ejecutar esos años.",
  "notifications/catalogue-update-partial/subject":
    "Actualización del catálogo de vehículos: resultado parcial ({{fromYear}}-{{toYear}})",
  "notifications/catalogue-update-partial/summary":
    "Fallaron {{failedPortions}} de {{totalPortions}} partes; se guardaron {{new}} versiones nuevas y {{updated}} actualizadas.",
  "notifications/catalogue-update-partial/title":
    "Actualización del catálogo de vehículos: resultado parcial",
  "notifications/catalogue-update-succeeded/body":
    "La actualización de los años modelo {{fromYear}} a {{toYear}} terminó correctamente. Versiones nuevas: {{new}}. Versiones actualizadas: {{updated}}. De ellas, {{pending}} esperan la normalización de nombres. Excluidas a propósito: {{excluded}}. Sin regla aplicable: {{unclassified}}.\n\nInicia sesión en el portal y abre Notificaciones.",
  "notifications/catalogue-update-succeeded/subject":
    "Actualización del catálogo de vehículos completada ({{fromYear}}-{{toYear}})",
  "notifications/catalogue-update-succeeded/summary":
    "{{new}} versiones nuevas y {{updated}} actualizadas, {{pending}} pendientes de normalizar.",
  "notifications/catalogue-update-succeeded/title":
    "Actualización del catálogo de vehículos completada",
  "notifications/login-email-changed/body":
    "Un administrador cambió el correo de inicio de sesión de tu cuenta. Si no lo esperabas, contacta a tu administrador.",
  "notifications/login-email-changed/subject":
    "Se cambió tu correo de inicio de sesión",
  "policy/requester": "Solicitante",
  "portal/account": "Cliente",
  "portal/account-is-required":
    "Es necesario indicar la cuenta a la que pertenece la póliza",
  "portal/account-users": "Usuarios del cliente",
  "portal/accounts": "Clientes",
  "portal/add": "Agregar",
  "portal/add-aircraft": "Agregar Aeronave",
  "portal/add-commission-table": "Agregar Tabla de Comisión",
  "portal/add-condition": "Agregar Condición",
  "portal/add-entry": "Agregar Entrada",
  "portal/add-file": "Agregar Archivo",
  "portal/add-line-of-business": "Agregar Línea de Negocio",
  "portal/add-lob": "Agregar Ramo",
  "portal/add-pipeline": "Agregar Pipeline",
  "portal/add-pipeline-step": "Agregar Paso de Pipeline",
  "portal/add-proposal": "Agregar Propuesta",
  "portal/add-rate-table": "Agregar Tabla de Tarifas",
  "portal/add-rate-table-entry": "Agregar Entrada de Tabla de Tarifas",
  "portal/add-step": "Agregar Paso",
  "portal/add-step-condition": "Agregar Condición de Paso",
  "portal/add-variable": "Agregar Variable",
  "portal/address": "Dirección",
  "portal/address/address-is-required":
    "Es necesario seleccionar una dirección",
  "portal/address/apt-suite": "No. Interior",
  "portal/address/existing-address": "Dirección Existente",
  "portal/address/neighboorhood": "Colonia",
  "portal/address/neighborhood-is-required": "Es necesario la colonia",
  "portal/address/new-address": "Nueva Dirección",
  "portal/address/new-or-existing": "Dirección Nueva o Existente",
  "portal/address/new-or-existing-is-required":
    "Es necesario indicar si la dirección es nueva o existente",
  "portal/address/street-name": "Calle",
  "portal/address/street-name-is-required": "Es necesario la calle",
  "portal/address/street-number": "No. Exterior",
  "portal/address/street-number-is-required": "Es necesario el número de calle",
  "portal/address/zipcode": "Código Postal",
  "portal/address/zipcode-is-required": "Es necesario el código postal",
  "portal/addresses": "Direcciones",
  "portal/agencies": "Agencias",
  "portal/agencies/add-commission-table": "Agregar Tabla",
  "portal/agencies/all": "Todas las Agencias",
  "portal/agencies/edit-commission-table": "Modificar Tabla",
  "portal/agencies/level-1-agency": "Agencia Nivel 1",
  "portal/agencies/level-1-agency-commission": "Comisión Agencia Nivel 1",
  "portal/agencies/level-2-agency": "Agencia Nivel 2",
  "portal/agencies/level-2-agency-commission": "Comisión Agencia Nivel 2",
  "portal/agencies/level-3-agency": "Agencia Nivel 3",
  "portal/agencies/level-3-agency-commission": "Comisión Agencia Nivel 3",
  "portal/agencies/promoter": "Promotor",
  "portal/agencies/promoter-commission": "Comisión Promotor",
  "portal/agencies/regional": "Regional",
  "portal/agencies/regional-commission": "Comisión Regional",
  "portal/agency": "Agencia",
  "portal/agency-is-required":
    "Es necesario indicar la agencia a la que pertenece la póliza",
  "portal/agency-level": "Nivel de Agencia",
  "portal/agency-level-agency1": "Agencia Nivel 1",
  "portal/agency-level-agency2": "Agencia Nivel 2",
  "portal/agency-level-agency3": "Agencia Nivel 3",
  "portal/agency-level-promoter": "Promotoría",
  "portal/agency-level-regional": "Regional",
  "portal/agency-users": "Usuarios de la agencia",
  "portal/agency/add-agent-key": "Agregar clave de agente",
  "portal/agency/add-commission-table": "Agregar tabla de comisiones",
  "portal/agency/add-participation": "Agregar participación",
  "portal/agency/add-sub-agency": "Agregar Sub-agencia",
  "portal/agency/create-sub-agency": "Crear Sub-agencia",
  "portal/agency/edit-alias": "Editar alias",
  "portal/agency/general/agent-keys": "Claves de agente",
  "portal/agency/general/all-insurers": "Todas las aseguradoras",
  "portal/agency/general/by-office": "Por oficina",
  "portal/agency/general/chain": "Cadena",
  "portal/agency/general/commercial-name": "Nombre comercial",
  "portal/agency/general/contact": "Contacto y constitución",
  "portal/agency/general/country": "País",
  "portal/agency/general/email": "Correo electrónico",
  "portal/agency/general/entity-id": "Identificador de entidad",
  "portal/agency/general/incorporation-date": "Fecha de constitución",
  "portal/agency/general/legal-entity": "Razón social",
  "portal/agency/general/legal-person": "Persona moral",
  "portal/agency/general/level": "Nivel",
  "portal/agency/general/mobile": "Celular",
  "portal/agency/general/natural-person": "Persona física",
  "portal/agency/general/no-expiry": "Sin vencimiento",
  "portal/agency/general/no-key-captured": "Sin clave capturada",
  "portal/agency/general/no-own-keys": "Sin claves propias",
  "portal/agency/general/no-own-keys-house":
    "Sin claves propias · usa las claves de {{house}}",
  "portal/agency/general/offices": "Oficinas",
  "portal/agency/general/parent-agency": "Agencia superior",
  "portal/agency/general/pending": "Por confirmar",
  "portal/agency/general/person-type": "Tipo de persona",
  "portal/agency/general/positions": "Posiciones",
  "portal/agency/general/shared-with": "Compartida con {{names}}",
  "portal/agency/general/validity": "Vigencia: {{from}} – {{to}}",
  "portal/agency/keys": "Claves",
  "portal/agency/keys/actions": "Acciones de la clave",
  "portal/agency/keys/edit": "Editar clave",
  "portal/agency/keys/empty-body-house":
    "Coloca negocio con las claves de {{house}}.",
  "portal/agency/keys/empty-body-house-keys":
    "Coloca negocio con las claves de {{house}} ({{keys}}).",
  "portal/agency/keys/empty-title": "Sin claves propias",
  "portal/agency/keys/history": "Historial",
  "portal/agency/keys/own": "Propia",
  "portal/agency/keys/retire": "Dar de baja",
  "portal/agency/keys/retire-message":
    "La clave deja de estar vigente desde hoy para {{nodes}}. Las pólizas emitidas conservan la clave con la que se emitieron.",
  "portal/agency/keys/retire-message-no-nodes":
    "La clave deja de estar vigente desde hoy. Las pólizas emitidas conservan la clave con la que se emitieron.",
  "portal/agency/keys/retire-title": "Dar de baja la clave {{code}}",
  "portal/agency/keys/shared": "Compartida",
  "portal/agency/keys/valid-between": "Vigente del {{from}} al {{to}}",
  "portal/agency/keys/valid-since": "Vigente desde {{from}}",
  "portal/agency/legal-entity": "Entidad legal",
  "portal/agency/parent-not-found": "Agencia padre no encontrada",
  "portal/agency/parents": "Padres",
  "portal/agency/positions-one": "1 posición",
  "portal/agency/positions-other": "{{count}} posiciones",
  "portal/agency/program": "Programa",
  "portal/agency/reparent-participation": "Cambiar padres",
  "portal/agency/shared-participation": "Compartida",
  "portal/agency/sheet/alias-hint":
    "Opcional · el nombre con que se muestra en la lista",
  "portal/agency/sheet/legal-entity-required":
    "Elige una razón social o agrega una nueva",
  "portal/agency/sheet/level-required": "El nivel es obligatorio",
  "portal/agency/sheet/new-legal-name": "Nueva razón social",
  "portal/agency/sheet/position": "Posición",
  "portal/agency/structure": "Estructura",
  "portal/agency/structure/empty":
    "Esta agencia no tiene posición en la estructura",
  "portal/agency/structure/this-agency": "Esta agencia",
  "portal/agency/structure/tree": "Árbol de la estructura",
  "portal/agent-key/assigned-to": "Asignada a",
  "portal/agent-key/assigned-to-hint":
    "Posiciones del titular. Una clave puede asignarse a varias.",
  "portal/agent-key/code": "Clave",
  "portal/agent-key/conflict":
    "{{node}} ya tiene la clave {{code}} vigente en {{insurer}}",
  "portal/agent-key/edit": "Editar clave de agente",
  "portal/agent-key/holder": "Titular",
  "portal/agent-key/insurer": "Aseguradora",
  "portal/agent-key/key-group": "Clave",
  "portal/agent-key/new": "Nueva clave de agente",
  "portal/agent-key/required": "Obligatorio",
  "portal/agent-key/valid-from": "Vigencia desde",
  "portal/agent-key/valid-to": "Vigencia hasta",
  "portal/agents": "Agentes",
  "portal/agents/laipo/actions/approve": "Aprobar",
  "portal/agents/laipo/actions/archive": "Archivar",
  "portal/agents/laipo/actions/cancel": "Cancelar",
  "portal/agents/laipo/actions/edit": "Editar",
  "portal/agents/laipo/actions/escalate": "Escalar",
  "portal/agents/laipo/actions/followup": "Seguimiento",
  "portal/agents/laipo/actions/refresh": "Actualizar",
  "portal/agents/laipo/actions/reject": "Rechazar",
  "portal/agents/laipo/actions/save-and-review": "Guardar y revisar",
  "portal/agents/laipo/actions/send": "Enviar",
  "portal/agents/laipo/archived": "Archivado",
  "portal/agents/laipo/card/already-on-thread": "Ya en el hilo",
  "portal/agents/laipo/card/applied-knowledge": "Conocimiento aplicado",
  "portal/agents/laipo/card/brief": "Resumen",
  "portal/agents/laipo/card/draft": "Borrador",
  "portal/agents/laipo/card/from": "De",
  "portal/agents/laipo/card/intent": "Intención propuesta",
  "portal/agents/laipo/card/matched-rule": "Regla aplicada",
  "portal/agents/laipo/card/subject": "Asunto",
  "portal/agents/laipo/chat/counter": "{{count}} / {{max}}",
  "portal/agents/laipo/chat/empty":
    "Enséñale a Laipo cómo manejar este caso y lo recordará para la próxima.",
  "portal/agents/laipo/chat/failed":
    "Laipo no pudo responder. Toca Reintentar para intentar otra vez.",
  "portal/agents/laipo/chat/laipo": "Laipo",
  "portal/agents/laipo/chat/placeholder":
    "Cuéntale a Laipo cómo manejar este caso…",
  "portal/agents/laipo/chat/retry": "Reintentar",
  "portal/agents/laipo/chat/send": "Enviar",
  "portal/agents/laipo/chat/title": "Chatea con Laipo",
  "portal/agents/laipo/chat/you": "Tú",
  "portal/agents/laipo/delegated": "Delegado",
  "portal/agents/laipo/escalated": "Escalado",
  "portal/agents/laipo/followup": "Marcado para seguimiento",
  "portal/agents/laipo/followup/1-week": "En 1 semana",
  "portal/agents/laipo/followup/3-days": "En 3 días",
  "portal/agents/laipo/followup/custom": "Fecha personalizada",
  "portal/agents/laipo/followup/submit": "Aceptar",
  "portal/agents/laipo/followup/tomorrow": "Mañana",
  "portal/agents/laipo/new": "Nuevo",
  "portal/agents/laipo/rejected": "Rechazado",
  "portal/agents/laipo/resolver": "Responsable",
  "portal/agents/laipo/teach": "Enseñar a Laipo",
  "portal/agents/laipo/teach/just-absorbed": "Aprendido",
  "portal/agents/laipo/teach/recent-title": "Recién aprendido",
  "portal/agents/laipo/teach/submit": "Enseñar",
  "portal/agents/laipo/teach/textarea-placeholder":
    "Cuéntale a Laipo algo que debería saber…",
  "portal/agents/laipo/teach/title": "Enseñar a Laipo",
  "portal/agents/not-found": "Agente no encontrado",
  "portal/aggregation-strategy": "Estrategia de Agregación",
  "portal/aircraft-brands": "Marcas de Aeronaves",
  "portal/aircraft-usages": "Usos de aeronaves",
  "portal/aircraft-usages-is-required":
    "Debe seleccionar al menos un uso de aeronave",
  "portal/all-policies": "Todas las Pólizas",
  "portal/all-rights-reserved": "Todos los derechos reservados",
  "portal/appearance/auto": "Automático",
  "portal/appearance/close": "Cerrar",
  "portal/appearance/dark": "Oscuro",
  "portal/appearance/light": "Claro",
  "portal/appearance/save-error":
    "No se pudo guardar tu preferencia de apariencia. Intenta de nuevo.",
  "portal/appearance/title": "Apariencia",
  "portal/assign-role": "Asignar Rol",
  "portal/audit-trail/action/catalogue-entry-availability-changed":
    "Disponibilidad modificada",
  "portal/audit-trail/action/catalogue-mapping-normalized":
    "Fila del diccionario normalizada",
  "portal/audit-trail/action/catalogue-update-started":
    "Actualización iniciada",
  "portal/audit-trail/after": "Después",
  "portal/audit-trail/before": "Antes",
  "portal/audit-trail/empty": "Sin cambios registrados.",
  "portal/audit-trail/load-error": "No se pudo cargar el historial.",
  "portal/audit-trail/title": "Historial",
  "portal/authentication/change-password-instructions":
    "Debes establecer una nueva contraseña para continuar.",
  "portal/authentication/change-user": "Cambiar Usuario",
  "portal/authentication/click-continue-to-sign-in":
    "Presiona Continuar para iniciar sesión en tu cuenta.",
  "portal/authentication/code-delivery-failed":
    "No pudimos enviar el código de acceso a tu correo. Por favor contacta a soporte.",
  "portal/authentication/confirm-new-password": "Confirmar Nueva Contraseña",
  "portal/authentication/confirm-new-password-is-required":
    "Es necesario confirmar la contraseña",
  "portal/authentication/expired-code":
    "El código de verificación ha expirado. Por favor, solicita uno nuevo.",
  "portal/authentication/forgot-password": "Olvidé mi Contraseña",
  "portal/authentication/forgot-password-reset-instructions":
    "Ingresa el código de verificación y tu nueva contraseña.",
  "portal/authentication/generic-error":
    "Algo salió mal. Por favor, intenta de nuevo.",
  "portal/authentication/invalid-code":
    "El código de verificación no es válido.",
  "portal/authentication/invalid-new-password":
    "La nueva contraseña no cumple con los requisitos.",
  "portal/authentication/network-error":
    "No se pudo conectar. Verifica tu conexión e intenta de nuevo.",
  "portal/authentication/new-password": "Nueva Contraseña",
  "portal/authentication/new-password-is-required":
    "Es necesario introducir una nueva contraseña",
  "portal/authentication/otp": "Código de Verificación",
  "portal/authentication/otp-expired":
    "El código de verificación ha expirado. Por favor, solicita uno nuevo.",
  "portal/authentication/otp-instructions":
    "Ingresa el código de verificación que se envió a tu correo electrónico.",
  "portal/authentication/otp-invalid":
    "El código de verificación no es válido. Por favor, intenta de nuevo.",
  "portal/authentication/otp-is-required":
    "Es necesario ingresar el código quue te enviamos.",
  "portal/authentication/otp-session-expired":
    "Tu código expiró. Te enviamos un código nuevo a tu correo.",
  "portal/authentication/otp-title": "Código de verificación",
  "portal/authentication/otp-verification-failed":
    "La verificación falló. Por favor, intenta de nuevo.",
  "portal/authentication/password": "Contraseña",
  "portal/authentication/password-at-least-1-lowercase":
    "Al menos 1 letra minúscula",
  "portal/authentication/password-at-least-1-number": "Al menos 1 número",
  "portal/authentication/password-at-least-1-special-character":
    "Al menos 1 caracter especial",
  "portal/authentication/password-at-least-1-uppercase":
    "Al menos 1 letra mayúscula",
  "portal/authentication/password-at-least-8-characters":
    "Al menos 8 caracteres",
  "portal/authentication/password-change-failed":
    "No se pudo cambiar la contraseña. Por favor, intenta de nuevo.",
  "portal/authentication/password-is-invalid":
    "La contraseña proporcionada no es válida",
  "portal/authentication/password-is-required":
    "Es necesario introducir una contraseña",
  "portal/authentication/password-must-be-changed":
    "Debes cambiar tu contraseña",
  "portal/authentication/password-reset-failed":
    "No se pudo restablecer la contraseña. Por favor, intenta de nuevo.",
  "portal/authentication/passwords-do-not-match":
    "Las contraseñas no coinciden",
  "portal/authentication/resend-code": "Reenviar Código",
  "portal/authentication/resend-code-countdown":
    "Reenviar Código ({{countdown}})",
  "portal/authentication/resend-code-failed":
    "No se pudo reenviar el código. Por favor, intenta de nuevo.",
  "portal/authentication/resend-code-sent":
    "Se ha enviado un nuevo código a tu correo electrónico.",
  "portal/authentication/reset-password-title": "Restablecer contraseña",
  "portal/authentication/session-error":
    "No se pudo cargar tu sesión. Por favor, intenta de nuevo.",
  "portal/authentication/session-expired":
    "Tu sesión expiró. Vuelve a iniciar sesión.",
  "portal/authentication/sso-redirect-message":
    "Haz clic en Continuar para iniciar sesión con el proveedor de identidad de tu organización.",
  "portal/authentication/sso-title": "Inicio de sesión único",
  "portal/authentication/too-many-attempts":
    "Demasiados intentos. Por favor, espera un momento e intenta de nuevo.",
  "portal/authentication/use-your-account": "Usa tu cuenta de {{DisplayName}}",
  "portal/authentication/user-not-confirmed":
    "Tu cuenta no está confirmada. Por favor, revisa tu correo electrónico.",
  "portal/authentication/user-not-registred":
    "No existe un usuario registrado con la dirección de correo electrónico proporcionada",
  "portal/authentication/verification-code": "Código de Verificación",
  "portal/authentication/verification-code-is-required":
    "Es necesario ingresar el código de verificación",
  "portal/authentication/welcome-back": "Hola de nuevo",
  "portal/authentication/welcome-back-female": "Bienvenida de nuevo",
  "portal/authentication/welcome-back-male": "Bienvenido de nuevo",
  "portal/autos/brands": "Marcas",
  "portal/autos/dictionary": "Diccionario",
  "portal/autos/group": "Autos",
  "portal/autos/models": "Modelos",
  "portal/autos/updates": "Actualizaciones",
  "portal/autos/versions": "Versiones",
  "portal/back": "Regresar",
  "portal/businesses": "Negocios",
  "portal/cancelled-policies": "Cancelado",
  "portal/catalogue-admin/filters": "Filtros",
  "portal/catalogue-admin/in-catalogue": "En el catálogo",
  "portal/catalogue-admin/no-results": "No se encontraron resultados.",
  "portal/catalogue-admin/normalized": "Normalizada",
  "portal/catalogue-admin/retry": "Reintentar",
  "portal/catalogue-admin/section-origin": "Origen",
  "portal/catalogue-admin/status": "Estado",
  "portal/catalogue-admin/system-actor": "Actualización automática",
  "portal/catalogue-admin/tab-summary": "Resumen",
  "portal/catalogue-definitions/add-attribute": "Agregar Atributo",
  "portal/catalogue-definitions/add-entry": "Agregar Entrada",
  "portal/catalogue-definitions/attribute": "Atributo",
  "portal/catalogue-definitions/attribute-values-helper":
    "Objeto JSON cuyas llaves correspondan a los Names de los atributos definidos.",
  "portal/catalogue-definitions/attribute-values-json":
    "Valores de atributos (JSON)",
  "portal/catalogue-definitions/attributes": "Atributos",
  "portal/catalogue-definitions/children": "Catálogos Hijos",
  "portal/catalogue-definitions/delete": "Eliminar",
  "portal/catalogue-definitions/edit": "Editar",
  "portal/catalogue-definitions/empty-list":
    "Aún no hay definiciones de catálogos.",
  "portal/catalogue-definitions/empty-results":
    "No se encontraron definiciones de catálogos.",
  "portal/catalogue-definitions/entries": "Entradas",
  "portal/catalogue-definitions/entry": "Entrada",
  "portal/catalogue-definitions/general": "General",
  "portal/catalogue-definitions/load-error":
    "No se pudieron cargar las definiciones de catálogos",
  "portal/catalogue-definitions/no-attributes":
    "Aún no hay atributos definidos.",
  "portal/catalogue-definitions/no-children": "No hay catálogos hijos.",
  "portal/catalogue-definitions/no-entries":
    "Aún no hay entradas en este catálogo.",
  "portal/catalogue-definitions/no-parent": "Sin padre",
  "portal/catalogue-definitions/parent-catalogue": "Catálogo Padre",
  "portal/catalogue-definitions/save": "Guardar",
  "portal/catalogue-definitions/saving": "Guardando…",
  "portal/catalogue-definitions/search-placeholder":
    "Buscar definiciones de catálogos",
  "portal/catalogue-definitions/select":
    "Selecciona un catálogo para ver sus detalles.",
  "portal/catalogue-definitions/sidebar": "Catálogos",
  "portal/catalogue-definitions/title": "Definiciones de Catálogos",
  "portal/catalogue-dictionary/brand": "Marca normalizada",
  "portal/catalogue-dictionary/conflict":
    "Otra persona la modificó. Recarga para verla.",
  "portal/catalogue-dictionary/conflict-body":
    "Recarga para verla. No se guardó ningún cambio.",
  "portal/catalogue-dictionary/conflict-title": "Otra persona la modificó",
  "portal/catalogue-dictionary/edit-title": "Editar correspondencia",
  "portal/catalogue-dictionary/empty":
    "No hay correspondencias en el diccionario.",
  "portal/catalogue-dictionary/failed-body":
    "Ninguna versión cambió. Lo que capturaste sigue aquí; vuelve a guardar.",
  "portal/catalogue-dictionary/failed-title": "No se guardó",
  "portal/catalogue-dictionary/filter-all": "Todas",
  "portal/catalogue-dictionary/filter-pending": "Pendientes",
  "portal/catalogue-dictionary/governed":
    "Versiones que dependen de esta fila: {{count}}",
  "portal/catalogue-dictionary/grouping": "Agrupación",
  "portal/catalogue-dictionary/include-model": "Agrupar por modelo",
  "portal/catalogue-dictionary/include-model-hint":
    "Las versiones se agrupan bajo el nombre del modelo.",
  "portal/catalogue-dictionary/load-error": "No se pudo cargar el diccionario.",
  "portal/catalogue-dictionary/model": "Modelo normalizado",
  "portal/catalogue-dictionary/name-brand": "Marca",
  "portal/catalogue-dictionary/name-model": "Modelo",
  "portal/catalogue-dictionary/names": "Nombres normalizados",
  "portal/catalogue-dictionary/names-hint":
    "Así se muestran la marca y el modelo de las versiones de esta correspondencia.",
  "portal/catalogue-dictionary/names-missing": "Captura la marca y el modelo.",
  "portal/catalogue-dictionary/no-changes": "No hay cambios por guardar.",
  "portal/catalogue-dictionary/no-name": "Sin nombre normalizado",
  "portal/catalogue-dictionary/no-names": "Sin nombres normalizados",
  "portal/catalogue-dictionary/only-pending": "Solo pendientes",
  "portal/catalogue-dictionary/only-pending-count":
    "Solo pendientes · {{pending}} de {{total}}",
  "portal/catalogue-dictionary/pending": "Pendiente",
  "portal/catalogue-dictionary/pending-body":
    "Mientras no tenga nombres normalizados, las versiones de esta correspondencia no se publican.",
  "portal/catalogue-dictionary/record-load-error":
    "No se pudo cargar la correspondencia.",
  "portal/catalogue-dictionary/record-type": "Clase",
  "portal/catalogue-dictionary/reload": "Recargar",
  "portal/catalogue-dictionary/required":
    "Captura la marca y el modelo normalizados.",
  "portal/catalogue-dictionary/save-failed":
    "No se guardó. Ninguna versión cambió.",
  "portal/catalogue-dictionary/saved":
    "Guardado. Versiones actualizadas: {{count}}.",
  "portal/catalogue-dictionary/saved-body":
    "Versiones actualizadas: {{count}}.",
  "portal/catalogue-dictionary/saved-title": "Guardado",
  "portal/catalogue-dictionary/search": "Buscar correspondencias",
  "portal/catalogue-dictionary/select":
    "Selecciona una correspondencia para ver sus detalles.",
  "portal/catalogue-dictionary/source-brand": "Marca de origen",
  "portal/catalogue-dictionary/source-model": "Modelo de origen",
  "portal/catalogue-dictionary/subtitle": "{{pending}} pendientes de {{total}}",
  "portal/catalogue-dictionary/versions": "Versiones",
  "portal/catalogue-dictionary/versions-many": "{{count}} versiones",
  "portal/catalogue-dictionary/versions-one": "{{count}} versión",
  "portal/catalogue-updates/active-body":
    "Se inició {{when}} ({{trigger}}). Podrás iniciar otra cuando termine; no se inició ninguna nueva.",
  "portal/catalogue-updates/active-notice":
    "Actualización iniciada {{when}} en curso. Espera a que termine.",
  "portal/catalogue-updates/active-title": "Ya hay una actualización en curso",
  "portal/catalogue-updates/affected": "Registros afectados",
  "portal/catalogue-updates/affected-conflict": "Conflicto",
  "portal/catalogue-updates/affected-invalid": "Inválida",
  "portal/catalogue-updates/affected-title": "{{brand}} · código {{code}}",
  "portal/catalogue-updates/card-new": "Versiones que entraron al catálogo",
  "portal/catalogue-updates/card-unchanged": "Ya estaban al día",
  "portal/catalogue-updates/card-updated": "Con cambios",
  "portal/catalogue-updates/count/conflicts": "Conflictos",
  "portal/catalogue-updates/count/excluded": "Excluidas a propósito",
  "portal/catalogue-updates/count/invalid": "Inválidas",
  "portal/catalogue-updates/count/new": "Nuevas",
  "portal/catalogue-updates/count/pending": "De ellas pendientes de normalizar",
  "portal/catalogue-updates/count/unchanged": "Sin cambios",
  "portal/catalogue-updates/count/unclassified": "Sin clasificar",
  "portal/catalogue-updates/count/updated": "Actualizadas",
  "portal/catalogue-updates/effective": "Rango efectivo",
  "portal/catalogue-updates/effective-by-source": "Rango efectivo por fuente",
  "portal/catalogue-updates/effective-hint":
    "Lo que cada fuente entregará para el rango solicitado.",
  "portal/catalogue-updates/effective-of": "Rango efectivo · {{source}}",
  "portal/catalogue-updates/errors": "Errores",
  "portal/catalogue-updates/errors-shown":
    "Mostrando {{shown}} de {{total}} errores",
  "portal/catalogue-updates/failed-note":
    "No se importó nada. El catálogo sigue como estaba.",
  "portal/catalogue-updates/failed-title": "La actualización falló",
  "portal/catalogue-updates/finished": "Fin",
  "portal/catalogue-updates/footer-active": "Hay una actualización en curso",
  "portal/catalogue-updates/footer-invalid": "Corrige el rango",
  "portal/catalogue-updates/from-year": "Del año",
  "portal/catalogue-updates/history-empty": "Aún no hay actualizaciones.",
  "portal/catalogue-updates/interrupted-note":
    "La actualización dejó de responder y se cerró.",
  "portal/catalogue-updates/load-error":
    "No se pudieron cargar las actualizaciones.",
  "portal/catalogue-updates/no-range": "Sin rango",
  "portal/catalogue-updates/not-run": "No se ejecutó",
  "portal/catalogue-updates/partial-note":
    "Los registros obtenidos siguen disponibles. Solicita el rango de nuevo para reintentar.",
  "portal/catalogue-updates/partial-title": "Resultado parcial",
  "portal/catalogue-updates/portion-counts":
    "{{new}} nuevas · {{updated}} actualizadas · {{unchanged}} sin cambios",
  "portal/catalogue-updates/portion-label": "{{source}} · {{year}}",
  "portal/catalogue-updates/portions": "Partes",
  "portal/catalogue-updates/range-invalid": "Captura un rango de años válido.",
  "portal/catalogue-updates/requested": "Rango solicitado",
  "portal/catalogue-updates/requested-by": "Solicitada por",
  "portal/catalogue-updates/requested-by-name": "Solicitada por {{name}}",
  "portal/catalogue-updates/result": "Resultado",
  "portal/catalogue-updates/row-counts":
    "{{new}} nuevas · {{updated}} actualizadas",
  "portal/catalogue-updates/run-load-error":
    "No se pudo cargar la actualización.",
  "portal/catalogue-updates/run-title": "Actualización {{range}}",
  "portal/catalogue-updates/search": "Buscar actualizaciones",
  "portal/catalogue-updates/section-range": "Rango",
  "portal/catalogue-updates/section-run": "Ejecución",
  "portal/catalogue-updates/see-run": "Ver actualización",
  "portal/catalogue-updates/select":
    "Selecciona una actualización para ver sus detalles.",
  "portal/catalogue-updates/skipped-note":
    "Se omitió porque ya había otra actualización en curso. No es un error.",
  "portal/catalogue-updates/start": "Iniciar actualización",
  "portal/catalogue-updates/start-failed":
    "No se pudo iniciar la actualización.",
  "portal/catalogue-updates/start-submit": "Iniciar",
  "portal/catalogue-updates/start-subtitle":
    "Trae del origen las versiones nuevas y los cambios del rango.",
  "portal/catalogue-updates/started": "Inicio",
  "portal/catalogue-updates/status/empty": "Sin registros",
  "portal/catalogue-updates/status/excluded-only": "Solo excluidos",
  "portal/catalogue-updates/status/failed": "Fallida",
  "portal/catalogue-updates/status/interrupted": "Interrumpida",
  "portal/catalogue-updates/status/partial": "Parcial",
  "portal/catalogue-updates/status/pending": "Pendiente",
  "portal/catalogue-updates/status/running": "En curso",
  "portal/catalogue-updates/status/skipped-overlap":
    "Omitida (había otra en curso)",
  "portal/catalogue-updates/status/succeeded": "Exitosa",
  "portal/catalogue-updates/to-year": "Al año",
  "portal/catalogue-updates/trigger": "Disparo",
  "portal/catalogue-updates/trigger/manual": "Manual",
  "portal/catalogue-updates/trigger/scheduled": "Programada",
  "portal/catalogue-updates/years": "Rango de años",
  "portal/catalogue-updates/years-hint":
    "El catálogo abarca de {{min}} a {{max}}.",
  "portal/catalogue/company-wide-entry": "De toda la compañía",
  "portal/catalogue/constraint/at-least-one-line":
    "Este tipo de uso debe aplicar a autos, motocicletas, o ambos antes de poder guardarse.",
  "portal/catalogue/constraint/at-least-one-type":
    "Esta marca debe aplicar a aviones, helicópteros, o ambos antes de poder guardarse.",
  "portal/catalogue/definition": "Catálogo",
  "portal/catalogue/enabled": "Habilitada",
  "portal/catalogue/entry": "Entrada",
  "portal/catalogue/parent-catalogue": "Catálogo Padre",
  "portal/catalogue/parent-entry": "Entrada Padre",
  "portal/catalogue/required-field": "Este campo es obligatorio",
  "portal/category": "Categoría",
  "portal/cedent": "Cedente",
  "portal/cedent-is-required": "Es necesario indicar la cedente",
  "portal/cedent/edit": "Editar Cedente",
  "portal/cedents": "Cedentes",
  "portal/cedents/all": "Todos las Cedentes",
  "portal/cedents/availability": "Cedentes",
  "portal/cedents/availability-agency": "Disponible para la agencia",
  "portal/cedents/availability-direct": "Sin agencia",
  "portal/cedents/availability-program": "Programa",
  "portal/cedents/filter-all": "Todos",
  "portal/cedents/filter-disabled": "Deshabilitados",
  "portal/cedents/filter-enabled": "Habilitados",
  "portal/change-file": "Cambiar Archivo",
  "portal/commission-tables": "Tablas de Comisión",
  "portal/commission-tables/agency-component": "Comisión de agencia",
  "portal/commission-tables/cedent-component": "Comisión de cedente",
  "portal/commission-tables/component": "Componente",
  "portal/commission-tables/rate": "Tasa",
  "portal/companies": "Compañías",
  "portal/companies/select-a-company-from-the-list":
    "Selecciona una compañía de la lista para continuar",
  "portal/company": "Compañía",
  "portal/company-is-required": "Es necesario indicar la compañía",
  "portal/company/favicon-dark": "Favicon (Modo Oscuro)",
  "portal/company/favicon-light": "Favicon (Modo Claro)",
  "portal/company/logo-dark": "Logo (Modo Oscuro)",
  "portal/company/logo-light": "Logo (Modo Claro)",
  "portal/condition": "Condición",
  "portal/condition-result": "Resultado de Condición",
  "portal/conditions": "Condiciones",
  "portal/conditions/and": "Y",
  "portal/conditions/or": "O",
  "portal/configuration/currencies": "Monedas",
  "portal/configuration/currencies-inherited": "Monedas heredadas",
  "portal/configuration/currency-boundary": "Monedas permitidas",
  "portal/configuration/lines-of-business": "Líneas de negocio",
  "portal/configuration/lob-delete-message":
    "El ramo deja de estar en este cedente. Puedes agregarlo de nuevo más adelante. Un ramo con negocio no se puede eliminar; deshabilítalo en su lugar.",
  "portal/configuration/lob-delete-title": "Eliminar ramo",
  "portal/configuration/lob-disabled": "Deshabilitada",
  "portal/configuration/lob-enabled": "Habilitada",
  "portal/configuration/lob-inherited": "Heredada",
  "portal/configuration/lob-status": "Estatus",
  "portal/configuration/program-configuration": "Configuración del programa",
  "portal/configuration/term-rule": "Regla de vigencia",
  "portal/continue": "Continuar",
  "portal/count-variable": "Variable de Conteo",
  "portal/create-policy": "Nueva Póliza",
  "portal/create-proposal": "Crear Propuesta",
  "portal/create-proposal/cedent-is-required": "La cedente es requerida",
  "portal/create-proposal/missing-params":
    "Faltan parámetros requeridos para crear una propuesta",
  "portal/create-proposal/no-cedents-available":
    "No hay cedentes habilitadas para esta agencia.",
  "portal/currency": "Moneda",
  "portal/data-type": "Tipo de Dato",
  "portal/date-variable": "Variable de Fecha",
  "portal/default-expression": "Expresión por Defecto",
  "portal/default-value": "Valor por Defecto",
  "portal/dependants": "Dependientes",
  "portal/dependants/all": "Todos",
  "portal/dependants/capture": "En Captura",
  "portal/dependants/overview": "Resumen",
  "portal/dependants/quote": "Cotizados",
  "portal/dependants/requested": "Solicitados",
  "portal/dependants/select-a-certificate":
    "Seleccionar un certificado para continuar",
  "portal/dependants/welcome": "Bienvenido",
  "portal/description": "Descripción",
  "portal/document-asset/file": "Archivo",
  "portal/document-asset/font-upload": "Subir fuente",
  "portal/document-asset/image-upload": "Subir imagen",
  "portal/documents": "Documentos",
  "portal/download-file": "Descargar Archivo",
  "portal/dynamic-form/add-instance": "Agregar",
  "portal/dynamic-form/add-item": "Agregar",
  "portal/dynamic-form/async-error":
    "No se pudo cargar esta información. Intenta de nuevo.",
  "portal/dynamic-form/collection-active": "Activo",
  "portal/dynamic-form/collection-filter": "Filtrar",
  "portal/dynamic-form/collection-inactive": "Inactivo",
  "portal/dynamic-form/collection-search": "Buscar",
  "portal/dynamic-form/collection-update-failed":
    "No se pudo guardar el cambio.",
  "portal/dynamic-form/delete-success": "Eliminado",
  "portal/dynamic-form/error": "Error de Formulario",
  "portal/dynamic-form/invalid-submit":
    "Algunos campos requieren atención. Revisa el formulario e intenta de nuevo.",
  "portal/dynamic-form/load-error":
    "Error al cargar la definición del formulario.",
  "portal/dynamic-form/load-more": "Cargar más",
  "portal/dynamic-form/loading": "Cargando Formulario",
  "portal/dynamic-form/pending-submit":
    "Espera a que el formulario termine de cargar",
  "portal/dynamic-form/pending-submit-field":
    "Espera a que termine de cargar: {{field}}",
  "portal/dynamic-form/remove-instance": "Eliminar",
  "portal/dynamic-form/render-error": "Error al Renderizar Formulario",
  "portal/dynamic-form/retry": "Reintentar",
  "portal/dynamic-form/save-success": "Guardado",
  "portal/dynamic-form/submit-blocked-generic":
    "Completa los campos obligatorios",
  "portal/dynamic-form/timeout":
    "La solicitud tardó demasiado. Intenta de nuevo.",
  "portal/dynamic-form/unavailable":
    "Este formulario no está disponible en este momento.",
  "portal/dynamic-form/unknown-error":
    "Ocurrió un error inesperado al renderizar el formulario.",
  "portal/dynamic-form/validation/date-eq": "La fecha debe ser {{date}}",
  "portal/dynamic-form/validation/date-max":
    "Elige una fecha igual o anterior al {{max}}",
  "portal/dynamic-form/validation/date-min":
    "Elige una fecha igual o posterior al {{min}}",
  "portal/easyre/add-rate": "Agregar Tarifa",
  "portal/easyre/add-territory": "Agregar Territorio",
  "portal/easyre/add-usage": "Agregar Uso",
  "portal/easyre/age-surcharges": "Recargos por Edad",
  "portal/easyre/aircraft": "Aeronave",
  "portal/easyre/aircraft-brand": "Marca de Aeronave",
  "portal/easyre/aircraft-brand-is-required":
    "La marca de aeronave es requerida",
  "portal/easyre/aircraft-identification": "Identificación",
  "portal/easyre/aircraft-operation": "Operación",
  "portal/easyre/aircraft-type": "Tipo de Aeronave",
  "portal/easyre/aircraft-type-is-required": "Es necesario el tipo de aeronave",
  "portal/easyre/aircrafts": "Aeronaves",
  "portal/easyre/airplanes": "Aviones",
  "portal/easyre/all-risk": "Todo Riesgo",
  "portal/easyre/base-airport": "Aeropuerto Base",
  "portal/easyre/basic": "Básica",
  "portal/easyre/brand": "Marca",
  "portal/easyre/breach-of-warranty": "Quebrantamiento de Garantías",
  "portal/easyre/breach-of-warranty-hint": "90 % del valor casco",
  "portal/easyre/breach-of-warranty-sum": "Suma Asegurada",
  "portal/easyre/cargo-liability": "Responsabilidad de Carga",
  "portal/easyre/cargo-liability-sum": "Suma Asegurada",
  "portal/easyre/coverage-section-hull": "Casco",
  "portal/easyre/coverage-type": "Tipo de Cobertura",
  "portal/easyre/coverage-type/all-risk-body":
    "Casco en vuelo y en tierra, más responsabilidad civil.",
  "portal/easyre/coverage-type/all-risk-title": "Todo riesgo",
  "portal/easyre/coverage-type/basic-body": "Responsabilidad civil sin casco.",
  "portal/easyre/coverage-type/basic-title": "Básica",
  "portal/easyre/coverage-type/hull-only-body":
    "Daño físico sin responsabilidad civil.",
  "portal/easyre/coverage-type/hull-only-title": "Solo casco",
  "portal/easyre/coverage-type/limited-body":
    "Casco en tierra únicamente, más responsabilidad civil.",
  "portal/easyre/coverage-type/limited-title": "Limitada",
  "portal/easyre/crew-is-required": "El número de tripulantes es requerido",
  "portal/easyre/crew-medical-payments": "Gastos Médicos Tripulantes",
  "portal/easyre/crew-medical-payments-sum": "Suma Asegurada por Tripulante",
  "portal/easyre/crew-must-be-greater-than-zero":
    "El número de tripulantes debe ser mayor a 0",
  "portal/easyre/crew-number": "Tripulantes",
  "portal/easyre/crew-voluntary-settlements": "Pagos Voluntarios Tripulación",
  "portal/easyre/crew-voluntary-settlements-sum":
    "Suma de Asegurada por Tripulante",
  "portal/easyre/csl": "Límite Único y Combinado",
  "portal/easyre/edit-rate": "Editar Tarifa",
  "portal/easyre/edit-territory": "Editar Territorio",
  "portal/easyre/edit-usage": "Editar Uso",
  "portal/easyre/entity-is-required": "La entidad es requerida",
  "portal/easyre/extended-liability": "Extensión de R.C.",
  "portal/easyre/geographic-limit": "Límite Geográfico",
  "portal/easyre/geographic-limit-is-required":
    "El límite geográfico es requerido",
  "portal/easyre/geographic-limits": "Límites Geográficos",
  "portal/easyre/hangar-liability": "RC Hangares",
  "portal/easyre/hangar-liability-sum": "Suma Asegurada",
  "portal/easyre/helicopter": "Helicóptero",
  "portal/easyre/helicopters": "Helicópteros",
  "portal/easyre/hull-coverage": "Cobertura de Casco",
  "portal/easyre/hull-deductible": "Deducible del Casco",
  "portal/easyre/hull-only": "Solo Casco",
  "portal/easyre/hull-value": "Suma Asegurada del Casco",
  "portal/easyre/hull-value-is-required": "El valor del casco es requerido",
  "portal/easyre/hull-value-must-be-greater-than-zero":
    "El valor del casco debe ser mayor a 0",
  "portal/easyre/hull-value-must-not-exceed-limit":
    "El valor del casco no debe exceder 5,000,000",
  "portal/easyre/liability": "RC",
  "portal/easyre/liability-coverage": "Responsabilidad Civil",
  "portal/easyre/liability-limit": "Límite de Responsabilidad",
  "portal/easyre/liability-limit-is-required":
    "El límite de responsabilidad civil debe ser mayor a 0",
  "portal/easyre/licence": "Matrícula",
  "portal/easyre/licence-is-required": "La matrícula es requerida",
  "portal/easyre/limited": "Limitado",
  "portal/easyre/luggage-liability": "Responsabilidad Civil de Equipaje",
  "portal/easyre/luggage-liability-sum": "Suma Asegurada por Pasajero",
  "portal/easyre/max-is-required": "Maximo es requerido",
  "portal/easyre/medical-payments": "GM Pasajeros",
  "portal/easyre/medical-payments-sum": "Suma Asegurada por Pasajero",
  "portal/easyre/min-is-required": "Minimo es requerido",
  "portal/easyre/model": "Modelo",
  "portal/easyre/model-is-required": "El modelo es requerido",
  "portal/easyre/other-coverages": "Otras Coberturas",
  "portal/easyre/passenger-voluntary-settlements":
    "Pagos Voluntarios de Pasajeros",
  "portal/easyre/passenger-voluntary-settlements-hint": "Por asiento",
  "portal/easyre/passenger-voluntary-settlements-sum":
    "Suma de Asegurada por Pasajero",
  "portal/easyre/passengers": "Pasajeros",
  "portal/easyre/pilot": "Piloto",
  "portal/easyre/pilot/add-pilot": "Agregar piloto",
  "portal/easyre/pilot/age": "Edad",
  "portal/easyre/pilot/aircraft-type-hours": "Horas en tipo de aeronave",
  "portal/easyre/pilot/change-certificate": "Cambiar certificado",
  "portal/easyre/pilot/detail-certificate": "Certificado",
  "portal/easyre/pilot/detail-last-simulator": "Último simulador",
  "portal/easyre/pilot/detail-next-simulator": "Próximo simulador",
  "portal/easyre/pilot/detail-total-hours": "Horas totales",
  "portal/easyre/pilot/detail-type-hours": "Horas en tipo",
  "portal/easyre/pilot/hours-total-suffix": "h totales",
  "portal/easyre/pilot/hours-type-suffix": "h en tipo",
  "portal/easyre/pilot/hours-warranty-notice":
    "Cada piloto nombrado debe cumplir la garantía de horas de vuelo aplicable a esta aeronave.",
  "portal/easyre/pilot/last-simulator-training":
    "Último entrenamiento en simulador (últimos 12 meses)",
  "portal/easyre/pilot/license": "Licencia",
  "portal/easyre/pilot/make-model-hours": "Horas en marca y modelo",
  "portal/easyre/pilot/modal-title": "Piloto",
  "portal/easyre/pilot/name": "Nombre",
  "portal/easyre/pilot/next-scheduled-simulator":
    "Próximo simulador programado",
  "portal/easyre/pilot/no-pilots": "No se han agregado pilotos",
  "portal/easyre/pilot/select-certificate": "Seleccionar certificado",
  "portal/easyre/pilot/total-flight-hours": "Horas totales de vuelo",
  "portal/easyre/pilot/training-certificate": "Certificado de entrenamiento",
  "portal/easyre/pilot/training-date": "Fecha del entrenamiento",
  "portal/easyre/pilot/training-details":
    "Detalles del entrenamiento más reciente",
  "portal/easyre/pilot/training-location": "Lugar del entrenamiento",
  "portal/easyre/pilot/validation/positive": "Debe ser mayor que cero",
  "portal/easyre/pilot/validation/required": "Este campo es obligatorio",
  "portal/easyre/pilots": "Pilotos",
  "portal/easyre/quote": "Cotización",
  "portal/easyre/quote/error": "No se pudo calcular la cotización",
  "portal/easyre/quote/loading": "Calculando cotización…",
  "portal/easyre/quote/retry": "Reintentar",
  "portal/easyre/rate-is-required": "Cuota es requerida",
  "portal/easyre/rates": "Tarifas",
  "portal/easyre/serial": "Serie",
  "portal/easyre/serial-is-required": "La serie es requerida",
  "portal/easyre/spare-parts": "Partes y Refacciones",
  "portal/easyre/spare-parts-sum": "Suma Asegurada",
  "portal/easyre/usage": "Uso",
  "portal/easyre/usage-is-required": "Es necesario el uso",
  "portal/easyre/usage-surcharges": "Recargos por Uso",
  "portal/easyre/voluntary-settlements": "PV",
  "portal/easyre/war-risk-coverage": "Cobertura de Guerra",
  "portal/easyre/war-risk-coverage-hint": "LSW555D",
  "portal/easyre/war-risk-coverage-sum": "Suma Asegurada de Guerra",
  "portal/easyre/year": "Año",
  "portal/easyre/year-is-required": "Es necesario el año",
  "portal/easyre/year-must-be-between":
    "El año debe estar entre {{min}} y {{max}}",
  "portal/edit": "Editar",
  "portal/edit-aircraft": "Editar Aeronave",
  "portal/edit-cedent": "Editar Cedente",
  "portal/edit-commission-table": "Modificar Tabla de Comisión",
  "portal/edit-condition": "Editar Condición",
  "portal/edit-entity": "Editar Entidad",
  "portal/edit-entry": "Editar Entrada",
  "portal/edit-insurer": "Editar Aseguradora",
  "portal/edit-line-of-business": "Editar Línea de Negocio",
  "portal/edit-lob": "Editar Ramo",
  "portal/edit-pipeline": "Editar Pipeline",
  "portal/edit-pipeline-step": "Editar Paso de Pipeline",
  "portal/edit-policy-file": "Editar Archivo de Póliza",
  "portal/edit-policy-payment": "Registrar Pago",
  "portal/edit-policy-receipt": "Detalles del Recibo",
  "portal/edit-proposal": "Editar Propuesta",
  "portal/edit-rate-table": "Editar Tabla de Tarifas",
  "portal/edit-rate-table-entry": "Editar Entrada de Tabla de Tarifas",
  "portal/edit-step": "Editar Paso",
  "portal/edit-step-condition": "Editar Condición de Paso",
  "portal/edit-variable": "Editar Variable",
  "portal/editDependent/authorization-form-is-required":
    "Se requiere el formulario de autorización",
  "portal/editDependent/birthday": "Fecha de Nacimiento",
  "portal/editDependent/birthday-is-required":
    "Es necesario indicar la fecha de nacimiento",
  "portal/editDependent/child": "Hijo/Hija",
  "portal/editDependent/dependent": "Dependiente",
  "portal/editDependent/female": "Femenino",
  "portal/editDependent/gender": "Género",
  "portal/editDependent/gender-is-required": "Es necesario indicar el género",
  "portal/editDependent/invalid-birthday": "Fecha de nacimiento inválida",
  "portal/editDependent/invalid-national-id": "CURP inválida",
  "portal/editDependent/lastname": "Apellido Paterno",
  "portal/editDependent/lastname-is-required":
    "Es necesario indicar el apellido paterno",
  "portal/editDependent/male": "Masculino",
  "portal/editDependent/medical-form-is-required":
    "Se requiere el formulario médico",
  "portal/editDependent/name": "Nombre(s)",
  "portal/editDependent/name-is-required": "Es necesario indicar el nombre",
  "portal/editDependent/national-id": "CURP",
  "portal/editDependent/national-id-is-required":
    "Es necesario indicar la CURP",
  "portal/editDependent/relationship": "Relación",
  "portal/editDependent/relationship-is-required": "Es necesaria la relación",
  "portal/editDependent/request-id-is-required":
    "Es necesario el Id de la solicitud",
  "portal/editDependent/spouse": "Cónyuge",
  "portal/editDependent/surname": "Apellido Materno",
  "portal/editDependent/surname-is-required":
    "Es necesario indicar el apellido materno",
  "portal/email": "Correo Electrónico",
  "portal/email-is-invalid":
    "La dirección de correo electrónico proporcionada no es válida",
  "portal/email-is-required":
    "Es necesario introducir una dirección de correo electrónico",
  "portal/employees": "Empleados",
  "portal/end-date": "Fecha de Fin",
  "portal/entities/load-error": "No se pudo cargar la lista",
  "portal/entities/search-placeholder": "Buscar",
  "portal/entity": "Entidad",
  "portal/entity-not-found": "Entidad no encontrada",
  "portal/entity/alias": "Alias",
  "portal/entity/appointed-carrier": "Aseguradora Designada",
  "portal/entity/birthday": "Fecha de Nacimiento",
  "portal/entity/birthday-is-required": "Es necesario la fecha de nacimiento",
  "portal/entity/client": "Cliente",
  "portal/entity/client-is-required": "Es necesario seleccionar el cliente",
  "portal/entity/commercial-name": "Nombre Comercial",
  "portal/entity/country": "País",
  "portal/entity/country-is-required": "El país es requerido",
  "portal/entity/email": "Correo Electrónico",
  "portal/entity/entity": "Persona",
  "portal/entity/entity-type": "Tipo",
  "portal/entity/entity-type-is-required":
    "Es necesario seleccionar el cliente",
  "portal/entity/existing-client": "Persona Existente",
  "portal/entity/existing-entity-is-required":
    "Es necesario seleccionar la persona existente",
  "portal/entity/external-id": "ID externo",
  "portal/entity/gender": "Género",
  "portal/entity/gender/female": "Femenino",
  "portal/entity/gender/male": "Masculino",
  "portal/entity/incorporation-date": "Fecha de Constitución",
  "portal/entity/incorporation-date-is-required":
    "Es necesario la fecha de constitución",
  "portal/entity/is-insurer": "Es Aseguradora",
  "portal/entity/lastname": "Apellido Paterno",
  "portal/entity/lastname-is-required": "Es necesario el apellido paterno",
  "portal/entity/legal-person": "Persona Moral",
  "portal/entity/legalname": "Razón Social",
  "portal/entity/legalname-is-required": "Es necesario la razón social",
  "portal/entity/middlename": "Segundo(s) Nombre(s)",
  "portal/entity/mobile": "Celular",
  "portal/entity/name": "Primer Nombre",
  "portal/entity/name-is-required": "Es necesario el nombre",
  "portal/entity/national-id": "CURP",
  "portal/entity/natural-person": "Persona Física",
  "portal/entity/new-client": "Persona Nueva",
  "portal/entity/new-or-existing": "Persona Nueva o Existente",
  "portal/entity/new-or-existing-is-required":
    "Es necesario indicar si el cliente es nueva o existente",
  "portal/entity/not-a-legal-entity": "El registro no es una persona moral",
  "portal/entity/not-a-natural-entity": "El registro no es una persona física",
  "portal/entity/summary/commercial-name": "Nombre comercial",
  "portal/entity/summary/country": "País",
  "portal/entity/summary/entity-id": "Identificador de entidad",
  "portal/entity/summary/general": "Datos generales",
  "portal/entity/summary/incorporation-date": "Fecha de constitución",
  "portal/entity/summary/incorporation-section": "Constitución",
  "portal/entity/summary/legal-name": "Razón social",
  "portal/entity/summary/tax-id": "Identificador fiscal",
  "portal/entity/surname": "Apellido Materno",
  "portal/entity/surname-is-required": "Es necesario el apellido paterno",
  "portal/entity/tax-id-is-invalid": "El RFC es inválido",
  "portal/entity/tax-id-is-required": "Es necesario el RFC",
  "portal/entity/tax-regime": "Regimen Fiscal",
  "portal/entity/taxid": "RFC",
  "portal/entity/use-existing-client": "Usar Cliente Existente",
  "portal/error-behavior": "Comportamiento de Error",
  "portal/error-description-key": "Clave de Descripción de Error",
  "portal/error-message-key": "Clave de Mensaje de Error",
  "portal/errors/acknowledge": "Entendido",
  "portal/errors/close": "Cerrar",
  "portal/errors/dismiss": "Continuar",
  "portal/errors/recovering": "Recuperando el estado de la aplicación...",
  "portal/executed-by": "Ejecutado Por",
  "portal/execution-time": "Tiempo de Ejecución",
  "portal/existing": "Existente",
  "portal/exixting": "Existente",
  "portal/expiration-date": "Fin de Vigencia",
  "portal/expiration-date-is-required":
    "Es necesario indicar la fecha de fin de vigencia",
  "portal/expression": "Expresión",
  "portal/external-catalogues/active-codes": "Códigos activos",
  "portal/external-catalogues/assign-code": "Asignar código",
  "portal/external-catalogues/catalogue": "Catálogo",
  "portal/external-catalogues/cedent": "Cedente",
  "portal/external-catalogues/code": "Código",
  "portal/external-catalogues/codes": "Códigos",
  "portal/external-catalogues/country": "País",
  "portal/external-catalogues/deactivate-code": "Desactivar código",
  "portal/external-catalogues/deactivate-code-message":
    "El código dejará de ofrecerse. Los registros existentes lo conservan.",
  "portal/external-catalogues/deactivate-code-title":
    "¿Desactivar este código?",
  "portal/external-catalogues/disabled": "Deshabilitado",
  "portal/external-catalogues/edit": "Editar catálogo",
  "portal/external-catalogues/edit-code": "Editar código",
  "portal/external-catalogues/empty-list": "Aún no hay catálogos externos.",
  "portal/external-catalogues/empty-results":
    "Ningún catálogo coincide con tu búsqueda.",
  "portal/external-catalogues/enabled": "Habilitado",
  "portal/external-catalogues/general": "General",
  "portal/external-catalogues/key": "Clave",
  "portal/external-catalogues/load-error":
    "No se pudieron cargar los catálogos externos.",
  "portal/external-catalogues/name": "Nombre",
  "portal/external-catalogues/search-placeholder": "Buscar catálogos",
  "portal/external-catalogues/select":
    "Selecciona un catálogo para ver sus detalles.",
  "portal/external-catalogues/sidebar": "Catálogos externos",
  "portal/external-catalogues/status": "Estatus",
  "portal/external-catalogues/title": "Catálogos externos",
  "portal/extract-fields": "Campos a Extraer (key:variable, ...)",
  "portal/file": "Archivo",
  "portal/files": "Archivos",
  "portal/filter-agencies": "Agencias",
  "portal/filter-by": "Filtrar por",
  "portal/filter-insurers": "Aseguradoras",
  "portal/filter-lobs": "Ramos",
  "portal/final-premiums": "Primas Finales",
  "portal/form/accepted-formats": "Formatos Aceptados",
  "portal/form/action-target": "Campo Destino",
  "portal/form/action-type": "Tipo de Accion",
  "portal/form/action-value": "Valor",
  "portal/form/action/calculate": "Calcular",
  "portal/form/action/callMethod": "Llamar método",
  "portal/form/action/clearValue": "Limpiar Valor",
  "portal/form/action/copyValue": "Copiar valor",
  "portal/form/action/fetchData": "Obtener Datos",
  "portal/form/action/fetchMatch": "Obtener registro coincidente",
  "portal/form/action/fetchRecord": "Obtener registro",
  "portal/form/action/setCardOptions": "Establecer opciones de tarjeta",
  "portal/form/action/setDisabled": "Asignar Deshabilitado",
  "portal/form/action/setFieldProps": "Establecer propiedades del campo",
  "portal/form/action/setOptions": "Asignar Opciones",
  "portal/form/action/setOrder": "Establecer orden",
  "portal/form/action/setRequired": "Asignar Requerido",
  "portal/form/action/setValidationBounds": "Establecer límites de validación",
  "portal/form/action/setValidationBoundsFromFields":
    "Establecer límites desde otros campos",
  "portal/form/action/setValue": "Asignar Valor",
  "portal/form/action/setVisibility": "Asignar Visibilidad",
  "portal/form/actions": "Acciones",
  "portal/form/add": "Nuevo Formulario",
  "portal/form/add-action": "Agregar Accion",
  "portal/form/add-condition": "Agregar Condicion",
  "portal/form/add-field": "Agregar Campo",
  "portal/form/add-filter": "Agregar Filtro",
  "portal/form/add-format": "Agregar",
  "portal/form/add-group": "Agregar Grupo",
  "portal/form/add-rule": "Agregar Regla",
  "portal/form/add-step": "Agregar Paso",
  "portal/form/add-validation": "Agregar Regla de Validacion",
  "portal/form/all": "Todos",
  "portal/form/allow-create": "Permitir Crear",
  "portal/form/back-to-list": "Volver a la Lista",
  "portal/form/both": "Ambos",
  "portal/form/close": "Cerrar",
  "portal/form/collapse-group": "Contraer grupo",
  "portal/form/condition-group": "Grupo",
  "portal/form/conditions": "Condiciones",
  "portal/form/configure": "Configurar",
  "portal/form/create-form": "Crear Formulario",
  "portal/form/custom-field": "Campo Personalizado",
  "portal/form/data-source": "Fuente de Datos",
  "portal/form/default-value": "Valor Predeterminado",
  "portal/form/delete": "Eliminar",
  "portal/form/delete-confirm":
    "Esta seguro que desea eliminar esta definicion de formulario?",
  "portal/form/disabled": "Inactivo",
  "portal/form/disabled-condition": "Condicion de Deshabilitado",
  "portal/form/edit": "Editar",
  "portal/form/edit-roles": "Roles de Edicion",
  "portal/form/editor": "Editor de Formulario",
  "portal/form/embedded": "Incrustado",
  "portal/form/enabled": "Activo",
  "portal/form/error-message": "Mensaje de Error",
  "portal/form/expand-group": "Expandir grupo",
  "portal/form/expression": "Expresion",
  "portal/form/field-config": "Configuracion del Campo",
  "portal/form/field-label": "Etiqueta",
  "portal/form/field-name": "Nombre del Campo",
  "portal/form/field-reference": "Referencia de Campo",
  "portal/form/field-type": "Tipo de Campo",
  "portal/form/field-types": "Tipos de Campo",
  "portal/form/fields": "Campos",
  "portal/form/file-config": "Configuracion de Archivo",
  "portal/form/filter-attribute": "Atributo",
  "portal/form/filter-lob": "Filtrar por Ramo",
  "portal/form/filter-model": "Filtrar por Modelo",
  "portal/form/filter-operator": "Operador",
  "portal/form/filter-source-field": "Campo Fuente",
  "portal/form/filter-status": "Filtrar por Estado",
  "portal/form/filters": "Filtros",
  "portal/form/general": "General",
  "portal/form/group-assignment": "Grupo",
  "portal/form/label-attribute": "Atributo de Etiqueta",
  "portal/form/literal-value": "Valor Literal",
  "portal/form/lob": "Ramo",
  "portal/form/max-file-size": "Tamano Maximo de Archivo (MB)",
  "portal/form/modal": "Modal",
  "portal/form/model-attribute": "Atributo del Modelo",
  "portal/form/move-down": "Bajar",
  "portal/form/move-up": "Subir",
  "portal/form/multiple-files": "Archivos Multiples",
  "portal/form/name": "Nombre",
  "portal/form/name-required": "El nombre es requerido",
  "portal/form/no-conditions": "Sin condiciones",
  "portal/form/no-definitions": "No se encontraron definiciones de formularios",
  "portal/form/no-fields":
    "Sin campos. Agregue un campo desde la barra lateral.",
  "portal/form/no-results": "Ningún formulario coincide con tu búsqueda",
  "portal/form/no-rules": "Sin reglas definidas",
  "portal/form/no-steps":
    "No hay pasos configurados. Usa Agregar Paso para crear el primero.",
  "portal/form/no-validations": "Sin reglas de validacion",
  "portal/form/operand": "Operando",
  "portal/form/operands": "Operandos",
  "portal/form/operation": "Operacion",
  "portal/form/order": "Orden",
  "portal/form/permissions": "Permisos",
  "portal/form/phase": "Fase",
  "portal/form/placeholder": "Texto de Referencia",
  "portal/form/preview": "Vista Previa",
  "portal/form/remove": "Eliminar",
  "portal/form/remove-format": "Eliminar formato",
  "portal/form/remove-step": "Eliminar paso",
  "portal/form/render-mode": "Modo de Renderizado",
  "portal/form/repeatable": "Repetible",
  "portal/form/required": "Requerido",
  "portal/form/required-condition": "Condicion de Requerido",
  "portal/form/rule-name": "Nombre de la Regla",
  "portal/form/rules": "Reglas",
  "portal/form/save": "Guardar",
  "portal/form/save-error": "Error al guardar formulario",
  "portal/form/save-success": "Formulario guardado exitosamente",
  "portal/form/saving": "Guardando...",
  "portal/form/search-attribute": "Atributo de Busqueda",
  "portal/form/select-a-form": "Seleccione un formulario de la lista",
  "portal/form/select-field": "Selecciona un campo para configurar",
  "portal/form/slug": "Slug",
  "portal/form/slug-required": "El slug es requerido",
  "portal/form/source-model": "Modelo Fuente",
  "portal/form/step-assignment": "Paso",
  "portal/form/step-label": "Etiqueta del paso",
  "portal/form/steps": "Pasos",
  "portal/form/target-model": "Modelo Destino",
  "portal/form/title": "Definiciones de Formularios",
  "portal/form/trigger-field-change": "Al Cambiar Campo",
  "portal/form/trigger-fields": "Campos del Disparador",
  "portal/form/trigger-init": "Al Inicializar",
  "portal/form/trigger-type": "Tipo de Disparador",
  "portal/form/type/age": "Edad",
  "portal/form/type/creditCard": "Tarjeta de Credito",
  "portal/form/type/currency": "Moneda",
  "portal/form/type/date": "Fecha",
  "portal/form/type/email": "Correo",
  "portal/form/type/file": "Archivo",
  "portal/form/type/multipleSelect": "Seleccion Multiple",
  "portal/form/type/number": "Numero",
  "portal/form/type/otp": "OTP",
  "portal/form/type/percentage": "Porcentaje",
  "portal/form/type/phone": "Telefono",
  "portal/form/type/radio": "Radio",
  "portal/form/type/richText": "Texto Enriquecido",
  "portal/form/type/select": "Seleccion",
  "portal/form/type/selectFetch": "Seleccion (Remota)",
  "portal/form/type/switch": "Interruptor",
  "portal/form/type/text": "Texto",
  "portal/form/type/url": "URL",
  "portal/form/validation": "Validacion",
  "portal/form/validator-type": "Validador",
  "portal/form/value-attribute": "Atributo de Valor",
  "portal/form/view-roles": "Roles de Visualizacion",
  "portal/form/virtual-path": "Ruta Virtual",
  "portal/form/visibility-condition": "Condicion de Visibilidad",
  "portal/forms": "Formularios",
  "portal/forms/move-down": "Bajar",
  "portal/forms/move-up": "Subir",
  "portal/forms/name-and-slug-required": "El nombre y el slug son obligatorios",
  "portal/global": "Global",
  "portal/go-back": "Regresar",
  "portal/home": "Inicio",
  "portal/home/active-in-force": "Vigentes",
  "portal/home/balance": "Saldo Pendiente",
  "portal/home/days-ago": "Hace {{count}}d",
  "portal/home/hours-ago": "Hace {{count}}h",
  "portal/home/in-pipeline": "En proceso",
  "portal/home/just-now": "Ahora",
  "portal/home/load-error": "No se pudieron cargar los datos",
  "portal/home/minutes-ago": "Hace {{count}}m",
  "portal/home/my-assignments": "Mis Asignaciones",
  "portal/home/no-assignments": "Sin asignaciones pendientes",
  "portal/home/no-recent-activity": "Sin actividad reciente",
  "portal/home/placements": "Colocaciones",
  "portal/home/policies": "Pólizas",
  "portal/home/premium": "Prima",
  "portal/home/recent-activity": "Actividad Reciente",
  "portal/home/retry": "Reintentar",
  "portal/home/total-outstanding": "Total pendiente",
  "portal/home/total-written": "Prima total",
  "portal/home/view-all": "Ver todo",
  "portal/home/welcome": "Bienvenido,",
  "portal/icon": "Ícono",
  "portal/in-force-date": "Inicio de Vigencia",
  "portal/in-force-policies": "En Vigor",
  "portal/inforce-date-is-required":
    "Es necesario indicar la fecha de vigencia",
  "portal/input-context": "Contexto de Entrada",
  "portal/insurer/edit": "Editar Aseguradora",
  "portal/insurer/financials/accumulated": "Acumulado {{range}}",
  "portal/insurer/financials/caption": "Cifras en millones de pesos.",
  "portal/insurer/financials/collapse": "Contraer",
  "portal/insurer/financials/column-account": "Concepto",
  "portal/insurer/financials/column-annual-change": "Var. anual (%)",
  "portal/insurer/financials/empty-title":
    "Sin estados financieros publicados para la clave {{key}}",
  "portal/insurer/financials/expand": "Expandir",
  "portal/insurer/financials/operation": "Operación",
  "portal/insurer/financials/period": "Periodo",
  "portal/insurer/financials/statement": "Estado financiero",
  "portal/insurer/financials/statement-balance": "Balance",
  "portal/insurer/financials/statement-results": "Resultados",
  "portal/insurer/financials/summary": "Resumen",
  "portal/insurer/financials/summary-assets": "Total Activo",
  "portal/insurer/financials/summary-claims": "Costo Neto de Siniestralidad",
  "portal/insurer/financials/summary-equity": "Total Capital",
  "portal/insurer/financials/summary-liabilities": "Total Pasivo",
  "portal/insurer/financials/summary-premiums": "Primas Emitidas",
  "portal/insurer/financials/summary-result":
    "Utilidad (Pérdida) del Ejercicio",
  "portal/insurer/financials/tab": "Financieros",
  "portal/insurer/financials/title-balance": "Balance general",
  "portal/insurer/financials/title-results": "Estado de resultados",
  "portal/insurer/financials/unit": "MXN mm",
  "portal/insurer/indexes/cnsf-key": "Clave CNSF",
  "portal/insurer/indexes/column-quarter": "Trimestre",
  "portal/insurer/indexes/coverage-index": "Índice de cobertura",
  "portal/insurer/indexes/empty-body":
    "Asigna la clave CNSF en Datos generales para consultar sus índices.",
  "portal/insurer/indexes/empty-title": "Esta aseguradora no tiene clave CNSF",
  "portal/insurer/indexes/history": "Histórico",
  "portal/insurer/indexes/history-range": "Periodo del histórico",
  "portal/insurer/indexes/last-quarter-title":
    "Último trimestre reportado · {{period}} · Clave CNSF {{key}}",
  "portal/insurer/indexes/no-data-title":
    "Sin indicadores publicados para la clave {{key}}",
  "portal/insurer/indexes/range-all": "Todo",
  "portal/insurer/indexes/range-last-8": "Últimos 8 trimestres",
  "portal/insurer/indexes/source":
    "Fuente: CNSF · Información Financiera, indicadores revisados por la CNSF. Se publica trimestralmente.",
  "portal/insurer/indexes/stale":
    "La CNSF no publica indicadores de la clave {{key}} desde {{month}} de {{year}}.",
  "portal/insurer/indexes/state-green": "Suficiente",
  "portal/insurer/indexes/state-red": "Insuficiente",
  "portal/insurer/indexes/state-yellow": "Ajustado",
  "portal/insurer/indexes/tab": "Índices",
  "portal/insurer/lobs": "Ramos de Seguro",
  "portal/insurer/no-lobs": "Sin ramos de seguro asignados",
  "portal/insurer/period/month-01": "Enero",
  "portal/insurer/period/month-02": "Febrero",
  "portal/insurer/period/month-03": "Marzo",
  "portal/insurer/period/month-04": "Abril",
  "portal/insurer/period/month-05": "Mayo",
  "portal/insurer/period/month-06": "Junio",
  "portal/insurer/period/month-07": "Julio",
  "portal/insurer/period/month-08": "Agosto",
  "portal/insurer/period/month-09": "Septiembre",
  "portal/insurer/period/month-10": "Octubre",
  "portal/insurer/period/month-11": "Noviembre",
  "portal/insurer/period/month-12": "Diciembre",
  "portal/insurer/period/month-in-text-01": "enero",
  "portal/insurer/period/month-in-text-02": "febrero",
  "portal/insurer/period/month-in-text-03": "marzo",
  "portal/insurer/period/month-in-text-04": "abril",
  "portal/insurer/period/month-in-text-05": "mayo",
  "portal/insurer/period/month-in-text-06": "junio",
  "portal/insurer/period/month-in-text-07": "julio",
  "portal/insurer/period/month-in-text-08": "agosto",
  "portal/insurer/period/month-in-text-09": "septiembre",
  "portal/insurer/period/month-in-text-10": "octubre",
  "portal/insurer/period/month-in-text-11": "noviembre",
  "portal/insurer/period/month-in-text-12": "diciembre",
  "portal/insurer/period/month-short-01": "Ene",
  "portal/insurer/period/month-short-02": "Feb",
  "portal/insurer/period/month-short-03": "Mar",
  "portal/insurer/period/month-short-04": "Abr",
  "portal/insurer/period/month-short-05": "May",
  "portal/insurer/period/month-short-06": "Jun",
  "portal/insurer/period/month-short-07": "Jul",
  "portal/insurer/period/month-short-08": "Ago",
  "portal/insurer/period/month-short-09": "Sep",
  "portal/insurer/period/month-short-10": "Oct",
  "portal/insurer/period/month-short-11": "Nov",
  "portal/insurer/period/month-short-12": "Dic",
  "portal/insurer/period/month-short-in-text-01": "ene",
  "portal/insurer/period/month-short-in-text-02": "feb",
  "portal/insurer/period/month-short-in-text-03": "mar",
  "portal/insurer/period/month-short-in-text-04": "abr",
  "portal/insurer/period/month-short-in-text-05": "may",
  "portal/insurer/period/month-short-in-text-06": "jun",
  "portal/insurer/period/month-short-in-text-07": "jul",
  "portal/insurer/period/month-short-in-text-08": "ago",
  "portal/insurer/period/month-short-in-text-09": "sep",
  "portal/insurer/period/month-short-in-text-10": "oct",
  "portal/insurer/period/month-short-in-text-11": "nov",
  "portal/insurer/period/month-short-in-text-12": "dic",
  "portal/insurer/period/month-year": "{{month}} {{year}}",
  "portal/insurer/period/range": "{{from}}–{{to}} {{year}}",
  "portal/insurer/regulatory/load-error":
    "No se pudieron cargar los datos regulatorios.",
  "portal/insurers": "Aseguradoras",
  "portal/insurers/active": "Activas",
  "portal/insurers/all": "Todas",
  "portal/insurers/appointed": "Designadas",
  "portal/insurers/inactive": "Inactivas",
  "portal/internal-users": "Usuarios internos",
  "portal/invalid-json": "JSON inválido",
  "portal/is-active": "Activo",
  "portal/label": "Etiqueta",
  "portal/lapsed-policies": "Lapsadas",
  "portal/limit-variable": "Variable de Límite",
  "portal/line-of-business": "Ramo",
  "portal/lines-of-business": "Ramos",
  "portal/list/and": "{{list}} y {{last}}",
  "portal/loading": "Cargando",
  "portal/lob/add-stage": "Agregar Etapa",
  "portal/lob/create-pipeline": "Crear Pipeline",
  "portal/lob/forms": "Formularios",
  "portal/lob/generates-receipts": "Genera recibos",
  "portal/lob/icon": "Ícono",
  "portal/lob/issuable": "Emisible",
  "portal/lob/lob1": "Operación",
  "portal/lob/lob2": "Ramo",
  "portal/lob/lob3": "Sub-ramo",
  "portal/lob/lob4": "Category",
  "portal/lob/pipeline-builder": "Constructor de Pipeline",
  "portal/lob/prefix": "Prefijo del Ramo",
  "portal/lob/publish-pipeline": "Publicar",
  "portal/lob/stages": "Etapas",
  "portal/lobs/builders-risk": "Obra Civil",
  "portal/lobs/dno": "Directores y Funcionarios",
  "portal/lobs/er-aviation": "Aviación (excepto fumigadores)",
  "portal/lobs/group-accident": "Accidentes Personales Colectivo",
  "portal/lobs/group-health": "Gastos Médicos Mayores Colectivo",
  "portal/lobs/group-life": "Vida Grupo",
  "portal/lobs/home": "Hogar",
  "portal/lobs/individual-health": "Gastos Médicos Mayores Individual",
  "portal/lobs/individual-vehicle": "Vehiculo Individual",
  "portal/lobs/load-error": "No se pudieron cargar los ramos",
  "portal/lobs/motor": "Motor — Vehículos de Alto Valor",
  "portal/lobs/search-placeholder": "Buscar ramos",
  "portal/lobs/select-a-lob-from-the-list": "Selecciona un Ramo de la lista",
  "portal/lobs/tra": "Viajero",
  "portal/logical-operator": "Operador Lógico",
  "portal/lookup-field": "Campo de Búsqueda",
  "portal/lookup-type": "Tipo de Búsqueda",
  "portal/lookup-value-variable": "Variable de Valor de Búsqueda",
  "portal/managed-catalogue/availability": "Disponibilidad",
  "portal/managed-catalogue/availability-hint":
    "Un registro no disponible no se ofrece al cotizar.",
  "portal/managed-catalogue/available": "Disponible",
  "portal/managed-catalogue/available-to-quote": "Disponible para cotizar",
  "portal/managed-catalogue/children": "{{label}}: {{count}}",
  "portal/managed-catalogue/empty": "Aún no hay registros.",
  "portal/managed-catalogue/filter-all": "Todos",
  "portal/managed-catalogue/filter-no": "No",
  "portal/managed-catalogue/filter-status": "Estado",
  "portal/managed-catalogue/filter-yes": "Sí",
  "portal/managed-catalogue/load-error": "No se pudieron cargar los registros.",
  "portal/managed-catalogue/load-error-of": "No se pudieron cargar {{title}}.",
  "portal/managed-catalogue/normalization": "Normalización",
  "portal/managed-catalogue/pending": "Pendiente de normalizar",
  "portal/managed-catalogue/record-load-error":
    "No se pudo cargar el registro.",
  "portal/managed-catalogue/save-failed":
    "No se guardó. Disponibilidad sin cambios.",
  "portal/managed-catalogue/save-failed-body":
    "La disponibilidad sigue como estaba. Inténtalo de nuevo.",
  "portal/managed-catalogue/save-failed-short": "No se pudo guardar.",
  "portal/managed-catalogue/save-failed-title":
    "No se pudo guardar la disponibilidad",
  "portal/managed-catalogue/saving": "Guardando…",
  "portal/managed-catalogue/search": "Buscar {{title}}",
  "portal/managed-catalogue/section-catalogue": "Catálogo",
  "portal/managed-catalogue/section-general": "General",
  "portal/managed-catalogue/see-in-dictionary": "Ver en Diccionario",
  "portal/managed-catalogue/source": "Fuente",
  "portal/managed-catalogue/source-value": "{{source}} · {{code}}",
  "portal/managed-catalogue/unavailable": "No disponible",
  "portal/managed-catalogue/update-running":
    "Actualización en curso. Los registros siguen disponibles.",
  "portal/managed-catalogue/update-running-body":
    "Hay una actualización del catálogo en curso. Las filas siguen disponibles; los cambios de disponibilidad no se pierden.",
  "portal/managed-catalogue/update-running-title": "Actualización en curso",
  "portal/marketing": "Marketing",
  "portal/marketing-preferences/required-badge": "Obligatorio",
  "portal/marketing-preferences/required-explanation":
    "Esta categoría no se puede desactivar.",
  "portal/marketing-preferences/save": "Guardar preferencias",
  "portal/marketing-preferences/saved": "Tus preferencias se guardaron.",
  "portal/marketing-preferences/stale":
    "Esta página estaba desactualizada; ahora muestra tus preferencias actuales.",
  "portal/marketing-preferences/subtitle": "Elige qué correos quieres recibir.",
  "portal/marketing-preferences/test-preview-body":
    "Ninguna preferencia se ve afectada por este enlace de vista previa.",
  "portal/marketing-preferences/test-preview-title":
    "Esta es una vista previa de prueba",
  "portal/marketing-preferences/title": "Preferencias de correo",
  "portal/marketing/access-denied": "No tienes acceso a Marketing.",
  "portal/marketing/approval/approved": "Aprobada",
  "portal/marketing/approval/pending": "Pendiente de aprobación",
  "portal/marketing/approval/rejected": "Rechazada",
  "portal/marketing/audiences": "Audiencias",
  "portal/marketing/campaigns": "Campañas",
  "portal/marketing/campaigns/audience/audiences": "Audiencias",
  "portal/marketing/campaigns/audience/audiences-empty":
    "No hay audiencias que puedas leer.",
  "portal/marketing/campaigns/audience/audiences-selected":
    "{{count}} audiencias seleccionadas",
  "portal/marketing/campaigns/audience/blocked-body":
    "Una parte de la audiencia guardada (fuentes o contactos) está oculta para tu rol, así que guardar una nueva revisión la eliminaría sin avisar. Pide a alguien con más acceso que modifique esta campaña, o duplícala y arma una audiencia nueva.",
  "portal/marketing/campaigns/audience/blocked-title":
    "Esta audiencia no se puede editar desde aquí",
  "portal/marketing/campaigns/audience/excluded-unnamed": "Contacto {{number}}",
  "portal/marketing/campaigns/audience/exclusion-add": "Excluir",
  "portal/marketing/campaigns/audience/exclusion-remove":
    "Quitar la exclusión de {{name}}",
  "portal/marketing/campaigns/audience/exclusions": "Contactos excluidos",
  "portal/marketing/campaigns/audience/exclusions-search":
    "Buscar contactos para excluir",
  "portal/marketing/campaigns/audience/exclusions-selected":
    "{{count}} contactos excluidos",
  "portal/marketing/campaigns/audience/groups": "Grupos",
  "portal/marketing/campaigns/audience/groups-empty":
    "No hay grupos que puedas leer.",
  "portal/marketing/campaigns/audience/groups-selected":
    "{{count}} grupos seleccionados",
  "portal/marketing/campaigns/audience/lists": "Listas",
  "portal/marketing/campaigns/audience/lists-empty":
    "No hay listas que puedas leer.",
  "portal/marketing/campaigns/audience/lists-selected":
    "{{count}} listas seleccionadas",
  "portal/marketing/campaigns/audience/no-size-estimate":
    "El número final de destinatarios se calcula al programar la campaña.",
  "portal/marketing/campaigns/audience/none-selected":
    "Selecciona al menos una lista, grupo o audiencia.",
  "portal/marketing/campaigns/back": "Atrás",
  "portal/marketing/campaigns/conflict-body":
    "Recarga para ver la versión más reciente antes de hacer más cambios. No se sobrescribió nada.",
  "portal/marketing/campaigns/conflict-reload": "Recargar",
  "portal/marketing/campaigns/conflict-title":
    "Alguien más cambió esta campaña",
  "portal/marketing/campaigns/content/category": "Categoría",
  "portal/marketing/campaigns/content/name": "Nombre de la campaña",
  "portal/marketing/campaigns/content/name-readonly":
    "El nombre no se puede cambiar después de crear la campaña.",
  "portal/marketing/campaigns/content/no-templates":
    "Aún no hay plantillas. Crea una primero en Plantillas.",
  "portal/marketing/campaigns/content/sender": "Remitente",
  "portal/marketing/campaigns/content/subject": "Asunto",
  "portal/marketing/campaigns/content/subject-hint":
    "El asunto viene de la versión de plantilla elegida y es el mismo para todos los destinatarios.",
  "portal/marketing/campaigns/content/template": "Plantilla",
  "portal/marketing/campaigns/content/version": "Versión de la plantilla",
  "portal/marketing/campaigns/content/version-label": "Versión {{version}}",
  "portal/marketing/campaigns/control/already":
    "El envío ya estaba en ese estado.",
  "portal/marketing/campaigns/control/cancel": "Cancelar envío",
  "portal/marketing/campaigns/control/cancel-done": "Cancelación solicitada.",
  "portal/marketing/campaigns/control/cancel-message":
    "Los mensajes aún no enviados no se enviarán. Esta acción no se puede deshacer.",
  "portal/marketing/campaigns/control/cancel-title": "¿Cancelar este envío?",
  "portal/marketing/campaigns/control/conflict-body":
    "Se actualizó el progreso. Revisa el nuevo estado e inténtalo de nuevo.",
  "portal/marketing/campaigns/control/conflict-title": "El envío cambió",
  "portal/marketing/campaigns/control/held-body":
    "El envío no puede reanudarse mientras la espera esté activa. Cancela esta campaña y duplícala para enviarla de nuevo.",
  "portal/marketing/campaigns/control/held-title": "La espera sigue activa",
  "portal/marketing/campaigns/control/pause": "Pausar",
  "portal/marketing/campaigns/control/pause-done": "Pausa solicitada.",
  "portal/marketing/campaigns/control/resume": "Reanudar",
  "portal/marketing/campaigns/control/resume-done": "Envío reanudado.",
  "portal/marketing/campaigns/control/still-draining-body":
    "El envío aún termina los mensajes en curso. Inténtalo de nuevo en un momento.",
  "portal/marketing/campaigns/control/still-draining-title":
    "Aún se está pausando",
  "portal/marketing/campaigns/detail/duplicate": "Duplicar",
  "portal/marketing/campaigns/detail/duplicate-failed":
    "No se pudo duplicar la campaña.",
  "portal/marketing/campaigns/detail/edit": "Abrir en el asistente",
  "portal/marketing/campaigns/detail/load-error":
    "No se pudo cargar la campaña.",
  "portal/marketing/campaigns/detail/no-dispatch":
    "Esta campaña aún no se programa.",
  "portal/marketing/campaigns/detail/refresh": "Actualizar",
  "portal/marketing/campaigns/detail/select":
    "Selecciona una campaña para ver sus detalles.",
  "portal/marketing/campaigns/field-required": "Este campo es obligatorio.",
  "portal/marketing/campaigns/list/empty": "Aún no hay campañas.",
  "portal/marketing/campaigns/list/no-revision": "Sin revisión",
  "portal/marketing/campaigns/list/not-scheduled": "Sin programar",
  "portal/marketing/campaigns/list/readiness": "Revisión: {{state}}",
  "portal/marketing/campaigns/list/readiness/invalid": "con errores",
  "portal/marketing/campaigns/list/readiness/pending": "en revisión",
  "portal/marketing/campaigns/list/readiness/ready": "lista",
  "portal/marketing/campaigns/list/readiness/unknown": "desconocida",
  "portal/marketing/campaigns/list/scheduled-at": "Programada {{when}}",
  "portal/marketing/campaigns/list/subtitle":
    "Crea, revisa y monitorea campañas de correo.",
  "portal/marketing/campaigns/list/title": "Campañas",
  "portal/marketing/campaigns/list/updated-at": "Actualizada {{when}}",
  "portal/marketing/campaigns/load-error":
    "No se pudieron cargar los datos de la campaña.",
  "portal/marketing/campaigns/loading": "Cargando…",
  "portal/marketing/campaigns/new": "Nueva campaña",
  "portal/marketing/campaigns/next": "Siguiente",
  "portal/marketing/campaigns/permission-denied":
    "No tienes permiso para hacer esto.",
  "portal/marketing/campaigns/placeholder-title": "Campañas",
  "portal/marketing/campaigns/progress/counts": "Destinatarios por estado",
  "portal/marketing/campaigns/progress/hold-body":
    "El envío se detuvo automáticamente. Si la causa no se resuelve, cancela esta campaña y duplícala para enviarla de nuevo.",
  "portal/marketing/campaigns/progress/hold-reasons": "Motivos",
  "portal/marketing/campaigns/progress/hold-reasons-hidden":
    "Tu rol no puede ver los motivos de la espera. Consulta a un administrador.",
  "portal/marketing/campaigns/progress/hold-title": "Este envío está en espera",
  "portal/marketing/campaigns/progress/issues":
    "{{count}} destinatarios requieren atención",
  "portal/marketing/campaigns/progress/load-error":
    "No se pudo cargar el progreso. Se muestran los últimos valores conocidos.",
  "portal/marketing/campaigns/progress/pausing":
    "Pausando: se terminan los mensajes en curso. Podrás reanudar cuando el envío esté en pausa.",
  "portal/marketing/campaigns/progress/scheduled-for":
    "Programada para {{when}}",
  "portal/marketing/campaigns/progress/state": "Estado",
  "portal/marketing/campaigns/progress/title": "Progreso del envío",
  "portal/marketing/campaigns/progress/total": "{{total}} destinatarios",
  "portal/marketing/campaigns/read-only":
    "Puedes revisar esta campaña pero no editarla.",
  "portal/marketing/campaigns/request-failed":
    "La solicitud falló. Inténtalo de nuevo.",
  "portal/marketing/campaigns/review/approval": "Aprobación",
  "portal/marketing/campaigns/review/approve": "Aprobar",
  "portal/marketing/campaigns/review/approved-done": "Revisión aprobada.",
  "portal/marketing/campaigns/review/audiences": "Audiencias",
  "portal/marketing/campaigns/review/category": "Categoría",
  "portal/marketing/campaigns/review/contacts": "Contactos individuales",
  "portal/marketing/campaigns/review/deleted": "Eliminado",
  "portal/marketing/campaigns/review/excluded": "Contactos excluidos",
  "portal/marketing/campaigns/review/groups": "Grupos",
  "portal/marketing/campaigns/review/lists": "Listas",
  "portal/marketing/campaigns/review/no-approval": "Aún no solicitada",
  "portal/marketing/campaigns/review/no-revision":
    "Esta campaña aún no tiene una revisión guardada.",
  "portal/marketing/campaigns/review/none": "Ninguno",
  "portal/marketing/campaigns/review/not-ready": "No está lista para enviar",
  "portal/marketing/campaigns/review/readiness": "Preparación",
  "portal/marketing/campaigns/review/readiness-hidden":
    "La preparación se muestra a quienes pueden programar o aprobar.",
  "portal/marketing/campaigns/review/ready": "Lista para enviar",
  "portal/marketing/campaigns/review/reject": "Rechazar",
  "portal/marketing/campaigns/review/rejected-done": "Revisión rechazada.",
  "portal/marketing/campaigns/review/restricted": "Restringido",
  "portal/marketing/campaigns/review/revision": "Revisión {{number}}",
  "portal/marketing/campaigns/review/sender": "Remitente",
  "portal/marketing/campaigns/review/subject": "Asunto",
  "portal/marketing/campaigns/review/template": "Plantilla",
  "portal/marketing/campaigns/saving": "Guardando…",
  "portal/marketing/campaigns/schedule/date": "Fecha",
  "portal/marketing/campaigns/schedule/done": "Campaña programada.",
  "portal/marketing/campaigns/schedule/invalid-time":
    "Escribe la hora como HH:mm.",
  "portal/marketing/campaigns/schedule/missing-date": "Elige una fecha.",
  "portal/marketing/campaigns/schedule/no-access":
    "Programar y enviar pruebas está disponible para quienes pueden enviar campañas.",
  "portal/marketing/campaigns/schedule/offset": "Desfase UTC",
  "portal/marketing/campaigns/schedule/offset-hint":
    "Esta hora ocurre dos veces cuando se atrasa el reloj. Elige a cuál te refieres.",
  "portal/marketing/campaigns/schedule/replayed":
    "Esta solicitud ya se había procesado; no se creó un segundo envío.",
  "portal/marketing/campaigns/schedule/submit": "Programar envío",
  "portal/marketing/campaigns/schedule/time": "Hora (HH:mm)",
  "portal/marketing/campaigns/schedule/time-zone": "Zona horaria",
  "portal/marketing/campaigns/step-go-to": "Volver a {{step}}",
  "portal/marketing/campaigns/step/audience": "Audiencia",
  "portal/marketing/campaigns/step/content": "Contenido",
  "portal/marketing/campaigns/step/review": "Revisión",
  "portal/marketing/campaigns/step/schedule": "Programar y probar",
  "portal/marketing/campaigns/test/done": "Prueba enviada.",
  "portal/marketing/campaigns/test/limit":
    "Puedes elegir como máximo {{max}} destinatarios.",
  "portal/marketing/campaigns/test/none-allowed":
    "No hay destinatarios de prueba configurados. Agrégalos en la configuración de Marketing.",
  "portal/marketing/campaigns/test/recipients": "Destinatarios de prueba",
  "portal/marketing/campaigns/test/select-one":
    "Elige al menos un destinatario.",
  "portal/marketing/campaigns/test/send": "Enviar prueba",
  "portal/marketing/campaigns/test/title": "Enviar una prueba",
  "portal/marketing/campaigns/wizard-nav": "Pasos de la campaña",
  "portal/marketing/campaigns/wizard-title": "Nueva campaña",
  "portal/marketing/campaigns/wizard-title-edit": "Editar campaña",
  "portal/marketing/category/announcements": "Comunicados",
  "portal/marketing/category/marketing-sales": "Marketing y Ventas",
  "portal/marketing/category/transactional": "Transaccionales",
  "portal/marketing/contacts": "Contactos",
  "portal/marketing/contacts/audit-action/contact.created": "Contacto creado",
  "portal/marketing/contacts/audit-action/subscription.changed":
    "Preferencias modificadas",
  "portal/marketing/contacts/create": "Crear contacto",
  "portal/marketing/contacts/display-name": "Nombre para mostrar",
  "portal/marketing/contacts/display-name-entity-owned":
    "Se sincroniza desde la Entidad vinculada. Edítalo ahí para cambiar el nombre.",
  "portal/marketing/contacts/edit-title": "Editar contacto",
  "portal/marketing/contacts/email": "Correo electrónico",
  "portal/marketing/contacts/empty":
    "Aún no hay contactos. Importa un CSV o espera a que se sincronicen las entidades.",
  "portal/marketing/contacts/entity-linked": "Vinculado a entidad",
  "portal/marketing/contacts/existing-found":
    "Se encontró un contacto existente.",
  "portal/marketing/contacts/filter/all": "Todos",
  "portal/marketing/contacts/filter/entity-linked": "Vinculados a entidad",
  "portal/marketing/contacts/filter/mailing-only": "Solo para comunicaciones",
  "portal/marketing/contacts/filter/suppressed": "Suprimidos",
  "portal/marketing/contacts/filter/unsubscribed": "Sin suscripción",
  "portal/marketing/contacts/history/audit-events": "Actividad",
  "portal/marketing/contacts/history/campaigns": "Campañas",
  "portal/marketing/contacts/history/coming-soon":
    "Disponible cuando se lancen las campañas.",
  "portal/marketing/contacts/history/memberships": "Listas",
  "portal/marketing/contacts/history/no-audit-events":
    "No hay actividad registrada.",
  "portal/marketing/contacts/history/no-memberships":
    "No pertenece a ninguna lista.",
  "portal/marketing/contacts/history/suppressions": "Supresiones",
  "portal/marketing/contacts/identity": "Identidad",
  "portal/marketing/contacts/locale": "Idioma",
  "portal/marketing/contacts/mailing-only": "Solo para comunicaciones",
  "portal/marketing/contacts/no-notes": "Sin notas",
  "portal/marketing/contacts/notes": "Notas",
  "portal/marketing/contacts/open-entity": "Abrir entidad",
  "portal/marketing/contacts/open-existing": "Abrir existente",
  "portal/marketing/contacts/personalization": "Personalización",
  "portal/marketing/contacts/provenance": "Origen",
  "portal/marketing/contacts/provenance/entity-sync":
    "Sincronización de entidades",
  "portal/marketing/contacts/provenance/import": "Importación de CSV",
  "portal/marketing/contacts/provenance/manual": "Creación manual",
  "portal/marketing/contacts/select-from-list":
    "Selecciona un contacto de la lista",
  "portal/marketing/contacts/tab/history": "Historial",
  "portal/marketing/contacts/tab/main": "Principal",
  "portal/marketing/contacts/tab/preferences": "Preferencias",
  "portal/marketing/contacts/unsubscribe-all":
    "Cancelar todas las suscripciones",
  "portal/marketing/contacts/unsubscribe-all-confirm":
    "Este contacto dejará de recibir todas las comunicaciones opcionales. Las comunicaciones requeridas continúan.",
  "portal/marketing/contacts/updated": "Actualizado",
  "portal/marketing/deliverability/check-advisory": "Advertencia",
  "portal/marketing/deliverability/check-failed": "Fallido",
  "portal/marketing/deliverability/check-passed": "Aprobado",
  "portal/marketing/deliverability/hold-placed": "Colocado",
  "portal/marketing/deliverability/hold-reason": "Motivo",
  "portal/marketing/deliverability/hold-scope": "Alcance",
  "portal/marketing/deliverability/holds-title": "Bloqueos de envío activos",
  "portal/marketing/deliverability/kill-switch-banner":
    "El envío está actualmente bloqueado: {{count}} bloqueo(s) activo(s) o una verificación de preparación fallida.",
  "portal/marketing/deliverability/no-holds": "No hay bloqueos activos.",
  "portal/marketing/deliverability/no-suppressions":
    "No hay direcciones suprimidas.",
  "portal/marketing/deliverability/not-ready": "No está listo para enviar",
  "portal/marketing/deliverability/readiness-title":
    "Preparación de lanzamiento",
  "portal/marketing/deliverability/ready": "Listo para enviar",
  "portal/marketing/deliverability/refresh": "Actualizar",
  "portal/marketing/deliverability/suppression-effective": "Desde",
  "portal/marketing/deliverability/suppression-email": "Correo",
  "portal/marketing/deliverability/suppression-reason": "Motivo",
  "portal/marketing/deliverability/suppressions-title": "Supresiones",
  "portal/marketing/deliverability/suppressions-total":
    "{{count}} supresión(es) activa(s) — se muestran las 50 más recientes",
  "portal/marketing/disabled":
    "Marketing no está habilitado para esta empresa.",
  "portal/marketing/hold-reason/audience-cap-exceeded":
    "La audiencia es demasiado grande",
  "portal/marketing/hold-reason/authority-revoked":
    "Quien programó ya no tiene permiso",
  "portal/marketing/hold-reason/aws-reputation-bounce":
    "Alerta de reputación de la cuenta de envío",
  "portal/marketing/hold-reason/complaint-campaign":
    "Quejas de spam en esta campaña",
  "portal/marketing/hold-reason/complaint-provider-scope":
    "Quejas de spam en la cuenta de envío",
  "portal/marketing/hold-reason/feedback-health-degraded":
    "La retroalimentación de entrega está degradada",
  "portal/marketing/hold-reason/feedback-inbox-hard-failure-unprocessed":
    "No se pudo procesar la retroalimentación de entrega",
  "portal/marketing/hold-reason/local-permanent-bounce-ratio":
    "Demasiados rebotes permanentes",
  "portal/marketing/hold-reason/missed-window": "Se perdió la hora programada",
  "portal/marketing/hold-reason/module-disabled":
    "Marketing está deshabilitado",
  "portal/marketing/hold-reason/operational-eligibility-missing":
    "La elegibilidad de esta categoría no está configurada",
  "portal/marketing/hold-reason/other": "Retenida",
  "portal/marketing/hold-reason/provider-sending-paused":
    "El envío del proveedor está en pausa",
  "portal/marketing/hold-reason/provider-sending-state":
    "El envío del proveedor está restringido",
  "portal/marketing/hold-reason/provider-suppression-sync-untrusted":
    "La lista de supresión no está sincronizada",
  "portal/marketing/hold-reason/revision-drifted":
    "La revisión aprobada cambió",
  "portal/marketing/hold-reason/sender-not-ready": "El remitente no está listo",
  "portal/marketing/import/already-imported": "Ya se importó el {{date}}",
  "portal/marketing/import/change-file": "Elegir otro archivo",
  "portal/marketing/import/columns": "Columnas del CSV",
  "portal/marketing/import/commit": "Confirmar",
  "portal/marketing/import/commit-action": "Confirmar importación",
  "portal/marketing/import/continue": "Continuar",
  "portal/marketing/import/created": "Contactos creados",
  "portal/marketing/import/display-name": "Nombre para mostrar",
  "portal/marketing/import/done": "Importación completada",
  "portal/marketing/import/download-file-name":
    "problemas-importacion-contactos.csv",
  "portal/marketing/import/download-problems": "Descargar filas con problemas",
  "portal/marketing/import/duplicates-in-file": "Duplicados en el archivo",
  "portal/marketing/import/email": "Correo electrónico",
  "portal/marketing/import/existing-contacts": "Contactos existentes",
  "portal/marketing/import/file-size-limit":
    "Tamaño máximo del archivo: {{bytes}} bytes",
  "portal/marketing/import/file-too-large":
    "El archivo supera el tamaño permitido para importar.",
  "portal/marketing/import/ignore": "No importar esta columna",
  "portal/marketing/import/invalid": "Filas inválidas",
  "portal/marketing/import/invalid-page":
    "No se pudieron leer los resultados de la importación.",
  "portal/marketing/import/locale": "Idioma",
  "portal/marketing/import/map": "Asignar columnas",
  "portal/marketing/import/next-page": "Filas siguientes",
  "portal/marketing/import/notes": "Notas",
  "portal/marketing/import/nothing-written":
    "No se han creado ni modificado contactos.",
  "portal/marketing/import/personalization": "Campo de personalización",
  "portal/marketing/import/personalization-key":
    "Nombre del campo de personalización",
  "portal/marketing/import/personalization-key-required":
    "Ingresa un nombre para este campo de personalización",
  "portal/marketing/import/previous-page": "Filas anteriores",
  "portal/marketing/import/problem/duplicate-in-file":
    "Duplicado dentro de este archivo",
  "portal/marketing/import/problem/existing-contact": "El contacto ya existe",
  "portal/marketing/import/problem/invalid-display-name":
    "El nombre para mostrar es demasiado largo (máximo 255 caracteres)",
  "portal/marketing/import/problem/invalid-email":
    "Correo electrónico inválido",
  "portal/marketing/import/problem/invalid-locale": "Idioma no soportado",
  "portal/marketing/import/problem/invalid-notes":
    "Las notas son demasiado largas (máximo 2,000 caracteres)",
  "portal/marketing/import/problem/invalid-personalization-value":
    "El valor de personalización es demasiado largo (máximo 500 caracteres)",
  "portal/marketing/import/problems": "Problemas",
  "portal/marketing/import/row": "Fila",
  "portal/marketing/import/skipped": "Duplicados omitidos",
  "portal/marketing/import/title": "Importar contactos",
  "portal/marketing/import/unmapped": "Elige un campo…",
  "portal/marketing/import/upload": "Cargar",
  "portal/marketing/import/upload-helper": "Elige un archivo CSV.",
  "portal/marketing/import/valid": "Filas válidas",
  "portal/marketing/import/validate": "Validar",
  "portal/marketing/import/view-contacts": "Ver contactos",
  "portal/marketing/import/will-create": "Contactos por crear",
  "portal/marketing/lists": "Listas",
  "portal/marketing/lists/add-members": "Agregar miembros",
  "portal/marketing/lists/create": "Crear lista",
  "portal/marketing/lists/current-members": "Miembros actuales",
  "portal/marketing/lists/current-members-count": "{{count}} miembros actuales",
  "portal/marketing/lists/current-members-count-one": "1 miembro actual",
  "portal/marketing/lists/description": "Descripción",
  "portal/marketing/lists/edit": "Editar lista",
  "portal/marketing/lists/empty": "Aún no hay listas",
  "portal/marketing/lists/members": "Miembros",
  "portal/marketing/lists/name": "Nombre",
  "portal/marketing/lists/no-members": "Esta lista no tiene miembros visibles",
  "portal/marketing/lists/remove": "Quitar miembro",
  "portal/marketing/lists/remove-confirm": "¿Quitar este contacto de la lista?",
  "portal/marketing/lists/select": "Selecciona una lista",
  "portal/marketing/lists/select-contacts": "Buscar contactos",
  "portal/marketing/lists/subtitle": "Administra listas estáticas de contactos",
  "portal/marketing/lists/tab/members": "Miembros",
  "portal/marketing/lists/tab/settings": "Configuración",
  "portal/marketing/not-enabled":
    "Marketing no está habilitado para esta empresa.",
  "portal/marketing/overview": "Resumen",
  "portal/marketing/overview/add-sender": "Agregar remitente",
  "portal/marketing/overview/attention": "Bloqueados y atención",
  "portal/marketing/overview/campaigns-sent": "Campañas enviadas",
  "portal/marketing/overview/contacts-eligible": "Contactos elegibles",
  "portal/marketing/overview/import-contacts": "Importar contactos",
  "portal/marketing/overview/last-30-days": "Últimos 30 días",
  "portal/marketing/overview/load-error": "No se pudo cargar el resumen",
  "portal/marketing/overview/new-campaign": "Nueva campaña",
  "portal/marketing/overview/no-campaigns": "Aún no hay campañas",
  "portal/marketing/overview/recent-campaigns": "Campañas recientes",
  "portal/marketing/overview/recipients-accepted": "Destinatarios aceptados",
  "portal/marketing/overview/see-all": "Ver todas",
  "portal/marketing/overview/sender-readiness": "Remitentes listos",
  "portal/marketing/overview/start": "Comenzar",
  "portal/marketing/preferences/all-optional-opt-out":
    "Cancelar suscripción a todos los correos opcionales",
  "portal/marketing/preferences/conflict":
    "Las preferencias se actualizaron en otro lugar; se muestra la versión más reciente.",
  "portal/marketing/preferences/load-error":
    "No se pudieron cargar las preferencias.",
  "portal/marketing/preferences/loading": "Cargando preferencias",
  "portal/marketing/preferences/required": "Obligatoria",
  "portal/marketing/preferences/required-readout":
    "Obligatoria, no se puede cambiar",
  "portal/marketing/preferences/retry": "Reintentar",
  "portal/marketing/preferences/subscribed": "Suscrito",
  "portal/marketing/preferences/unset": "Sin definir",
  "portal/marketing/recipient-state/accepted": "Aceptado para entrega",
  "portal/marketing/recipient-state/cancelled": "Cancelado",
  "portal/marketing/recipient-state/claimed": "En proceso",
  "portal/marketing/recipient-state/failed": "Fallido",
  "portal/marketing/recipient-state/pending": "Pendiente",
  "portal/marketing/recipient-state/pending-error": "No se pudo preparar",
  "portal/marketing/recipient-state/suppressed": "Suprimido",
  "portal/marketing/recipient-state/unknown": "Resultado desconocido",
  "portal/marketing/resources": "Recursos",
  "portal/marketing/retry": "Reintentar",
  "portal/marketing/settings": "Configuración",
  "portal/marketing/settings/ImportMaxCellBytes": "Máximo de bytes por celda",
  "portal/marketing/settings/ImportMaxColumns":
    "Máximo de columnas por importación",
  "portal/marketing/settings/ImportMaxFileBytes":
    "Máximo de bytes del archivo CSV",
  "portal/marketing/settings/ImportMaxRows": "Máximo de filas por importación",
  "portal/marketing/settings/MaxAttachmentAggregateBytes":
    "Máximo total de bytes en adjuntos",
  "portal/marketing/settings/MaxAttachments": "Máximo de archivos adjuntos",
  "portal/marketing/settings/MaxCampaignRecipients":
    "Máximo de destinatarios por campaña",
  "portal/marketing/settings/MaxEncodedMessageBytes":
    "Máximo de bytes del mensaje codificado",
  "portal/marketing/settings/TestRecipientMaxCount":
    "Máximo de destinatarios de prueba",
  "portal/marketing/settings/add-sender": "Agregar remitente",
  "portal/marketing/settings/audit": "Auditoría",
  "portal/marketing/settings/audit-actor": "Identificador del actor",
  "portal/marketing/settings/audit-object": "Tipo de objeto",
  "portal/marketing/settings/brand": "Marca",
  "portal/marketing/settings/brand-accent-color": "Color de acento",
  "portal/marketing/settings/brand-footer-address":
    "Dirección en el pie de página",
  "portal/marketing/settings/brand-footer-legal-name":
    "Razón social en el pie de página",
  "portal/marketing/settings/brand-logo": "Logotipo",
  "portal/marketing/settings/brand-name": "Nombre de marca",
  "portal/marketing/settings/brand-no-logo": "Aún no hay logotipo registrado",
  "portal/marketing/settings/categories": "Categorías",
  "portal/marketing/settings/category-subscription-note":
    "Cambiar una categoría nunca modifica las suscripciones existentes.",
  "portal/marketing/settings/check-now": "Verificar ahora",
  "portal/marketing/settings/check-now-caption":
    "Con el verificador manual, ningún remitente llega a verificado automáticamente.",
  "portal/marketing/settings/click-tracking-enabled": "Medir clics",
  "portal/marketing/settings/create-brand-profile": "Crear perfil de marca",
  "portal/marketing/settings/default": "Predeterminado",
  "portal/marketing/settings/deliverability": "Entregabilidad",
  "portal/marketing/settings/disable": "Deshabilitar",
  "portal/marketing/settings/disable-sender-confirm":
    "Un remitente deshabilitado no puede seleccionarse para borradores nuevos. Las campañas programadas existentes no se ven afectadas.",
  "portal/marketing/settings/disabled": "Deshabilitado",
  "portal/marketing/settings/edit": "Editar",
  "portal/marketing/settings/edit-category": "Editar categoría",
  "portal/marketing/settings/edit-limits": "Editar límites",
  "portal/marketing/settings/enable": "Habilitar",
  "portal/marketing/settings/enabled": "Habilitado",
  "portal/marketing/settings/first-batch-observation-hold-minutes":
    "Pausa de observación del primer lote (minutos)",
  "portal/marketing/settings/first-batch-size": "Tamaño del primer lote",
  "portal/marketing/settings/label-en": "Etiqueta en inglés",
  "portal/marketing/settings/label-es": "Etiqueta en español",
  "portal/marketing/settings/limits": "Límites",
  "portal/marketing/settings/max-recipients": "Máximo de destinatarios",
  "portal/marketing/settings/no-audit": "No hay eventos de auditoría",
  "portal/marketing/settings/no-brand-profile":
    "Aún no hay un perfil de marca configurado",
  "portal/marketing/settings/no-policy": "No hay política configurada",
  "portal/marketing/settings/no-senders": "Aún no hay remitentes configurados",
  "portal/marketing/settings/open-tracking-enabled": "Medir aperturas",
  "portal/marketing/settings/order": "Orden",
  "portal/marketing/settings/register-hosted-logo":
    "Registrar logotipo alojado",
  "portal/marketing/settings/register-hosted-logo-caption":
    "Registra una imagen ya alojada (por ejemplo, un logotipo existente de la empresa) como el logotipo publicado de esta marca. Esta es una acción de arranque de M1, no el flujo de carga de la biblioteca de recursos.",
  "portal/marketing/settings/register-hosted-logo-name": "Nombre del logotipo",
  "portal/marketing/settings/register-hosted-logo-url":
    "URL de la imagen alojada",
  "portal/marketing/settings/required": "Obligatorio",
  "portal/marketing/settings/sender-binding": "Vinculación de proveedor",
  "portal/marketing/settings/sender-display-name": "Nombre visible",
  "portal/marketing/settings/sender-from-email": "Dirección de remitente",
  "portal/marketing/settings/sender-reply-to": "Dirección de respuesta",
  "portal/marketing/settings/senders": "Remitentes",
  "portal/marketing/settings/set-default": "Establecer como predeterminado",
  "portal/marketing/settings/test-recipient-limit":
    "Límite de destinatarios de prueba",
  "portal/marketing/settings/test-recipients":
    "Destinatarios de prueba aprobados",
  "portal/marketing/state/accepted": "Aceptado",
  "portal/marketing/state/approved": "Aprobada",
  "portal/marketing/state/blocked": "Bloqueado",
  "portal/marketing/state/bounced": "Rebotado",
  "portal/marketing/state/cancelled": "Cancelada",
  "portal/marketing/state/cancelling": "Cancelando",
  "portal/marketing/state/claimed": "Reservado",
  "portal/marketing/state/clean": "Limpio",
  "portal/marketing/state/complained": "Queja",
  "portal/marketing/state/complaint": "Queja",
  "portal/marketing/state/completed": "Completada",
  "portal/marketing/state/completed-with-issues": "Completada con incidencias",
  "portal/marketing/state/delivered": "Entregado",
  "portal/marketing/state/draft": "Borrador",
  "portal/marketing/state/hard-bounce": "Rebote permanente",
  "portal/marketing/state/held": "En espera",
  "portal/marketing/state/manual": "Manual",
  "portal/marketing/state/manual-attested": "Validado manualmente",
  "portal/marketing/state/manual-attested-description":
    "Validado manualmente, no escaneado",
  "portal/marketing/state/not_verified": "Sin verificar",
  "portal/marketing/state/paused": "Pausada",
  "portal/marketing/state/pausing": "Pausando",
  "portal/marketing/state/pending": "Pendiente",
  "portal/marketing/state/pending-error": "Pendiente de corrección",
  "portal/marketing/state/preparing": "Preparando",
  "portal/marketing/state/provider-suppressed": "Supresión del proveedor",
  "portal/marketing/state/ready": "Lista",
  "portal/marketing/state/revalidation_required": "Requiere revalidación",
  "portal/marketing/state/scheduled": "Programada",
  "portal/marketing/state/sending": "Enviando",
  "portal/marketing/state/suppressed": "Suprimido",
  "portal/marketing/state/temporary": "Temporal",
  "portal/marketing/state/unknown": "Desconocido",
  "portal/marketing/state/verification_failed": "Verificación fallida",
  "portal/marketing/state/verification_pending": "Verificación pendiente",
  "portal/marketing/state/verified": "Verificado",
  "portal/marketing/templates": "Plantillas",
  "portal/marketing/templates/category": "Categoría",
  "portal/marketing/templates/create": "Nueva plantilla",
  "portal/marketing/templates/diagnostics-title":
    "Contenido eliminado o no compatible",
  "portal/marketing/templates/empty": "Aún no hay plantillas",
  "portal/marketing/templates/insert-variable": "Insertar variable",
  "portal/marketing/templates/name": "Nombre",
  "portal/marketing/templates/no-variables":
    "No hay variables de personalización declaradas",
  "portal/marketing/templates/preheader": "Preencabezado",
  "portal/marketing/templates/preview-desktop": "Escritorio",
  "portal/marketing/templates/preview-mobile": "Móvil",
  "portal/marketing/templates/preview-title": "Vista previa del correo",
  "portal/marketing/templates/reload-latest": "Recargar más reciente",
  "portal/marketing/templates/revision-conflict":
    "Esta plantilla cambió en otro lugar. Recarga la versión más reciente antes de guardar.",
  "portal/marketing/templates/select-from-list":
    "Selecciona una plantilla de la lista",
  "portal/marketing/templates/select-variable": "Selecciona una variable",
  "portal/marketing/templates/subject": "Asunto",
  "portal/marketing/templates/updated": "Actualizado",
  "portal/missing-company-context": "No hay una compañía seleccionada",
  "portal/modals/editEntityRole/no-assignable-scopes":
    "No tienes alcances asignables",
  "portal/modals/editEntityRole/options-load-failed":
    "No se pudieron cargar los roles que puedes asignar. Cierra esta ventana e inténtalo de nuevo.",
  "portal/model": "Modelo",
  "portal/name": "Nombre",
  "portal/new": "Nuevo",
  "portal/new-business": "Póliza Nueva",
  "portal/next": "Siguiente",
  "portal/no": "No",
  "portal/no-agencies-to-display": "No hay agencias para mostrar",
  "portal/no-cedents-to-display": "No hay cedentes para mostrar",
  "portal/no-commission-tables": "No hay tablas de comisiones para mostrar",
  "portal/no-customers-to-display": "No hay clientes para mostrar",
  "portal/no-employees-to-display": "No hay empleados para mostrar",
  "portal/no-files": "No hay ningún archivo",
  "portal/no-insurers-to-display": "No hay aseguradoras para mostrar",
  "portal/no-placement-to-display": "No hay colocaciones para mostrar",
  "portal/no-policies-to-display": "No hay pólizas para mostrar",
  "portal/no-records": "Sin registros",
  "portal/no-results-found": "No se encontraron resultados",
  "portal/no-roles-assigned": "No hay roles asignados",
  "portal/no-users-to-display": "No hay usuarios para mostrar",
  "portal/no-vendors-to-display": "No hay proveedores para mostrar",
  "portal/none": "Ninguno",
  "portal/not-a-valid-date": "Fecha no válida",
  "portal/notifications/empty": "No tienes notificaciones.",
  "portal/notifications/load-error": "No se pudieron cargar.",
  "portal/notifications/mark-all-read": "Marcar todo como leído",
  "portal/notifications/severity-error": "Error",
  "portal/notifications/severity-info": "Información",
  "portal/notifications/severity-warning": "Aviso",
  "portal/notifications/title": "Notificaciones",
  "portal/notifications/unread": "Sin leer: {{count}}",
  "portal/notifications/unread-status": "Sin leer",
  "portal/order": "Orden",
  "portal/output-context": "Contexto de Salida",
  "portal/output-fields": "Campos de Salida (key:variable, ...)",
  "portal/output-variable": "Variable de Salida",
  "portal/overview": "General",
  "portal/payment-annually": "Anual",
  "portal/payment-monthly": "Mensual",
  "portal/payment-quarterly": "Trimestral",
  "portal/payment-semiannually": "Semestral",
  "portal/pipeline-active": "Activo",
  "portal/pipeline-version": "Versión",
  "portal/pipeline/actions": "Acciones",
  "portal/pipeline/activity-tab":
    "Pestaña de actividad: muestra la línea de tiempo del caso, no tiene campos.",
  "portal/pipeline/add-action": "Agregar Acción",
  "portal/pipeline/add-condition": "Agregar Condición",
  "portal/pipeline/add-document": "Agregar Documento",
  "portal/pipeline/add-field": "Agregar Campo",
  "portal/pipeline/add-group": "Agregar Grupo",
  "portal/pipeline/add-rule": "Agregar Regla",
  "portal/pipeline/add-stage": "Agregar Etapa",
  "portal/pipeline/add-step": "Agregar Paso",
  "portal/pipeline/add-tab": "Agregar Pestaña",
  "portal/pipeline/add-transition": "Agregar Transición",
  "portal/pipeline/add-user-skill": "Agregar Habilidad",
  "portal/pipeline/assignment-rule-name": "Nombre de Regla",
  "portal/pipeline/assignment-rules": "Reglas de Asignación",
  "portal/pipeline/back": "Regresar",
  "portal/pipeline/capabilities": "Capacidades",
  "portal/pipeline/column-format": "Formato",
  "portal/pipeline/column-header": "Encabezado de Columna",
  "portal/pipeline/column-width": "Ancho",
  "portal/pipeline/columns": "Columnas",
  "portal/pipeline/component": "Componente",
  "portal/pipeline/condition-group": "Grupo",
  "portal/pipeline/conditions": "Condiciones",
  "portal/pipeline/delete-transition": "Eliminar Transición",
  "portal/pipeline/delete-transition-confirm":
    "¿Estás seguro de que deseas eliminar esta transición? Esta acción no se puede deshacer.",
  "portal/pipeline/detail-layout": "Diseño de Detalle",
  "portal/pipeline/detail-view": "Detalle",
  "portal/pipeline/disabled": "Deshabilitado",
  "portal/pipeline/document-format": "Formato",
  "portal/pipeline/documents": "Documentos",
  "portal/pipeline/edit-action": "Editar Acción",
  "portal/pipeline/edit-condition": "Editar Condición",
  "portal/pipeline/edit-document": "Editar Documento",
  "portal/pipeline/edit-pdf-template": "Editar Plantilla PDF",
  "portal/pipeline/edit-rule": "Editar Regla",
  "portal/pipeline/edit-stage": "Editar Etapa",
  "portal/pipeline/edit-transition": "Editar Transición",
  "portal/pipeline/edit-user-skill": "Editar Habilidad",
  "portal/pipeline/edit-xlsx-template": "Editar Plantilla XLSX",
  "portal/pipeline/enabled": "Habilitado",
  "portal/pipeline/expression": "Expresión",
  "portal/pipeline/field": "Campo",
  "portal/pipeline/fields/agency-name": "Nombre de la agencia",
  "portal/pipeline/fields/group-entity": "Entidad",
  "portal/pipeline/fields/group-lob": "Ramo",
  "portal/pipeline/fields/group-policy": "Póliza",
  "portal/pipeline/fields/insurer-name": "Nombre de la aseguradora",
  "portal/pipeline/fields/lob-generates-receipts": "Ramo genera recibos",
  "portal/pipeline/fields/lob-issuable": "Ramo emisible",
  "portal/pipeline/fields/lob-name": "Nombre del ramo",
  "portal/pipeline/fields/lob-prefix": "Prefijo del ramo",
  "portal/pipeline/fields/modality": "Modalidad",
  "portal/pipeline/fields/net-premium": "Prima neta",
  "portal/pipeline/fields/policy-holder-country": "País del contratante",
  "portal/pipeline/fields/policy-holder-name": "Nombre del contratante",
  "portal/pipeline/fields/policy-number": "Número de póliza",
  "portal/pipeline/fields/policy-type": "Tipo de póliza",
  "portal/pipeline/fields/stage": "Etapa",
  "portal/pipeline/fields/total-premium": "Prima total",
  "portal/pipeline/fields/type": "Tipo",
  "portal/pipeline/form-definition": "Formulario Dinámico",
  "portal/pipeline/form-definition-none": "Ninguno",
  "portal/pipeline/form-steps": "Pasos del Formulario",
  "portal/pipeline/form-view": "Formulario",
  "portal/pipeline/icon": "Ícono",
  "portal/pipeline/indent": "Anidar",
  "portal/pipeline/insert-field": "Insertar Campo",
  "portal/pipeline/label": "Etiqueta",
  "portal/pipeline/lob-categories": "Categorías de LOB",
  "portal/pipeline/lock-all-fields":
    "Bloquear todos los campos del caso en esta etapa",
  "portal/pipeline/lock-all-fields-hint":
    "El servidor rechaza cualquier cambio al caso, a su materia asegurada y a sus atributos mientras esté en esta etapa. Los movimientos de etapa y las actualizaciones del sistema siguen funcionando.",
  "portal/pipeline/method": "Método",
  "portal/pipeline/move-down": "Mover abajo",
  "portal/pipeline/move-up": "Mover arriba",
  "portal/pipeline/no-actions-configured": "Sin acciones configuradas.",
  "portal/pipeline/no-attributes": "No hay atributos definidos.",
  "portal/pipeline/no-columns":
    "No hay columnas definidas. Haga clic en + para agregar una.",
  "portal/pipeline/no-conditions": "Sin condiciones configuradas",
  "portal/pipeline/no-definitions":
    "No se encontraron definiciones de materia asegurada para esta línea.",
  "portal/pipeline/no-documents-configured":
    "Sin plantillas de documento configuradas.",
  "portal/pipeline/no-fields-configured": "Sin campos configurados.",
  "portal/pipeline/no-form-steps-configured":
    "Sin pasos de formulario configurados.",
  "portal/pipeline/no-lob-selected":
    "No hay línea de negocio vinculada a esta etapa.",
  "portal/pipeline/no-rules": "No hay reglas de asignación configuradas.",
  "portal/pipeline/notes-content": "Contenido de Notas",
  "portal/pipeline/operator": "Operador",
  "portal/pipeline/order": "Orden",
  "portal/pipeline/outdent": "Desanidar",
  "portal/pipeline/priority": "Prioridad",
  "portal/pipeline/read-only-at-stage": "Solo lectura en esta etapa",
  "portal/pipeline/rename-sheet": "Renombrar Hoja",
  "portal/pipeline/required-at-stage": "Requerido en esta etapa",
  "portal/pipeline/roles/assignee": "Asignado",
  "portal/pipeline/roles/external": "Externo",
  "portal/pipeline/roles/internal": "Interno",
  "portal/pipeline/roles/requester": "Solicitante",
  "portal/pipeline/section-header": "Encabezado",
  "portal/pipeline/section-notes": "Notas",
  "portal/pipeline/section-separator": "Separador",
  "portal/pipeline/section-table": "Tabla",
  "portal/pipeline/section-title": "Título",
  "portal/pipeline/sections": "Secciones",
  "portal/pipeline/select-section": "Seleccione una sección para editar",
  "portal/pipeline/separator-description":
    "Muestra una línea horizontal en el documento",
  "portal/pipeline/sheet-name": "Nombre de Hoja",
  "portal/pipeline/skill-filter": "Filtro de Habilidades",
  "portal/pipeline/stage-not-found": "Etapa no encontrada",
  "portal/pipeline/stage-properties": "Propiedades de Etapa",
  "portal/pipeline/strategy": "Estrategia",
  "portal/pipeline/strategy/least-loaded": "Menos cargado",
  "portal/pipeline/strategy/manual-claim": "Asignación manual",
  "portal/pipeline/strategy/round-robin": "Por turnos",
  "portal/pipeline/subject-matter-requirements":
    "Requisitos de Materia Asegurada",
  "portal/pipeline/tab": "Pestaña",
  "portal/pipeline/task-type": "Tipo de Tarea",
  "portal/pipeline/transition-not-found": "Transición no encontrada",
  "portal/pipeline/transition-properties": "Propiedades de Transición",
  "portal/pipeline/transition-type": "Tipo",
  "portal/pipeline/type-action": "Acción",
  "portal/pipeline/type-automatic": "Automática",
  "portal/pipeline/user-skill-capability": "Capacidad",
  "portal/pipeline/user-skill-lob-category": "Categoría de LOB",
  "portal/pipeline/value": "Valor",
  "portal/pipeline/value-type": "Tipo de Valor",
  "portal/pipeline/view-detail": "Detalle",
  "portal/pipeline/view-form": "Formulario",
  "portal/pipeline/view-none": "Ninguno",
  "portal/pipeline/views": "Vistas",
  "portal/pipelines": "Pipelines",
  "portal/placement": "Colocación",
  "portal/placement/accepted": "Aceptado",
  "portal/placement/add-proposal": "Agregar Propuesta",
  "portal/placement/all": "Todos los Casos",
  "portal/placement/cancelled": "Cancelado",
  "portal/placement/closed": "Casos Cerrados",
  "portal/placement/completed": "Completados",
  "portal/placement/declined": "Rechazado",
  "portal/placement/draft": "Borrador",
  "portal/placement/drafts": "Borradores",
  "portal/placement/edit-quote": "Modificar Cotización",
  "portal/placement/expedition": "En Expedición",
  "portal/placement/inforce": "En Vigencia",
  "portal/placement/issuance": "En Emisión",
  "portal/placement/issuance-accepted": "Emisión aceptada",
  "portal/placement/issuance-rejected": "Emisión rechazada",
  "portal/placement/issuance-requested": "Emisión solicitada",
  "portal/placement/issuing": "En Emisión",
  "portal/placement/lapsed": "Lapsado",
  "portal/placement/lost": "Perdido",
  "portal/placement/open": "Casos Abiertos",
  "portal/placement/pending-issuance": "Emisión Pendiente",
  "portal/placement/pending-quote": "Cotización Pendiente",
  "portal/placement/pre-issuance": "Pre-emisión",
  "portal/placement/quote-expired": "Expirados",
  "portal/placement/quoted": "Cotizados",
  "portal/placement/rejected": "Rechazado",
  "portal/placement/requested": "Solicitado",
  "portal/policies": "Pólizas",
  "portal/policies/address": "Dirección",
  "portal/policies/cancel-order": "Cancelar Orden",
  "portal/policies/contacts": "Contactos",
  "portal/policies/coverages": "Coberturas",
  "portal/policies/endorsement": "Endoso",
  "portal/policies/entity-information": "Datos del Cliente",
  "portal/policies/er-aircrafts": "Aeronaves",
  "portal/policies/expiration-date": "Fecha de Fin de Vigencia",
  "portal/policies/files": "Archivos",
  "portal/policies/filters/expired": "Expiradas",
  "portal/policies/filters/issued": "Emitidas",
  "portal/policies/group-accidents": "Accidentes Personales Colectivo",
  "portal/policies/group-health": "Gastos Medicos Mayores Colectivo",
  "portal/policies/group-life": "Vida Grupo",
  "portal/policies/home": "Hogar",
  "portal/policies/in-force-date": "Fecha de Inicio de Vigencia",
  "portal/policies/individual-health": "Gastos Médicos Mayores Individual",
  "portal/policies/individual-vehicle": "Vehículo Individual",
  "portal/policies/list-filters": "Filtros",
  "portal/policies/list-filters-all": "Todos",
  "portal/policies/load-error": "No se pudo cargar la lista de pólizas",
  "portal/policies/main-contact": "Contacto Principal",
  "portal/policies/no-policies-to-display": "No hay pólizas para mostrar",
  "portal/policies/no-results": "Sin resultados",
  "portal/policies/overview": "General",
  "portal/policies/policy": "Póliza",
  "portal/policies/policy-files": "Archivos de Póliza",
  "portal/policies/policy-holder": "Contratante",
  "portal/policies/policy-information": "Información de la Póliza",
  "portal/policies/policyholder": "Contratante",
  "portal/policies/premiums": "Primas",
  "portal/policies/primary-insured": "Asegurado Principal",
  "portal/policies/proposal": "Propuesta",
  "portal/policies/quote": "Cotizar",
  "portal/policies/quotes": "Cotización",
  "portal/policies/recall-quote": "Cancelar Solicitud",
  "portal/policies/search-placeholder-placement": "Buscar colocaciones",
  "portal/policies/search-placeholder-policies": "Buscar pólizas",
  "portal/policies/select-policy-from-the-list":
    "Selecciona una póliza de la lista",
  "portal/policies/select-quote-from-the-list":
    "Selecciona una cotización de la lista",
  "portal/policies/sh/caribean": "Caribe",
  "portal/policies/sh/hull-region": "Región del Casco",
  "portal/policies/sh/hull-value": "Valor del Casco",
  "portal/policies/sh/hull-year": "Año del Casco",
  "portal/policies/sh/pacific": "Pacífico",
  "portal/policies/sh/ship-information": "Datos de la Embarcación",
  "portal/policies/ship-happens": "Ship Happens",
  "portal/policies/term-and-modality": "Vigencia y Modalidad",
  "portal/policies/total-premium": "Prima Total",
  "portal/policies/underwriter": "Suscriptor",
  "portal/policies/usual-driver": "Conductor Habitual",
  "portal/policies/vehicle": "Vehículo",
  "portal/policy-field": "Campo de Póliza",
  "portal/policy-file/change-file": "Cambiar",
  "portal/policy-file/endorsement-id": "ID de Endoso",
  "portal/policy-file/file": "Archivo",
  "portal/policy-file/file-is-required": "El archivo es requerido",
  "portal/policy-file/name": "Nombre del Archivo",
  "portal/policy-file/name-is-required": "El nombre del archivo es requerido",
  "portal/policy-file/policy-id": "ID de Póliza",
  "portal/policy-file/policy-id-is-required": "El ID de póliza es requerido",
  "portal/policy-file/select-file": "Seleccionar",
  "portal/policy-holder": "Asegurado",
  "portal/policy-receipt/due-date": "Fecha de Vencimiento",
  "portal/policy-receipt/fees": "Derechos",
  "portal/policy-receipt/inforce-date": "Fecha de Vigencia",
  "portal/policy-receipt/net-premium": "Prima Neta",
  "portal/policy-receipt/number": "Número",
  "portal/policy-receipt/stage": "Estatus",
  "portal/policy-receipt/stage-is-required": "El estatus es requerido",
  "portal/policy-receipt/taxes": "Impuestos",
  "portal/policy-receipt/total-premium": "Prima Total",
  "portal/policy-type": "Tipo de Póliza",
  "portal/policy-type-is-required": "Es necesario indicar el tipo de póliza",
  "portal/policy/accounting": "Contabilidad",
  "portal/policy/accounting/amount": "Monto",
  "portal/policy/accounting/balance": "Saldo",
  "portal/policy/accounting/date": "Fecha",
  "portal/policy/accounting/description": "Descripción",
  "portal/policy/accounting/empty": "Aún no hay recibos ni pagos",
  "portal/policy/accounting/movements": "Movimientos",
  "portal/policy/accounting/stage": "Estatus",
  "portal/policy/action-failed": "La acción falló",
  "portal/policy/action-not-found": "Acción no encontrada",
  "portal/policy/action-not-found-description":
    'La acción "{{action}}" no existe en el modelo de Póliza',
  "portal/policy/activity/created": "Registró datos",
  "portal/policy/activity/error-title": "No se pudo cargar la actividad",
  "portal/policy/activity/moved-to": "Pasó a {{stage}}",
  "portal/policy/activity/no": "No",
  "portal/policy/activity/someone": "Un usuario",
  "portal/policy/activity/system": "Sistema",
  "portal/policy/activity/tab": "Actividad",
  "portal/policy/activity/today": "Hoy",
  "portal/policy/activity/truncated":
    "Se muestran los 200 eventos más recientes.",
  "portal/policy/activity/updated": "Actualizó datos",
  "portal/policy/activity/yes": "Sí",
  "portal/policy/activity/yesterday": "Ayer",
  "portal/policy/add-file": "Agregar Archivo",
  "portal/policy/add-payment": "Agregar Pago",
  "portal/policy/add-receipt": "Agregar Recibo",
  "portal/policy/agency": "Agencia",
  "portal/policy/agency-1": "Agencia Nivel 1",
  "portal/policy/agency-1-commission": "Comisión Agencia 1",
  "portal/policy/agency-2": "Agencia Nivel 2",
  "portal/policy/agency-2-commission": "Comisión Agencia 2",
  "portal/policy/agency-3": "Agencia Nivel 3",
  "portal/policy/agency-3-commission": "Comisión Agencia 3",
  "portal/policy/aircraft": "Aeronave",
  "portal/policy/aircraft/aircraftType": "Tipo de aeronave",
  "portal/policy/aircraft/aircraftType/airplane": "Avión",
  "portal/policy/aircraft/aircraftType/helicopter": "Helicóptero",
  "portal/policy/aircraft/airplaneClass": "Clase de aeronave",
  "portal/policy/aircraft/airplaneClass/jet": "Jet",
  "portal/policy/aircraft/airplaneClass/piston": "Pistón",
  "portal/policy/aircraft/airplaneClass/turboprop": "Turboprop",
  "portal/policy/aircraft/baseAirport": "Aeropuerto base",
  "portal/policy/aircraft/brand": "Marca",
  "portal/policy/aircraft/crew": "Tripulación",
  "portal/policy/aircraft/engineCount": "Número de motores",
  "portal/policy/aircraft/engineCount/multi": "Multimotor",
  "portal/policy/aircraft/engineCount/single": "Monomotor",
  "portal/policy/aircraft/geographicLimit": "Límite geográfico",
  "portal/policy/aircraft/geographicLimit/required":
    "El límite geográfico es obligatorio",
  "portal/policy/aircraft/helicopterPropulsion": "Propulsión del helicóptero",
  "portal/policy/aircraft/helicopterPropulsion/piston": "Pistón",
  "portal/policy/aircraft/helicopterPropulsion/turbine": "Turbina",
  "portal/policy/aircraft/hullValue": "Valor del casco (USD)",
  "portal/policy/aircraft/licence": "Matrícula",
  "portal/policy/aircraft/licence-format":
    "Matrícula inválida. Formatos aceptados: (1) de 1 a 3 letras, un guion y de 1 a 5 letras o dígitos — HK-5039, HC-CPQ, TG-ABC, YS-904P, HI-1015A, FAC-1234; (2) lo mismo, más un segundo guion opcional con 1 a 3 letras o dígitos — HK-5071-X, YS-111-N, TI-UL-042, UAV-TG-001; (3) una matrícula de EE. UU.: N seguida de 1 a 5 dígitos y hasta 2 letras, sin I ni O — N2801, N421A, N700AF, N99999. El guion después de la marca de país siempre es obligatorio (FAC-1234, no FAC1234).",
  "portal/policy/aircraft/model": "Modelo",
  "portal/policy/aircraft/passengers": "Pasajeros",
  "portal/policy/aircraft/serial": "Número de serie",
  "portal/policy/aircraft/usage": "Uso",
  "portal/policy/aircraft/usage/required": "El uso es obligatorio",
  "portal/policy/aircraft/validation/required": "Este campo es obligatorio",
  "portal/policy/aircraft/year": "Año",
  "portal/policy/allocated": "Asignado",
  "portal/policy/authority-correct": "Corregir dato",
  "portal/policy/av/line-breach-of-warranty": "Incumplimiento de garantías",
  "portal/policy/av/line-cargo": "Carga",
  "portal/policy/av/line-cmp": "Gastos médicos de tripulación",
  "portal/policy/av/line-cvs": "Pagos voluntarios a tripulación",
  "portal/policy/av/line-hangar-liability": "Responsabilidad de hangar",
  "portal/policy/av/line-hull": "Casco",
  "portal/policy/av/line-liability": "Responsabilidad civil",
  "portal/policy/av/line-luggage": "Equipaje",
  "portal/policy/av/line-pmp": "Gastos médicos de pasajeros",
  "portal/policy/av/line-pvs": "Pagos voluntarios a pasajeros",
  "portal/policy/av/line-spare-parts": "Partes y refacciones",
  "portal/policy/av/line-war": "Guerra",
  "portal/policy/balance": "Saldo",
  "portal/policy/cancel": "Cancelar",
  "portal/policy/cedent": "Cedente",
  "portal/policy/close": "Cerrar",
  "portal/policy/close-unissued": "Cerrar sin emitir",
  "portal/policy/coberturas-adicionales": "Coberturas adicionales",
  "portal/policy/coberturas-adicionales/avn23p":
    "AVN23A — Aeropuertos tipo E y F",
  "portal/policy/coberturas-adicionales/avn26a":
    "AVN26A — Devolución de prima por estadía",
  "portal/policy/coberturas-adicionales/avn61": "AVN61 — Valor Convenido",
  "portal/policy/coberturas-adicionales/avn63":
    "AVN63 — Cláusula de responsabilidad cruzada",
  "portal/policy/coberturas-adicionales/avn6a": "AVN6A — Pago de Primas",
  "portal/policy/coberturas-adicionales/avn71":
    "AVN71 — Exclusión de riesgos nucleares",
  "portal/policy/coberturas-adicionales/avn72":
    "AVN72 — Contratos (Derechos de Terceras Personas), Exclusión Act 1999",
  "portal/policy/coberturas-adicionales/avn73":
    "AVN73 — Cláusula de responsabilidad de pilotos y tripulación",
  "portal/policy/coberturas-adicionales/avn74":
    "AVN74 — Indemnización a Pilotos",
  "portal/policy/coberturas-adicionales/avn75":
    "AVN75 — Ropa y efectos de vuelo",
  "portal/policy/coberturas-adicionales/avn76":
    "AVN76 — Pagos Suplementarios, párrafos (a) al (d)",
  "portal/policy/coberturas-adicionales/avn77": "AVN77 — Uso no Autorizado",
  "portal/policy/coberturas-adicionales/avn78":
    "AVN78 — Cláusula de aterrizaje forzoso",
  "portal/policy/coberturas-adicionales/avn81":
    "AVN81 — Notificación Fuera de Horas",
  "portal/policy/coberturas-adicionales/avn91": "AVN91 — Costo de Intrusos",
  "portal/policy/coberturas-adicionales/avn94":
    "AVN94 — Regulaciones de Aeronavegabilidad",
  "portal/policy/commissions": "Comisiones",
  "portal/policy/coverages": "Coberturas",
  "portal/policy/coverages/breachOfWarranty": "Incumplimiento de garantía",
  "portal/policy/coverages/breachOfWarrantyLimit":
    "Límite de incumplimiento de garantía",
  "portal/policy/coverages/cargo": "Carga",
  "portal/policy/coverages/cargoLimit": "Límite de carga",
  "portal/policy/coverages/cmp": "Pagos médicos de tripulación",
  "portal/policy/coverages/cmpLimit": "Límite CMP",
  "portal/policy/coverages/coverage-row-not-found":
    "No se encontró esta cobertura en el caso. Vuelva a abrirla desde el paso del objeto asegurable.",
  "portal/policy/coverages/coverageType": "Tipo de cobertura",
  "portal/policy/coverages/coverageType/all-risk": "Todo riesgo",
  "portal/policy/coverages/coverageType/basic": "Básica",
  "portal/policy/coverages/coverageType/hull-only": "Solo casco",
  "portal/policy/coverages/coverageType/limited": "Limitada",
  "portal/policy/coverages/cvs": "Acuerdos voluntarios de tripulación",
  "portal/policy/coverages/cvsLimit": "Límite CVS",
  "portal/policy/coverages/extendedLiability": "Responsabilidad extendida",
  "portal/policy/coverages/hangarLiability": "Responsabilidad de hangar",
  "portal/policy/coverages/hangarLiabilityLimit":
    "Límite de responsabilidad de hangar",
  "portal/policy/coverages/host-definition-not-found":
    "Este paso de cobertura no tiene un objeto asegurable configurado.",
  "portal/policy/coverages/hull-type-cap":
    "El valor del casco no puede exceder {{max}} para este tipo de aeronave",
  "portal/policy/coverages/hullValue": "Valor casco (USD)",
  "portal/policy/coverages/liability-type-cap":
    "El límite de responsabilidad (LUC) no puede exceder {{max}} para este tipo de aeronave",
  "portal/policy/coverages/liabilityLimit": "Límite de responsabilidad",
  "portal/policy/coverages/limit-out-of-range":
    "El límite debe estar entre {{min}} y {{max}}",
  "portal/policy/coverages/luggage": "Equipaje",
  "portal/policy/coverages/luggageLimit": "Límite de equipaje",
  "portal/policy/coverages/no-target-to-link":
    "El objeto asegurable debe capturarse antes de las coberturas.",
  "portal/policy/coverages/pmp": "Pagos médicos de pasajeros",
  "portal/policy/coverages/pmpLimit": "Límite PMP",
  "portal/policy/coverages/pvs": "Acuerdos voluntarios de pasajeros",
  "portal/policy/coverages/pvsLimit": "Límite PVS",
  "portal/policy/coverages/section/hull": "Cobertura de casco",
  "portal/policy/coverages/section/liability": "Cobertura de responsabilidad",
  "portal/policy/coverages/section/other": "Otras coberturas",
  "portal/policy/coverages/spareParts": "Refacciones",
  "portal/policy/coverages/sparePartsLimit": "Límite de refacciones",
  "portal/policy/coverages/unknown-attribute-owner":
    "Un campo de este paso no está configurado correctamente y no puede guardarse. Contacte a soporte.",
  "portal/policy/coverages/usage-hull-value-cap":
    "El valor del casco no puede exceder {{max}} para el uso «{{label}}»",
  "portal/policy/coverages/validation/liability-limit-positive":
    "Ingrese un monto mayor a cero",
  "portal/policy/coverages/validation/positive":
    "Ingrese un monto mayor a cero",
  "portal/policy/coverages/validation/required": "Este campo es obligatorio",
  "portal/policy/coverages/warRiskCoverage": "Riesgo de guerra",
  "portal/policy/covered-period-text":
    "De las {{inForceTime}} horas del {{inForceDate}} a las {{expirationTime}} horas del {{expirationDate}}",
  "portal/policy/credit": "Abono",
  "portal/policy/crew-medical-payments-coverage":
    "Gastos Médicos a Tripulación",
  "portal/policy/crew-medical-payments-coverage-description":
    "USD {{sum}} a cada tripulante.",
  "portal/policy/crew-voluntary-settlements-coverage":
    "Pagos Voluntarios a Tripulación",
  "portal/policy/crew-voluntary-settlements-coverage-description":
    "USD {{sum}} a cada tripulante.",
  "portal/policy/currency": "Moneda",
  "portal/policy/currency-description":
    "Todo y cada uno de los pagos de las primas y siniestros se realizarán en {{currencyName}} ({{currencyId}})",
  "portal/policy/data-client-not-available":
    "El cliente de datos no está disponible",
  "portal/policy/debit": "Cargo",
  "portal/policy/document-download-failed": "No se pudo descargar el documento",
  "portal/policy/document-download-failed-description":
    "Inténtalo de nuevo en unos momentos.",
  "portal/policy/document-download-subtitle": "Seleccionar el tipo de archivo",
  "portal/policy/document-download-title": "Descargar {{name}}",
  "portal/policy/document-format-docx": "Word",
  "portal/policy/document-format-pdf": "PDF",
  "portal/policy/download": "Descargar",
  "portal/policy/due-date": "Fecha de Vencimiento",
  "portal/policy/duplicate": "Duplicar",
  "portal/policy/endorse": "Endosar",
  "portal/policy/endorsement": "Endoso",
  "portal/policy/endorsement-is-required": "Es necesario seleccionar la endoso",
  "portal/policy/endorsement-number": "Número de Endoso",
  "portal/policy/endorsement-number-is-required":
    "Es necesario introducir el número de endoso",
  "portal/policy/entity/fetch-failed": "No se pudo obtener la entidad",
  "portal/policy/entity/save-failed":
    "No se pudo crear o actualizar la entidad",
  "portal/policy/er-aircrafts": "Aeronaves",
  "portal/policy/er-aircrafts/add-aircraft": "Agregar Aeronave",
  "portal/policy/er-aircrafts/age-surcharge": "Recargo por Antigüedad",
  "portal/policy/er-aircrafts/aircraft-details": "Detalles de la Aeronave",
  "portal/policy/er-aircrafts/applicable-clauses": "Cláusulas Aplicables",
  "portal/policy/er-aircrafts/base-airport": "Aeropuerto Base",
  "portal/policy/er-aircrafts/base-rate": "Tarifa Base",
  "portal/policy/er-aircrafts/brand-and-model": "Marca y Modelo",
  "portal/policy/er-aircrafts/breach-of-warranty":
    "Quebrantamiento de Garantías",
  "portal/policy/er-aircrafts/capacity": "Capacidad",
  "portal/policy/er-aircrafts/cargo": "Carga",
  "portal/policy/er-aircrafts/coverages": "Coberturas",
  "portal/policy/er-aircrafts/crew": "Tripulantes",
  "portal/policy/er-aircrafts/geographic-surcharge":
    "Recargo por Límite Geográfico",
  "portal/policy/er-aircrafts/gmp": "GMP",
  "portal/policy/er-aircrafts/gmt": "GMT",
  "portal/policy/er-aircrafts/hangar-liability": "RC Hangares",
  "portal/policy/er-aircrafts/hull-all-risk-coverage": "Casco Todo Riesgo ",
  "portal/policy/er-aircrafts/hull-all-risk-coverage-description":
    "Cubriendo todo riesgo y pérdidas materiales a la aeronave propiedad del asegurado, operada o arrendada por el asegurado mientras se encuentre en vuelo, taxeo o en tierra.",
  "portal/policy/er-aircrafts/hull-all-risk-coverage-war":
    "Casco Todo Riesgo / Casco Guerra",
  "portal/policy/er-aircrafts/hull-all-risk-coverage-war-description":
    "Cubriendo todo riesgo / Casco Guerra y pérdidas materiales a la aeronave propiedad del asegurado, operada o arrendada por el asegurado mientras se encuentre en vuelo, taxeo o en tierra.",
  "portal/policy/er-aircrafts/hull-insured-sum": "Suma Asegurada Casco",
  "portal/policy/er-aircrafts/hull-insured-sum-description":
    "USD {{sum}}, con deducible de USD $ 5,000.00 aplicable en toda y cada pérdida o reclamación.",
  "portal/policy/er-aircrafts/hull-limited-coverage": "Casco Limitada ",
  "portal/policy/er-aircrafts/hull-limited-coverage-description":
    "Cubriendo todo riesgo y pérdidas materiales a la aeronave propiedad del asegurado, operada o arrendada por el asegurado mientras se encuentre en taxeo o en tierra.",
  "portal/policy/er-aircrafts/liability-coverage": "Responsabilidad Civil",
  "portal/policy/er-aircrafts/liability-coverage-description":
    "Se cubre al asegurado en responsabilidad civil por daños a terceros en sus bienes y/o personas.",
  "portal/policy/er-aircrafts/liability-insured-sum":
    "Suma Asegurada de Responsabilidad Civil",
  "portal/policy/er-aircrafts/liability-insured-sum-description":
    "Límite Único y Combinado de USD {{sum}} para toda y cada pérdida o reclamación, y en el agregado de las mismas.",
  "portal/policy/er-aircrafts/licence": "Licencia",
  "portal/policy/er-aircrafts/luc": "LUC",
  "portal/policy/er-aircrafts/luggage": "Equipaje",
  "portal/policy/er-aircrafts/modify": "Modificar",
  "portal/policy/er-aircrafts/net-premium": "Prima Neta",
  "portal/policy/er-aircrafts/no-aircrafts":
    "Esta propuesta no cuenta con ninguna aeronave registrada",
  "portal/policy/er-aircrafts/passengers": "Pasajeros",
  "portal/policy/er-aircrafts/pvp": "PVP",
  "portal/policy/er-aircrafts/pvt": "PVT",
  "portal/policy/er-aircrafts/sections-description":
    "Partida {{section}} de {{sections}}",
  "portal/policy/er-aircrafts/serial": "Serie",
  "portal/policy/er-aircrafts/spare-parts": "Partes y Refacciones",
  "portal/policy/er-aircrafts/sub-limits": "Sub Límites",
  "portal/policy/er-aircrafts/sum-insured": "Suma Asegurada",
  "portal/policy/er-aircrafts/total-hull": "Total Casco",
  "portal/policy/er-aircrafts/total-liability": "Total Responsabilidad Civil",
  "portal/policy/er-aircrafts/total-others": "Total Otras Coberturas",
  "portal/policy/er-aircrafts/usage": "Uso",
  "portal/policy/er-aircrafts/usage-surcharge": "Recargo por Uso",
  "portal/policy/er-aircrafts/war-risk": "Guerra",
  "portal/policy/er-aircrafts/year": "Año",
  "portal/policy/expedition-date": "Fecha de Expedición",
  "portal/policy/expiration-date": "Fin de Vigencia",
  "portal/policy/expiration-date-is-required":
    "Es necesario la fecha de vencimiento",
  "portal/policy/fees": "Gastos de Expedición",
  "portal/policy/fees-is-required": "Es necesario el Prima Neta",
  "portal/policy/file-upload": "Subir",
  "portal/policy/files": "Archivos",
  "portal/policy/files-empty": "Aún no hay archivos",
  "portal/policy/files/download": "Descargar",
  "portal/policy/files/edit": "Modificar",
  "portal/policy/files/remove": "Eliminar",
  "portal/policy/first-payment": "Primer Pago",
  "portal/policy/first-payment-is-required": "Es necesario el primer pago",
  "portal/policy/form/calculate-quote": "Calcular cotización",
  "portal/policy/form/error": "Error al cargar el formulario",
  "portal/policy/form/insured-pending": "Asegurado por definir",
  "portal/policy/form/loading": "Cargando formulario...",
  "portal/policy/form/no-form-layout":
    "No hay un layout de formulario configurado para este paso",
  "portal/policy/form/no-renderer-declared":
    "No hay componente declarado para este paso",
  "portal/policy/form/no-step-defined": "No hay paso de formulario definido",
  "portal/policy/form/not-found": "No se encontró la definición del formulario",
  "portal/policy/form/present": "Presentar",
  "portal/policy/form/salamander-test": "Formulario de Prueba (Salamander)",
  "portal/policy/form/test-notes": "Notas de Prueba",
  "portal/policy/in-force-date": "Fecha de Vigencia",
  "portal/policy/inforce-date": "Inicio de Vigencia",
  "portal/policy/inforce-date-is-required": "Es necesario la fecha de vigencia",
  "portal/policy/insurer": "Aseguradora",
  "portal/policy/insurer-is-required":
    "Es necesario seleccionar la aseguradora",
  "portal/policy/interest": "Recargo por Pago Fraccionado",
  "portal/policy/interest-is-required": "Es necesario el interés",
  "portal/policy/issue": "Emitir Póliza",
  "portal/policy/issue-date": "Fecha de Emisión",
  "portal/policy/issue-date-is-required":
    "Es necesario introducir la fecha de emisión",
  "portal/policy/ledger": "Libro contable",
  "portal/policy/lifecycle/actions/issue": "Emitir",
  "portal/policy/lifecycle/actions/reactivate": "Re-activar",
  "portal/policy/lifecycle/actions/reply-and-resend": "Responder y reenviar",
  "portal/policy/lifecycle/actions/reply-to-insurer": "Responder",
  "portal/policy/lifecycle/back/changed-hint":
    "Recotiza para guardar los cambios",
  "portal/policy/lifecycle/cancel/confirm-cancel": "Volver",
  "portal/policy/lifecycle/cancel/confirm-message":
    "La propuesta se eliminará y la aeronave quedará libre. Esta acción no se puede deshacer.",
  "portal/policy/lifecycle/cancel/confirm-ok": "Eliminar",
  "portal/policy/lifecycle/cancel/confirm-title": "¿Eliminar propuesta?",
  "portal/policy/lifecycle/cancel/label": "Cancelar",
  "portal/policy/lifecycle/claim/field":
    "Esta aeronave está en otra propuesta vigente o en una póliza emitida.",
  "portal/policy/lifecycle/claim/refusal-description":
    "La aeronave {{label}} está en otra propuesta vigente o en una póliza emitida.",
  "portal/policy/lifecycle/claim/refusal-ok": "Entendido",
  "portal/policy/lifecycle/claim/refusal-title": "No se puede re-activar",
  "portal/policy/lifecycle/general-information/step": "Información General",
  "portal/policy/lifecycle/general-information/title": "Información General",
  "portal/policy/lifecycle/issuance/eyebrow": "Emisión",
  "portal/policy/lifecycle/validity/expired":
    "Cotización expirada el {{date}}. Re-activa la propuesta para cotizar de nuevo.",
  "portal/policy/lifecycle/validity/expired-status": "Expirada",
  "portal/policy/lifecycle/validity/issued-label": "Cotizada",
  "portal/policy/lifecycle/validity/remaining": "{{days}} días restantes",
  "portal/policy/lifecycle/validity/running":
    "Vigente hasta {{date}} · {{days}} días",
  "portal/policy/lifecycle/validity/section-title": "Cotización",
  "portal/policy/lifecycle/validity/valid-until-label": "Válida hasta",
  "portal/policy/main": "General",
  "portal/policy/modal-payments": "Pagos Modales",
  "portal/policy/modal-payments-is-required": "Es necesario el pago",
  "portal/policy/modality": "Modalidad",
  "portal/policy/modality-is-required": "Es necesario la modalidad",
  "portal/policy/modify": "Modificar",
  "portal/policy/motor-retention-ceiling-inline": "Debe ser menor al 100%",
  "portal/policy/motor-retention-too-low-inline":
    "Debe ser al menos el mínimo de la banda",
  "portal/policy/motor/annual-premium": "Prima anual",
  "portal/policy/motor/armoring-cost": "Costo del blindaje (USD)",
  "portal/policy/motor/armoring-level": "Nivel de blindaje",
  "portal/policy/motor/band": "Banda de valor",
  "portal/policy/motor/block-1": "Bloque 1",
  "portal/policy/motor/block-2": "Bloque 2",
  "portal/policy/motor/block-3": "Bloque 3",
  "portal/policy/motor/block-card-title": "Bloque {number}",
  "portal/policy/motor/blocks-title": "Bloque de daños materiales + robo",
  "portal/policy/motor/brand": "Marca",
  "portal/policy/motor/brand-model-year": "Marca / Modelo / Año",
  "portal/policy/motor/ceded-xl": "Monto cedido al XL",
  "portal/policy/motor/cedent-declared": "Declarado por el cedente",
  "portal/policy/motor/ceding-commission": "Comisión de cesión",
  "portal/policy/motor/coverages": "Coberturas",
  "portal/policy/motor/coverages/band-error":
    "Ninguna banda de tarifas corresponde a la suma asegurada declarada para este tipo de vehículo.",
  "portal/policy/motor/coverages/loading": "Cargando banda de tarifas…",
  "portal/policy/motor/derived-chip": "Derivada",
  "portal/policy/motor/derived-note":
    "Prorrateada por la retención solicitada — esta prima es calculada, no tarificada.",
  "portal/policy/motor/dm-deductible": "Deducible daños materiales",
  "portal/policy/motor/elected-limit": "Límite elegido",
  "portal/policy/motor/gm-limit": "Límite de GM (USD)",
  "portal/policy/motor/gm-toggle": "Gastos médicos (GM)",
  "portal/policy/motor/gross-premium": "Prima bruta anual",
  "portal/policy/motor/limit-bounds": "Entre {min} y {max}",
  "portal/policy/motor/limit-help":
    "Desde 1 hasta el límite de tabla ({limit})",
  "portal/policy/motor/line-block": "Daños materiales + robo (bloque)",
  "portal/policy/motor/line-gm": "Gastos médicos (GM)",
  "portal/policy/motor/line-rc": "Responsabilidad civil (RC)",
  "portal/policy/motor/model": "Modelo",
  "portal/policy/motor/net-to-reinsurer": "Neto al reasegurador",
  "portal/policy/motor/policy-period": "Vigencia",
  "portal/policy/motor/policy-period-value": "{from} — {to} (12 meses)",
  "portal/policy/motor/premium-lines": "Líneas de prima",
  "portal/policy/motor/pro-rata-factor": "Factor prorrata",
  "portal/policy/motor/quote": "Cotización",
  "portal/policy/motor/quote-expiry": "Cotización válida hasta",
  "portal/policy/motor/quote/error": "No se pudo calcular la cotización",
  "portal/policy/motor/quote/loading": "Calculando cotización…",
  "portal/policy/motor/quote/retry": "Reintentar",
  "portal/policy/motor/rc-limit": "Límite de RC (USD)",
  "portal/policy/motor/rc-toggle": "Responsabilidad civil (RC)",
  "portal/policy/motor/reinsurance-slip": "Slip de Reaseguro",
  "portal/policy/motor/requested-retention": "Retención solicitada",
  "portal/policy/motor/retention-bounds": "Entre {min} y {max}",
  "portal/policy/motor/retention-help":
    "Mínimo de banda {min}%. Debe ser menor al 100%.",
  "portal/policy/motor/retention-pct": "Retención %",
  "portal/policy/motor/retention-usd": "Retención (USD)",
  "portal/policy/motor/retention-usd-echo": "Monto retenido",
  "portal/policy/motor/selected-block": "Bloque seleccionado",
  "portal/policy/motor/sum-insured": "Suma asegurada (USD)",
  "portal/policy/motor/sum-insured-split":
    "Vehículo {vehicle} + blindaje {armoring}",
  "portal/policy/motor/theft-deductible": "Deducible robo",
  "portal/policy/motor/validation/positive": "Debe ser mayor a cero",
  "portal/policy/motor/validation/required": "Este campo es requerido",
  "portal/policy/motor/validation/vin-format":
    "17 caracteres, letras/dígitos, sin I, O ni Q",
  "portal/policy/motor/validation/year-range":
    "El año debe ser 1900 o posterior",
  "portal/policy/motor/vehicle": "Vehículo",
  "portal/policy/motor/vehicle-type":
    "Tipo de vehículo (declarado por el cedente)",
  "portal/policy/motor/vehicle-type/blindados": "Blindado",
  "portal/policy/motor/vehicle-type/deportivo": "Deportivo",
  "portal/policy/motor/vehicle-type/motocicletas": "Motocicleta",
  "portal/policy/motor/vehicle-type/pasajeros-privados": "Pasajeros / Privados",
  "portal/policy/motor/vehicle-type/sedan": "Sedán",
  "portal/policy/motor/vehicle-type/suv": "SUV",
  "portal/policy/motor/vehicle-value": "Valor del vehículo (USD)",
  "portal/policy/motor/vin": "VIN (número de serie)",
  "portal/policy/motor/year": "Año",
  "portal/policy/net-premium": "Prima Neta",
  "portal/policy/net-premium-is-required": "Es necesario el Prima Neta",
  "portal/policy/no-agency": "Sin agencia",
  "portal/policy/not-found": "Póliza no encontrada",
  "portal/policy/number": "Número de Póliza",
  "portal/policy/outstanding-balance": "Saldo Pendiente",
  "portal/policy/overpaid": "Sobrepago",
  "portal/policy/partial": "Parcial",
  "portal/policy/parties": "Partes",
  "portal/policy/parties/add-additional-insured": "Agregar asegurado adicional",
  "portal/policy/parties/add-additional-insured-title":
    "Agregar asegurado adicional",
  "portal/policy/parties/additional-insured": "Asegurado adicional",
  "portal/policy/parties/additional-insureds": "Asegurados adicionales",
  "portal/policy/parties/additional-insureds-empty":
    "No se han agregado asegurados adicionales",
  "portal/policy/parties/capture-main-insured":
    "¿Deseas capturar la información del asegurado principal?",
  "portal/policy/parties/capture-main-insured-blocked-hint":
    "Elimina los asegurados adicionales para desactivar esta opción.",
  "portal/policy/parties/capture-main-insured-hint": "Este paso es opcional.",
  "portal/policy/parties/capture-preferred-beneficiary":
    "¿Deseas capturar la información del beneficiario preferente?",
  "portal/policy/parties/capture-preferred-beneficiary-hint": "Opcional.",
  "portal/policy/parties/main-insured-title": "Asegurado principal",
  "portal/policy/parties/preferred-beneficiary": "Beneficiario preferente",
  "portal/policy/passenger-medical-payments-coverage":
    "Gastos Médicos a Pasajeros",
  "portal/policy/passenger-medical-payments-coverage-description":
    "USD {{sum}} a cada pasajero.",
  "portal/policy/passenger-voluntary-settlements-coverage":
    "Pagos Voluntarios a Pasajeros",
  "portal/policy/passenger-voluntary-settlements-coverage-description":
    "USD {{sum}} a cada pasajero.",
  "portal/policy/payment": "Pago",
  "portal/policy/payment-amount": "Monto",
  "portal/policy/payment-date": "Fecha de Pago",
  "portal/policy/payment-date-is-required": "La fecha de pago es requerida",
  "portal/policy/payment-ref": "Pago — {{reference}}",
  "portal/policy/payment-reference": "Referencia",
  "portal/policy/payments": "Pagos",
  "portal/policy/period": "Vigencia",
  "portal/policy/policy-fees": "Derechos y Cargos",
  "portal/policy/policy-files": "Archivos de Póliza",
  "portal/policy/policy-holder": "Contratante",
  "portal/policy/policy-id-is-required": "La póliza es obligatoria",
  "portal/policy/policy-information": "Información de la póliza",
  "portal/policy/policy-interest": "Recargo por Pago Fraccionado",
  "portal/policy/policy-number": "Número de Póliza",
  "portal/policy/policy-number-is-required":
    "Es necesario introducir el número de póliza",
  "portal/policy/policy-taxes": "Impuestos",
  "portal/policy/policy-term": "Vigencia",
  "portal/policy/policy-term-description":
    "De las 00:00 horas del {{inForceDate}} a las 23:59 horas del {{expirationDate}}, hora estandar del domicilio del asegurado.",
  "portal/policy/policy-type": "Tipo de Póliza",
  "portal/policy/policy-type/new": "Nuevo Negocio",
  "portal/policy/policy-type/renewal": "Renovación",
  "portal/policy/policy-type/required": "El tipo de póliza es requerido",
  "portal/policy/primary-insured": "Asegurado Principal",
  "portal/policy/promoter": "Promotor",
  "portal/policy/promoter-commission": "Comisión Promotor",
  "portal/policy/proposal": "Propuesta",
  "portal/policy/quotation-date": "Fecha de Cotización",
  "portal/policy/quote-error/back": "Regresar y editar",
  "portal/policy/quote-error/continue": "Continuar",
  "portal/policy/quote-error/message":
    "No se pudo calcular la cotización. Tu información se guardó — inténtalo de nuevo.",
  "portal/policy/quote-layout/caption-on-csl": "Sobre LUC {{valor}}",
  "portal/policy/quote-layout/caption-on-value": "Sobre {{valor}}",
  "portal/policy/quote-layout/caption-quoted-on": "Cotizada el {{fecha}}",
  "portal/policy/quote-layout/note-count-times-limit": "{{count}} × {{limit}}",
  "portal/policy/quote-reference/deductibles": "Deducibles",
  "portal/policy/quote-reference/insured-value": "Suma asegurada",
  "portal/policy/quote-reference/package": "Paquete",
  "portal/policy/quote-reference/term": "Vigencia",
  "portal/policy/quote-reference/value-type": "Tipo de valor",
  "portal/policy/quote-step/derived-chip": "Derivada",
  "portal/policy/quote-step/error": "No se pudo calcular la cotización",
  "portal/policy/quote-step/hull-total": "Prima de casco",
  "portal/policy/quote-step/liability-total": "Prima de responsabilidad civil",
  "portal/policy/quote-step/loading": "Calculando cotización…",
  "portal/policy/quote-step/no-quote": "Aún no hay cotización",
  "portal/policy/quote-step/others-total": "Prima de otras coberturas",
  "portal/policy/quote-step/retry": "Reintentar",
  "portal/policy/quote-step/title": "Cotización",
  "portal/policy/quote-step/usage-premium": "Recargo por uso",
  "portal/policy/reasons/carrier-decline-reasons/driver-profile":
    "Perfil del conductor",
  "portal/policy/reasons/carrier-decline-reasons/incomplete-information":
    "Información incompleta",
  "portal/policy/reasons/carrier-decline-reasons/other": "Otro",
  "portal/policy/reasons/carrier-decline-reasons/risk-not-accepted":
    "Fuera de apetito de riesgo",
  "portal/policy/reasons/carrier-decline-reasons/title":
    "Motivos de rechazo de aseguradora",
  "portal/policy/reasons/carrier-decline-reasons/vehicle-not-insurable":
    "Vehículo no asegurable",
  "portal/policy/reasons/carrier-decline-reasons/zone-not-covered":
    "Zona sin cobertura",
  "portal/policy/reasons/close-reasons/chose-outside-hyper":
    "Eligió otra opción fuera de Hyper",
  "portal/policy/reasons/close-reasons/do-not-renew": "No renovar",
  "portal/policy/reasons/close-reasons/no-response": "Sin respuesta",
  "portal/policy/reasons/close-reasons/not-accepted": "No aceptó",
  "portal/policy/reasons/close-reasons/other": "Otro",
  "portal/policy/reasons/close-reasons/price": "Precio",
  "portal/policy/reasons/close-reasons/sold-vehicle": "Vendió el auto",
  "portal/policy/reasons/close-reasons/title": "Motivos de cierre",
  "portal/policy/reasons/no-issue-reasons/carrier-declines-risk":
    "La aseguradora declina el riesgo",
  "portal/policy/reasons/no-issue-reasons/carrier-system-unavailable":
    "Sistema de la aseguradora no disponible",
  "portal/policy/reasons/no-issue-reasons/data-error": "Error en los datos",
  "portal/policy/reasons/no-issue-reasons/missing-document":
    "Falta un documento",
  "portal/policy/reasons/no-issue-reasons/other": "Otro",
  "portal/policy/reasons/no-issue-reasons/price-changed": "Cambió el precio",
  "portal/policy/reasons/no-issue-reasons/title":
    "Motivos de la aseguradora no emite",
  "portal/policy/reasons/no-renewal-reasons/customer-declines":
    "El cliente no desea renovar",
  "portal/policy/reasons/no-renewal-reasons/moving-to-another-broker":
    "Se cambia de corredor",
  "portal/policy/reasons/no-renewal-reasons/no-contact": "Sin contacto",
  "portal/policy/reasons/no-renewal-reasons/other": "Otro",
  "portal/policy/reasons/no-renewal-reasons/price": "Precio",
  "portal/policy/reasons/no-renewal-reasons/sold-vehicle": "Vendió el auto",
  "portal/policy/reasons/no-renewal-reasons/title": "Motivos de no renovar",
  "portal/policy/reasons/no-renewal-reasons/total-loss": "Pérdida total",
  "portal/policy/reasons/requote-origins/add-carriers": "Agregar aseguradoras",
  "portal/policy/reasons/requote-origins/carrier-update":
    "Actualización de la aseguradora",
  "portal/policy/reasons/requote-origins/customer-requested-change":
    "El cliente pidió un cambio",
  "portal/policy/reasons/requote-origins/data-correction":
    "Corrección de datos",
  "portal/policy/reasons/requote-origins/offer-expired": "La oferta venció",
  "portal/policy/reasons/requote-origins/other": "Otro",
  "portal/policy/reasons/requote-origins/title": "Origen de la recotización",
  "portal/policy/reasons/vehicle-change-reasons/other": "Otro",
  "portal/policy/reasons/vehicle-change-reasons/replaced-by-new":
    "Lo cambió por uno nuevo",
  "portal/policy/reasons/vehicle-change-reasons/replaced-by-used":
    "Lo cambió por uno usado",
  "portal/policy/reasons/vehicle-change-reasons/sold-vehicle": "Vendió el auto",
  "portal/policy/reasons/vehicle-change-reasons/title":
    "Motivos de cambio de vehículo",
  "portal/policy/reasons/vehicle-change-reasons/total-loss": "Pérdida total",
  "portal/policy/receipt": "Recibo",
  "portal/policy/receipt-of": "Recibo {{number}} de {{total}}",
  "portal/policy/receipts": "Recibos",
  "portal/policy/received": "Recibido",
  "portal/policy/regional": "Wholesaler",
  "portal/policy/regional-commission": "Comisión Regional",
  "portal/policy/report-download-failed": "Error al descargar el reporte",
  "portal/policy/requester": "Solicitante",
  "portal/policy/slip": "Slip",
  "portal/policy/slip/additional-insureds": "Asegurados Adicionales",
  "portal/policy/slip/aeronave": "Aeronave",
  "portal/policy/slip/aeronave-ano": "Año",
  "portal/policy/slip/aeronave-clase": "Clase",
  "portal/policy/slip/aeronave-marca": "Marca",
  "portal/policy/slip/aeronave-matricula": "Matrícula",
  "portal/policy/slip/aeronave-modelo": "Modelo",
  "portal/policy/slip/aeronave-pasajeros": "Capacidad de pasajeros",
  "portal/policy/slip/aeronave-serie": "Número de serie",
  "portal/policy/slip/aeronave-tipo": "Tipo",
  "portal/policy/slip/aeronave-tripulacion": "Tripulación",
  "portal/policy/slip/aeropuerto-base": "Aeropuerto base",
  "portal/policy/slip/aeropuertos-permitidos": "Aeropuertos permitidos",
  "portal/policy/slip/asegurado-principal": "Asegurado principal",
  "portal/policy/slip/breach-of-warranty": "Breach of warranty",
  "portal/policy/slip/capacidad": "Capacidad",
  "portal/policy/slip/caption-cotizada-el": "Cotizada el",
  "portal/policy/slip/caption-limite-unico-combinado-ocurrencia":
    "Límite único y combinado por ocurrencia",
  "portal/policy/slip/caption-sobre": "Sobre",
  "portal/policy/slip/caption-sobre-luc": "Sobre LUC",
  "portal/policy/slip/caption-tripulacion-pasajeros": "Tripulación + pasajeros",
  "portal/policy/slip/cardinality-blocked":
    "Este negocio no puede generar un nuevo slip de cotización. Mensaje de respaldo — el servidor siempre debería proporcionar uno específico.",
  "portal/policy/slip/cardinality-blocked-title":
    "Este negocio no puede generar un slip nuevo",
  "portal/policy/slip/cedente": "Cedente",
  "portal/policy/slip/clause-description": "Descripción",
  "portal/policy/slip/clause-identifier": "Código",
  "portal/policy/slip/clausulas-aplicables": "Cláusulas aplicables",
  "portal/policy/slip/clausulas-incluidas": "Cláusulas incluidas",
  "portal/policy/slip/cobertura-casco": "Casco",
  "portal/policy/slip/cobertura-partes-refacciones": "Partes y Refacciones",
  "portal/policy/slip/cobertura-responsabilidad-civil": "Responsabilidad Civil",
  "portal/policy/slip/cobertura-responsabilidad-civil-hangar":
    "Responsabilidad Civil de Hangar",
  "portal/policy/slip/coberturas-limites": "Coberturas y límites",
  "portal/policy/slip/condiciones": "Condiciones",
  "portal/policy/slip/condiciones-particulares": "Condiciones particulares",
  "portal/policy/slip/content-error-title":
    "No se pudo cargar el contenido del slip",
  "portal/policy/slip/dano-fisico": "Daño físico",
  "portal/policy/slip/date-range": "Del {{start}} al {{end}}",
  "portal/policy/slip/datos-aeronave": "Datos de la Aeronave",
  "portal/policy/slip/datos-generales": "Datos Generales",
  "portal/policy/slip/deducible": "Deducible",
  "portal/policy/slip/deducibles": "Deducibles",
  "portal/policy/slip/fecha-cotizacion": "Fecha de la Cotización",
  "portal/policy/slip/garantia": "Garantía",
  "portal/policy/slip/garantia-pilotos": "Garantía de Pilotos",
  "portal/policy/slip/guerra-riesgos-afines": "Guerra y riesgos afines",
  "portal/policy/slip/impuestos-aplicables": "Impuestos aplicables",
  "portal/policy/slip/instruccion-horas": "Horas",
  "portal/policy/slip/insurer-at-issuance":
    "Aseguradora definida en la emisión",
  "portal/policy/slip/marca-y-modelo": "Marca y modelo",
  "portal/policy/slip/moneda": "Moneda",
  "portal/policy/slip/partes": "Partes",
  "portal/policy/slip/pilot-age-exceeds-maximum":
    "Excede la edad máxima para pilotos nombrados — verificar dato",
  "portal/policy/slip/piloto-nombrado": "Piloto nombrado",
  "portal/policy/slip/pilotos": "Pilotos",
  "portal/policy/slip/pilotos-nombrados": "Pilotos Nombrados",
  "portal/policy/slip/pilotos-nombrados-edad": "Edad",
  "portal/policy/slip/pilotos-nombrados-horas-marca-modelo":
    "Horas en marca y modelo",
  "portal/policy/slip/pilotos-nombrados-horas-totales": "Horas totales",
  "portal/policy/slip/pilotos-nombrados-licencia": "Licencia",
  "portal/policy/slip/pilotos-nombrados-nombre": "Nombre",
  "portal/policy/slip/poliza": "Póliza",
  "portal/policy/slip/por-confirmar": "Por confirmar",
  "portal/policy/slip/preferred-beneficiary": "Beneficiario Preferente",
  "portal/policy/slip/prima": "Prima",
  "portal/policy/slip/prima-neta": "Prima Neta",
  "portal/policy/slip/ramo": "Ramo",
  "portal/policy/slip/recargos": "Recargos",
  "portal/policy/slip/solicitante": "Solicitante",
  "portal/policy/slip/sublimite-carga": "Carga",
  "portal/policy/slip/sublimite-cmp": "Gastos Médicos a Tripulación",
  "portal/policy/slip/sublimite-cvs": "Pagos Voluntarios a Tripulación",
  "portal/policy/slip/sublimite-equipaje": "Equipaje",
  "portal/policy/slip/sublimite-extortion-secuestro":
    "Gastos de Extorsión y Secuestro",
  "portal/policy/slip/sublimite-pmp": "Gastos Médicos a Pasajeros",
  "portal/policy/slip/sublimite-pvs": "Pagos Voluntarios a Pasajeros",
  "portal/policy/slip/sublimites": "Sublímites",
  "portal/policy/slip/sufijo-limite-unico-combinado":
    "Límite único y combinado",
  "portal/policy/slip/sufijo-por-evento": "por evento",
  "portal/policy/slip/sufijo-por-pasajero": "por pasajero",
  "portal/policy/slip/sufijo-por-tripulante": "por tripulante",
  "portal/policy/slip/term-days": "Desde las {{time}} h · {{days}} días",
  "portal/policy/slip/term-days-hours":
    "Desde las {{start}} h hasta las {{end}} h · {{days}} días",
  "portal/policy/slip/territorialidad": "Territorialidad",
  "portal/policy/slip/uso": "Uso",
  "portal/policy/slip/usos-aeronave": "Usos de la aeronave",
  "portal/policy/slip/usos-territorio": "Usos y territorio",
  "portal/policy/slip/validez-cotizacion": "Validez de la cotización",
  "portal/policy/slip/valor-casco": "Valor casco",
  "portal/policy/slip/vigencia": "Vigencia",
  "portal/policy/stage-canceled": "Cancelado",
  "portal/policy/stage-due": "Vencido",
  "portal/policy/stage-not-defined": "Etapa no definida",
  "portal/policy/stage-paid": "Pagado",
  "portal/policy/stage-scheduled": "Programado",
  "portal/policy/stages/bind-accepted": "Emisión Aceptada",
  "portal/policy/stages/bind-authorization": "Autorización de Emisión",
  "portal/policy/stages/bind-authorized": "Emisión Autorizada",
  "portal/policy/stages/bind-correction-requested": "Corrección Solicitada",
  "portal/policy/stages/bind-form": "Formulario de Emisión",
  "portal/policy/stages/bind-in-progress": "Emisión en Progreso",
  "portal/policy/stages/bind-rejected": "Emisión Rechazada",
  "portal/policy/stages/bind-requested": "Emisión Solicitada",
  "portal/policy/stages/bind-validation": "En Validación",
  "portal/policy/stages/bind-validation-escalated": "Validación Escalada",
  "portal/policy/stages/binded": "Emitida",
  "portal/policy/stages/binding-form": "En Emisión",
  "portal/policy/stages/canceled": "Cancelada",
  "portal/policy/stages/closed-lost": "Cerrada",
  "portal/policy/stages/closed-unissued": "Cerrada sin Emitir",
  "portal/policy/stages/deleted": "Eliminado",
  "portal/policy/stages/draft": "Borrador",
  "portal/policy/stages/endorsing": "Endosando",
  "portal/policy/stages/expired": "Vencida",
  "portal/policy/stages/inforce": "En Vigor",
  "portal/policy/stages/issued": "Emitida",
  "portal/policy/stages/issuing": "Emitiendo",
  "portal/policy/stages/placement-completed": "Colocación Completada",
  "portal/policy/stages/placement-declined": "Colocación Declinada",
  "portal/policy/stages/placement-rejected": "Colocación Rechazada",
  "portal/policy/stages/placement-requested": "Colocación Solicitada",
  "portal/policy/stages/policy-expired": "Expirada",
  "portal/policy/stages/quote-accepted": "Cotización Aceptada",
  "portal/policy/stages/quote-declined": "Cotización Declinada",
  "portal/policy/stages/quote-expired": "Expirado",
  "portal/policy/stages/quote-rejected": "Cotización Rechazada",
  "portal/policy/stages/quote-requested": "Cotización Solicitada",
  "portal/policy/stages/quoted": "Cotizado",
  "portal/policy/stages/recalled": "Cancelada",
  "portal/policy/stages/requoting": "En Recotización",
  "portal/policy/stages/withdrawn": "Retirada",
  "portal/policy/subject-matter/earlier-version":
    "Estás viendo una versión anterior de este registro, no la vigente.",
  "portal/policy/subject-matter/locked":
    "Ya se emitió una póliza con esta versión, por lo que se muestra solo de lectura. Los cambios se registran como una versión nueva.",
  "portal/policy/taxes": "Impuestos",
  "portal/policy/taxes-is-required": "Es necesario el impuesto",
  "portal/policy/total-billed": "Total Facturado",
  "portal/policy/total-collected": "Total Cobrado",
  "portal/policy/total-premium": "Prima Total",
  "portal/policy/total-premium-is-required":
    "Es necesario el total de la prima",
  "portal/policy/unallocated": "Sin Asignar",
  "portal/policy/vehicle": "Vehículo",
  "portal/policy/vehicle/brand": "Marca",
  "portal/policy/vehicle/brandFilter": "Filtrar por marca",
  "portal/policy/vehicle/color": "Color",
  "portal/policy/vehicle/model": "Modelo",
  "portal/policy/vehicle/modelFilter": "Filtrar por modelo",
  "portal/policy/vehicle/motorNumber": "No. de motor",
  "portal/policy/vehicle/passengers": "Pasajeros",
  "portal/policy/vehicle/plates": "Placas",
  "portal/policy/vehicle/transmission": "Transmisión",
  "portal/policy/vehicle/type/car": "Automóvil",
  "portal/policy/vehicle/type/motorcycle": "Motocicleta",
  "portal/policy/vehicle/type/pickup": "Pickup",
  "portal/policy/vehicle/usage": "Uso",
  "portal/policy/vehicle/validation/required": "Este campo es obligatorio",
  "portal/policy/vehicle/vehicleType": "Tipo de vehículo",
  "portal/policy/vehicle/version": "Versión",
  "portal/policy/vehicle/vin": "Serie (NIV)",
  "portal/policy/vehicle/year": "Año",
  "portal/policy/view-not-defined": "Vista no definida",
  "portal/precision": "Precisión",
  "portal/previous-policy": "Póliza Anterior",
  "portal/previous-policy-is-required":
    "Es necesario indicar la póliza anterior",
  "portal/privacy-policy": "Aviso de Privacidad",
  "portal/program/access-denied": "No tienes acceso a este programa",
  "portal/program/context-unavailable":
    "Esta dirección del portal no está configurada para un programa",
  "portal/program/session-expired": "Tu sesión terminó",
  "portal/program/session-expired-body":
    "Vuelve a iniciar sesión para continuar.",
  "portal/program/sign-out": "Cerrar sesión",
  "portal/proposal-model": "Modelo de Propuesta",
  "portal/proposals/select-proposal-from-the-list":
    "Selecciona una propuesta de la lista",
  "portal/quote-snapshots": "Snapshots de Cotización",
  "portal/quote-snapshots/created": "Creado",
  "portal/quote-snapshots/error": "Error",
  "portal/quote-snapshots/executed": "Ejecutado",
  "portal/quote-snapshots/execution-time": "Tiempo de ejecución (ms)",
  "portal/quote-snapshots/final-premiums": "Primas finales",
  "portal/quote-snapshots/output-value": "Valor de salida",
  "portal/quote-snapshots/output-variable": "Variable de salida",
  "portal/quote-snapshots/proposal-id": "Propuesta",
  "portal/quote-snapshots/status": "Estado",
  "portal/quote-snapshots/step": "Paso",
  "portal/quote-snapshots/step-details": "Detalle de pasos",
  "portal/quotes": "Cotizaciones",
  "portal/rate-table-slug": "Tabla de Tarifas",
  "portal/rate-table/aggregation/average": "Promedio",
  "portal/rate-table/aggregation/first": "Primero",
  "portal/rate-table/aggregation/max": "Máximo",
  "portal/rate-table/aggregation/min": "Mínimo",
  "portal/rate-table/aggregation/sum": "Suma",
  "portal/rate-table/key": "Clave",
  "portal/rate-table/label": "Etiqueta",
  "portal/rate-table/lookup-type/exact": "Exacto",
  "portal/rate-table/lookup-type/range": "Rango",
  "portal/rate-table/lookup-type/selection": "Selección",
  "portal/rate-table/max": "Máximo",
  "portal/rate-table/min": "Mínimo",
  "portal/rate-table/rate": "Tasa",
  "portal/rate-table/rate-type": "Tipo de tasa",
  "portal/rate-table/rate-type/currency": "Monto en moneda",
  "portal/rate-table/rate-type/percentage": "Porcentaje",
  "portal/rate-tables": "Tablas de Tarifas",
  "portal/rate-type": "Tipo de Tarifa",
  "portal/record-not-found": "Registro no encontrado",
  "portal/registration/identifier/ar-cuit": "CUIT (persona jurídica)",
  "portal/registration/identifier/ar-cuit-help":
    "CUIT de 11 dígitos asignado por la ARCA a la persona jurídica",
  "portal/registration/identifier/bo-nit": "NIT (persona jurídica)",
  "portal/registration/identifier/bo-nit-help":
    "NIT asignado por el Servicio de Impuestos Nacionales a la persona jurídica",
  "portal/registration/identifier/cl-rut": "RUT (persona jurídica)",
  "portal/registration/identifier/cl-rut-help":
    "RUT asignado por el SII a la persona jurídica (carácter verificador 0-9 o 'K')",
  "portal/registration/identifier/co-nit": "NIT (persona jurídica, con DV)",
  "portal/registration/identifier/co-nit-help":
    "NIT de 9 dígitos más su DV de 1 dígito, asignado por la DIAN a la persona jurídica",
  "portal/registration/identifier/cr-cedula-juridica": "Cédula jurídica",
  "portal/registration/identifier/cr-cedula-juridica-help":
    "Cédula jurídica de 10 dígitos asignada a la persona jurídica",
  "portal/registration/identifier/do-rnc": "RNC (persona jurídica, con DV)",
  "portal/registration/identifier/do-rnc-help":
    "RNC de base de 8 dígitos más su DV de 1 dígito, asignado por la DGII a la persona jurídica",
  "portal/registration/identifier/ec-ruc": "RUC (sociedad)",
  "portal/registration/identifier/ec-ruc-help":
    "RUC de 13 dígitos asignado por el SRI a la sociedad",
  "portal/registration/identifier/gt-nit": "NIT (persona jurídica)",
  "portal/registration/identifier/gt-nit-help":
    "NIT asignado por la SAT a la persona jurídica, incluyendo su carácter verificador",
  "portal/registration/identifier/hn-rtn": "RTN (persona jurídica)",
  "portal/registration/identifier/hn-rtn-help":
    "Registro Tributario Nacional de 14 dígitos asignado a la persona jurídica",
  "portal/registration/identifier/mx-rfc": "RFC (persona moral)",
  "portal/registration/identifier/mx-rfc-help":
    "RFC de 12 caracteres asignado por el SAT a la persona moral",
  "portal/registration/identifier/mx-rfc-pf": "RFC (persona física)",
  "portal/registration/identifier/mx-rfc-pf-help":
    "RFC de 13 caracteres asignado por el SAT a la persona física",
  "portal/registration/identifier/ni-ruc": "RUC (persona jurídica)",
  "portal/registration/identifier/ni-ruc-help":
    "RUC asignado por la DGI a la persona jurídica ('J' seguida de 13 dígitos)",
  "portal/registration/identifier/pa-ruc": "RUC (persona jurídica)",
  "portal/registration/identifier/pa-ruc-help":
    "RUC segmentado (folio-tipo-año) más su DV, asignado por la DGI a la persona jurídica",
  "portal/registration/identifier/pe-ruc": "RUC (persona jurídica)",
  "portal/registration/identifier/pe-ruc-help":
    "RUC de 11 dígitos asignado por la SUNAT a la persona jurídica (prefijo de persona jurídica '20')",
  "portal/registration/identifier/py-ruc": "RUC (persona jurídica, con DV)",
  "portal/registration/identifier/py-ruc-help":
    "RUC de base de 3 a 8 dígitos más su DV de 1 dígito, asignado por la DNIT a la persona jurídica",
  "portal/registration/identifier/sv-nit": "NIT (persona jurídica)",
  "portal/registration/identifier/sv-nit-help":
    "NIT de 14 dígitos asignado por el Ministerio de Hacienda a la persona jurídica",
  "portal/registration/identifier/uy-rut": "RUT (persona jurídica)",
  "portal/registration/identifier/uy-rut-help":
    "RUT de 12 dígitos asignado por la DGI a la persona jurídica",
  "portal/remove": "Eliminar",
  "portal/remove-file": "Eliminar Archivo",
  "portal/remove-role": "Eliminar Rol",
  "portal/renewal": "Renovación",
  "portal/renewals": "Renovaciones",
  "portal/requester": "Solicitante",
  "portal/requester-is-required":
    "Es necesario indicar el solicitante de la póliza",
  "portal/role-level": "Nivel de Rol",
  "portal/role-level-is-required": "Es necesario indicar el nivel del rol",
  "portal/role-scope": "Alcance del Rol",
  "portal/role-scope-is-required": "Es necesario indicar el alcance del rol",
  "portal/roles": "Roles",
  "portal/roles-management": "Roles",
  "portal/roles-management/action-count": "acción(es)",
  "portal/roles-management/active": "Activo",
  "portal/roles-management/add-condition": "Agregar Condición",
  "portal/roles-management/add-group": "Agregar Grupo",
  "portal/roles-management/add-parent": "Agregar Rol Padre",
  "portal/roles-management/all": "Todos los Roles",
  "portal/roles-management/app-access": "Acceso a Apps",
  "portal/roles-management/assignment-count": "asignación(es)",
  "portal/roles-management/assignments": "Asignaciones",
  "portal/roles-management/condition-left-operand": "Operando izquierdo",
  "portal/roles-management/condition-operator": "Operador",
  "portal/roles-management/condition-overrides": "Sobrecargas de Condiciones",
  "portal/roles-management/condition-overrides-description":
    "Sobrecargar condiciones auto-derivadas para permisos específicos. Habilite sobrecargas para personalizar el árbol de condiciones.",
  "portal/roles-management/condition-plural": "condiciones",
  "portal/roles-management/condition-right-operand": "Operando derecho",
  "portal/roles-management/condition-singular": "condición",
  "portal/roles-management/create": "Crear Rol",
  "portal/roles-management/create-role": "Crear Rol",
  "portal/roles-management/custom": "Roles Personalizados",
  "portal/roles-management/custom-badge": "Personalizado",
  "portal/roles-management/denied": "Denegado",
  "portal/roles-management/description": "Descripción",
  "portal/roles-management/disable-override": "Deshabilitar Sobrecarga",
  "portal/roles-management/enable-overrides": "Habilitar Sobrecargas",
  "portal/roles-management/enable-overrides-description":
    "Active los permisos a continuación para habilitar sobrecargas de condiciones personalizadas en lugar de condiciones auto-derivadas.",
  "portal/roles-management/general": "General",
  "portal/roles-management/granted": "Otorgado",
  "portal/roles-management/inactive": "Inactivo",
  "portal/roles-management/inheritance": "Herencia",
  "portal/roles-management/level": "Nivel",
  "portal/roles-management/level/admin": "Administrador",
  "portal/roles-management/level/employee": "Empleado",
  "portal/roles-management/level/manager": "Gerente",
  "portal/roles-management/level/user": "Usuario",
  "portal/roles-management/load-error": "No se pudieron cargar los roles",
  "portal/roles-management/model": "Modelo",
  "portal/roles-management/more-actions": "Más acciones",
  "portal/roles-management/name": "Nombre",
  "portal/roles-management/no-assignments":
    "No hay usuarios asignados a este rol",
  "portal/roles-management/no-conditions":
    "No hay condiciones definidas. Agregue una condición o grupo abajo.",
  "portal/roles-management/no-overrides":
    "No hay sobrecargas de condiciones configuradas.",
  "portal/roles-management/no-parents": "No hay roles padre configurados",
  "portal/roles-management/no-results":
    "No hay roles que coincidan con tu búsqueda",
  "portal/roles-management/no-roles": "No se encontraron roles",
  "portal/roles-management/parent-roles": "Roles Padre",
  "portal/roles-management/permissions": "Permisos",
  "portal/roles-management/revoke-assignment": "Revocar Asignación",
  "portal/roles-management/role-name": "Nombre del Rol",
  "portal/roles-management/role-name-required":
    "El nombre del rol es requerido",
  "portal/roles-management/role-slug": "Slug del Rol",
  "portal/roles-management/role-slug-required": "El slug del rol es requerido",
  "portal/roles-management/scope-type": "Tipo de Alcance",
  "portal/roles-management/scope/account": "Cuenta",
  "portal/roles-management/scope/agency": "Agencia",
  "portal/roles-management/scope/company": "Compañía",
  "portal/roles-management/scope/global": "Global",
  "portal/roles-management/search-placeholder": "Buscar roles",
  "portal/roles-management/select-role": "Selecciona un rol para ver detalles",
  "portal/roles-management/slug": "Slug",
  "portal/roles-management/superadmin-only":
    "Las sobrecargas de condiciones solo están disponibles para super administradores.",
  "portal/roles-management/system": "Roles de Sistema",
  "portal/roles-management/system-badge": "Sistema",
  "portal/roles-management/system-role-inheritance-readonly":
    "La herencia de roles del sistema es de solo lectura.",
  "portal/roles-management/system-role-read-only":
    "El acceso del rol de sistema es de solo lectura.",
  "portal/roles-management/view-user": "Ver Usuario",
  "portal/roles/admin": "Administrador",
  "portal/roles/definition-owner": "Propietario de la definición",
  "portal/roles/employee": "Empleado",
  "portal/roles/family": "Familia de rol",
  "portal/roles/guest": "Invitado",
  "portal/roles/manager": "Gerente",
  "portal/roles/override-assignments-explanation":
    "Los usuarios se asignan a la familia del rol; esta definición aplica por jerarquía.",
  "portal/roles/override-definition": "Definición sobrescrita",
  "portal/roles/override-inheritance-disabled":
    "La herencia no está disponible para definiciones sobrescritas.",
  "portal/roles/super-admin": "Super Administrador",
  "portal/roles/user": "Usuario",
  "portal/route-not-authorized": "No tienes acceso a esta sección",
  "portal/route-not-found": "Esta ruta no ha sido implementada",
  "portal/save": "Guardar",
  "portal/scope/global": "Global",
  "portal/select-a-cedent-from-the-list": "Seleccione una cedente de la lista",
  "portal/select-a-customer-from-the-list": "Selecciona un cliente de la lista",
  "portal/select-a-placement-from-the-list":
    "Seleccione una colocación de la lista",
  "portal/select-a-policy-from-the-list": "Seleccione una póliza de la lista",
  "portal/select-a-user-from-the-list": "Selecciona un usuario de la lista",
  "portal/select-a-vendor-from-the-list": "Selecciona un proveedor de la lista",
  "portal/select-an-agency-from-the-list": "Selecciona una agencia de la lista",
  "portal/select-an-employee-from-the-list":
    "Selecciona un empleado de la lista",
  "portal/select-an-entity-from-the-list": "Selecciona una entidad de la lista",
  "portal/select-an-insurer-from-the-list":
    "Selecciona una aseguradora de la lista",
  "portal/select-existing-entity": "Seleccionar Entidad Existente",
  "portal/select-file": "Seleccionar Archivo",
  "portal/selected-ids-variable": "Variable de IDs Seleccionados",
  "portal/settings": "Configuración",
  "portal/settings/companies": "Compañías",
  "portal/settings/urls": "URLs",
  "portal/shortcut/access-denied":
    "Este acceso directo no está disponible o no tienes acceso.",
  "portal/shortcut/browse-only":
    "Esta definición no tiene un formulario independiente configurado.",
  "portal/shortcut/cancel": "Cancelar",
  "portal/shortcut/create": "Crear registro",
  "portal/shortcut/delete-confirm": "¿Eliminar este registro?",
  "portal/shortcut/empty": "No se encontraron registros.",
  "portal/shortcut/form-definition": "Formulario independiente",
  "portal/shortcut/linked-read-only":
    "Este registro está vinculado. Adminístralo desde el flujo de la póliza.",
  "portal/shortcut/previous": "Anterior",
  "portal/shortcut/search": "Buscar registros",
  "portal/shortcut/select": "Selecciona un registro para ver sus detalles.",
  "portal/shortcuts/category-general": "General",
  "portal/shortcuts/category-navigation": "Navegación",
  "portal/shortcuts/category-settings": "Configuración",
  "portal/shortcuts/open-palette": "Abrir paleta de comandos",
  "portal/shortcuts/open-sheet": "Mostrar atajos de teclado",
  "portal/show-sidebar": "Mostrar menú",
  "portal/sidebar-back": "Regresar",
  "portal/sidebar-hide": "Ocultar Barra Lateral",
  "portal/sidebar/account": "{{name}} — cuenta",
  "portal/sidebar/account-menu": "{{name}} — menú de cuenta",
  "portal/sidebar/appearance": "Apariencia",
  "portal/sidebar/connected": "Conectado",
  "portal/sidebar/logo": "Logotipo de la empresa",
  "portal/sidebar/main-navigation": "Navegación principal",
  "portal/sidebar/sign-out": "Cerrar sesión",
  "portal/sign-out-error": "Error al cerrar sesión",
  "portal/sign-out-error-message":
    "Ocurrió un error al cerrar sesión. Por favor, intente de nuevo.",
  "portal/signin": "Iniciar Sesión",
  "portal/skip-to-content": "Saltar al contenido",
  "portal/slug": "Slug",
  "portal/source": "Fuente",
  "portal/start-date": "Fecha de Inicio",
  "portal/step-config": "Configuración del Paso",
  "portal/step-slugs": "Slugs de Pasos (separados por coma)",
  "portal/step-type": "Tipo de Paso",
  "portal/steps": "Pasos",
  "portal/subject-matter-definitions/attribute": "Atributo",
  "portal/subject-matter-definitions/cardinality-many": "Varios por póliza",
  "portal/subject-matter-definitions/cardinality-one": "Uno por póliza",
  "portal/subject-matter-definitions/catalogue-id":
    "Id de definición de catálogo",
  "portal/subject-matter-definitions/coverages": "Coberturas",
  "portal/subject-matter-definitions/coverages/available-when":
    "Disponible cuando",
  "portal/subject-matter-definitions/coverages/declared-at":
    "Declarada en {{level}}",
  "portal/subject-matter-definitions/coverages/empty":
    "No hay coberturas declaradas para este ramo.",
  "portal/subject-matter-definitions/coverages/excluded-badge":
    "Excluida aquí, heredada de {{level}}",
  "portal/subject-matter-definitions/coverages/fields": "Campos",
  "portal/subject-matter-definitions/coverages/mandatory": "Obligatoria",
  "portal/subject-matter-definitions/coverages/mandatory-when":
    "Obligatoria cuando",
  "portal/subject-matter-definitions/coverages/no-fields": "Ninguno",
  "portal/subject-matter-definitions/coverages/reenable": "Reactivar",
  "portal/subject-matter-definitions/coverages/reenable-confirm":
    "¿Reactivar esta cobertura aquí? Volverá a resolverse desde el nivel del que se hereda.",
  "portal/subject-matter-definitions/coverages/state-declined": "Rechazada",
  "portal/subject-matter-definitions/coverages/state-elected": "Elegida",
  "portal/subject-matter-definitions/coverages/state-excluded": "Excluida",
  "portal/subject-matter-definitions/coverages/state-offered": "Ofrecida",
  "portal/subject-matter-definitions/delete": "Eliminar",
  "portal/subject-matter-definitions/description": "Descripción",
  "portal/subject-matter-definitions/edit": "Editar",
  "portal/subject-matter-definitions/empty-list":
    "Aún no hay definiciones de materia asegurada.",
  "portal/subject-matter-definitions/empty-results":
    "No se encontraron definiciones de materia asegurada.",
  "portal/subject-matter-definitions/enabled": "Habilitada",
  "portal/subject-matter-definitions/general": "General",
  "portal/subject-matter-definitions/label": "Etiqueta",
  "portal/subject-matter-definitions/link": "Vincular",
  "portal/subject-matter-definitions/link-lob":
    "Vincular Ramo a esta definición",
  "portal/subject-matter-definitions/linked-lobs": "Ramos vinculados",
  "portal/subject-matter-definitions/load-error":
    "No se pudieron cargar las definiciones de materia asegurada",
  "portal/subject-matter-definitions/lob": "Ramo",
  "portal/subject-matter-definitions/lobs": "Ramos",
  "portal/subject-matter-definitions/name": "Nombre",
  "portal/subject-matter-definitions/no": "No",
  "portal/subject-matter-definitions/no-lobs": "No hay ramos vinculados.",
  "portal/subject-matter-definitions/options-helper":
    'Obligatorio para type=select. Ejemplo: [{"value":"a","label":"A"}].',
  "portal/subject-matter-definitions/options-json": "Opciones (JSON)",
  "portal/subject-matter-definitions/order": "Orden",
  "portal/subject-matter-definitions/required": "Requerido",
  "portal/subject-matter-definitions/save": "Guardar",
  "portal/subject-matter-definitions/saving": "Guardando…",
  "portal/subject-matter-definitions/search-placeholder":
    "Buscar definiciones de materia asegurada",
  "portal/subject-matter-definitions/searchable": "Buscable",
  "portal/subject-matter-definitions/select":
    "Selecciona una definición para ver sus detalles.",
  "portal/subject-matter-definitions/sidebar": "Interés Asegurable",
  "portal/subject-matter-definitions/slug": "Slug",
  "portal/subject-matter-definitions/title":
    "Definiciones de Materia Asegurada",
  "portal/subject-matter-definitions/type": "Tipo",
  "portal/subject-matter-definitions/unique": "Único",
  "portal/subject-matter-definitions/unlink": "Desvincular",
  "portal/subject-matter-definitions/yes": "Sí",
  "portal/subject-matter/add-attribute": "Agregar Atributo",
  "portal/subject-matter/attributes": "Atributos",
  "portal/subject-matter/cardinality": "Cardinalidad",
  "portal/subject-matter/cardinality/many": "Varias",
  "portal/subject-matter/cardinality/one": "Una",
  "portal/subject-matter/definition": "Definición de Materia Asegurada",
  "portal/subject-matter/endorsable": "Endosable",
  "portal/subject-matter/entity-relationship": "Relación con Entidad",
  "portal/subject-matter/instance": "Materia Asegurada",
  "portal/subject-matter/no-attributes": "Aún no hay atributos definidos.",
  "portal/subject-matter/not-validated/default":
    "No validado. Este valor se guardó tal como se capturó y su formato no se verificó.",
  "portal/subject-matter/not-validated/model-year-unknown":
    "No validado. El año modelo no está disponible, por lo que no se pudo verificar el formato del identificador.",
  "portal/subject-matter/not-validated/pre-standard":
    "No validado. Los identificadores de este año modelo no siguen el formato estándar, por lo que se guardó tal como se capturó y solo se verificó que no esté duplicado.",
  "portal/subject-matter/validator/invalid": "El valor no es válido.",
  "portal/subject-matter/validator/niv-nom001/charset":
    "El identificador contiene un carácter no permitido (I, O, Q y símbolos no son válidos).",
  "portal/subject-matter/validator/niv-nom001/check-digit":
    "El carácter verificador del identificador no coincide. Revisa el identificador.",
  "portal/subject-matter/validator/niv-nom001/length":
    "El identificador debe tener exactamente 17 caracteres.",
  "portal/subject-matter/validator/niv-nom001/model-year":
    "El identificador no coincide con el año modelo del vehículo.",
  "portal/subject-matter/validator/vin-iso3779/charset":
    "El identificador contiene un carácter no permitido (I, O, Q y símbolos no son válidos).",
  "portal/subject-matter/validator/vin-iso3779/check-digit":
    "El carácter verificador del identificador no coincide. Revisa el identificador.",
  "portal/subject-matter/validator/vin-iso3779/length":
    "El identificador debe tener exactamente 17 caracteres.",
  "portal/subject-matter/validator/vin-iso3779/wmi":
    "El código de fabricante del identificador no es válido.",
  "portal/sum-field": "Campo de Suma",
  "portal/surcharge-factor": "Factor de Recargo",
  "portal/sync-to-parent": "Sincronizar con Padre",
  "portal/tab": "Pestaña",
  "portal/target": "Destino",
  "portal/tasks/assigned": "Asignado",
  "portal/tasks/cancelled": "Cancelado",
  "portal/tasks/claim": "Reclamar",
  "portal/tasks/complete": "Completar",
  "portal/tasks/completed": "Completado",
  "portal/tasks/in-progress": "En Progreso",
  "portal/tasks/my-tasks": "Mis Tareas",
  "portal/tasks/no-tasks": "No hay tareas para mostrar.",
  "portal/tasks/pending": "Pendiente",
  "portal/tasks/sort-by-created": "Creado",
  "portal/tasks/sort-by-priority": "Prioridad",
  "portal/tbc": "Por confirmar",
  "portal/terms-of-use": "Términos de Uso",
  "portal/this-account-uses-sso-you-will-be-redirected":
    "Esta cuenta utiliza SSO, al continuar, serás redirigido a la página de inicio de sesión de la organización.",
  "portal/transform": "Transformación",
  "portal/urls": "URLs",
  "portal/urls/agency-id": "Agencia",
  "portal/urls/company-id": "Compañía",
  "portal/urls/display-name": "Nombre para mostrar",
  "portal/urls/entity-id": "Entidad",
  "portal/urls/favicon-dark": "Favicon (oscuro)",
  "portal/urls/favicon-light": "Favicon (claro)",
  "portal/urls/feature-flags": "Funciones activadas",
  "portal/urls/legal-name": "Razón social",
  "portal/urls/load-error": "No se pudieron cargar las URLs",
  "portal/urls/logo-dark": "Logotipo (oscuro)",
  "portal/urls/logo-light": "Logotipo (claro)",
  "portal/urls/no-urls": "No se encontraron URLs",
  "portal/urls/primary-dark": "Primario (oscuro)",
  "portal/urls/primary-light": "Primario (claro)",
  "portal/urls/promoter-id": "Promotor",
  "portal/urls/regional-id": "Regional",
  "portal/urls/search-placeholder": "Buscar URLs",
  "portal/urls/secondary-dark": "Secundario (oscuro)",
  "portal/urls/secondary-light": "Secundario (claro)",
  "portal/urls/select-a-url": "Seleccione una URL de la lista",
  "portal/urls/theme": "Tema",
  "portal/urls/title": "Configuración de URLs",
  "portal/urls/url": "URL",
  "portal/user-roles/remove-confirm-message":
    "El usuario dejará de tener el rol {{role}} en {{target}}. Sus demás roles no cambian.",
  "portal/user-roles/remove-confirm-title": "¿Eliminar este rol?",
  "portal/user-roles/remove-last-confirm-message":
    "El rol {{role}} en {{target}} es el único rol de este usuario. Al eliminarlo, el usuario pierde todo acceso: podrá iniciar sesión, pero no verá ningún contenido hasta que reciba un nuevo rol.",
  "portal/users": "Usuarios",
  "portal/users-and-access-control": "Usuarios y Control de Acceso",
  "portal/users/all": "Todos los Usuarios",
  "portal/users/change-login-email": "Cambiar correo de inicio de sesión",
  "portal/users/change-login-email-confirmation":
    "Se cerrarán todas las sesiones del usuario y se notificará a la dirección anterior.",
  "portal/value": "Valor",
  "portal/variables": "Variables",
  "portal/vehicle": "Vehículo",
  "portal/vehicle-catalogues": "Catálogos de Vehículos",
  "portal/vehicle-is-required":
    "Es necesario indicar el vehículo al que pertenece la póliza",
  "portal/vehicles": "Vehículos",
  "portal/vendors": "Proveedores",
  "portal/view-file": "Ver Archivo",
  "portal/was-executed": "Ejecutado",
  "portal/year": "Año",
  "portal/yes": "Sí",
  "renaissance/activity-timeline/after": "Después: {{value}}",
  "renaissance/activity-timeline/before": "Antes: {{value}}",
  "renaissance/activity-timeline/empty": "No hay actividad que mostrar.",
  "renaissance/activity-timeline/filter-actions": "Acciones",
  "renaissance/activity-timeline/filter-all": "Todo",
  "renaissance/activity-timeline/filter-changes": "Cambios de datos",
  "renaissance/activity-timeline/filter-system": "Sistema e IA",
  "renaissance/activity-timeline/no-value": "Sin valor",
  "renaissance/activity-timeline/title": "Actividad",
  "renaissance/input-currency/currency-code": "Código de moneda",
  "renaissance/modal/assign": "Asignar",
  "renaissance/modal/back": "Regresar",
  "renaissance/modal/cancel": "Cancelar",
  "renaissance/modal/close": "Cerrar",
  "renaissance/modal/continue": "Continuar",
  "renaissance/modal/create": "Crear",
  "renaissance/modal/register": "Registrar",
  "renaissance/modal/save": "Guardar",
  "renaissance/more": "Más",
  "renaissance/portal-shell/connection-offline": "Sin conexión",
  "renaissance/portal-shell/connection-reconnecting": "Reconectando…",
  "renaissance/portal-shell/show-sidebar": "Mostrar barra lateral",
  "renaissance/search": "Buscar",
  "renaissance/steps/label": "Pasos",
  "renaissance/steps/progress": "Paso {{current}} de {{total}}",
  "renaissance/ui-command-palette/dialog-label": "Paleta de comandos",
  "renaissance/ui-command-palette/hint":
    "↑↓ para navegar, ↵ para seleccionar, Esc para cerrar",
  "renaissance/ui-command-palette/no-results": "Sin coincidencias",
  "renaissance/ui-command-palette/no-results-body":
    "Intenta con otro término de búsqueda.",
  "renaissance/ui-command-palette/placeholder":
    "Buscar páginas y configuración…",
  "renaissance/ui-confirm/cancel-label": "Cancelar",
  "renaissance/ui-confirm/confirm-label": "Confirmar",
  "renaissance/ui-input-file/upload-not-configured":
    "La carga de archivos no está configurada para este campo.",
  "renaissance/ui-input-percentage/required": "Este campo es obligatorio",
  "renaissance/ui-input-percentage/value-above-max":
    "El valor debe ser como máximo {{max}}%",
  "renaissance/ui-input-percentage/value-below-min":
    "El valor debe ser al menos {{min}}%",
  "renaissance/ui-input-phone/country-code": "Código de país",
  "renaissance/ui-input-select/no-options": "Sin coincidencias",
  "renaissance/ui-input-url/copy": "Copiar al portapapeles",
  "renaissance/ui-list/error": "Ocurrió un error al cargar esta lista",
  "renaissance/ui-live-region/alerts-label": "Alertas",
  "renaissance/ui-live-region/updates-label": "Actualizaciones",
  "renaissance/ui-loading-view/label": "Cargando",
  "renaissance/ui-popover/close": "Cerrar",
  "renaissance/ui-search/clear": "Limpiar búsqueda",
  "renaissance/ui-shortcut-sheet/close": "Cerrar",
  "renaissance/ui-shortcut-sheet/title": "Atajos de teclado",
  "renaissance/ui-table/empty": "Todavía no hay nada aquí",
  "renaissance/ui-table/error": "Ocurrió un error al cargar esta tabla",
  "renaissance/ui-table/loading": "Cargando filas",
  "renaissance/ui-table/no-access": "No tienes acceso a estos datos",
  "renaissance/ui-table/no-results": "No hay resultados para tu búsqueda",
  "renaissance/ui-table/retry": "Reintentar",
  "renaissance/ui-table/select-all-rows": "Seleccionar todas las filas",
  "renaissance/ui-table/select-row": "Seleccionar fila",
  "renaissance/ui-table/sort-ascending":
    "Ordenado ascendente. Actívalo para ordenar descendente.",
  "renaissance/ui-table/sort-descending":
    "Ordenado descendente. Actívalo para quitar el orden.",
  "renaissance/ui-table/sort-none":
    "Sin ordenar. Actívalo para ordenar ascendente.",
  "renaissance/ui-toast/dismiss": "Cerrar",
  "renaissance/ui-tree-list/collapse": "Contraer {{name}}",
  "renaissance/ui-tree-list/expand": "Expandir {{name}}",
  "renaissance/wizard/actions": "Acciones del paso",
  "renaissance/wizard/summary": "Resumen",
  "spare-parts-limit-exceeded": "Límite de Partes y Refacciones excedido",
  "spare-parts-limit-exceeded-description":
    "El límite de Partes y Refacciones no puede ser superior a USD $ 1,500,000.00, verifique la información e intente de nuevo.",
  "spare-parts-ratio-exceeded": "Límite de Partes y Refacciones excedido",
  "spare-parts-ratio-exceeded-description":
    "El límite de Partes y Refacciones no puede ser mayor al 30% del valor del casco, verifique la información e intente de nuevo.",
  "to-be-informed": "Para ser informado",
  "united-states-dollars": "Dólares de los Estados Unidos de América",
  "websites/hyperseguros/go-to-mian-page": "Ir a la página principal",
  "websites/hyperseguros/go-to-second-page": "Ir a la página secundaria",
  "websites/hyperseguros/hello-main-page": "Hola desde la página principal",
  "websites/hyperseguros/hello-second-page": "Hola desde la página secundaria",
};

export default esmx;
